window.KP_REVIEW_WALL_DATA = {
  "source": "Google reviews export generated for Krishna Pearls",
  "generatedAt": "2026-06-25T11:53:43Z",
  "stats": {
    "googleReviewCount": 2574,
    "averageRating": 4.9,
    "photoReviews": 59,
    "textReviews": 2108,
    "rawTextRows": 2574,
    "blankTextRowsExcluded": 282,
    "weakRowsExcluded": 121,
    "privacyRowsExcluded": 4,
    "duplicateRowsExcluded": 0,
    "photoDuplicateRowsExcluded": 59,
    "corruptedPhotoRowsExcluded": 1
  },
  "photoReviews": [
    {
      "id": "photo-11",
      "name": "bharath reddy",
      "rating": 5,
      "date": "2026-05-17",
      "displayDate": "May 17, 2026",
      "text": "Executive Satish helped us with pearls selection And over all ambience n good customer support 👌",
      "image": "kp-review-photo-11.webp",
      "tags": [
        "jewellery",
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-03",
      "name": "Senthilkumar Baarathi",
      "rating": 5,
      "date": "2026-05-09",
      "displayDate": "May 9, 2026",
      "text": "Good Experience at KP showroom, Jubilee Hills Branch.. Specially to mention Mr.Kalyan taken us through with every step. Thanks for your hospitality!",
      "image": "kp-review-photo-03.webp",
      "tags": [
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-19",
      "name": "Abhijith A R",
      "rating": 5,
      "date": "2026-05-07",
      "displayDate": "May 7, 2026",
      "text": "Very good service and pretty collections, the sales man mogulaiah is excellent customer service. Thank you for your service",
      "image": "kp-review-photo-19.webp",
      "tags": [
        "jewellery",
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-15",
      "name": "Pavani Mehra",
      "rating": 5,
      "date": "2026-04-10",
      "displayDate": "Apr 10, 2026",
      "text": "Thankyou so much kalyan! Great service, amazing designs",
      "image": "kp-review-photo-15.webp",
      "tags": [
        "jewellery",
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-07",
      "name": "Anupama Malik",
      "rating": 5,
      "date": "2026-03-31",
      "displayDate": "Mar 31, 2026",
      "text": "Mr. Sai Charan, Sonia, and Santosh were extremely helpful in selecting the pearl necklace and earrings. The collection and quality are excellent—highly recommended.",
      "image": "kp-review-photo-07.webp",
      "tags": [
        "jewellery",
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-33",
      "name": "Viacheslav Ocheretnyi",
      "rating": 5,
      "date": "2026-03-29",
      "displayDate": "Mar 29, 2026",
      "text": "Mr Jogu helped me so much ! Great service! Thank you 🙏",
      "image": "kp-review-photo-33.webp",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-01",
      "name": "Afeera m",
      "rating": 5,
      "date": "2026-03-24",
      "displayDate": "Mar 24, 2026",
      "text": "Me Sai Charan and Ms Kanaka Durga are amazing! They are patient and really help you in choosing the best designs. Will visit again! maryam",
      "image": "kp-review-photo-01.webp",
      "tags": [
        "jewellery",
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-17",
      "name": "Seema",
      "rating": 5,
      "date": "2026-03-24",
      "displayDate": "Mar 24, 2026",
      "text": "Great experience overall and the quality of pearls were great! They were super helpful and patient throughout our buying process. Highly recommend this place!",
      "image": "kp-review-photo-17.webp",
      "tags": [
        "jewellery",
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-05",
      "name": "Gautham N",
      "rating": 5,
      "date": "2026-03-06",
      "displayDate": "Mar 6, 2026",
      "text": "Wide variety of collection. Kind and patient executives showcasing all the options. Special thanks to Mr. Sai Charan ans Ms. Sonia for being supportive.",
      "image": "kp-review-photo-05.webp",
      "tags": [
        "jewellery",
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-02",
      "name": "Rituparna Bhandari",
      "rating": 5,
      "date": "2026-02-28",
      "displayDate": "Feb 28, 2026",
      "text": "Great hospitality! Staff are so humble and courteous specifically Mr Ramesh, Mogulaiah. Thank you so much",
      "image": "kp-review-photo-02.webp",
      "tags": [
        "gifting",
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-08",
      "name": "krishna veni",
      "rating": 5,
      "date": "2026-02-04",
      "displayDate": "Feb 4, 2026",
      "text": "Sales person Mr.Saicharan is amazing he has shown everything with show patience. For aure we will come back",
      "image": "kp-review-photo-08.webp",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-06",
      "name": "Dr. Sree Prathyusha Samavedam",
      "rating": 5,
      "date": "2026-01-10",
      "displayDate": "Jan 10, 2026",
      "text": "Attended a Pearl Bracelet making workshop. It was a great experience. Had lots of fun. Then shopped some jewellery with the help of Jagannath . He was really helpful.",
      "image": "kp-review-photo-06.webp",
      "tags": [
        "jewellery",
        "photo",
        "service",
        "showroom",
        "workshop"
      ]
    },
    {
      "id": "photo-04",
      "name": "Jishnu Harikumar",
      "rating": 5,
      "date": "2025-11-08",
      "displayDate": "Nov 8, 2025",
      "text": "Had an excellent experience at Krishna Jewellery! The collection is stunning and of top quality. A special thanks to Pasha, who was extremely helpful, polite, and knowledgeable. He guided us perfectly and made the shopping experience smooth and enjoyable. Highly recommend both Krishna Jewellery and Pasha for exceptional service!",
      "image": "kp-review-photo-04.webp",
      "tags": [
        "jewellery",
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-12",
      "name": "Sharon Robertson",
      "rating": 5,
      "date": "2025-11-07",
      "displayDate": "Nov 7, 2025",
      "text": "Loved shopping for the perfect pearls. Satish was such a help in finding the right color and shape. I needed a longer bracelet and they were able to add them while I waited. Great service!!",
      "image": "kp-review-photo-12.webp",
      "tags": [
        "jewellery",
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-09",
      "name": "Manisha",
      "rating": 5,
      "date": "2025-10-12",
      "displayDate": "Oct 12, 2025",
      "text": "Had a really great purchase experience here. The staff is extremely patient and soft spoken . Special thanks to Rohit and Krish",
      "image": "kp-review-photo-09.webp",
      "tags": [
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-32",
      "name": "Jai Heer",
      "rating": 5,
      "date": "2025-09-26",
      "displayDate": "Sep 26, 2025",
      "text": "Very great service by Rohit.The pearls were beautiful. Definitely worth it! ⭐️⭐️⭐️⭐️⭐️",
      "image": "kp-review-photo-32.webp",
      "tags": [
        "jewellery",
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-16",
      "name": "Urvashi Bhandari",
      "rating": 5,
      "date": "2025-09-24",
      "displayDate": "Sep 24, 2025",
      "text": "Loved the service! Mr T Rohit was super polite, not pushy at all, and helped me pick exactly what I wanted. Definitely made my jewellery shopping stress-free.",
      "image": "kp-review-photo-16.webp",
      "tags": [
        "gifting",
        "jewellery",
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-26",
      "name": "Khusha Manav",
      "rating": 5,
      "date": "2025-09-08",
      "displayDate": "Sep 8, 2025",
      "text": "T Rohit was very equipped and knowledgable in showing us the jewellery. Amazing experience with great designs",
      "image": "kp-review-photo-26.webp",
      "tags": [
        "jewellery",
        "photo",
        "showroom"
      ]
    },
    {
      "id": "photo-43",
      "name": "Aditya Bansal",
      "rating": 5,
      "date": "2025-07-19",
      "displayDate": "Jul 19, 2025",
      "text": "Outstanding Service by M. Jaganath Reddy – A True Pearl Expert I recently had the pleasure of purchasing pearls with the guidance of Mr. M. Jaganath Reddy, and I must say the experience was nothing short of exceptional. His deep knowledge of pearls, from quality grading to design recommendations, made the entire process smooth and enjoyable. Mr. Reddy was incredibly patient, attentive, and genuinely passionate about helping me find the perfect piece. He took the time to understand my preferences and offered insightful suggestions without ever being pushy. His professionalism and warm demeanor made me feel confident in my purchase and well taken care of throughout the transaction. What truly stood out was his commitment to customer satisfaction. He ensured that every detail met my expectations and went above and beyond to deliver a personalized experience. Thanks to Mr. Jaganath Reddy, I walked away with not just a stunning pearl set, but also a memorable buying experience. I highly recommend him to anyone looking for quality pearls and top-notch customer service. He is truly a gem in the industry!",
      "image": "kp-review-photo-43.webp",
      "tags": [
        "jewellery",
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-57",
      "name": "Shivani Karingula",
      "rating": 5,
      "date": "2025-07-19",
      "displayDate": "Jul 19, 2025",
      "text": "Had an amazing time at the pearl workshop and Kashinath provided great service in answer questions and assisting me during bracelet making.",
      "image": "kp-review-photo-57.webp",
      "tags": [
        "jewellery",
        "photo",
        "service",
        "workshop"
      ]
    },
    {
      "id": "photo-14",
      "name": "chiku taruni",
      "rating": 5,
      "date": "2025-07-05",
      "displayDate": "Jul 5, 2025",
      "text": "Had a wonderful experience at the DIY pearl workshop hosted by Krishna Jewellers. Never seen before in initiative by a jewellery store to educate its customers this way. Kashinath showed us different types of pearls and told us about the formation and maintenance. It was a very informative workshop. The patwas here also showed us the techniques of making pearl jewellery. Overall a wonderful experience!!",
      "image": "kp-review-photo-14.webp",
      "tags": [
        "jewellery",
        "photo",
        "showroom",
        "workshop"
      ]
    },
    {
      "id": "photo-18",
      "name": "prajwala poojary",
      "rating": 5,
      "date": "2025-07-05",
      "displayDate": "Jul 5, 2025",
      "text": "Rohit T from Sales team in Krishna Pearls is an amazing person. He was very kind and patient with our request for pearl accessories shopping. We had great time buying best pearl earnings from him. Keep up the good job and excellent customer service. All the best prajwala",
      "image": "kp-review-photo-18.webp",
      "tags": [
        "jewellery",
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-20",
      "name": "prashanthi",
      "rating": 5,
      "date": "2025-07-05",
      "displayDate": "Jul 5, 2025",
      "text": "Manager Pasha has given me knowledge of pearls by conducting a pearl workshop and with help of raj kumar patwa I made this pearl bracelet.I had a wonderful experience and do visit their store at Jubilee hills Road No. 36.They are having hude collection of all pearl jewellery.",
      "image": "kp-review-photo-20.webp",
      "tags": [
        "gifting",
        "jewellery",
        "photo",
        "service",
        "showroom",
        "workshop"
      ]
    },
    {
      "id": "photo-38",
      "name": "Aishwarya M",
      "rating": 5,
      "date": "2025-05-26",
      "displayDate": "May 26, 2025",
      "text": "Designs are too good must visit the store and pavani service very good I love it 😊",
      "image": "kp-review-photo-38.webp",
      "tags": [
        "jewellery",
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-37",
      "name": "neloufer ali",
      "rating": 5,
      "date": "2025-05-24",
      "displayDate": "May 24, 2025",
      "text": "Great experience at the pearl workshop with patwari sudhir,kashinath and shoukath Loved the snacks and experience here.",
      "image": "kp-review-photo-37.webp",
      "tags": [
        "jewellery",
        "photo",
        "showroom",
        "workshop"
      ]
    },
    {
      "id": "photo-13",
      "name": "R Gu",
      "rating": 5,
      "date": "2025-05-15",
      "displayDate": "May 15, 2025",
      "text": "I had an amazing time at my first visit to Krishna Pearls in Jubilee Hills, Hyderabad. Their hospitality, customer service, and beautiful collection were all top-notch. And I believe the prices were just right! I want to thank sales executive Mr. Abdullah Pasha and his team for making my experience so special. Thanks a bunch!",
      "image": "kp-review-photo-13.webp",
      "tags": [
        "jewellery",
        "photo",
        "service",
        "showroom",
        "workshop"
      ]
    },
    {
      "id": "photo-10",
      "name": "Rufus Sunny",
      "rating": 5,
      "date": "2025-05-10",
      "displayDate": "May 10, 2025",
      "text": "I had a wonderful experience shopping at Krishna Pearls. Their collection of pearl jewellery is not only authentic but also beautifully crafted. I was looking for a pearl set within a specific budget, and the staff were incredibly accommodating. A special mention to Rohit & Vivek, the executives who assisted me. They were patient, knowledgeable, and genuinely cared about helping me find the right piece. They explained the differences between freshwater and saltwater pearls clearly and made sure I was confident in my first purchase. His customer service was warm, honest, and professional – truly impressive! Ask for them on your visit! You’ll walk away not just with jewellery, but with a great buying experience.",
      "image": "kp-review-photo-10.webp",
      "tags": [
        "jewellery",
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-53",
      "name": "Maddy Traveller",
      "rating": 5,
      "date": "2025-04-13",
      "displayDate": "Apr 13, 2025",
      "text": "Huge collection of god idol items, and good customer service",
      "image": "kp-review-photo-53.webp",
      "tags": [
        "jewellery",
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-45",
      "name": "Sailendra Mishra",
      "rating": 5,
      "date": "2025-04-10",
      "displayDate": "Apr 10, 2025",
      "text": "Wide range of pearls & jewelleries. Nice behavior of staff Kunal. Loved the deal.",
      "image": "kp-review-photo-45.webp",
      "tags": [
        "jewellery",
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-24",
      "name": "Nandhini Prya",
      "rating": 5,
      "date": "2025-03-02",
      "displayDate": "Mar 2, 2025",
      "text": "Coustomer service is good and radha showed us patiently... And good quality pearls",
      "image": "kp-review-photo-24.webp",
      "tags": [
        "jewellery",
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-48",
      "name": "Srinivas Sirpa",
      "rating": 5,
      "date": "2025-01-25",
      "displayDate": "Jan 25, 2025",
      "text": "Excellent nice, Ambika is customer friendly and quiet motivate to promote the product",
      "image": "kp-review-photo-48.webp",
      "tags": [
        "photo"
      ]
    },
    {
      "id": "photo-27",
      "name": "Simran Sinha",
      "rating": 5,
      "date": "2025-01-02",
      "displayDate": "Jan 2, 2025",
      "text": "Sir pasha is really very good , he provides a very good service and very kind behaviour towards customers. Loved the service",
      "image": "kp-review-photo-27.webp",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-58",
      "name": "N U Prasanth",
      "rating": 5,
      "date": "2024-12-28",
      "displayDate": "Dec 28, 2024",
      "text": "Nice Store, Mr. Pasha give nice service.",
      "image": "kp-review-photo-58.webp",
      "tags": [
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-42",
      "name": "pankaj rao",
      "rating": 5,
      "date": "2024-12-04",
      "displayDate": "Dec 4, 2024",
      "text": "Pasha sir for very considerable and offered us great discount on pearls and also provided genuine along with certificate",
      "image": "kp-review-photo-42.webp",
      "tags": [
        "jewellery",
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-51",
      "name": "raghavendra naidu",
      "rating": 5,
      "date": "2024-12-03",
      "displayDate": "Dec 3, 2024",
      "text": "Mr. Pasha was quite helpful while detailing the products. There products are good compared to others. Their craftsmanship is the finest.",
      "image": "kp-review-photo-51.webp",
      "tags": [
        "gifting",
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-35",
      "name": "Kanika Payne",
      "rating": 5,
      "date": "2024-11-09",
      "displayDate": "Nov 9, 2024",
      "text": "Kashinath helped me with the pearl necklace selection, and was very cordial and knowledgeable on the offerings. Best place for pearls shopping!",
      "image": "kp-review-photo-35.webp",
      "tags": [
        "jewellery",
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-31",
      "name": "Sinjini Dutta",
      "rating": 5,
      "date": "2024-10-04",
      "displayDate": "Oct 4, 2024",
      "text": "Wonderful service and very helpful staff. Satish was really helpful with the option. Manjula also helped with everything .",
      "image": "kp-review-photo-31.webp",
      "tags": [
        "gifting",
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-46",
      "name": "Apoorva Shetty",
      "rating": 5,
      "date": "2024-10-04",
      "displayDate": "Oct 4, 2024",
      "text": "Elegant designs. great quality. And staff ( satish and kusuma ) very knowledgeable and helpfull",
      "image": "kp-review-photo-46.webp",
      "tags": [
        "jewellery",
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-30",
      "name": "Soumya Awasthi",
      "rating": 5,
      "date": "2024-08-18",
      "displayDate": "Aug 18, 2024",
      "text": "Mr Kashinath is a master of pearls. He explained all the differences of the pearls very politely and in detail. The Krishna pearls store is a huge store and has lots n lots of varieties. A must visit.",
      "image": "kp-review-photo-30.webp",
      "tags": [
        "jewellery",
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-47",
      "name": "Gaurav Shetty",
      "rating": 5,
      "date": "2024-08-14",
      "displayDate": "Aug 14, 2024",
      "text": "Wonderful experience with pasha and they explained all the details about pearls and very good service and best price💫",
      "image": "kp-review-photo-47.webp",
      "tags": [
        "jewellery",
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-25",
      "name": "Gopichand Gadde",
      "rating": 5,
      "date": "2024-08-02",
      "displayDate": "Aug 2, 2024",
      "text": "Kashinath and Kusuma helped us today to close a small purchase. Showed us multiple models, well organized and coordinating team.",
      "image": "kp-review-photo-25.webp",
      "tags": [
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-34",
      "name": "Ayushi Mathur",
      "rating": 5,
      "date": "2024-07-26",
      "displayDate": "Jul 26, 2024",
      "text": "Incredible experience! Bought 5-6 products in 10-15 mins. Satish was great help in the whole experience.",
      "image": "kp-review-photo-34.webp",
      "tags": [
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-22",
      "name": "Sunaina Shyam",
      "rating": 5,
      "date": "2024-07-05",
      "displayDate": "Jul 5, 2024",
      "text": "Kashinath and Kusuma gave us great service! They were very attentive and showed us the collections with so much patience. Love the collection at Krishna jewellers.",
      "image": "kp-review-photo-22.webp",
      "tags": [
        "gifting",
        "jewellery",
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-29",
      "name": "anant",
      "rating": 5,
      "date": "2024-06-15",
      "displayDate": "Jun 15, 2024",
      "text": "Excellent product. Attention to detail. Delivered in good condition. Neelam ji in staff was very polite and helped through the entire process",
      "image": "kp-review-photo-29.webp",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-52",
      "name": "Jieun Lee",
      "rating": 5,
      "date": "2024-05-11",
      "displayDate": "May 11, 2024",
      "text": "I visited the shop again to buy gift and bought great necklaces thanks to Kashinath. We would love to visit again.",
      "image": "kp-review-photo-52.webp",
      "tags": [
        "gifting",
        "jewellery",
        "photo",
        "showroom"
      ]
    },
    {
      "id": "photo-44",
      "name": "Willi Tang",
      "rating": 5,
      "date": "2023-12-16",
      "displayDate": "Dec 16, 2023",
      "text": "Very inviting store for shopping jewellery and especially pearls. Kashinath really took his time to explain and show me all the different products. Can really recommend this store.",
      "image": "kp-review-photo-44.webp",
      "tags": [
        "jewellery",
        "photo",
        "showroom"
      ]
    },
    {
      "id": "photo-41",
      "name": "Rajjeet Deval",
      "rating": 5,
      "date": "2023-08-27",
      "displayDate": "Aug 27, 2023",
      "text": "Beautiful experience at Krishna pearls, The staff were very welcoming especially Mr. Rajkumar were very helpful",
      "image": "kp-review-photo-41.webp",
      "tags": [
        "jewellery",
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-23",
      "name": "Sumanth Prabhu",
      "rating": 5,
      "date": "2023-07-22",
      "displayDate": "Jul 22, 2023",
      "text": "An amazing store for pearl ornaments. Mr. Mohith assisted in the entire process and it was a delightful experience. Coming from Bangalore and buying the best pearls here",
      "image": "kp-review-photo-23.webp",
      "tags": [
        "jewellery",
        "photo",
        "showroom"
      ]
    },
    {
      "id": "photo-28",
      "name": "Akriti Rana",
      "rating": 5,
      "date": "2023-07-13",
      "displayDate": "Jul 13, 2023",
      "text": "Terrific customer service! They have wide selection of jewelry choices. I bought a petal necklace and earring to match it! I love it! Raj Kumar was very helpful and knowledgeable about the pearls available in the store!",
      "image": "kp-review-photo-28.webp",
      "tags": [
        "jewellery",
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-60",
      "name": "ajit nimbalker",
      "rating": 5,
      "date": "2023-06-24",
      "displayDate": "Jun 24, 2023",
      "text": "Good collection and good service",
      "image": "kp-review-photo-60.webp",
      "tags": [
        "jewellery",
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-54",
      "name": "Raseel Kaur",
      "rating": 5,
      "date": "2023-06-14",
      "displayDate": "Jun 14, 2023",
      "text": "Received by the staff very nicely and she guided me well for my requirements. Overall very good experience. Pravin made it sure serve us with all the specicifications of the product and gave a satisfactory answer to all are queries.",
      "image": "kp-review-photo-54.webp",
      "tags": [
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-55",
      "name": "Praneeta Patnaik",
      "rating": 5,
      "date": "2023-05-21",
      "displayDate": "May 21, 2023",
      "text": "The collection is really amazing. I bought a pearl necklace set for my mom. The staff was very friendly. Mr. Raj Kumar and Ms. Soniya presented the collection so well to me. Store ambience looks regal. 10/10 recommend.",
      "image": "kp-review-photo-55.webp",
      "tags": [
        "jewellery",
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-50",
      "name": "Bharath Narla",
      "rating": 4,
      "date": "2023-04-22",
      "displayDate": "Apr 22, 2023",
      "text": "Great service by Kashinath, liked the product knowledge and the way he handled the sale",
      "image": "kp-review-photo-50.webp",
      "tags": [
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-40",
      "name": "abhijith abhi",
      "rating": 5,
      "date": "2023-04-15",
      "displayDate": "Apr 15, 2023",
      "text": "Very good ambiance nice collections. Abdulpasha very nice communication and other services also good. v soniya good communication nize p",
      "image": "kp-review-photo-40.webp",
      "tags": [
        "jewellery",
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-59",
      "name": "Mohd Sadath Ali",
      "rating": 5,
      "date": "2023-03-02",
      "displayDate": "Mar 2, 2023",
      "text": "Mohit Agarwal sales executive very friendly and professional approach towards costomers......",
      "image": "kp-review-photo-59.webp",
      "tags": [
        "gifting",
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-21",
      "name": "SK",
      "rating": 5,
      "date": "2023-02-14",
      "displayDate": "Feb 14, 2023",
      "text": "I am from Kerala...it was a wonderful experience @krishna pearls..a must visit place ..you can see different types of collections..Mr Kasinath's customer service is commendable👍",
      "image": "kp-review-photo-21.webp",
      "tags": [
        "jewellery",
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-39",
      "name": "Pranav Hundoo",
      "rating": 5,
      "date": "2023-01-26",
      "displayDate": "Jan 26, 2023",
      "text": "Best place for pearl shopping in Hyderabad. Natural sea water or natural fresh water pearls, they have you covered. Ask for Kashinath, he will give you the attention and the patience you deserve.",
      "image": "kp-review-photo-39.webp",
      "tags": [
        "jewellery",
        "photo",
        "showroom"
      ]
    },
    {
      "id": "photo-36",
      "name": "Hemanth sunny",
      "rating": 5,
      "date": "2022-06-16",
      "displayDate": "Jun 16, 2022",
      "text": "Great designs and regular customers. Always full crowded. Great service.",
      "image": "kp-review-photo-36.webp",
      "tags": [
        "jewellery",
        "photo",
        "service",
        "showroom"
      ]
    },
    {
      "id": "photo-49",
      "name": "priyankabv gowda",
      "rating": 5,
      "date": "2022-02-10",
      "displayDate": "Feb 10, 2022",
      "text": "Wonderful service and friendly staff.. immediately responds as soon as possible… excellent choice of gold and silver jwellery…",
      "image": "kp-review-photo-49.webp",
      "tags": [
        "photo",
        "service"
      ]
    }
  ],
  "textReviews": [
    {
      "id": "text-0001",
      "name": "R B Urikouth",
      "rating": 5,
      "text": "Ver good. Especially Mr Kalyan's dealing and support."
    },
    {
      "id": "text-0003",
      "name": "pcm rao",
      "rating": 5,
      "text": "Nice and very cooperative attendance by Mr.Saicharan"
    },
    {
      "id": "text-0004",
      "name": "Sujata Chanda",
      "rating": 5,
      "text": "I recently ordered a customized pearl necklace from Krishna Pearls, and I would like to express my sincere gratitude to Renuka from the e-commerce team for making my dream piece a reality. Renuka went above and beyond at every step, offering her time, patience, and genuine care. From helping me choose the right size and color to ensuring every detail was perfect, her sincere efforts and dedication truly stood out. Thank you, Renuka, for your kindness, professionalism, and commitment. You are truly a wonderful person. My heartfelt thanks also go to Sanjeev Kumar for customizing the necklace so beautifully. The final piece has exceeded my expectations and is absolutely stunning. Lastly, I would like to thank Krishna Pearls for the excellent quality of their products and outstanding customer service. Having dedicated and caring people like Renuka on your team is a true asset to the organization. Thank you all for making this such a memorable and delightful experience. 💕✨"
    },
    {
      "id": "text-0005",
      "name": "Nagi Reddy",
      "rating": 5,
      "text": "Models are good. I went with little hesitant about models. But they have good models. Bracelets models are bit limited. But got nice models in pearl section. I appreciate service. Sai Charan helps us in presenting nice models."
    },
    {
      "id": "text-0006",
      "name": "Akshat Chopra",
      "rating": 5,
      "text": "Wonderful recommendation suggested by Mr Ramesh, had a pleasant experience at Krishna pearls. The collection is amazing. They have pearl artifacts in wide range."
    },
    {
      "id": "text-0007",
      "name": "dark chocolate",
      "rating": 5,
      "text": "Came here for a workshop, stayed for the jewellery jaganath reddy was very helpful and guided us with the whole experience! Definitely recommend!"
    },
    {
      "id": "text-0008",
      "name": "mridula dasanla",
      "rating": 5,
      "text": "Great hospitality, amazing pearl workshop & guidance by the whole team & jagannath reddy"
    },
    {
      "id": "text-0009",
      "name": "tejaswini D",
      "rating": 5,
      "text": "Nice collections in perl sales person jagannath reddy is very politely and cooperative"
    },
    {
      "id": "text-0010",
      "name": "Satheesh Thalapalli",
      "rating": 5,
      "text": "The showroom has a very good collection of Pearl sets. Jagannath Reddy was very courteous and helpful. Worth exploring if you are planning to buy any pearl sets."
    },
    {
      "id": "text-0011",
      "name": "Abhishek Rathore",
      "rating": 5,
      "text": "Amazing store with great collection. Kalyan helped me pick the perfect pieces. 10/10 will visit again."
    },
    {
      "id": "text-0012",
      "name": "chetan gandhi",
      "rating": 5,
      "text": "Sai Charan is exceptionally well in his customer service"
    },
    {
      "id": "text-0013",
      "name": "mohammad muzammil",
      "rating": 5,
      "text": "Good Choices of options, best service by Sai Charan."
    },
    {
      "id": "text-0014",
      "name": "Ramani Krishnamoorthy",
      "rating": 5,
      "text": "Thank you for the wonderful service Jagganath Reddy"
    },
    {
      "id": "text-0015",
      "name": "Aarti Singh Parmar",
      "rating": 5,
      "text": "Here at Krishna pearls, HICC. The pearl collection is absolutely elegant, timeless, and beautifully crafted. Sai charan and rest of the staff was courteous and helpful, making the shopping experience even better. Recommended for elegant timeless collection."
    },
    {
      "id": "text-0016",
      "name": "Afreen Aarif",
      "rating": 5,
      "text": "Excellent experience shopping at Krishna Pearls. Sai Charan and Arjun were very helpful."
    },
    {
      "id": "text-0017",
      "name": "harshada B.N.",
      "rating": 5,
      "text": "It was a very satisfying experience at Krishna pearls Jubilee Hills. Jaganath Reddy was the sale person, and he explained very well. And gave the best service."
    },
    {
      "id": "text-0018",
      "name": "Sudheer Darapureddy",
      "rating": 5,
      "text": "Excellent Service. Had a very good experience shopping here for Jewelry. Ramesh has been super helpful and explained every detail, making it a very pleasant experience. Thanks!"
    },
    {
      "id": "text-0019",
      "name": "mahidharreddy mahidharreddymaddikunta",
      "rating": 5,
      "text": "They were awesome and the person saikumar has showed me nice collection helped me with discounts also"
    },
    {
      "id": "text-0020",
      "name": "kartheek mariserla",
      "rating": 5,
      "text": "Collections are good with good price"
    },
    {
      "id": "text-0021",
      "name": "Sahithi",
      "rating": 5,
      "text": "Lovely designs, Sai Charan assisted so well, thank you"
    },
    {
      "id": "text-0022",
      "name": "Avinita Yadav",
      "rating": 5,
      "text": "A real treasure house for pearls. Ask for Mr Ramesh to guide you through designs and history of pearls."
    },
    {
      "id": "text-0023",
      "name": "Sunitha Deepak",
      "rating": 5,
      "text": "Service was really nice, Sai Charan helped us select the right kind of jewellery we were looking for the occasion 😊😊👍 will be visiting the shop soon."
    },
    {
      "id": "text-0024",
      "name": "Sumalatha A",
      "rating": 5,
      "text": "Great collection! Absolutely loved the design. Mogulaiah who attended us was very patient, not pushy with suggestions and let me make my own choices. He was definitely the reason I got all I wanted! Thank you"
    },
    {
      "id": "text-0025",
      "name": "mohua ball(sanyal)",
      "rating": 5,
      "text": "Came for the first time to buy some small jewelry for my daughters bday, it was a superb experience. Sai Charan was extremely patient throughout the search process. Love the designs here."
    },
    {
      "id": "text-0026",
      "name": "akshi kotecha",
      "rating": 5,
      "text": "Jaganath was good and showed variety"
    },
    {
      "id": "text-0027",
      "name": "Bujji",
      "rating": 5,
      "text": "Good way of greeting from jaganath reddy . Good designs available"
    },
    {
      "id": "text-0028",
      "name": "A.Rajendraprasad Reddy",
      "rating": 5,
      "text": "Jaganath ...he explained very well about jewellery...the other staff were good 👍"
    },
    {
      "id": "text-0029",
      "name": "NAMAN MITTAL",
      "rating": 5,
      "text": "Very nice collection and the salesperson jagganath reddy was very nice person"
    },
    {
      "id": "text-0030",
      "name": "Dope Amine",
      "rating": 5,
      "text": "Came to Krishna Pearls to buy pearl ornaments . Mr.Prasad recieved with care and took time to show the Pearls .They have wide variety of collections .Previously came to buy Pearl necklace and now bought bracelet .Would suggest to anyone looking to buy from the city of pearls - Hyderabad ."
    },
    {
      "id": "text-0031",
      "name": "Akshi Gill",
      "rating": 5,
      "text": "A Great Place for purchasing jewellery."
    },
    {
      "id": "text-0032",
      "name": "Chandana J",
      "rating": 5,
      "text": "Great experience! Sai Charan was very helpful and friendly. He understood what I needed and guided me perfectly. Highly recommend him! 😊"
    },
    {
      "id": "text-0034",
      "name": "Manthena Saritha",
      "rating": 5,
      "text": "M Jaganath Reddy Nice experience patiently shown every thing"
    },
    {
      "id": "text-0035",
      "name": "Thotakura Satish",
      "rating": 4,
      "text": "Good collection and pleasant service by jaganath reddy"
    },
    {
      "id": "text-0036",
      "name": "Murari karun sachetan",
      "rating": 5,
      "text": "Good collection and polite staff .."
    },
    {
      "id": "text-0037",
      "name": "Pushpita Das",
      "rating": 4,
      "text": "Really good experience and good staff. Sai charan has been really good with assisting me with my jewellery shopping!!"
    },
    {
      "id": "text-0038",
      "name": "Pragnya Bandaragal",
      "rating": 5,
      "text": "Mr. Sai Charan attended us very well, very satisfied."
    },
    {
      "id": "text-0039",
      "name": "srinivasa bodasingu",
      "rating": 5,
      "text": "Good experience with Jaganadh. Thank you!"
    },
    {
      "id": "text-0040",
      "name": "Radhika V",
      "rating": 5,
      "text": "M jaganath reddy was a very good communicator and clarified the doubts well"
    },
    {
      "id": "text-0041",
      "name": "ashitha khanapure",
      "rating": 4,
      "text": "Good service and ambience"
    },
    {
      "id": "text-0042",
      "name": "Atharva Deshmukh",
      "rating": 5,
      "text": "Jagannath guided well."
    },
    {
      "id": "text-0043",
      "name": "Asha Priya",
      "rating": 4,
      "text": "Friendly staff a good shopping experience Pasha assisted us well"
    },
    {
      "id": "text-0044",
      "name": "SAFOORA",
      "rating": 5,
      "text": "Wide range of varieties present Good service from A Kalyan"
    },
    {
      "id": "text-0045",
      "name": "Rajchinna Mudavath",
      "rating": 5,
      "text": "Nice explain about product Mudavath balaji"
    },
    {
      "id": "text-0046",
      "name": "Charchil Kumar",
      "rating": 5,
      "text": "Saicharan from HICC Best Behaviour and very Polite"
    },
    {
      "id": "text-0047",
      "name": "Anushka Nair",
      "rating": 5,
      "text": "Mogulaiah was great"
    },
    {
      "id": "text-0048",
      "name": "Akshay Raghuvanshi",
      "rating": 5,
      "text": "Thank you for a great experience. especially appreciate J Ramesh for his incredible patience and humility for making our shopping really easy."
    },
    {
      "id": "text-0049",
      "name": "Amit Kumar",
      "rating": 5,
      "text": "Mogulaiah helped us select a pearl set and was very helpful throughout. This is a great place with a wide variety of designs. Definitely recommended if you’re looking for beautiful pearl designs."
    },
    {
      "id": "text-0050",
      "name": "Muralidhar dasari",
      "rating": 5,
      "text": "I had a wonderful experience at Sri Krishna Jewellers. They have an impressive collection with a wide variety of designs to choose from, catering to different tastes and preferences. The quality and presentation of the jewellery are truly commendable. A special appreciation to the sales executive, Mr. Jaganath Reddy, for his exceptional customer service. He was very patient, knowledgeable, and guided us professionally throughout the selection process. His friendly approach and attention to detail made the shopping experience even more pleasant. Highly recommended for anyone looking for beautiful jewellery and excellent customer service!"
    },
    {
      "id": "text-0052",
      "name": "amrit das",
      "rating": 5,
      "text": "Mr CH Mogulaiah was very professional in his approach and helped me to get the right product..Really happy with the service levels..I would strongly recommend people to visit the store..Great shipping experience..Special thanks to Mr Mogulaiah."
    },
    {
      "id": "text-0053",
      "name": "Shrirang Kundle",
      "rating": 5,
      "text": "A Kalyan showed up good jwellery Very easy to make decisions Good experience"
    },
    {
      "id": "text-0054",
      "name": "Rashmi Ganvir",
      "rating": 5,
      "text": "Shopping at Krishna Pearls was amazing. They have a pretty good collections and CH Mogulaiah was very very helpful in helping me find exactly what i wanted."
    },
    {
      "id": "text-0055",
      "name": "sirisha tadepalli",
      "rating": 5,
      "text": "Mouguliah was excellent!"
    },
    {
      "id": "text-0056",
      "name": "Santhosh kumar Selvaraj",
      "rating": 5,
      "text": "Thank you for the assistance Kalyan"
    },
    {
      "id": "text-0057",
      "name": "sai charan reddy kamireddy",
      "rating": 5,
      "text": "Jaganath and Arvind is so supportive had excellent experience."
    },
    {
      "id": "text-0058",
      "name": "Neha Musaddi",
      "rating": 5,
      "text": "Mogulaian was very active and helpful. Not at all pushing, showed all possible options, Helped to buy whats most suited"
    },
    {
      "id": "text-0059",
      "name": "Kris Rajagopal",
      "rating": 5,
      "text": "Please visit the shop for good ornaments in pearls and silver and for your assistance, please meet Mr. Mogulaiah for all your needs. He is one of the best sales person who can guide you and support for a good purchase. 👍🏼"
    },
    {
      "id": "text-0060",
      "name": "prathyusha katamareddy",
      "rating": 5,
      "text": "Very good collection in pearl jewellery, mogulaiah and Prasad helped us patiently in selecting earrings."
    },
    {
      "id": "text-0061",
      "name": "Areesha Shahid",
      "rating": 5,
      "text": "Great store with very good hospitality by Ramesh! Very polite staff and the collection is also great!"
    },
    {
      "id": "text-0062",
      "name": "Neha Sahu",
      "rating": 5,
      "text": "Mahesh thanks for showing so patiently"
    },
    {
      "id": "text-0063",
      "name": "Sheetal Ranadive",
      "rating": 5,
      "text": "Kalyan gave very good service"
    },
    {
      "id": "text-0064",
      "name": "Roveena Ruby Suares",
      "rating": 5,
      "text": "Kalyan : best service loved it."
    },
    {
      "id": "text-0066",
      "name": "Raju Gulumuru",
      "rating": 5,
      "text": "Good service by kalyan"
    },
    {
      "id": "text-0067",
      "name": "Md javed Ahmad",
      "rating": 5,
      "text": "Best place for city of pearls and gems. Staff are great and helpful."
    },
    {
      "id": "text-0068",
      "name": "Nethra Ballal",
      "rating": 5,
      "text": "Great collection of pearls. Lovely experience in shopping. Mr. Kalyan helped in my overall shopping experience by showing the pearl collection with patience!!"
    },
    {
      "id": "text-0069",
      "name": "anootpol roy",
      "rating": 5,
      "text": "Excellent and seamless service by Sai Charan and his team. Keep it up😊😊"
    },
    {
      "id": "text-0070",
      "name": "dharnish dhaksha",
      "rating": 5,
      "text": "Good experiance, Warm greeting by Mr. Jaganatha reddy"
    },
    {
      "id": "text-0071",
      "name": "Vaishi Raj",
      "rating": 5,
      "text": "Very friendly and professional service. Jagannath ji was very patient in helping me choose the perfect gift."
    },
    {
      "id": "text-0072",
      "name": "elizabeth thomas",
      "rating": 5,
      "text": ".Excellent service from M. JAGANATH REDDY👌"
    },
    {
      "id": "text-0073",
      "name": "Vikrant Singh",
      "rating": 5,
      "text": "Your salesman Jagannath is absolutely awesome. Had a great time at your store"
    },
    {
      "id": "text-0074",
      "name": "Adithi Bhaskar",
      "rating": 5,
      "text": "Thank you so much Kalyan for your patience and expertise! You helped me find the perfect pearl set and your excellent service made the whole experience wonderful."
    },
    {
      "id": "text-0076",
      "name": "Kumar Prashant",
      "rating": 5,
      "text": "Nice experience with Krishna pearls. Thanx to Jagarnath"
    },
    {
      "id": "text-0077",
      "name": "ranjitha ramamoorthy",
      "rating": 5,
      "text": "They have good Collections. Mr. Sathish and mr. Krish gave good service."
    },
    {
      "id": "text-0078",
      "name": "Rimi Shah",
      "rating": 5,
      "text": "Very nice pearl jewellery collection. Mr. Ramesh showed us many very good options and helped us choose the best designs. Good service and pleasant shopping experience."
    },
    {
      "id": "text-0079",
      "name": "rohan sinha",
      "rating": 5,
      "text": "Vast collection and amazing helpful staff Esp Sathish has been extremely helpful and patient"
    },
    {
      "id": "text-0080",
      "name": "Shalini Esther Thomas",
      "rating": 5,
      "text": "Amazing store with real pearls, Kalyan was very helpful and happy go lucky guy. Give him a raise for a good job done"
    },
    {
      "id": "text-0081",
      "name": "uma shankar",
      "rating": 5,
      "text": "Jagnatha reddy did great service and he is customer oriental person. He understands what customer needs and delivers and no over explanation to buy Simple and sweet person"
    },
    {
      "id": "text-0082",
      "name": "Sri Latha",
      "rating": 5,
      "text": "Excellent collection ..M. Janardan reddy showed very patiently ."
    },
    {
      "id": "text-0083",
      "name": "Polina Tserkassova",
      "rating": 5,
      "text": "We loved our experience here at this shop! It smells nice, looks nice, the people, especially Y Sai Charan was especially helpful, kind and helped me find what I needed. Got beautiful pearls here!"
    },
    {
      "id": "text-0084",
      "name": "Rajiv Joshi",
      "rating": 5,
      "text": "Excellent designs and thanks Satish for your assistance in selecting the jewellery of my choice…!"
    },
    {
      "id": "text-0085",
      "name": "Lokender Kaushik",
      "rating": 5,
      "text": "M. Satish was very engaging and informative salesperson.he displayed all the items very patiently"
    },
    {
      "id": "text-0086",
      "name": "Nani reddy",
      "rating": 5,
      "text": "I purchased a piece of jewelry earlier, but later I felt it was not the right choice for me. When I visited again, I came to know that Krishna Pearls has an 80% exchange policy, which was very helpful. Mr. Ramesh showed me some excellent jewelry collections and helped me choose a much better design. Thank you for the wonderful support and service."
    },
    {
      "id": "text-0087",
      "name": "Rajalakshmi R",
      "rating": 5,
      "text": "Ramesh sir was patient and kind enough to show us different varities of pearls and explained the difference between the variations."
    },
    {
      "id": "text-0088",
      "name": "Salini Nimmagadda",
      "rating": 5,
      "text": "The experience in the krishna pearls is good , the products are in all ranges for the customer to choose from ,espescially Mogulaiah is very through in showing the products and we felt very good"
    },
    {
      "id": "text-0089",
      "name": "Sayantee Jana",
      "rating": 5,
      "text": "Mogulaiah was incredibly helpful and had great patience in showing their wide range of pearls collection."
    },
    {
      "id": "text-0090",
      "name": "Vedika Malik",
      "rating": 5,
      "text": "Mr Kalyan’s assistance was excellent. Helped conduct a smooth shopping experience of south sea pearls."
    },
    {
      "id": "text-0091",
      "name": "Partha Sarathi",
      "rating": 5,
      "text": "Mr. Ramesh supported us alot in selecting right jewel. Number of variations in pearls. Must visit place."
    },
    {
      "id": "text-0093",
      "name": "Ramesh Rock",
      "rating": 5,
      "text": "Excellent customer service by Mr. KALYAN"
    },
    {
      "id": "text-0094",
      "name": "Shubham Sharma",
      "rating": 5,
      "text": "Good shop with lots of variety for pearls jewellery and amit agrawal treated and helped us very nicely"
    },
    {
      "id": "text-0095",
      "name": "Jasleen Gangar",
      "rating": 5,
      "text": "Kalyan was helpful"
    },
    {
      "id": "text-0097",
      "name": "Ajanta Bhattacherjee",
      "rating": 5,
      "text": "Had a lovely experience. Mr Sai Charan was more than happy to show me till I got satisfied."
    },
    {
      "id": "text-0099",
      "name": "Aashi Online",
      "rating": 5,
      "text": "Extremely good service by Mogulaiah"
    },
    {
      "id": "text-0100",
      "name": "Mudit Singh",
      "rating": 5,
      "text": "I am very satisfied. My experience is nice. thanks to Y Sai Charan for helping me in choosing the perfect ear ring."
    },
    {
      "id": "text-0101",
      "name": "Mohit Rakhra",
      "rating": 5,
      "text": "excellent experience specially with M Jaganath Reddy."
    },
    {
      "id": "text-0102",
      "name": "Prashant Varshney",
      "rating": 5,
      "text": "Excellent showroom, lots of variety and special mention of Jagannath Reddy who was really helpful and patient and helped me buy the necklace."
    },
    {
      "id": "text-0103",
      "name": "Anukruti Das",
      "rating": 5,
      "text": "We had a great experience at Krishna Pearls, Hyderabad. Mr. Sai Charan was patient enough to show us various designs and suggest us the best piece according to our budget and criteria"
    },
    {
      "id": "text-0105",
      "name": "Ramya Bitra",
      "rating": 5,
      "text": "Had a great experience at Krishna Jewellery Store during the sale period. Special thanks to Saicharan for helping me choose the best design. Very patient and friendly. Happy with my purchase."
    },
    {
      "id": "text-0106",
      "name": "Thirukkumaran Nagarajan",
      "rating": 5,
      "text": "Very nice collections and designs. Thanks to Sai Charan for wonderful experience"
    },
    {
      "id": "text-0107",
      "name": "shalvi bhatnagar",
      "rating": 5,
      "text": "Took a choker Ch moghulia was polite and good at sales"
    },
    {
      "id": "text-0108",
      "name": "tooba banday",
      "rating": 5,
      "text": "Had a great experience at Krishna Pearls. The staff was very courteous and helpful throughout my visit. A special mention to Satish—he was extremely attentive, knowledgeable, and made the whole shopping experience smooth and enjoyable. Highly recommend this place for both quality products and excellent customer service!"
    },
    {
      "id": "text-0109",
      "name": "Samrah Sheikh",
      "rating": 5,
      "text": "Best assistance by M. Satish"
    },
    {
      "id": "text-0110",
      "name": "Vino Geoffrey",
      "rating": 5,
      "text": "Prasad was really good, nice customer service"
    },
    {
      "id": "text-0111",
      "name": "Harika Rao",
      "rating": 5,
      "text": "Kalyan was really helpful since the first time i spoke with him. He has helped us a lot during our purchase"
    },
    {
      "id": "text-0112",
      "name": "L Narayanan",
      "rating": 5,
      "text": "Kalyan helped us a lot"
    },
    {
      "id": "text-0113",
      "name": "saranya saranyan",
      "rating": 5,
      "text": "Recently I visited krishna pearls. I had a wonderful experience, really liked all the collections, sales persons Sai Charan and Aravind have shown all the collections with patience....so do visit and you people will also experience the same...."
    },
    {
      "id": "text-0115",
      "name": "CVS SASTRY",
      "rating": 5,
      "text": "Sai Charan I am delighted to have the interactions with utmost satisfaction. Being first customer of the day, discounts is also offered. Would like to visit again"
    },
    {
      "id": "text-0116",
      "name": "Vaishli Jagatap",
      "rating": 5,
      "text": "Harishraj nice service"
    },
    {
      "id": "text-0117",
      "name": "Shashank Kartha",
      "rating": 5,
      "text": "They have an excellent collection set to browse through. Mogulaiah gave an excellent service throughout our time here. He took his time explaining about the different kinds of pearls as well as patiently showed us the variety of collections. Kudos and keep up the great service!!"
    },
    {
      "id": "text-0118",
      "name": "Krishnan Venkatsubramanian",
      "rating": 5,
      "text": "Great service. Ask for discounts. A Kalyan, our sales agent did a great job."
    },
    {
      "id": "text-0119",
      "name": "subhendu patnaik",
      "rating": 5,
      "text": "Mr sai Charan and Mr Santosh excellent marketing personals.They guided us through the sopping very friendly"
    },
    {
      "id": "text-0120",
      "name": "Pasham Parameshwar",
      "rating": 5,
      "text": "We purchased pearl set at Ramesh table. It's really nice experience and we are happy with polite recieving Thank you"
    },
    {
      "id": "text-0121",
      "name": "Arun bableshwar",
      "rating": 5,
      "text": "Mr saicharan sales person was very good, he showed variety of pearls and necklaces"
    },
    {
      "id": "text-0122",
      "name": "Kedarnath",
      "rating": 5,
      "text": "It was s very good experience with Mr A KALYAN Sir for his salesmanship. Hope he will bring your shop to more & more visitors. Regards."
    },
    {
      "id": "text-0123",
      "name": "David Nayagam",
      "rating": 5,
      "text": "Excellent Customer service with like minded suggestions with kindness. Crown Mr Mogulaiah. Amazing staff!"
    },
    {
      "id": "text-0124",
      "name": "Kavya Mohan",
      "rating": 5,
      "text": "This is my third visit to the store and I’m completely satisfied. Mogulaiah was the one who attended us. He was excellent in his service and patience. We had an amazing customer experience. Collection was also amazing. Surely will be visiting again!"
    },
    {
      "id": "text-0125",
      "name": "Gita Nath",
      "rating": 5,
      "text": "Mr Sai Charan was Very pleasant and cooperative. We could make our purchase very efficiently."
    },
    {
      "id": "text-0126",
      "name": "Mayank Chauhan",
      "rating": 5,
      "text": "They have very good collection. Sai Charan helped us with selection"
    },
    {
      "id": "text-0127",
      "name": "Stitha Pragna",
      "rating": 5,
      "text": "Excellent collection. Mr Rajesh was helpful in guiding us during selection"
    },
    {
      "id": "text-0128",
      "name": "nagasri katukuri",
      "rating": 5,
      "text": "Very Good experience with Sai Charan As he showed Our Exact requirement, thank you Krishna Pearls"
    },
    {
      "id": "text-0129",
      "name": "Aishwarya Shekhawat",
      "rating": 5,
      "text": "Amazing collection. I am happy to find a beautiful piece.. thanks to Jagannath Reddy. Will visit soon again :)"
    },
    {
      "id": "text-0130",
      "name": "Jaiwanth Mandava",
      "rating": 5,
      "text": "Plenty of options for chains and pearls. Very happy with the Sai Charan with his assistance for our purchase"
    },
    {
      "id": "text-0131",
      "name": "Lalitha Reddy",
      "rating": 5,
      "text": "The collection is amazing Jagannath was patient and has excellent knowledge regarding the varieties"
    },
    {
      "id": "text-0132",
      "name": "Lakshmi Radhakrishnan",
      "rating": 5,
      "text": "We had visited Krishna pearls recently and had a good experience overall. The staff is very helpful in the selection process. Overall I would rate it as a great place to visit."
    },
    {
      "id": "text-0133",
      "name": "Amrutha Garikapati",
      "rating": 5,
      "text": "Vast number of designs . Good service from staff. Sai charan (staff) is very helpful."
    },
    {
      "id": "text-0134",
      "name": "Samridhi Jaiswal",
      "rating": 5,
      "text": "M Jaganath Reddy was extremely helpful and helped me buy the best pearls x"
    },
    {
      "id": "text-0135",
      "name": "Jagan Rao N",
      "rating": 5,
      "text": "Wide range of designs in pearls jewellery. Mr Ramesh has shown us many designs with patience."
    },
    {
      "id": "text-0136",
      "name": "Poonam Thakkar",
      "rating": 5,
      "text": "Ramesh provided excellent service and was quick to show me exactly what I was looking for. Super pleased"
    },
    {
      "id": "text-0137",
      "name": "Juan Manuel Rodriguez",
      "rating": 5,
      "text": "Excellent attention to customer questions. Thank you Ramesh!"
    },
    {
      "id": "text-0138",
      "name": "Saby J",
      "rating": 5,
      "text": "Great place to buy pearl jewellery. Moguliah was great in showing me all the varieties. Definitely great place to buy genuine pearls"
    },
    {
      "id": "text-0139",
      "name": "abhishek patil",
      "rating": 5,
      "text": "Thank you Jagannath reddy for helping to buy perl jewellery."
    },
    {
      "id": "text-0140",
      "name": "Chandana M",
      "rating": 5,
      "text": "Kalyan - Good job 👏"
    },
    {
      "id": "text-0141",
      "name": "Akshay",
      "rating": 4,
      "text": "Kalyan is going great job 👍"
    },
    {
      "id": "text-0142",
      "name": "Jeya Prabhu",
      "rating": 5,
      "text": "Had a wonderful experience, mr kalyan had given a very good customer support"
    },
    {
      "id": "text-0143",
      "name": "Neha choudhary",
      "rating": 5,
      "text": "Great collection and great experience shopping. The staffs are really very pleasant and Raghavendra helped us choose some amazing pieces. Wonderful shopping experience! ❤️"
    },
    {
      "id": "text-0144",
      "name": "Krishna Paul",
      "rating": 5,
      "text": "Execellent service by Moglaiya..very nice"
    },
    {
      "id": "text-0145",
      "name": "deepika kande",
      "rating": 5,
      "text": "Excellent customer service provided always Thank you Sai Charan garu"
    },
    {
      "id": "text-0146",
      "name": "sasikiran Thummalapenta",
      "rating": 5,
      "text": "Hospitality is very nice. Sachin and jagannath have good knowledge and understanding the customer requirement. Thank you for your service."
    },
    {
      "id": "text-0147",
      "name": "INDUJA REDDY",
      "rating": 5,
      "text": "Nice pearls collection"
    },
    {
      "id": "text-0148",
      "name": "Viswanatha Vaddi",
      "rating": 5,
      "text": "Amazing pearl collection. Representative Jaganath reddy guided me through their collection well and assisted me with the exact seti was looking to purchase."
    },
    {
      "id": "text-0149",
      "name": "latha koganti",
      "rating": 5,
      "text": "Model are too good. Ramesh service is excellent 👌"
    },
    {
      "id": "text-0150",
      "name": "Subrata Panda",
      "rating": 5,
      "text": "Jaganath Reddy helped us selecting the jewelry. Well behaved and understood what we were looking for."
    },
    {
      "id": "text-0151",
      "name": "Jyotsna Nandam",
      "rating": 5,
      "text": "Very good service by Mogulaiah."
    },
    {
      "id": "text-0152",
      "name": "kritika sinha",
      "rating": 5,
      "text": "Jagarnath is a true gem, he helped me purchase & showed what exactly I was looking for!!!! All the best to him 😇😇😇😇"
    },
    {
      "id": "text-0153",
      "name": "Aditi Chopra",
      "rating": 5,
      "text": "Kalyan was very helpful and patient"
    },
    {
      "id": "text-0154",
      "name": "Sreedevi Pyla",
      "rating": 5,
      "text": "Had a very good shopping experience at Krishna house of silver . Kalyan was very courteous and knowledgeable about the collection . Thank you Kalyan"
    },
    {
      "id": "text-0155",
      "name": "Mrunal Kalambe",
      "rating": 5,
      "text": "Had a great experience and good collection. Nice service provide by Mr. Ragvendra."
    },
    {
      "id": "text-0157",
      "name": "swati deshpande",
      "rating": 5,
      "text": "Good service by jaganNath"
    },
    {
      "id": "text-0158",
      "name": "Gopi Krishna Reddy",
      "rating": 4,
      "text": "Great designs, very intricate, appreciate Mr G Praveen for his patience"
    },
    {
      "id": "text-0159",
      "name": "Aruna Singh",
      "rating": 5,
      "text": "It was a great experience and Mr.Kalyan was very humble and was ready to show many designs."
    },
    {
      "id": "text-0160",
      "name": "Payal Patel",
      "rating": 5,
      "text": "Loved the shopping. Special mention to Raghavendra for his service and how he explained all details"
    },
    {
      "id": "text-0161",
      "name": "Kiran Matta",
      "rating": 5,
      "text": "Amit Agarwal is helpful and guided us all through."
    },
    {
      "id": "text-0162",
      "name": "Surabhi Rastogi",
      "rating": 5,
      "text": "Amit Agarwal was very hospitable and attended to us really well. It was a pleasure shopping here. I would recommend this place"
    },
    {
      "id": "text-0163",
      "name": "shashi kumar",
      "rating": 5,
      "text": "Excellent collection!! Right place for pearl selection… thank you Amit Agarwal for your wonderful service!!"
    },
    {
      "id": "text-0164",
      "name": "Debleena Mukherjee",
      "rating": 5,
      "text": "We came to the shop looking for pearls.Mr. J Ramesh was very patient with us, showing us all types, ranges and explaining everything. He helped us to select necklace, earrings and bracelets. It was a good experience. Thank you 😊"
    },
    {
      "id": "text-0167",
      "name": "Ankit Kamat",
      "rating": 5,
      "text": "Good experience, Mr. Ramesh helped us with the right options based on our choice of pearls. Various options/ varieties are available."
    },
    {
      "id": "text-0168",
      "name": "Swati G",
      "rating": 5,
      "text": "They have excellent designs in the pearls sections. Mr Sai Charan was extremely friendly and respectful, showed us everything with a lot of patience. Extremely satisfied with the customer service and the purchase."
    },
    {
      "id": "text-0169",
      "name": "Anand Rai",
      "rating": 5,
      "text": "Good experience with kalyan @ aravind nice supporte"
    },
    {
      "id": "text-0170",
      "name": "Kake Sheshikumar",
      "rating": 5,
      "text": "M jagannath Aravindh"
    },
    {
      "id": "text-0171",
      "name": "Madhuvani",
      "rating": 5,
      "text": "Jaganath reddy has shown the pearls collection very well ."
    },
    {
      "id": "text-0172",
      "name": "C NAMBI",
      "rating": 4,
      "text": "Good Collection & Prices are very good & Sales Manager Mr Mohulaliah showed us all the Collection & Convinced Us We Purchased"
    },
    {
      "id": "text-0173",
      "name": "Aarambh Keshri",
      "rating": 5,
      "text": "Had a great experience. Jogu was a good host"
    },
    {
      "id": "text-0175",
      "name": "gokul boopathi",
      "rating": 5,
      "text": "Had a wonderful experience.. Jagan showed us multiple collections with great patience and really useful suggestions that helped us narrow down things better. Ended up buying a necklace, earing and a bracelet at a reasonable price. Will recommend this place."
    },
    {
      "id": "text-0176",
      "name": "Jeffin Julius",
      "rating": 5,
      "text": "Had a wonderful experience at the pearl store today. The overall collection was elegant, premium, and beautifully designed, with a great variety of timeless and modern styles to choose from. What truly made the experience special was the excellent customer service. We were first attended by Amit Agrawal, who was extremely warm, patient, and knowledgeable. He helped us explore the designs with great attention and made the entire selection process smooth and enjoyable. A special mention to the floor manager, Pasha, as well, who ensured everything was handled seamlessly and made us feel truly valued as customers. From the service to the stunning designs, the entire experience was exceptional. Highly recommend this store to anyone looking for beautiful pearl jewellery and top-notch hospitality."
    },
    {
      "id": "text-0177",
      "name": "Pooja Bharali",
      "rating": 5,
      "text": "We were guided by Mr. J. Ramesh and Mr. Praveer. They were very helpful. Would definitely recommend Krishna Jewellers."
    },
    {
      "id": "text-0178",
      "name": "Aparna Sundari",
      "rating": 5,
      "text": "Y Sai Charan and Rama Devi were really helpful and they showed interested in what kind of jewellery I want. I wasn’t prepared to spend a lot of money and they showed within my budget."
    },
    {
      "id": "text-0179",
      "name": "nidhi maheshwari",
      "rating": 5,
      "text": "Sai charan was very coperarive and showed around the different jewellery deaigns with patience Thanks"
    },
    {
      "id": "text-0180",
      "name": "Srinivasa Rao Pillarisetti",
      "rating": 5,
      "text": "Jogu Krishna and Jaganath have done great job in demonstrating the products."
    },
    {
      "id": "text-0181",
      "name": "Urvi Gopani",
      "rating": 5,
      "text": "Thank you Mr Jagannath sir.."
    },
    {
      "id": "text-0182",
      "name": "Karan Jaiswal",
      "rating": 5,
      "text": "beautiful collection and Mr. Sai Charan ji helped us through the selected very well. Thanks"
    },
    {
      "id": "text-0183",
      "name": "atia imtiaz",
      "rating": 5,
      "text": "Had a great experience in krishna pearls. Sai charan, Sonia and Durga were really helpful in choosing the jewellery. Huge variety in pearls gold dimonds and silver."
    },
    {
      "id": "text-0184",
      "name": "Sasi Veena Devarapalli",
      "rating": 5,
      "text": "Had a great experience at Krishna Pearls! The service by Sai Charan was excellent very helpful and attentive throughout. The collection was also impressive, with some really beautiful designs. Definitely worth a visit!"
    },
    {
      "id": "text-0185",
      "name": "Chandrima Chandrima",
      "rating": 5,
      "text": "Very cordial and friendly and impressive service by Y Sai Charan. Each and every time whenever I enter the Krishna Pearl Store always feel good vive. Thank you Sai."
    },
    {
      "id": "text-0186",
      "name": "rajeshwari patel",
      "rating": 5,
      "text": "Good service for Kalyan very good pantions"
    },
    {
      "id": "text-0187",
      "name": "Manjiri Karve",
      "rating": 5,
      "text": "Superb collection.Ramesh was very helpful and patiently showing us various designs…thanks for the lovely experience"
    },
    {
      "id": "text-0189",
      "name": "Shalini Roy",
      "rating": 5,
      "text": "Amazing experience at Krishna Pearls, Jublie Hills today. A special thanks to Kalyan, who helped us pick the perfect jewellery for our family and friends. Thank you !"
    },
    {
      "id": "text-0191",
      "name": "shruti khanna",
      "rating": 5,
      "text": "Great experience shopping for pearls! Y. Sai Charan and Sonia provided excellent customer service and were very helpful and friendly. Loved the collection—will definitely visit again with my parents."
    },
    {
      "id": "text-0192",
      "name": "Sizzle bear",
      "rating": 5,
      "text": "Amazing pearl collection.. helpful people.. Jaganath reddy helped a lot in our selection"
    },
    {
      "id": "text-0193",
      "name": "Anushka Verma",
      "rating": 5,
      "text": "Amazing in store experience, very patient and explained in detail. Absolutely great collection of pearls. Thanks to Mr Sai Charan, Durga and Santosh for their hospitality."
    },
    {
      "id": "text-0195",
      "name": "Mohammed Zohair",
      "rating": 5,
      "text": "It was a very good deal with M jaganath and arvind the staff was very honest and sincere"
    },
    {
      "id": "text-0196",
      "name": "Palakh Tuli",
      "rating": 5,
      "text": "Very nice experience! Mr. Mogulaiah showed us good designs and supported us throughout. Thankyou."
    },
    {
      "id": "text-0197",
      "name": "V. Raji Vasantham",
      "rating": 5,
      "text": "Nice collection and Mr Ramesh and Rama Lakshmi both are very cooperative and patience"
    },
    {
      "id": "text-0199",
      "name": "Suyash Sinha",
      "rating": 5,
      "text": "Sai Charan was a great representative. Good collections at store"
    },
    {
      "id": "text-0200",
      "name": "Samar Shaikh",
      "rating": 5,
      "text": "The experience was great! Ramesh was super helpful and warm."
    },
    {
      "id": "text-0201",
      "name": "UAHome YT",
      "rating": 5,
      "text": "Very nice collection in pearls . Good service by Mr . Sai chand and Ms Durga"
    },
    {
      "id": "text-0202",
      "name": "Gadusatla Harsha Kiran Reddy",
      "rating": 5,
      "text": "Had a good experience and specially Sales person Mr. Ramesh helped us a lot by showing multiple options according to our requirement . Good designs and good staff."
    },
    {
      "id": "text-0203",
      "name": "Prathap Rachamallu",
      "rating": 5,
      "text": "Great collection of jewelry, awesome support by Sai charan & Ramesh garu"
    },
    {
      "id": "text-0204",
      "name": "Ambrish Kanungo",
      "rating": 5,
      "text": "Thanks Y Sai Charan & Sonia for sharing a wide range of Pearls"
    },
    {
      "id": "text-0205",
      "name": "Ankita Chugh",
      "rating": 5,
      "text": "Fantastic collection and great service. Sai Charan and Sonia were very helpful"
    },
    {
      "id": "text-0206",
      "name": "Simhachalam Baratam",
      "rating": 5,
      "text": "Mr J Ramesh assigned is to show what we require. He did nice presentation and explained well about the ornaments. Finally we purchased one item with his best interaction and explanation."
    },
    {
      "id": "text-0207",
      "name": "sudha madisetti (Sudha)",
      "rating": 5,
      "text": "Jogu Krishnap Good sevice and good collection"
    },
    {
      "id": "text-0208",
      "name": "Swapna V",
      "rating": 5,
      "text": "Jogu krishna good service"
    },
    {
      "id": "text-0209",
      "name": "Risha Kaur",
      "rating": 5,
      "text": "Great service by Y SAI CHARAN."
    },
    {
      "id": "text-0210",
      "name": "Nikhil Chinnam",
      "rating": 5,
      "text": "Collection was amazing, Sai Charan was so patient while showing us. Will recommend for sure."
    },
    {
      "id": "text-0213",
      "name": "Neha Tiwari",
      "rating": 5,
      "text": "Mr. Mogulaiah gave us a great service 👏"
    },
    {
      "id": "text-0214",
      "name": "Aditi Shetty",
      "rating": 5,
      "text": "Had a great experience, they have variety of pearls collection and even in gold light weight they have amazing collection. The staff were very humble and cooperative. I was attended by Mogulaiah and Sonia ,both were great in showcasing different patterns and designs. Will recommend my relatives and friends.Thanks Krishna Pearls jewelers"
    },
    {
      "id": "text-0215",
      "name": "Venkat Ragahav",
      "rating": 5,
      "text": "Good service.. jogu krishna"
    },
    {
      "id": "text-0216",
      "name": "Meghna Rao",
      "rating": 5,
      "text": "Kalyan is amazing sales person. Very patient and creative. Helped us with very good service"
    },
    {
      "id": "text-0217",
      "name": "Padmini Vikrant Desai",
      "rating": 5,
      "text": "We had a great experience, Jogu Krishna showed us beautiful designers..👍"
    },
    {
      "id": "text-0218",
      "name": "SHRI RAM TRANSMISSIONS",
      "rating": 5,
      "text": "Best place for pearls...don't get bluffed with the people manipulating you are charminar. Staff was very best and helpful. Especially Mr. Jogu krishna... thanks"
    },
    {
      "id": "text-0219",
      "name": "Sudagar Singh",
      "rating": 5,
      "text": "Mr J. Ramesh was awesome person helped me to choose the best for my grand daughter Thq"
    },
    {
      "id": "text-0220",
      "name": "Chakradhararao Seepana",
      "rating": 4,
      "text": "Nice Pearls Collection - Good interactions with Mogulaiah to show the multiple models"
    },
    {
      "id": "text-0221",
      "name": "tanusree nag",
      "rating": 5,
      "text": "Wonderful collection with a wide variety to choose from. Jogu Krishna assisted us so warmly and was very soft-spoken and courteous."
    },
    {
      "id": "text-0222",
      "name": "Souvik Nag",
      "rating": 5,
      "text": "Very nice and reasonable place for authentic pearls. Mr. Jogu Ganesh is a very good staff member and very helpful."
    },
    {
      "id": "text-0223",
      "name": "Roshni Roy",
      "rating": 5,
      "text": "Overall a very good experience and various collections available here. Must visit!"
    },
    {
      "id": "text-0224",
      "name": "Sujatha I",
      "rating": 5,
      "text": "Kasinadh and Kalyan nice receiving and good service"
    },
    {
      "id": "text-0225",
      "name": "Angapparaj K",
      "rating": 5,
      "text": "Jogu Krishna and Sonia Brahma's response were excellent during the shopping. They have cooperated and offered all kind of display without any fuss for all our queries. We are extremely satisfied with the deal. Nice and versatile pearl collections in the shop. Surely, we look forward to shopping here again due to the generous behaviour of staffs and beautiful varieties of pearl"
    },
    {
      "id": "text-0228",
      "name": "Ashwini Gopal",
      "rating": 5,
      "text": "Jagannath was very helpful in select9ng pearls ."
    },
    {
      "id": "text-0229",
      "name": "reddy manoher",
      "rating": 5,
      "text": "Had a great experience shopping at Krishna Jewellery Jublihills branch, very unique pieces with elegant craftsmanship. Special thanks to Vinod and Swamy for great customer service."
    },
    {
      "id": "text-0231",
      "name": "Sanjeev Kumar",
      "rating": 5,
      "text": "A great place to purchase pearls — they have an amazing collection. Kalyan was very helpful and made the whole experience smooth and enjoyable."
    },
    {
      "id": "text-0232",
      "name": "Renu Atri",
      "rating": 5,
      "text": "Very good service by Mr jagarnath reddy. Quick response. Thank you"
    },
    {
      "id": "text-0233",
      "name": "Debashis Majumder",
      "rating": 5,
      "text": "Very good experience with kalyan"
    },
    {
      "id": "text-0234",
      "name": "Atul Gautam",
      "rating": 5,
      "text": "Great collection and very helpful staff."
    },
    {
      "id": "text-0235",
      "name": "Vikas G D",
      "rating": 5,
      "text": "Ch Mogulaiah supported really well with full patience. Entire Krishna experience was amazing"
    },
    {
      "id": "text-0236",
      "name": "Supriya Nandamuri",
      "rating": 5,
      "text": "Mr. Sai Charan & Ms. Sonia had given the best service, by making my work easy."
    },
    {
      "id": "text-0237",
      "name": "Pamarty Padma",
      "rating": 5,
      "text": "Sai Charan had showed very patiently at the last hour of closing, beautiful understood our choice and reverted with the collection"
    },
    {
      "id": "text-0238",
      "name": "Khushboo Mavi",
      "rating": 5,
      "text": "It was wonderful experience at the store. Mr.Kalyan and other staff members were very kind and helpful in my purchase. I selected a beautiful pearl neck piece and I will definitely visit again for my next purchase."
    },
    {
      "id": "text-0239",
      "name": "Geetanjali Thakur",
      "rating": 5,
      "text": "M Jaganath did great job..highly recommend"
    },
    {
      "id": "text-0240",
      "name": "INDUMATHI AYYASWAMY",
      "rating": 5,
      "text": "Unfortunately i found krishna jewellery particularly pearls, wow am amazed!! Extra ordinary collections... I loved it"
    },
    {
      "id": "text-0241",
      "name": "Jaydeep Gubba",
      "rating": 5,
      "text": "Great collection, and great service. Satish and krish showed an excellent collection and service"
    },
    {
      "id": "text-0242",
      "name": "Ѕαмαяριтα В",
      "rating": 5,
      "text": "Such an wonderful service by the stuff sonia and sai charan . Great service ."
    },
    {
      "id": "text-0243",
      "name": "Swaminathan",
      "rating": 5,
      "text": "Excellent store. I worked with Mr Vipin Kumar at sales. Very courteous and friendly staff. They also answered all my questions well. Overall a great experience. I will comeback again for my needs in future."
    },
    {
      "id": "text-0244",
      "name": "SRUTHISHREE ANAND",
      "rating": 5,
      "text": "Good Service, staff were attentive and patient."
    },
    {
      "id": "text-0246",
      "name": "utsa bhattacharyya",
      "rating": 5,
      "text": "Excellent collection of pearl jewellery at affordable price and great hospitality by Mr. Ramesh. Great purchase!"
    },
    {
      "id": "text-0247",
      "name": "Sayan Dhara",
      "rating": 5,
      "text": "Satish was very helpful. Thank you."
    },
    {
      "id": "text-0249",
      "name": "sagar g h",
      "rating": 5,
      "text": "Excellent service, genuine pearls, and beautiful designs. Mr. Jaganatha Reddy is very helpful, trustworthy, and ensures a pleasant shopping experience."
    },
    {
      "id": "text-0250",
      "name": "SSurabhi",
      "rating": 5,
      "text": "Great collection, Mogulaiah helped us very well and we got our favourite pieces!"
    },
    {
      "id": "text-0251",
      "name": "Angela Kemnitzer",
      "rating": 5,
      "text": "Thank you Jaganath for helping us today"
    },
    {
      "id": "text-0253",
      "name": "Madhavi Valluri",
      "rating": 5,
      "text": "Thanks to Satish and Sonia and Roshan for your lovely support"
    },
    {
      "id": "text-0254",
      "name": "sarada surapaneni",
      "rating": 5,
      "text": "J Ramesh assisted very well customer service was really good. Had lot of designs to choose"
    },
    {
      "id": "text-0255",
      "name": "Deepa .Suresh",
      "rating": 5,
      "text": "Superb experience, special thanks to Mogulaiah to patiently show varieties and matching combinations that helped me select. Shop has great varieties"
    },
    {
      "id": "text-0256",
      "name": "Priya Padma",
      "rating": 5,
      "text": "Very well and polite staff The staff member J ramesh received us very warmly and showed each and every piece very patiently Happy with staff discipline and respect"
    },
    {
      "id": "text-0257",
      "name": "Radhi K",
      "rating": 5,
      "text": "M jaganath reddy helped in finding right product and receiving is very good"
    },
    {
      "id": "text-0258",
      "name": "Rajeshwari Poojari",
      "rating": 5,
      "text": "We had visited this place for the first time ,and had a comfortable and friendly experience, staff by name Jagannath was really good to us and showed us all the available best options .... We would definitely revisit this place ,and I would recommend other people too ..."
    },
    {
      "id": "text-0259",
      "name": "Beatriz",
      "rating": 5,
      "text": "Great attention and service. Y Sai Charan took the time to understand our needs and budget, and thoughtfully presented all the options we were looking for."
    },
    {
      "id": "text-0260",
      "name": "Sivaranjani",
      "rating": 5,
      "text": "We visited Krishna jewellery for buying pearl jewellery as a souvenir. They had extensive collection on pearls and gem stone jewellery. The staff Mogulaiah was very kind and patient to explain us about various qualities and the designs. Highly recommend this place."
    },
    {
      "id": "text-0261",
      "name": "am c",
      "rating": 5,
      "text": "Great experience! Jaganath was very helpful!"
    },
    {
      "id": "text-0262",
      "name": "swetha chavali",
      "rating": 5,
      "text": "Wide variety of pearls in all ranges and perfect for gifting. The staff is very welcoming and helped with multiple options to fit our budget. Jagannath Reddy was very polite and helped us through the purchase with great energy and patience. Would like to visit the store again!!"
    },
    {
      "id": "text-0263",
      "name": "A R",
      "rating": 5,
      "text": "Helpful & informative staff. Y Sai Charan waa knowledgable, understood our tastes & did not push, showing the appropriate product & letting us make the decision. All the staff members were uniformly pleasant & helpful, even in counters where we were just browsing. A good place to visit for your shopping in hyderabad."
    },
    {
      "id": "text-0264",
      "name": "Jarne Sikkens",
      "rating": 5,
      "text": "Felt super welcome, Jaganath was super helpful and understood what I wanted I wanted perfectly. Super nice store and super many options"
    },
    {
      "id": "text-0266",
      "name": "Ritushree Ghosh",
      "rating": 5,
      "text": "Great experience overall. A must-visit place. M Jaganath was extremely helpful and guided me well with the selection."
    },
    {
      "id": "text-0267",
      "name": "Madhavi G",
      "rating": 5,
      "text": "Salesman Ramesh garu was very patience in showing me the stuff I wanted in pearls and also showed many varieties with great discounts and a friendly person. Really appreciate his service."
    },
    {
      "id": "text-0271",
      "name": "Arpan Karwal",
      "rating": 5,
      "text": "⭐⭐⭐⭐⭐ I recently bought a pair of earrings from Krishna Jewellers in Hyderabad and had a fantastic experience. The designs were elegant and beautifully crafted, with great attention to detail. It was hard to choose because they have such a lovely collection! The staff was very patient and helpful, taking the time to show different options and explain everything clearly. I’m extremely happy with my earrings — they’re classy and perfect for both traditional and formal wear. Highly recommend Krishna Jewellers for quality jewellery and excellent customer service. I will definitely shop here again!"
    },
    {
      "id": "text-0272",
      "name": "Karan Kapoor",
      "rating": 5,
      "text": "Amazing service from Ramesh"
    },
    {
      "id": "text-0274",
      "name": "Ragalatha Mallipeddi",
      "rating": 5,
      "text": "Ramesh service is good"
    },
    {
      "id": "text-0275",
      "name": "Deepak Arora",
      "rating": 5,
      "text": "M Jaganath was very sweet and did a great job with patience. He was very supportive, had a great experience."
    },
    {
      "id": "text-0276",
      "name": "Suzette Peltier",
      "rating": 5,
      "text": "Very attentive help; always with a smile. Sonia was especially helpful."
    },
    {
      "id": "text-0278",
      "name": "Sathish Barani",
      "rating": 5,
      "text": "Had good shopping experience. And Mr. M. Jaganath showed all the things and clearly explained."
    },
    {
      "id": "text-0279",
      "name": "Chandrababu naidu Rayavaram",
      "rating": 5,
      "text": "Very good collection"
    },
    {
      "id": "text-0280",
      "name": "rukhsar parveen",
      "rating": 5,
      "text": "Mr Ramesh is well behaved staff of Krishna Jewellers. Understand the requirement and show the pears jewellery accordingly. He is polite and professional."
    },
    {
      "id": "text-0281",
      "name": "Munichandra G",
      "rating": 5,
      "text": "Variety designs are available , customer interaction also really good Sales person : Ramesh"
    },
    {
      "id": "text-0282",
      "name": "Balaji Ganesh Dommeti",
      "rating": 5,
      "text": "Service is very good. Mr jagannath received and showed me different designs and explained very nice ."
    },
    {
      "id": "text-0283",
      "name": "A Bose",
      "rating": 5,
      "text": "Satish M. ji is very polite and guided as per requirement of us within a short timeframe. Thanks"
    },
    {
      "id": "text-0285",
      "name": "Arijit Bhattacharyya",
      "rating": 5,
      "text": "Had a nice shopping experience with rep. sai charan. He was helpful in the buying experience. Worth visiting to buy all kinds of jewellery."
    },
    {
      "id": "text-0287",
      "name": "Anwesha Mandal",
      "rating": 5,
      "text": "Jagannath was very helpful and I didn’t have any issue choosing the perfect pearl set"
    },
    {
      "id": "text-0288",
      "name": "Maja Bumberák",
      "rating": 5,
      "text": "Yozr shop is amazing and your staff is nice. Sai Charan gave us wobderful treatment. I recommend this shop to everyone."
    },
    {
      "id": "text-0289",
      "name": "J Cynthia Samuel",
      "rating": 5,
      "text": "Very nice collections. Nice interaction with the customer."
    },
    {
      "id": "text-0290",
      "name": "Sam",
      "rating": 5,
      "text": "We attended Pearl workshop at Kokapet branch for affordable and reasonable price. Everyone welcomed us warmly and explained Abt the work , types of pearls and how to know the difference between pearls. We get to take home pearl bracelet made by us , thank you for this wonderful experience."
    },
    {
      "id": "text-0291",
      "name": "Meghana Tandaboina",
      "rating": 5,
      "text": "Splendid experience shopping at Krishna Jewellers. Meenakshi always helps us and does a fabulous job in showing us some exquisite pieces. Highly recommend!"
    },
    {
      "id": "text-0292",
      "name": "Sumita Kundu",
      "rating": 5,
      "text": "J Ramesh and other staff were very courteous and helpful. Over all very good experience"
    },
    {
      "id": "text-0293",
      "name": "Kushi Shravan",
      "rating": 5,
      "text": "Mr Kashinath is very excellent person and Sathish also thank you"
    },
    {
      "id": "text-0294",
      "name": "Meghana Kiran",
      "rating": 5,
      "text": "The place is great! mr y sai chran sir helped us . It was great survice and great collection. Was a great experience overall"
    },
    {
      "id": "text-0295",
      "name": "0473_Akhila Reddy",
      "rating": 5,
      "text": "Vinod excellent servicing, great job"
    },
    {
      "id": "text-0296",
      "name": "Sanjit Kundu",
      "rating": 5,
      "text": "Nice and courteous staff Mr.Ramesh and lovely ambience, good experience"
    },
    {
      "id": "text-0297",
      "name": "RUTTALA LIKITHA",
      "rating": 4,
      "text": "Great designs and Mr. Sai charan has given us a great deal of service aswell as price."
    },
    {
      "id": "text-0298",
      "name": "S. Srinivasa Reddy Shanivarapu",
      "rating": 5,
      "text": "Good service to Laleppa & Raju. Good collections to Krishna jewellery & pearls"
    },
    {
      "id": "text-0299",
      "name": "Madhurya Bandyopadhyay",
      "rating": 5,
      "text": "Excellent service by Mr J Ramesh and team! Very knowledgeable about their products and extremely courteous."
    },
    {
      "id": "text-0300",
      "name": "Anuradha Sawant",
      "rating": 5,
      "text": "Good hospitality by Ramesh sir"
    },
    {
      "id": "text-0301",
      "name": "Harshitha Reddy",
      "rating": 5,
      "text": "I bought 2 pearl sets for me and my sister.Here they have very wide range of collection in pearls and also budget friendly.Staff are very patient.Special mention to the staff personnel named Sai Charan.Would definitely re-visit!!"
    },
    {
      "id": "text-0304",
      "name": "Kunal Boxi",
      "rating": 5,
      "text": "Jaganath was excellent in client handling. Good hospitality and variety in products.Ovaerall immensely satisfied"
    },
    {
      "id": "text-0305",
      "name": "R Harsha",
      "rating": 5,
      "text": "The hospitality offered is good and patiently showed around available products until satisfied .. Arvind and jaganath reddy helped and guided us choose perfect ones"
    },
    {
      "id": "text-0307",
      "name": "Simmren Bama Roy",
      "rating": 5,
      "text": "Very good and satisfied service by Mr. Jagannath"
    },
    {
      "id": "text-0308",
      "name": "Aakash Agrawal",
      "rating": 5,
      "text": "Sandhya Rani helped us a lot"
    },
    {
      "id": "text-0309",
      "name": "Varun Choudhary",
      "rating": 5,
      "text": "Ramesh was very helpful"
    },
    {
      "id": "text-0310",
      "name": "Arunima Lahiri",
      "rating": 5,
      "text": "Sai Charan is responsible for a very good experience. Arunima Lahiri"
    },
    {
      "id": "text-0311",
      "name": "Dr Hemraj Patel",
      "rating": 5,
      "text": "Very nice collection Very good guidance and support to us from Mr J Ramesh Sales Person. recommended for shopping of pearls"
    },
    {
      "id": "text-0313",
      "name": "kavitha baddam",
      "rating": 5,
      "text": "Showing with very patience and we all time want to go with Sandhya garu,thank you once again."
    },
    {
      "id": "text-0317",
      "name": "Mamta Sarda",
      "rating": 5,
      "text": "Loved the servuce and the jwellery"
    },
    {
      "id": "text-0318",
      "name": "Deep Jyoti Kalita",
      "rating": 5,
      "text": "Very good experience in Krishna Pearls. Mr Satish and Miss Sonia were extremely helpful."
    },
    {
      "id": "text-0319",
      "name": "A.Aftab Begum",
      "rating": 5,
      "text": "Really I satisfied the purchase With this shop Mr.Sai charan accompanied with us very friendly manar"
    },
    {
      "id": "text-0320",
      "name": "Jyothi Tella",
      "rating": 5,
      "text": "M jaganath, was very helpful & made our shopping experience a wonderful one! Will certainly come back again to shop here!"
    },
    {
      "id": "text-0321",
      "name": "Shaik Subhanbi",
      "rating": 5,
      "text": "Collection is good . Good service by Sunitha Maam."
    },
    {
      "id": "text-0322",
      "name": "Aparna Janagam",
      "rating": 5,
      "text": "M.jaganath reddy good receiving and gave concession.. happy shopping"
    },
    {
      "id": "text-0323",
      "name": "Venkat N",
      "rating": 5,
      "text": "Great pearl collection. Loved the quality and service. Jaganath and Satish were super helpful and gave great suggestions. Just visit if you’re looking to buy something special!!!"
    },
    {
      "id": "text-0324",
      "name": "Bhairavi Thakkar",
      "rating": 5,
      "text": "Excellent management, staff, jewellery and ambience. Sai Charan, Soniya and U Krish were were very good in their service and hospitality. Highly recommended to shop from this store."
    },
    {
      "id": "text-0325",
      "name": "Ramyashri Vinay",
      "rating": 5,
      "text": "The collection was great and pretty. Mr Ramesh wa very helpful and he showed us a variety of pretty pearls."
    },
    {
      "id": "text-0326",
      "name": "Soumya Sindhur",
      "rating": 5,
      "text": "Very good collection, will get light weight jewelry here.. even the staff is very cooperative ..Satish sir guided me about each and every details.. about pearls . Really happy to shop again.. ☺️"
    },
    {
      "id": "text-0327",
      "name": "Sridevi Mallipamula",
      "rating": 5,
      "text": "Colection is excellent Pavani Service is very good😊"
    },
    {
      "id": "text-0328",
      "name": "Pavan Samsani",
      "rating": 5,
      "text": "Quickly purchased gold ,Best models showed by Ramadevi"
    },
    {
      "id": "text-0329",
      "name": "Syed Khader",
      "rating": 5,
      "text": "We were served by Mr LOKNATH, an outstanding professional. I found him very cordial, refined and patient. We could get items of our choice due to his excellent advise. A highly accomplished salesman."
    },
    {
      "id": "text-0330",
      "name": "sandhya guduru",
      "rating": 5,
      "text": "Bheem suggested many types of models that suted me very well he is a good person"
    },
    {
      "id": "text-0331",
      "name": "Ranireddy Gaddam",
      "rating": 5,
      "text": "We have visited this store today . I met sales person named Bheem . He is very jovial and friendly person. We enjoyed talking with him. Thank you . Also I met Laxmi prasanna . She took care of us very well well."
    },
    {
      "id": "text-0332",
      "name": "Raghupathi Reddy",
      "rating": 5,
      "text": "Bheem has shown all models and suggested few models and helped to close deal quickly."
    },
    {
      "id": "text-0333",
      "name": "jyothi reddy",
      "rating": 5,
      "text": "Bheem has all models and is very humble."
    },
    {
      "id": "text-0334",
      "name": "Mita Sarkar",
      "rating": 5,
      "text": "Mr Kashinath was extremely polite and patient during our selection process. His service was extremely courteous and efficient. Extremely good variety at the store with polite staff."
    },
    {
      "id": "text-0335",
      "name": "aarzoo sharma",
      "rating": 5,
      "text": "Mr Sai Charan helped us select some exquisite pearls on our trip to Hyderabad. Wonderful store wonderful collection friendly staff"
    },
    {
      "id": "text-0336",
      "name": "Roaming World",
      "rating": 5,
      "text": "Very good Shop and chandu has taken very good care"
    },
    {
      "id": "text-0337",
      "name": "Pushkar Shinde",
      "rating": 4,
      "text": "Satish was good in marketing"
    },
    {
      "id": "text-0338",
      "name": "Smile Ekka",
      "rating": 5,
      "text": "Satish & S Santoshi were good."
    },
    {
      "id": "text-0339",
      "name": "G Rekha",
      "rating": 5,
      "text": "Good experience in Store,good service and the person Sarvesh service good, satisfied"
    },
    {
      "id": "text-0340",
      "name": "Pankaj Patil",
      "rating": 5,
      "text": "Awesome collection. Staff is really nice and they are helpful. They made it very easy for me to select the jwellery. Special thanks to Y sai charan and durga madam."
    },
    {
      "id": "text-0341",
      "name": "hima bulusu",
      "rating": 5,
      "text": "It was a good experience and the staff was extremely courteous and helped us select all our jewellery at our own pace. We were assisted really well by Satish and Jagannath. Durga was extremely helpful in trying out all the jewellery l."
    },
    {
      "id": "text-0342",
      "name": "Mohit Mall",
      "rating": 5,
      "text": "Mr Ramesh helped me a lot and gave me better suggestions, very good hospitality"
    },
    {
      "id": "text-0343",
      "name": "Dheeraj Krishna",
      "rating": 5,
      "text": "Had an amazing experience with buying pearls. The staffs are very welcoming and friendly, specially Mr. V Kashinath."
    },
    {
      "id": "text-0344",
      "name": "GOKUL REDDY",
      "rating": 5,
      "text": "It was a awesome experience in Krishna jewellery. Ramesh sir explain about everything in a clear way. He gave us the best price. Completely satisfied with Krishna jewellery ."
    },
    {
      "id": "text-0346",
      "name": "Navneet Negi",
      "rating": 5,
      "text": "Vet helpful and patience behaviour by staff Ramesh and arvind, goof quality of pearl products."
    },
    {
      "id": "text-0347",
      "name": "shanmugasundaram keerthana",
      "rating": 4,
      "text": "Good collections"
    },
    {
      "id": "text-0348",
      "name": "Aarti Mukherjee",
      "rating": 5,
      "text": "Sai Charan was polite and patient in showing the jewelry. Very nice collection too"
    },
    {
      "id": "text-0349",
      "name": "Sangeeta Arora",
      "rating": 5,
      "text": "Pasha service well-done"
    },
    {
      "id": "text-0350",
      "name": "Subhashree Mohapatra",
      "rating": 5,
      "text": "Me and my friend purchased and it was a fabolous experience. The staff, Sai Charan, Krish, Santoshi, Durga, were extremely helpful. Fussed over us and let us try as many things as we wanted. On top, the tea is fantastic. Recommended 100 percent."
    },
    {
      "id": "text-0351",
      "name": "Shravya M",
      "rating": 5,
      "text": "Bought all my wedding jewelry here, excellent collection."
    },
    {
      "id": "text-0352",
      "name": "Ashok Sharma",
      "rating": 5,
      "text": "Great shopping experience. Satish was excellent. This is the place to come for jewellery in Hyderabad."
    },
    {
      "id": "text-0353",
      "name": "Akash Mandava",
      "rating": 5,
      "text": "Easy to find what you need. Satish was great."
    },
    {
      "id": "text-0354",
      "name": "Sravya S",
      "rating": 5,
      "text": "Collection is amazing and staff is very welcoming. Sai Charan and Ashok has helped us to get to the finest and unique jewelry . Special thanks !"
    },
    {
      "id": "text-0356",
      "name": "meenakshi chhillar",
      "rating": 5,
      "text": "Ramesh did a fabulous job in showing all the varieties and we thoroughly enjoyed our shopping experience"
    },
    {
      "id": "text-0357",
      "name": "Annu Chaudhary",
      "rating": 5,
      "text": "I had a great experience at this jewelry store. The hospitality was really good, and the staff welcomed us very nicely. They were helpful throughout and offered us good-quality products. Overall, a pleasant and reliable place to shop for jewelry."
    },
    {
      "id": "text-0358",
      "name": "Navni Chowdhury",
      "rating": 5,
      "text": "Sri Lakshmi garu is good nd patience"
    },
    {
      "id": "text-0359",
      "name": "venugopal donepudi",
      "rating": 5,
      "text": "Ramadevi excellent service, good collection"
    },
    {
      "id": "text-0360",
      "name": "Midhunmohan sreesasthabhavan",
      "rating": 5,
      "text": "Had a good experience at Krishna Pearls. Thanks to Satish and whole team for the help."
    },
    {
      "id": "text-0361",
      "name": "Avinash Khandelwal",
      "rating": 5,
      "text": "Sai Charan good sales man"
    },
    {
      "id": "text-0362",
      "name": "Sravani Palaparthi",
      "rating": 5,
      "text": "Excellent service.!! The sales manager(Mr. Neelam) was patient, knowledgeable, and helped me to choose the perfect jewellery with good discount too. He was professional, knowledgeable. Friendly and attentive, about the designs and pricing where he explained clearly and helped me to select what I’m looking for. Exceptional customer Service! This was my third online purchase, and I must say I’m very impressed with the trust, quality of the product, and the overall process. Highly recommended..!!"
    },
    {
      "id": "text-0364",
      "name": "fatma mago",
      "rating": 5,
      "text": "Amazing shop for original pearls, thanks for satish for exceptional service"
    },
    {
      "id": "text-0365",
      "name": "Khadiga Abubaker",
      "rating": 5,
      "text": "Best shop ever 😍"
    },
    {
      "id": "text-0366",
      "name": "FERAS B",
      "rating": 5,
      "text": "Very nice and kind from ASHOK"
    },
    {
      "id": "text-0367",
      "name": "Mayte Zavaleta",
      "rating": 5,
      "text": "A wonderful experience, V Kashinath helped me select beautiful pieces I’ll cherish forever. A must stop."
    },
    {
      "id": "text-0370",
      "name": "Bhavana Sinha",
      "rating": 5,
      "text": "Mr Satish was very helpful and it was a great experience."
    },
    {
      "id": "text-0371",
      "name": "Shambhavi Srivastava",
      "rating": 5,
      "text": "I had a wonderful experience at Krishna house of silver. Mr. Ramesh and team have been very supportive in choosing the right product ! Thanks so much !"
    },
    {
      "id": "text-0372",
      "name": "sumveg malik",
      "rating": 5,
      "text": "I had a wonderful experience at Krishna Jewellers jublie hills centre.They have a beautiful collection with great designs for pearls at reasonable pricing. Special thanks to Mr. Sai Charan for his excellent service—he was patient, knowledgeable, and helped us choose the perfect piece. Truly impressed with the customer care and professionalism. Highly recommend this store!"
    },
    {
      "id": "text-0373",
      "name": "Phani Kumar",
      "rating": 5,
      "text": "Best service chandu. Very good customer service and very passionate on what he is doing"
    },
    {
      "id": "text-0374",
      "name": "Sridhar Nalluri",
      "rating": 5,
      "text": "Best service by Chandu"
    },
    {
      "id": "text-0375",
      "name": "Ryan Pais",
      "rating": 5,
      "text": "Great service by Sai Kiran"
    },
    {
      "id": "text-0376",
      "name": "Manisha Gupta",
      "rating": 5,
      "text": "Ramesh helped us with varous variety of jewelleries. Very good experience."
    },
    {
      "id": "text-0377",
      "name": "Bhavana Jennifer",
      "rating": 5,
      "text": "Sai charan was very helpful and kind while we were shopping here and gave us a good clarity about the product."
    },
    {
      "id": "text-0378",
      "name": "Harish Upadhya",
      "rating": 5,
      "text": "Had good shopping with Sai Charan"
    },
    {
      "id": "text-0379",
      "name": "Keerthi Jupally",
      "rating": 5,
      "text": "Nice designs and very good service by sai charan ."
    },
    {
      "id": "text-0380",
      "name": "George Asirvatharaj",
      "rating": 5,
      "text": "Kashinath is a very good customer representative"
    },
    {
      "id": "text-0381",
      "name": "Chandana chevva",
      "rating": 5,
      "text": "Good collection and the staff has shown the collection very patiently.."
    },
    {
      "id": "text-0382",
      "name": "sashi bhushan",
      "rating": 5,
      "text": "One of the Best Experience., Mr Sai Charan was very helpful in choosing the Best Combination., All the Best Krishna Jewellers for the Overall Smooth and Lovely Experience."
    },
    {
      "id": "text-0383",
      "name": "sandeep reddy",
      "rating": 5,
      "text": "Great shop with great service not very commercial which is the best part of this, Chandu asssted and supported well getting us the best price and better suggestions that’s helped!"
    },
    {
      "id": "text-0384",
      "name": "Prathyusha reddy",
      "rating": 5,
      "text": "Nice collection and designs Govind"
    },
    {
      "id": "text-0386",
      "name": "Sai Durga Prasad P",
      "rating": 5,
      "text": "Best pearls and gold showroom in Hyderabad. Best designs and Mrs. Sandya was very friendly. Good hospitality and well mannered employees."
    },
    {
      "id": "text-0387",
      "name": "namratha sandya",
      "rating": 5,
      "text": "Very good rating pearl and hospitality"
    },
    {
      "id": "text-0388",
      "name": "Zühal Meydan",
      "rating": 5,
      "text": "Great Service very friendly consultant Satish"
    },
    {
      "id": "text-0389",
      "name": "vishnu priya c.k",
      "rating": 5,
      "text": "Visited Krishna Pearls on my visit to Hyderabad. Really appreciate Mr.Praveen’s suggestions and patience with us to show us variety of designs! Thank you!"
    },
    {
      "id": "text-0391",
      "name": "Chaitanya Venkata",
      "rating": 5,
      "text": "Bharat has shown us multiple design and trendy ones as per our requests, He has lot of patience and nicely dealing with customers. I would recommend jubliee hills branch compared to Kondapur."
    },
    {
      "id": "text-0392",
      "name": "Shibani Rembersu",
      "rating": 5,
      "text": "G praveen happy about the service"
    },
    {
      "id": "text-0393",
      "name": "Raghu Games",
      "rating": 5,
      "text": "Very good service from Ramesh, nice collections"
    },
    {
      "id": "text-0395",
      "name": "Alur Chakrapani",
      "rating": 5,
      "text": "It was a pleasant experience and Ms Ramadevi was fantastic in her dealing and we closed a pretty good transaction"
    },
    {
      "id": "text-0396",
      "name": "Sridevi Reddy",
      "rating": 5,
      "text": "Good service to Laleppa & kranti , very nice in explaining about the product , good knowledge . Very nice hospitality."
    },
    {
      "id": "text-0397",
      "name": "Suyash Grover",
      "rating": 5,
      "text": "Very pleasant and seamless experience. Great assistance and service by Satish."
    },
    {
      "id": "text-0399",
      "name": "chairman zppkurnool",
      "rating": 5,
      "text": "M Satish & u krish"
    },
    {
      "id": "text-0400",
      "name": "Rishitha Kantheti",
      "rating": 5,
      "text": "Had a great experience! Sunitha was very helpful."
    },
    {
      "id": "text-0401",
      "name": "Rajib Roy",
      "rating": 5,
      "text": "Kashinath the Sales person deals with us and the experience was very good."
    },
    {
      "id": "text-0402",
      "name": "Hartej Singh",
      "rating": 5,
      "text": "It was an incredible experience and the whole team at Krishna Pearls is amazing ✨"
    },
    {
      "id": "text-0403",
      "name": "Gneya Gandhi",
      "rating": 5,
      "text": "Thank you for your service and patience Mr Ramesh. 😊"
    },
    {
      "id": "text-0404",
      "name": "Saipraveen Koduru",
      "rating": 5,
      "text": "Sales Person Ramesh has been excellent. Thank you"
    },
    {
      "id": "text-0405",
      "name": "Abhay Singh",
      "rating": 5,
      "text": "It was a nice experience. Mr. Ramesh who attended us was very patient and polite and helped me to buy the right thing. Will visit again in future."
    },
    {
      "id": "text-0406",
      "name": "Suganya Radhakrishnan",
      "rating": 5,
      "text": "We came to see wedding rings and silver jewellery . The collections are awesome and the sales persons are very hospitable. Special thanks to Mr. U Krish who was so patient and shown us all possible varieties of jewellery, until we are happy 😁"
    },
    {
      "id": "text-0407",
      "name": "Sivan kumar B",
      "rating": 5,
      "text": "They have a very good collection of pearls. J Ramesh’s service was great"
    },
    {
      "id": "text-0408",
      "name": "SIVARAMAKRISHNAN P",
      "rating": 5,
      "text": "Good service from G Praveen kumar"
    },
    {
      "id": "text-0409",
      "name": "Neha Khatanhar",
      "rating": 5,
      "text": "Good variety. M Satish n S Santoshi Mam were very uselful. Showed with dedication . Must visit store"
    },
    {
      "id": "text-0410",
      "name": "Padma Ved",
      "rating": 5,
      "text": "G.Praveen kumar has shown us the best pearl chain models."
    },
    {
      "id": "text-0411",
      "name": "Nandhi Ravindra",
      "rating": 5,
      "text": "Ramesh is good made us to select what is required."
    },
    {
      "id": "text-0412",
      "name": "Sudhan Dhakshneswaran",
      "rating": 5,
      "text": "Best pearls with best price. Thanks to Mr.Sathish for the wonderful service"
    },
    {
      "id": "text-0414",
      "name": "abhishek v",
      "rating": 5,
      "text": "The place has a really good collection and good service ,Pasha supported us in the selection and we had a very good experience"
    },
    {
      "id": "text-0416",
      "name": "Jerin Varghese",
      "rating": 5,
      "text": "Came to buy a gift for mum. Great service by Praveen Kumar. Keep it up!"
    },
    {
      "id": "text-0417",
      "name": "Parnash Shukla",
      "rating": 5,
      "text": "G Praveen Kumar"
    },
    {
      "id": "text-0418",
      "name": "LAKSHMI BALAKRISHNAN",
      "rating": 5,
      "text": "Had a great time in the shop.Thank you M Jagannath and Krish for the warm welcome and the great customer service."
    },
    {
      "id": "text-0419",
      "name": "Pradeep Agrawal",
      "rating": 5,
      "text": "⭐⭐⭐⭐⭐ Excellent Experience at Sri Krishna Jewellers, Hyderabad! I recently visited Sri Krishna Jewellers in Hyderabad and had a fantastic experience. Their selection of traditional and contemporary pieces is truly exceptional, offering something beautiful for every occasion. What really set this visit apart was the outstanding service provided by Mr. J Ramesh. He is an absolute professional—knowledgeable, patient, and genuinely committed to helping me find exactly what I was looking for. He took the time to explain the various options without ever making me feel rushed. If you are planning to shop here, I highly recommend seeking out Mr. Ramesh for a smooth, pleasant, and highly personalized experience. Five stars for the beautiful jewelry and their wonderfu"
    },
    {
      "id": "text-0420",
      "name": "Ambareshwaram Rapolu",
      "rating": 5,
      "text": "Awesome hospitality good collaboration with Satesh and awesome quality and collections"
    },
    {
      "id": "text-0421",
      "name": "Saritha Reddy",
      "rating": 5,
      "text": "Good collection mahalakshmi’s service is good"
    },
    {
      "id": "text-0422",
      "name": "Anitha Reddy",
      "rating": 5,
      "text": "Good collection & Mahalakshmi service is good"
    },
    {
      "id": "text-0423",
      "name": "Archana Immaneni",
      "rating": 5,
      "text": "Good collection in nakshi and diamonds. Lot of people to help around. Bharath had patiently shown lot of models. Must visit if you like unique models."
    },
    {
      "id": "text-0424",
      "name": "Meg B",
      "rating": 5,
      "text": "Thank you Rohith for showing us the collection and patiently taking us through the trial and options. We appreciate the service and the items purchased were great"
    },
    {
      "id": "text-0425",
      "name": "RAKESH BABU NALLAMOTHU",
      "rating": 5,
      "text": "Awesome experience and numerous designs and models displayed by Mr.M Jagannath and Kasinath Both helped us in finding best pearl set with amazing affordable price"
    },
    {
      "id": "text-0426",
      "name": "Shilpa Vurukala",
      "rating": 5,
      "text": "Very great service by Bharat"
    },
    {
      "id": "text-0427",
      "name": "Samya Gupta",
      "rating": 5,
      "text": "Excellent collection.Good service by G. Praveen Kumar."
    },
    {
      "id": "text-0428",
      "name": "Madhavi Nadella",
      "rating": 5,
      "text": "Laleppa good service"
    },
    {
      "id": "text-0429",
      "name": "Sasi Kala",
      "rating": 5,
      "text": "Mr. Rohit Sales executive"
    },
    {
      "id": "text-0430",
      "name": "Balaji Sanjeevi",
      "rating": 5,
      "text": "Kashinath was so supportive and showed multiple designs. Overall great experience. Collections are also too good"
    },
    {
      "id": "text-0431",
      "name": "Padma Bujji",
      "rating": 5,
      "text": "Laleppa exlent services &Good collection for Krishna jewels"
    },
    {
      "id": "text-0432",
      "name": "Dr Akash Grampurohit",
      "rating": 5,
      "text": "Mr Rohit and Mr Satish helped us with extra care to select the Jwellary of our choice ."
    },
    {
      "id": "text-0433",
      "name": "rajeev kumar",
      "rating": 5,
      "text": "T Rohit is very nice and showed good communication skills"
    },
    {
      "id": "text-0435",
      "name": "devaki sonawala",
      "rating": 5,
      "text": "Krishna pearls has good variety and sales people are good too. Satish and kanaka durga were extremely helpful in helping us choose pearl jewellery"
    },
    {
      "id": "text-0436",
      "name": "Ar Anuja Shinde",
      "rating": 4,
      "text": "It was wonderful experience with kashinath ji. Very nice pearl jewellery collection and knowledge."
    },
    {
      "id": "text-0437",
      "name": "Gulzar Wallani",
      "rating": 5,
      "text": "Had a good experience , Jagannath was helpful .. thank you"
    },
    {
      "id": "text-0438",
      "name": "PHY17",
      "rating": 5,
      "text": "Great collection. Excellent service and absolutely great prizing. Executive - Sathish was a great help in explaining the product range. He was patient all the while. Rohit was good with the guidance."
    },
    {
      "id": "text-0440",
      "name": "Mridul Gupta",
      "rating": 5,
      "text": "Budget friendly pricing"
    },
    {
      "id": "text-0441",
      "name": "Naufal mh",
      "rating": 5,
      "text": "Authentic pearls are available here Rohit guided us in selecting the pearls"
    },
    {
      "id": "text-0442",
      "name": "Sapna Goyal",
      "rating": 5,
      "text": "Extremely good experience with Ramesh"
    },
    {
      "id": "text-0443",
      "name": "Prem Mishra",
      "rating": 5,
      "text": "Had a great experience with the best deal possible for my money's worth along with the kind help of Jagganath."
    },
    {
      "id": "text-0444",
      "name": "Abhilash G S",
      "rating": 5,
      "text": "Just walked into Krishna Pearls & Jewels with a friend and ended up buying a pearl set. Kashinath helped us sorting and buying the set. Thank you much Kashinath. Definitely will recomend Krishna Pearls & Jewels for future purchase."
    },
    {
      "id": "text-0445",
      "name": "Shruti Ora",
      "rating": 5,
      "text": "Amazing place to buy pearls. J Ramesh sir was amazing and explained everything to us"
    },
    {
      "id": "text-0446",
      "name": "Damani .sirisha",
      "rating": 5,
      "text": "Ramesh was very patient enough in showing the different collections that I asked for and helped me with every detail. The experience was very satisfying here shopping with Ramesh guidance. Totally satisfied :)"
    },
    {
      "id": "text-0447",
      "name": "Karthikeyan Ramachandrula",
      "rating": 5,
      "text": "Great experience purchasing pearls here..... Sales people Jagannath and ramesh showed us different models across all ranges and patiently showed the pieces...... wonderful place to buy pearls"
    },
    {
      "id": "text-0448",
      "name": "Rehan Ahmad",
      "rating": 5,
      "text": "Kashinath, did a great job and handled our questions with patience. We were a group from USA on a business trip"
    },
    {
      "id": "text-0449",
      "name": "ayisha mahin",
      "rating": 5,
      "text": "Mr. JAGANATH has been very patient with us.. and Mr. Pasha has given us a good discount and collection is very good. We'll recommend people to come."
    },
    {
      "id": "text-0450",
      "name": "neha magaji",
      "rating": 5,
      "text": "Collection is Unique and beautiful. hospitality and service from the Staff is very nice . Satish was very cooperative and patient with our requirements and choices."
    },
    {
      "id": "text-0454",
      "name": "Kalai Selvi",
      "rating": 5,
      "text": "M Jagannath & Mr. Pasha.. showed all pearls and different types of chains..thank you"
    },
    {
      "id": "text-0455",
      "name": "Nalini Nagaraj",
      "rating": 4,
      "text": "Ramesh was kind and patient and helped me in selecting right pearl jewellery."
    },
    {
      "id": "text-0456",
      "name": "Shuchita Singh",
      "rating": 5,
      "text": "Had an amazing experience with M Jaganath. Explained so nicely and showed so many options. 5 star."
    },
    {
      "id": "text-0457",
      "name": "priyanshu singhal",
      "rating": 5,
      "text": "M Jagannath was very polite and helpful us to buy the best pearl necklace"
    },
    {
      "id": "text-0459",
      "name": "sreelakshmi santhosh kumar",
      "rating": 5,
      "text": "Very good experience and customer friendly. Have various collections. Good place to purchase."
    },
    {
      "id": "text-0460",
      "name": "dineshkumar p",
      "rating": 5,
      "text": "Good service and courties .. By Ashok & Rohit sales personnel"
    },
    {
      "id": "text-0461",
      "name": "Rithika Suresh",
      "rating": 5,
      "text": "Very nice collections and for a very reasonable price. The pearl collections are so pretty. Customer service was also 👌"
    },
    {
      "id": "text-0462",
      "name": "Ramya H R",
      "rating": 5,
      "text": "We had good experience shopping here and Mr Rohit was patient enough to show the pearls asked by my mom."
    },
    {
      "id": "text-0463",
      "name": "Dhiraj Das",
      "rating": 5,
      "text": "Ramesh is Very friendly and enthusiast in customer relations. Thank you."
    },
    {
      "id": "text-0464",
      "name": "Ashish",
      "rating": 5,
      "text": "Excellent collection of pearls. Very very helpful staff especially Mr Ramesh who showed us variety of options and helped us select the best choice"
    },
    {
      "id": "text-0465",
      "name": "Aanchal Sharma",
      "rating": 5,
      "text": "Beautiful pearl necklaces. Mr. Ramesh showed all varieties with great patience. Thanks to the staff as well."
    },
    {
      "id": "text-0466",
      "name": "Jasmine Gambhir",
      "rating": 5,
      "text": "Really good service specially by Ramesh Ji with innumerable variety of jewellery"
    },
    {
      "id": "text-0467",
      "name": "Priya Rawat",
      "rating": 5,
      "text": "Great experience, good collection at reasonable prices. Ramesh was very helpful and showed us a lot of options and suggestions"
    },
    {
      "id": "text-0468",
      "name": "gaurika bhardwaj",
      "rating": 5,
      "text": "Ramesh ji and Ashok were extremely courteous and very good at their work. Love the collection here! Must visit :)"
    },
    {
      "id": "text-0469",
      "name": "Bhumi Thakur",
      "rating": 5,
      "text": "Satish and mohit was amazing throughout the purchase.great experience"
    },
    {
      "id": "text-0470",
      "name": "Atul Khedkar",
      "rating": 5,
      "text": "Praveen and m jaganath very good hospitality"
    },
    {
      "id": "text-0471",
      "name": "Anusha Ashok",
      "rating": 5,
      "text": "Helpful staffs. Great service by Kiran."
    },
    {
      "id": "text-0472",
      "name": "Saksham Vashishtha",
      "rating": 5,
      "text": "Rohit was very kind and helpful to us, overall great experience and collection"
    },
    {
      "id": "text-0474",
      "name": "Abhay Kulshrestha",
      "rating": 5,
      "text": "Thanks Ramesh, your suggestions were spot on and helped me in figuring out the right decision"
    },
    {
      "id": "text-0475",
      "name": "Anirban Kaman",
      "rating": 5,
      "text": "Had a wonderful experience, wife variety of product & very helpful staff. special thanks to Mr G Prem Kumar"
    },
    {
      "id": "text-0476",
      "name": "Laxmi Bidari",
      "rating": 4,
      "text": "They had good collection and Rohit Kumar was helpful"
    },
    {
      "id": "text-0477",
      "name": "Dana Martin",
      "rating": 5,
      "text": "Wonderful experience! Kashinath was so helpful!"
    },
    {
      "id": "text-0478",
      "name": "Sahar Bano",
      "rating": 5,
      "text": "M jaganath and kashi they behaviour are very good and comfortable"
    },
    {
      "id": "text-0479",
      "name": "Harshita Khushi",
      "rating": 5,
      "text": "Nice experience,staffs behaviour is also so friendly and quality was so good"
    },
    {
      "id": "text-0480",
      "name": "Seema Khadirnaikar",
      "rating": 5,
      "text": "Was attended by Mr. Satish. Satisfied by service."
    },
    {
      "id": "text-0481",
      "name": "Pallavi Das",
      "rating": 4,
      "text": "Staff very cooperative and particularlySri. Pasha who was very patient in showing us the items that we looked for"
    },
    {
      "id": "text-0483",
      "name": "Gini",
      "rating": 5,
      "text": "Thank you Satish for helping me choose right piece."
    },
    {
      "id": "text-0486",
      "name": "Kirti Goyal",
      "rating": 5,
      "text": "The experience was really good. Staff is peaceful, calm and knowledgeable. This was the first time and Mr. Rohit was really helpful to guide us throughout, he was being patient through the entire time."
    },
    {
      "id": "text-0487",
      "name": "Mini jain",
      "rating": 5,
      "text": "Rohit was good and showed us very nice collection"
    },
    {
      "id": "text-0488",
      "name": "Nitin Mahur",
      "rating": 5,
      "text": "We shopped from Krishna pearls and the staff M jagannath and Kashinath are amazing and very polite"
    },
    {
      "id": "text-0490",
      "name": "Hari Sankar Chockalingam",
      "rating": 5,
      "text": "A really great experience. Bought pearls and the rate was reasonable. J Ramesh was really good and helped me choose within my price range and something I loved"
    },
    {
      "id": "text-0491",
      "name": "Dipan Halder",
      "rating": 5,
      "text": "Ramesh has been a wonderful help."
    },
    {
      "id": "text-0492",
      "name": "Manivannan TE",
      "rating": 5,
      "text": "Nice collections & affordable pricing. J.Ramesh sales excecutive was so helpful . Great place to shop genuine pearl sets."
    },
    {
      "id": "text-0494",
      "name": "Hiren Pandya",
      "rating": 5,
      "text": "I am very satisfied to purchasing and G..praveen is very good and well behaved staff...I am very thankful to him"
    },
    {
      "id": "text-0495",
      "name": "Reshma R",
      "rating": 5,
      "text": "Nice collection and good staffs."
    },
    {
      "id": "text-0497",
      "name": "Abhinav Mishra",
      "rating": 5,
      "text": "Excellent staff, very nice behavior was presented by Mr. Rohit."
    },
    {
      "id": "text-0498",
      "name": "Pranav Singh",
      "rating": 5,
      "text": "Excellent staff, very nice demeanour was presented by Mr. Rohit, who assisted us in purchasing pearl jwellery."
    },
    {
      "id": "text-0500",
      "name": "Vaibhav Wani",
      "rating": 5,
      "text": "Rohit has given best service and nice hospitality Thank u so much"
    },
    {
      "id": "text-0503",
      "name": "amit kumar",
      "rating": 5,
      "text": "It was nice experience. Thank you mr. Rohit. We will visit again for sure."
    },
    {
      "id": "text-0505",
      "name": "H JP",
      "rating": 5,
      "text": "Met Mr Ramesh, excellent professional. Happy to have shopped at Krishna"
    },
    {
      "id": "text-0506",
      "name": "Punith K G",
      "rating": 5,
      "text": "Good experience at Krishna pearls Hyderabad... V kashinath showed us good variety of pearls..must visit place .."
    },
    {
      "id": "text-0507",
      "name": "Sadhana Pandit",
      "rating": 5,
      "text": "Mr Satish guided us well...nice prices and discounts"
    },
    {
      "id": "text-0508",
      "name": "Sandesh K",
      "rating": 5,
      "text": "Sathish was patient and knowledgable . It helped us get the right pearls"
    },
    {
      "id": "text-0509",
      "name": "P S Lalith Kumar",
      "rating": 5,
      "text": "Thankyou for the service and everything. Extremely happy and satisfied with the service. Great Work - R Hanuman Naik and M Jaganath 🙏"
    },
    {
      "id": "text-0511",
      "name": "Meet Shah",
      "rating": 5,
      "text": "Good quality pearls and good service. V Kashinath helped us really well in selecting the best pearl necklace"
    },
    {
      "id": "text-0513",
      "name": "J JOHNSON",
      "rating": 5,
      "text": "Excellent service by Mr.M. Sathish. His kindness and patience is very much appreciated. He is an asset to Krishna Pearls."
    },
    {
      "id": "text-0514",
      "name": "Ramkumar Natarajan",
      "rating": 5,
      "text": "J Ramesh smile, Good service, Thanks, we recommend Krishna Pearls"
    },
    {
      "id": "text-0516",
      "name": "Krishna",
      "rating": 5,
      "text": "Nice and courteous staff throughout the store. Was assisted by Ramesh in buying pearls. He helped us to to choose the best ones from their box and elaborated making process as well. Another rep Kashinath also helped us in getting commendable prices for jewels and jewelery scheme. Overall a nice experience."
    },
    {
      "id": "text-0517",
      "name": "Narhari Buch",
      "rating": 5,
      "text": "One of the best jewelry showroom in Hyderabad. Excellent collection of pearls & other jewels. Outstanding service overall on both floors. Special thanks to Satish & Jaganath for guiding to sets. One of the few showrooms which is lavish yet they run with honesty & straightforwardness."
    },
    {
      "id": "text-0518",
      "name": "Smita Panigrahy",
      "rating": 5,
      "text": "They have beautiful collections, and staff member Rohit was very attentive. Thank you for the amazing experience!"
    },
    {
      "id": "text-0519",
      "name": "Pallavi Hadawale",
      "rating": 5,
      "text": "Fatanatic service by rohit"
    },
    {
      "id": "text-0520",
      "name": "Purnima Anand",
      "rating": 5,
      "text": "Loved shopping for the first time at Krishna Pearls! A special shout-out to Kashinath and Rohit for their amazing service. No pushy sales—just a warm, well-arranged experience from start to finish. Both were incredibly polite and helpful throughout."
    },
    {
      "id": "text-0522",
      "name": "Swathi Gangavaram",
      "rating": 5,
      "text": "I have purchased Kasulaperu in Krishna Jewellers. Collection is very good. Sales person R.Satheesh is very good and showed us good designs."
    },
    {
      "id": "text-0524",
      "name": "Akanksha singh",
      "rating": 5,
      "text": "Amazing place with very good collection . Very good service behavior and service by Rohit."
    },
    {
      "id": "text-0525",
      "name": "Gaurav Aaditya",
      "rating": 5,
      "text": "Had a great experience at the store. Special thanks to Rohit."
    },
    {
      "id": "text-0528",
      "name": "Annapoorna T",
      "rating": 5,
      "text": "Beautiful collections. Excellent service by Sarvesh. Very professional. Reasonable prices and good quality. Will visit again."
    },
    {
      "id": "text-0529",
      "name": "preethi miriyala",
      "rating": 5,
      "text": "As regular patrons of Krishna Jewelers, we have returned, and Sarvesh has been exceedingly helpful in showcasing the various models and designs."
    },
    {
      "id": "text-0531",
      "name": "Amitava Dey",
      "rating": 5,
      "text": "Good collection of pearl jellewelry.Cooperative sales person. Special mention Mr M Satish"
    },
    {
      "id": "text-0532",
      "name": "Anuradha GOTTUMUKKALA",
      "rating": 5,
      "text": "Good collection and service. Kashinath was especially helpful and answered all our questions patiently."
    },
    {
      "id": "text-0533",
      "name": "Tripti Gupta",
      "rating": 5,
      "text": "What a beautiful collection! Our experience at the store was amazing. The staff was very cordial and generous in the way they served. Mr Ramesh and Mr Kashinath was very hospitable and catered to our vision of the jewellery. It is definitely the best of Hyderabad! We will visit again 😄"
    },
    {
      "id": "text-0534",
      "name": "Bala Manikandan",
      "rating": 5,
      "text": "M Jaganathan good , very helpful"
    },
    {
      "id": "text-0536",
      "name": "Harshita Tiruvuru",
      "rating": 5,
      "text": "very good collection. excellent service by yadav garu."
    },
    {
      "id": "text-0537",
      "name": "Manikonda Nagasastry",
      "rating": 5,
      "text": "good experience with Mr Naresh"
    },
    {
      "id": "text-0538",
      "name": "Mrityunjaya Hiremath",
      "rating": 5,
      "text": "Very good service byr Rajkumar"
    },
    {
      "id": "text-0539",
      "name": "Sudharani Valavala",
      "rating": 5,
      "text": "Staff has good communications and too polite."
    },
    {
      "id": "text-0540",
      "name": "Chetna Poojari",
      "rating": 5,
      "text": "I love the experience at Krishna Silver section, thier designs are intriguing! T Rohit was excellent with the Customer experience!"
    },
    {
      "id": "text-0541",
      "name": "Prem Chander",
      "rating": 5,
      "text": "Worth the visit Beautiful collections"
    },
    {
      "id": "text-0542",
      "name": "Usha Palwankar",
      "rating": 5,
      "text": "Nice collection. Mr. Jagganath REDDY shows all products with nicely. Very Happy"
    },
    {
      "id": "text-0543",
      "name": "Prasad Inturi",
      "rating": 5,
      "text": "Good experience and good jewelry R satish"
    },
    {
      "id": "text-0544",
      "name": "Nandini A",
      "rating": 5,
      "text": "Yadav good service"
    },
    {
      "id": "text-0545",
      "name": "Neeharika Reddy",
      "rating": 5,
      "text": "Me and my friend visited the store today and srinivas yadav showed the beautiful designs and we enjoyed the shopping"
    },
    {
      "id": "text-0546",
      "name": "Aadi Samatha",
      "rating": 5,
      "text": "me and my friend visited the store today Srinivas yadav showed best models and we enjoyed the shopping"
    },
    {
      "id": "text-0549",
      "name": "meghana gudala",
      "rating": 5,
      "text": "Lovely pearl collection :) Kashinath and Santoshi were very friendly and helped with the selection :)"
    },
    {
      "id": "text-0550",
      "name": "Darshana Chande",
      "rating": 5,
      "text": "Pasha sir from krishna jewelers pearls and gems is very good salesman . They have very good collection of all types of pearls...must visit the store."
    },
    {
      "id": "text-0553",
      "name": "Deepika Matharoo",
      "rating": 5,
      "text": "Good stuff. Was served by G Praveen, thank you."
    },
    {
      "id": "text-0554",
      "name": "Mudra Resorts",
      "rating": 5,
      "text": "Good service and hospitality from Mr. shekar"
    },
    {
      "id": "text-0555",
      "name": "srujan kandanuru",
      "rating": 5,
      "text": "Very nice collection Very friendly staff Specially chandu helped a lot"
    },
    {
      "id": "text-0557",
      "name": "sumalatha poolavari",
      "rating": 5,
      "text": "We have recently purchased jewelry from shop and V . Srinivasulu from sales team guided us to purchase right jewelry. He responded properly for our queries. He has great knowledge about the products."
    },
    {
      "id": "text-0558",
      "name": "Rahul Nema",
      "rating": 5,
      "text": "Krishna pearls is a very good Shop, mr satish is a very knowledgeable person and has good knowledge about pearls. Good collection."
    },
    {
      "id": "text-0559",
      "name": "Lakshmi Prasanna",
      "rating": 5,
      "text": "Nicely showcase by KasiNath , lot of varieties available . Many options to choose"
    },
    {
      "id": "text-0562",
      "name": "Saurabh Agarwal",
      "rating": 5,
      "text": "Thank you Mr Jaganath and Mr Kashi for helping us find the right ornament. Smooth and quick purchase."
    },
    {
      "id": "text-0563",
      "name": "Pratik Rana",
      "rating": 5,
      "text": "A very good experience with the overall purchase. Thanks to Satish for the help choosing the earrings."
    },
    {
      "id": "text-0564",
      "name": "Hitesh Boro",
      "rating": 5,
      "text": "M.satish Good service Polite."
    },
    {
      "id": "text-0565",
      "name": "Kalla Jyothi",
      "rating": 5,
      "text": "The collection of silver and pearls was very good and staff was very good in receiving, detailed information of every jewellery. Love this place"
    },
    {
      "id": "text-0566",
      "name": "Shubhashree Chakraborty",
      "rating": 4,
      "text": "Great shop for authentic pearls in Hyderabad. G Pravin ji ensures that we don't come back empty handed"
    },
    {
      "id": "text-0567",
      "name": "Shashank Sahu",
      "rating": 5,
      "text": "Mr kashinath and M Jaganath Reddy Excellent customer service, explained very clearly, amazing experience, would come again. Thank you for the great service 😊"
    },
    {
      "id": "text-0568",
      "name": "Arhant Singh",
      "rating": 5,
      "text": "Mr Pasha was very helpful guided me to make the right choice, overall a good experience. They have quality products."
    },
    {
      "id": "text-0569",
      "name": "Inderjit kumar",
      "rating": 5,
      "text": "I had a great experience with G. Praveen Kumar. I liked the way he helped me out in the selection and responded to my question politely."
    },
    {
      "id": "text-0572",
      "name": "Nishtha Bhargav",
      "rating": 5,
      "text": "Amazing workshop, the staff was so friendly and helpful, Kashi and Sudhir were amazing"
    },
    {
      "id": "text-0574",
      "name": "Shalini Singh",
      "rating": 5,
      "text": "Good collection"
    },
    {
      "id": "text-0575",
      "name": "Shree 30",
      "rating": 5,
      "text": "Good service by rohit, thank you"
    },
    {
      "id": "text-0576",
      "name": "Amani Ani",
      "rating": 5,
      "text": "Good service by Rohit.. Thank you.."
    },
    {
      "id": "text-0577",
      "name": "Apoorva Acharya",
      "rating": 5,
      "text": "Mr Jaganath Readdy and Mr Pasha had attended us very nicely and they were very friendly."
    },
    {
      "id": "text-0578",
      "name": "Lengineni Vandana",
      "rating": 5,
      "text": "Nice experience, our experience with the executive Mr.Mohit was good"
    },
    {
      "id": "text-0579",
      "name": "Bhanu Garg",
      "rating": 5,
      "text": "Great experience and service by Satish"
    },
    {
      "id": "text-0580",
      "name": "Parul Verma",
      "rating": 5,
      "text": "T Rohit assisted me for buying pearls, great experience overall."
    },
    {
      "id": "text-0581",
      "name": "Bhavya Kumili",
      "rating": 5,
      "text": "They have very good collection. Satish really helped us in choosing the items as per requirement. Thank you for great service"
    },
    {
      "id": "text-0582",
      "name": "m w",
      "rating": 5,
      "text": "Very nice staff, especially one called V. KASHINATH. He provided us with many information."
    },
    {
      "id": "text-0583",
      "name": "Pradnya Hare",
      "rating": 5,
      "text": "Thanks..great collection..Jagannath Reddy was amazing in assisting."
    },
    {
      "id": "text-0584",
      "name": "Valarmathi Karthikeyan",
      "rating": 4,
      "text": "Rohit is really good at showing collections and very patient .. awesome service"
    },
    {
      "id": "text-0586",
      "name": "soma chauhan",
      "rating": 5,
      "text": "Jaganath Reddy and Pasha at the store was very polite and enlightened is with pearl knowledge. Feeling so good having learnt about the pearl types and varieties. The store has good collection of pearl chains"
    },
    {
      "id": "text-0587",
      "name": "Debasish Sarma",
      "rating": 5,
      "text": "It was an amazing experience guided by Mr. Jaganath Reddy and Mr. Pasha."
    },
    {
      "id": "text-0588",
      "name": "rochandrasekhar",
      "rating": 5,
      "text": "Rohit (sales executive) was very helpful and the place has a really good collection. Must visit."
    },
    {
      "id": "text-0589",
      "name": "Deepak Patil",
      "rating": 5,
      "text": "This shop is center of Hyderabad and have different designs in Perl’s. Customer Friendly staff and Rohit showed various options and I could able to pick the right Perl. Thank you!"
    },
    {
      "id": "text-0590",
      "name": "Harshal Arora",
      "rating": 5,
      "text": "it was a great experience the variety of pearls jewellery is tremendous their executives mr. kashinath and mr. M jagannath are very good at what they do"
    },
    {
      "id": "text-0593",
      "name": "DESHAVATH LIKHITHA",
      "rating": 5,
      "text": "I had a wonderful experience at Pearl Workshop! The team was professional, well-organized, and made sure every detail was taken care of, especially kashinadh and pasha , they gave a good amount of knowledge on pearls ! And vilash taught us how to make the bracelet, had good time making bracelet! The session was engaging, informative, and hands-on. The environment was comfortable, creative, and inspiring – perfect for learning and trying out new things. Whether you’re a beginner or looking to enhance your skills, this workshop is definitely worth attending. Highly recommended!"
    },
    {
      "id": "text-0594",
      "name": "B Smitha",
      "rating": 5,
      "text": "Had an amazing time and experienced with kashinath sir…looking forward for more workshops!!"
    },
    {
      "id": "text-0598",
      "name": "Jasmehar Singh Kohli",
      "rating": 5,
      "text": "Premium quality of pearls, silvers and gold, had a pearl pendant broken was fixed and guided by rohit thx"
    },
    {
      "id": "text-0599",
      "name": "Saniya Kareem",
      "rating": 5,
      "text": "Beautiful designs, rohit has been helpful"
    },
    {
      "id": "text-0600",
      "name": "Shamee Arora",
      "rating": 5,
      "text": "Great experience and beautiful collection. M Jaganath had good knowledge and patiently helped me to choose items. Great customer service."
    },
    {
      "id": "text-0601",
      "name": "Saileela Padakanti",
      "rating": 4,
      "text": "It was easy to find something I liked and the people were very kind. A special thanks to Rohit Pasha, he helped up find the earings I liked and was very polite."
    },
    {
      "id": "text-0602",
      "name": "Sruthi Iyer",
      "rating": 5,
      "text": "Had an amazing experience with the shop. Mr . Pasha guided us very nicely."
    },
    {
      "id": "text-0603",
      "name": "kasi nath",
      "rating": 5,
      "text": "The designs are unique and the customer service by Mr. Pasha and Mr. Jagantath Reddy is very welcoming and are patient in showing different designs"
    },
    {
      "id": "text-0604",
      "name": "Taranjot Bahl",
      "rating": 5,
      "text": "Rohit was v patient and helpful. Highly recommend."
    },
    {
      "id": "text-0605",
      "name": "Jyestha Arora",
      "rating": 5,
      "text": "Amazing collection and superb friendly staff, thanks to rohit for helping us finding dainty minimalistic jewellery for modern women."
    },
    {
      "id": "text-0606",
      "name": "Akshay",
      "rating": 5,
      "text": "Nice product and Nice service. Thanks Praveen for your excellent customer service and dealings."
    },
    {
      "id": "text-0608",
      "name": "Patibandla aruna.05",
      "rating": 5,
      "text": "pasha& jagannath reddy . thankyou nice"
    },
    {
      "id": "text-0611",
      "name": "Priyanka Kadam",
      "rating": 5,
      "text": "T Rohit showed me pearl jewelry. He was very patient during the whole process. It was a pleasant buying experience."
    },
    {
      "id": "text-0612",
      "name": "Sadaf Rahman",
      "rating": 5,
      "text": "Mr Satish knew about all products .! Dedicate devoted staff . The treatment ambience was calm and pleasant. Must visit"
    },
    {
      "id": "text-0615",
      "name": "Manasa Vempati",
      "rating": 5,
      "text": "Rohit showed us everything with great patience and made our experience pleasant."
    },
    {
      "id": "text-0616",
      "name": "Dr. Anjan Kumar K",
      "rating": 5,
      "text": "Mr Pasha and Mr Jaganath Reddy Helped us pick us what we wanted. I liked the way they explained the things and i appreciate their hospitality"
    },
    {
      "id": "text-0617",
      "name": "Aprajita Krishna",
      "rating": 5,
      "text": "Great variety of pearl sets. Kashinath Sir was very pleasant, helpful and quick! Had a great shopping experience."
    },
    {
      "id": "text-0618",
      "name": "sangeeta reddy",
      "rating": 5,
      "text": "Very nice experience with kasinath"
    },
    {
      "id": "text-0619",
      "name": "ankita agarwal",
      "rating": 5,
      "text": "Attended the pearl workshop guided by V.Kashinath and others and it was a great experience"
    },
    {
      "id": "text-0620",
      "name": "CHOWDAM VEERAJINI",
      "rating": 5,
      "text": "Had wonderful experience at the workshop and Kashi helped with understanding on different varieties of pearls"
    },
    {
      "id": "text-0621",
      "name": "srk reddy",
      "rating": 5,
      "text": "Attended the pearl workshop.kashinath and megret were very helpful in explaning everything in detail.we made bracelet and it turned out to be wonderful."
    },
    {
      "id": "text-0622",
      "name": "priyanka chama",
      "rating": 5,
      "text": "Very nice experice and really appreciate how helpful and informative Mr. Kashinath was. Lovely workshop, would definitely recommend."
    },
    {
      "id": "text-0623",
      "name": "Abhijeeth Kurapati",
      "rating": 5,
      "text": "Very great experience I ad in this workshop we had ,kashinath sir has a Great expertise in his work and very great person and has vast experience in his work"
    },
    {
      "id": "text-0624",
      "name": "Goutam Mukherjee",
      "rating": 5,
      "text": "Satish is quite helpful and based on his suggestion, I brought Perl sets"
    },
    {
      "id": "text-0625",
      "name": "ankita pandita",
      "rating": 5,
      "text": "Great collection. Amazing staff. Satish is really polite and helpful"
    },
    {
      "id": "text-0626",
      "name": "SHIVANI MANIMARAN",
      "rating": 5,
      "text": "Good service, sathish helped us choose jewelry and was knowledgeable"
    },
    {
      "id": "text-0627",
      "name": "santhana krishnan",
      "rating": 5,
      "text": "Satish service was exceptional"
    },
    {
      "id": "text-0628",
      "name": "Anand Yargole",
      "rating": 5,
      "text": "We are really happy with service given Bu Satish Highly recommend and suggest everyone to visit the store for Pearls and Stone"
    },
    {
      "id": "text-0629",
      "name": "Archana",
      "rating": 5,
      "text": "Wonderful collection, courteous staff. Much help and kind gestures by Mr. Kashinath. Thank you for patience."
    },
    {
      "id": "text-0630",
      "name": "Abhishek Badgolia",
      "rating": 5,
      "text": "I had a wonderful experience visiting the store. The staff (Rohit T) was very helpful and professional. I ended up buying something due to this experience."
    },
    {
      "id": "text-0633",
      "name": "Prachi Solanki",
      "rating": 4,
      "text": "Wonderful place with great staff especially Mr. Rohit who was of great assistance and really kind."
    },
    {
      "id": "text-0636",
      "name": "santhoshini nadiminti",
      "rating": 5,
      "text": "Satish garu chala oopikaga chupinchari.. very nice store. Lots of varieties. Much go and check 5/5 rating"
    },
    {
      "id": "text-0637",
      "name": "ramya thota",
      "rating": 5,
      "text": "Excellent service by Mr Rohit, very patient and helpful"
    },
    {
      "id": "text-0639",
      "name": "Hinduja Sainoji",
      "rating": 5,
      "text": "The experience was really good. Rohit took good care of us and was patient throughout the process. Overall a good experience."
    },
    {
      "id": "text-0641",
      "name": "Lakshmanan K",
      "rating": 5,
      "text": "Had a great experience buying pearl necklace from this place. Kunal was very helpful and had great patience in showing different options. They have good collection of pearl jewellery and good customer service."
    },
    {
      "id": "text-0642",
      "name": "shaiqua firdous",
      "rating": 5,
      "text": "Rohit has shown good products and excellent service"
    },
    {
      "id": "text-0643",
      "name": "PASUPULA SRINU",
      "rating": 5,
      "text": "Good staff behaviour bheem is excellent explanation for gold coins benifits thank you everyone one and also server give me lassi very tasty thank you everyone"
    },
    {
      "id": "text-0644",
      "name": "Shrivastava Sukirti",
      "rating": 5,
      "text": "Great hospitality,Special mention to Mr.Satish for his help"
    },
    {
      "id": "text-0645",
      "name": "Nimmala Ramya",
      "rating": 5,
      "text": "Costumer service is so patience and helpful especially thanks for Mr.yadav sir is very patience and helpful"
    },
    {
      "id": "text-0646",
      "name": "Ramya Dopariwada",
      "rating": 5,
      "text": "Nice collection by yadav sir...very good Shop and multiple options and all staff is genuine mr.srinivas yadav is very helpful and understands customer and very nice experience thank you 💫"
    },
    {
      "id": "text-0647",
      "name": "Fiona",
      "rating": 5,
      "text": "Good collection and very helpful staff…Thank you Satish for your service"
    },
    {
      "id": "text-0648",
      "name": "Samarjyoti Baruah",
      "rating": 5,
      "text": "Good service. Highly recommended. Special thanks to Mr. Satish for his help & service."
    },
    {
      "id": "text-0649",
      "name": "Vicky Sarin",
      "rating": 5,
      "text": "V. Kashinath was very helpful to get me the custom matching set."
    },
    {
      "id": "text-0650",
      "name": "Prerana Sanjay",
      "rating": 5,
      "text": "Mr. Kashinath was warm, and helped with all sorts of asks. Overall a very good experience!"
    },
    {
      "id": "text-0652",
      "name": "FITNESS GARAGE HYDERABAD",
      "rating": 5,
      "text": "Pavani showed us designs very well"
    },
    {
      "id": "text-0653",
      "name": "kavya tongali",
      "rating": 5,
      "text": "Excellent service by Satish and Praveen! Nice collections would definitely visit again"
    },
    {
      "id": "text-0654",
      "name": "Pavan Munukutla",
      "rating": 5,
      "text": "It's great workshop. Good help from kashinath Sudheer and Shoukath to make some things beautiful."
    },
    {
      "id": "text-0655",
      "name": "swathi alla",
      "rating": 4,
      "text": "Kasinath is very innovative pearl seller and durgesh has demonstrated very well in making jewellery"
    },
    {
      "id": "text-0657",
      "name": "sudha rayadurgam",
      "rating": 5,
      "text": "This is n excellent workshop. Kashinath, apporva and margharet and other staff were very informtive friendly and helpful.."
    },
    {
      "id": "text-0658",
      "name": "Jagadish Gowda",
      "rating": 5,
      "text": "Nice place… highly recommended.. suggest to contact Rohit.."
    },
    {
      "id": "text-0659",
      "name": "Pooja Rawat",
      "rating": 5,
      "text": "Nice service by Mr Rohit … good collection"
    },
    {
      "id": "text-0660",
      "name": "abhineetmukherji",
      "rating": 5,
      "text": "Wonderful experience... M. Satish and his team are very co-operative.. Must visit place for Pearl Lovers..."
    },
    {
      "id": "text-0661",
      "name": "Ananya Singh",
      "rating": 5,
      "text": "Satish and Jagannath was really helpful and whole experience was very good"
    },
    {
      "id": "text-0663",
      "name": "amu rutha",
      "rating": 5,
      "text": "Nice collection of pearls and jewellery, Good service by Satish"
    },
    {
      "id": "text-0664",
      "name": "Minj Ashish",
      "rating": 5,
      "text": "Had a good experience while purchasing pearl bracelet and the sales executive Radha helped us in choosing the Right product."
    },
    {
      "id": "text-0665",
      "name": "Dr. G. Raghuramaiah",
      "rating": 5,
      "text": "Mrs. Radha is good and cooperative"
    },
    {
      "id": "text-0666",
      "name": "Netflix Account",
      "rating": 5,
      "text": "Had a great experience shopping at Krishna Pearls. Special thanks to Radha ma'am for her help along with her honest advise and guidance."
    },
    {
      "id": "text-0669",
      "name": "sunil kumar",
      "rating": 5,
      "text": "Pearls quality is very Good. @rohit thanks"
    },
    {
      "id": "text-0670",
      "name": "Utkarsh Agnihotri",
      "rating": 5,
      "text": "Great experience. Radha mam was very helpful and showed a variety of jewellery with patience."
    },
    {
      "id": "text-0671",
      "name": "Balaganesh Mohanavel",
      "rating": 5,
      "text": "Radha was very kind and helpful"
    },
    {
      "id": "text-0672",
      "name": "Soumili Saha",
      "rating": 5,
      "text": "Rohit has been an amazing host at Krishna Pearls. Benevolent behaviour and good stock."
    },
    {
      "id": "text-0673",
      "name": "Harini Annam",
      "rating": 5,
      "text": "Thanks Mr. Rohit for your good advice in selection. Great collection and wonderful staff.👍"
    },
    {
      "id": "text-0674",
      "name": "Selva S",
      "rating": 5,
      "text": "Pearl Collections are really good and Sales Person Ms. Radha shown us variety of options and guided us very well."
    },
    {
      "id": "text-0675",
      "name": "Meet Shah",
      "rating": 5,
      "text": "Good collection.. Staff nature is to good. Rohit bhai so much helped to select a perfect jwellery for my wife.. thanks team krishna"
    },
    {
      "id": "text-0676",
      "name": "yashi vaish",
      "rating": 5,
      "text": "Amazing collection. Staff was polite -Rohit showed all the collection."
    },
    {
      "id": "text-0677",
      "name": "Swarna Latha",
      "rating": 5,
      "text": "Received item today safely. Thank you Ramya from online support and Mahesh from sales department. Very good customer service."
    },
    {
      "id": "text-0678",
      "name": "Akshi Madaan",
      "rating": 5,
      "text": "Great assistance by Radha"
    },
    {
      "id": "text-0679",
      "name": "Kamakshi B",
      "rating": 5,
      "text": "We had a great exp in Krishna pearls The salesperson Kashinathji was very polite and helpful. Assisted in showing all the collection and still being patience with our demands 😀 even provide good discount on purchase 🤗"
    },
    {
      "id": "text-0680",
      "name": "Nisha Shukla",
      "rating": 5,
      "text": "It was a great experience, staff members were so helpful ☺️"
    },
    {
      "id": "text-0681",
      "name": "Srinivas Reddy",
      "rating": 5,
      "text": "Mr.yadav it was a very good experience in krishna jewellers in jubilee hills staff was very friendly specially Mr.yadav garu wonderfull experience with yadav"
    },
    {
      "id": "text-0682",
      "name": "Kavitha Alakunta kavitha",
      "rating": 5,
      "text": "The collection was wonderful.... nice experience with yadav sirrr...He have so much patience Thank you yadav garu❤️❤️...."
    },
    {
      "id": "text-0683",
      "name": "asv puneet",
      "rating": 5,
      "text": "Radha was very helpful in providing us with options in pearl necklace. Satisfactory buy."
    },
    {
      "id": "text-0684",
      "name": "Mohit",
      "rating": 5,
      "text": "Really Nice experience, Satisha and Rohit really took good care"
    },
    {
      "id": "text-0685",
      "name": "Rama Nagaraja",
      "rating": 5,
      "text": "The store had good varieties and Rohit was patient and showed us all different ones and also put it in stand for us to see how things look."
    },
    {
      "id": "text-0686",
      "name": "Manali Tapre",
      "rating": 5,
      "text": "This is an awesome place for authentic pearls. Satish helped me very patiently with my purchase. Great staff"
    },
    {
      "id": "text-0687",
      "name": "Prajual P",
      "rating": 5,
      "text": "Had an Amazing and Smooth buying Experience at Krishna Pearls, Satish helped us and made the process smooth"
    },
    {
      "id": "text-0688",
      "name": "Sneha Gupta",
      "rating": 5,
      "text": "Mr Satish was our salesperson while purchasing gold chain. Superb experience. Great collection. Would definitely recommend if you’re in Hyderabad"
    },
    {
      "id": "text-0689",
      "name": "Glory Singh",
      "rating": 5,
      "text": "Rohit Sir provide us good service and we like the way he gave service. Thank you sir & Krishna pearls"
    },
    {
      "id": "text-0690",
      "name": "Harleen Kaur",
      "rating": 5,
      "text": "Very good service by Rohit and his team."
    },
    {
      "id": "text-0691",
      "name": "R Shah",
      "rating": 5,
      "text": "Nice collection and reasonable price. Satish was attentive and helped with decision."
    },
    {
      "id": "text-0692",
      "name": "Vrishan Shetty",
      "rating": 5,
      "text": "M Satish gave very good service They have a very nice collection"
    },
    {
      "id": "text-0693",
      "name": "shweta suryawanshi",
      "rating": 5,
      "text": "The service was so good here! The collection too is. . . .big thanks to Radha, she was so friendly and helpful! #Great customer service"
    },
    {
      "id": "text-0694",
      "name": "Harshita Kalra",
      "rating": 5,
      "text": "Rohit has served us well and showed amazing collection. Kuddos to the experience at Krishna. Thanks you"
    },
    {
      "id": "text-0696",
      "name": "Joyal Jose",
      "rating": 4,
      "text": "Good customer experience and service from Kunal"
    },
    {
      "id": "text-0698",
      "name": "Samyuktha reddy",
      "rating": 5,
      "text": "Service was too good. Radha helped us a lot"
    },
    {
      "id": "text-0699",
      "name": "Moin",
      "rating": 5,
      "text": "Kashinath shown best pearl strings"
    },
    {
      "id": "text-0700",
      "name": "drshruti Kotapalli",
      "rating": 5,
      "text": "Radha executive was very good ."
    },
    {
      "id": "text-0701",
      "name": "venkatasravani mandapati",
      "rating": 5,
      "text": "We got two beautiful chokers here and we really like those.Rohith showed us beautiful collection 😍. Thanku."
    },
    {
      "id": "text-0702",
      "name": "suchorita dutta",
      "rating": 5,
      "text": "I was absolutely impressed by Mr. Rajkumar's patience and excellent client service."
    },
    {
      "id": "text-0704",
      "name": "Nadeem Waris",
      "rating": 5,
      "text": "Very nice service and very nice collections please visit once especially satish is very polite"
    },
    {
      "id": "text-0705",
      "name": "Umamahesh Arvi",
      "rating": 5,
      "text": "I had a great experience with sales person SAINATH PATIL HE HELPED ME TO FIND MY BEST PEACE"
    },
    {
      "id": "text-0707",
      "name": "Billakanti Sowmya",
      "rating": 5,
      "text": "Excellent collection on silver and Ramlaxmi suggested best for our needs."
    },
    {
      "id": "text-0708",
      "name": "Sanjaya Kumar Deo",
      "rating": 5,
      "text": "Very nice service by kunal"
    },
    {
      "id": "text-0710",
      "name": "V. Guru Charan",
      "rating": 5,
      "text": "Kusuma, Radha and Kashinath did excellent customer service. Had a great time!"
    },
    {
      "id": "text-0711",
      "name": "V H Saran",
      "rating": 5,
      "text": "We had a wonderful shopping experience at the showroom on 10th April 2025While looking for pearls necklaces, we were attended at the showroom by radhaa helpful and polite salesperson. She an amazing knowledge about pearls and precious stones. As we were short of time, he helped us with the selections"
    },
    {
      "id": "text-0712",
      "name": "Anukriti Gupta",
      "rating": 5,
      "text": "Beautiful collection and amazing service by Rohit. He showed us all the things and also assisted us very well."
    },
    {
      "id": "text-0713",
      "name": "Syed Moin Hashmi",
      "rating": 5,
      "text": "Raj kumar is very nice service"
    },
    {
      "id": "text-0714",
      "name": "Seema Panchal",
      "rating": 5,
      "text": "Satish is very nice"
    },
    {
      "id": "text-0715",
      "name": "Raguram Marimuthu",
      "rating": 5,
      "text": "T.Kunal explained clearly & gave some good suggestions & variants."
    },
    {
      "id": "text-0716",
      "name": "Kritika Murali",
      "rating": 5,
      "text": "Great service, pretty pearls, polite staff and overall beautiful ambience. Ms. Radha was very helpful."
    },
    {
      "id": "text-0717",
      "name": "Dora D",
      "rating": 4,
      "text": "Very warm and nice service by Radha. Good collection."
    },
    {
      "id": "text-0718",
      "name": "SANTHANAM RENGASAMY",
      "rating": 5,
      "text": "Very good reception and polite staff. Rate is too reasonable."
    },
    {
      "id": "text-0719",
      "name": "Shivani Neb",
      "rating": 5,
      "text": "Pasha ji and Kunal ji are very nice salesmen and I had a very nice experience shopping here. Excellent collection"
    },
    {
      "id": "text-0720",
      "name": "Anjika Shukla",
      "rating": 5,
      "text": "Wonderful collection. Kunal was extremely helpful in bringing us the classiest pieces."
    },
    {
      "id": "text-0721",
      "name": "Raj Kumar",
      "rating": 5,
      "text": "Nice experience, Mr Kunal helped a lot at here. Overall a great experience"
    },
    {
      "id": "text-0722",
      "name": "Devina Bhardwaj",
      "rating": 5,
      "text": "We had good experience of the store Mr Kashinath was very helpful and a good sales man must visit for tourists in Hyderabad"
    },
    {
      "id": "text-0723",
      "name": "anju shukla",
      "rating": 5,
      "text": "Radha is an excellent skills with exceptionally helpful nature. An asset to any organization."
    },
    {
      "id": "text-0725",
      "name": "Rashmi Ragha",
      "rating": 5,
      "text": "Thank you Rohit for nice service"
    },
    {
      "id": "text-0726",
      "name": "Keerti Dullolli",
      "rating": 5,
      "text": "Nice experience n very good collections Thanks Rohit"
    },
    {
      "id": "text-0727",
      "name": "Lopa Bhatt",
      "rating": 5,
      "text": "Today I visited Krishna jewelers in jubilee hills haidarabad. I m from vadodara gujarat. The sales person Rohit was well mannered and easily understood what I want. Good experience. Bought a pearl necklace with earing"
    },
    {
      "id": "text-0729",
      "name": "Kavitha Gudibandi",
      "rating": 5,
      "text": "Pasha is very nice"
    },
    {
      "id": "text-0730",
      "name": "Sanchita Sanyal",
      "rating": 5,
      "text": "Good service provided by Raj Kumar"
    },
    {
      "id": "text-0731",
      "name": "dhara mehta",
      "rating": 5,
      "text": "Good shop for pearl jewellery,Kunal a good sales person"
    },
    {
      "id": "text-0732",
      "name": "Sujata Paul",
      "rating": 5,
      "text": "The variety of product are huge they have superb variety of jewellery and the staff were too good, the behaviour and all. We are very satisfied and served by miss pasha. We liked everything about the shop"
    },
    {
      "id": "text-0733",
      "name": "suresh babu GOUDAR",
      "rating": 5,
      "text": "A very good place to shop pearls with lot of variety & excellent quality."
    },
    {
      "id": "text-0734",
      "name": "Suman S",
      "rating": 4,
      "text": "It was a nice experience to visit and buy and Mr. Rajkumar staff were quite helpful."
    },
    {
      "id": "text-0735",
      "name": "Sana Fatima",
      "rating": 5,
      "text": "Great experience! Manjula and Pasha were excellent"
    },
    {
      "id": "text-0736",
      "name": "Prerna Kumari",
      "rating": 5,
      "text": "Rajkumar showed the best designs and helped us to select smoothly"
    },
    {
      "id": "text-0737",
      "name": "Pinkubhai Mistry",
      "rating": 5,
      "text": "Rohit service is good very nice collections in pearls very nice receiving tqu Krishna pearls jubilee hills please visit once all of u"
    },
    {
      "id": "text-0738",
      "name": "Vibha Bhargav",
      "rating": 5,
      "text": "Rohit thank you for helping, awesome experience"
    },
    {
      "id": "text-0739",
      "name": "Pallavi Wadhwa",
      "rating": 5,
      "text": "Thank you Kunal for the assisting us with so much patience and amazing offers. impressed with the collection and whole exp. Thanks Kunal"
    },
    {
      "id": "text-0741",
      "name": "deepak singh",
      "rating": 5,
      "text": "M satish is good We are wonderful experience to Krishna pearls"
    },
    {
      "id": "text-0742",
      "name": "Abhilash Rajan",
      "rating": 5,
      "text": "The experience with Rohit is meeting the expections of the customer"
    },
    {
      "id": "text-0743",
      "name": "sunkesula shahan",
      "rating": 5,
      "text": "Mr kashinath was good"
    },
    {
      "id": "text-0744",
      "name": "Spoorthi Samala",
      "rating": 5,
      "text": "Rohit showed us around and he was very helpful and patient. Very good service."
    },
    {
      "id": "text-0745",
      "name": "Munish Nanda",
      "rating": 5,
      "text": "Excellent products and customer service . A repeat customer"
    },
    {
      "id": "text-0746",
      "name": "Hymavathi G",
      "rating": 5,
      "text": "Very nice and friendly service .. facilitating and helping the customer's well in selecting the best ones ..👌👏"
    },
    {
      "id": "text-0747",
      "name": "Thedeadlydud BB",
      "rating": 5,
      "text": "Wow collection and very nice receiving and polite and best smile tqu Kusuma and kashinath is give nice"
    },
    {
      "id": "text-0748",
      "name": "Apoorva Singh",
      "rating": 5,
      "text": "Kunal was very helpful..."
    },
    {
      "id": "text-0750",
      "name": "neha nanaiah",
      "rating": 5,
      "text": "Unique collection in the store. Very good assistance by kashinath"
    },
    {
      "id": "text-0751",
      "name": "Richa saun",
      "rating": 5,
      "text": "It was a great experience buying pearls with Mr Kunal. Helpful in guiding and buying pearl."
    },
    {
      "id": "text-0752",
      "name": "sruthi makkena",
      "rating": 5,
      "text": "Very well served and great experience to go .... one of the best place for pearls collection ... Radha has assisted me well ... 😊"
    },
    {
      "id": "text-0753",
      "name": "Prakash ved",
      "rating": 5,
      "text": "Excellent experience with Krishna jwellers . Great experience with Kunal, very well behaved . Thanks"
    },
    {
      "id": "text-0754",
      "name": "Karthick Vijay Chandra Bose",
      "rating": 5,
      "text": "It's a very good store with so much varieties of pearls jewelleries. Very good service, kunal and Rohit were very patient and sweet. Must visit. Thanks."
    },
    {
      "id": "text-0755",
      "name": "Sindhu Munipally",
      "rating": 5,
      "text": "Radha and vivek were very helpful and had utmost professionalism Thankyou and had a great experience"
    },
    {
      "id": "text-0756",
      "name": "Vinod Kumar",
      "rating": 5,
      "text": "Serving is best Mr pasha TQ so much pasha"
    },
    {
      "id": "text-0757",
      "name": "Spandan Bollu",
      "rating": 5,
      "text": "I just walked in thi this krishna jewellery, had very friendly service with kusuma garu ,made me choose the best for my friends birthday with very good price ,hope everyone trys to buy something here you will be back again to buy more for other occasions for sure thats my promise"
    },
    {
      "id": "text-0758",
      "name": "Ridhima Gupta",
      "rating": 5,
      "text": "Great shopping place for pearls.. thanks to Mr Rohit and Mr Kunal for helping us I love this place"
    },
    {
      "id": "text-0759",
      "name": "NANDHINI VASUDEVAN",
      "rating": 5,
      "text": "Mr. Kunal helped us out getting the pearls we were looking for. Good and polite service."
    },
    {
      "id": "text-0760",
      "name": "DILLIP SAHOO",
      "rating": 5,
      "text": "Suraj helped us buy the right pearl set for us and was very pleasant with our purchase.will definitely recommend Suraj ."
    },
    {
      "id": "text-0761",
      "name": "Divya Surana",
      "rating": 5,
      "text": "I had a very great experience doing pearl jewellery shopping. There were a lot of good variety of designs and the team especially Rohit and Ashok helped us a lot in selecting the right design"
    },
    {
      "id": "text-0762",
      "name": "Neelava Maitra",
      "rating": 5,
      "text": "Great collection. Pasha helped us finalize the piece."
    },
    {
      "id": "text-0763",
      "name": "Vishal Ved",
      "rating": 5,
      "text": "Shopping quality price everything was perfect"
    },
    {
      "id": "text-0764",
      "name": "Vijji Ch",
      "rating": 5,
      "text": "Very nice service pasha"
    },
    {
      "id": "text-0766",
      "name": "VIPIN CHANDRA",
      "rating": 5,
      "text": "Mr kunal having good behavior for me ..he clarify to all my doubt about purchasing original pearls.."
    },
    {
      "id": "text-0767",
      "name": "Mohini gupta",
      "rating": 4,
      "text": "Collection is really nice and the customer service is very good. Thank you for attending and give attention towards us.."
    },
    {
      "id": "text-0768",
      "name": "TANGUDU SAI MANIKANTA",
      "rating": 5,
      "text": "Have good collections. Suraj has shown all the collections very patiently."
    },
    {
      "id": "text-0769",
      "name": "Mukul Gahlot",
      "rating": 5,
      "text": "Had a very good purchasing experience with Mr. Kunal. Would definitely recommend and come again to Krishna pearls."
    },
    {
      "id": "text-0770",
      "name": "Sahil Gadhia",
      "rating": 5,
      "text": "Nice service by satish and kunal"
    },
    {
      "id": "text-0771",
      "name": "anand babu",
      "rating": 5,
      "text": "I had a good experience I found my peace by the help of sale person Radha Thanks for making my choice"
    },
    {
      "id": "text-0772",
      "name": "Priyanka S",
      "rating": 5,
      "text": "Had a lovely experience! Mr Satish and Jagannath Reddy and other staff were very patiently and bought a lot of lovely pearls! Thank you 😊 Highly recommend!"
    },
    {
      "id": "text-0773",
      "name": "manorita singh",
      "rating": 5,
      "text": "We had a lovely experience here. Satish was very helpful & showed us exactly what we wanted. Thank you very much, your staff is wonderful!"
    },
    {
      "id": "text-0774",
      "name": "Poorna Kumaran",
      "rating": 4,
      "text": "Nice experience in buying pearls.Good service by Rajkumar"
    },
    {
      "id": "text-0775",
      "name": "ragu ranjan",
      "rating": 5,
      "text": "Very nice service by radha tqu krishna pearls Jubilee hills"
    },
    {
      "id": "text-0776",
      "name": "Hari haran",
      "rating": 5,
      "text": "Wonderful service and very helpful staff. Rajkumar helped us with everything from choosing the right design and models."
    },
    {
      "id": "text-0777",
      "name": "Manisha Sengupta",
      "rating": 5,
      "text": "Very nice collection of jewelry and staff. Raj Kumar sir is very helpful"
    },
    {
      "id": "text-0778",
      "name": "Sadanandandam Palle",
      "rating": 5,
      "text": "Very good collections and nice customer receiveing Kusuma very polite. Very good experience especially raj Kumar and Ashok you soo soo much krishna pearl’s pls visit all off u"
    },
    {
      "id": "text-0779",
      "name": "jyothi gamini",
      "rating": 5,
      "text": "Very beautiful collections nice service by radha and kusuma tqu soo much both off u"
    },
    {
      "id": "text-0780",
      "name": "Annapurna Subbalakshmi",
      "rating": 5,
      "text": "Very nice service by Radha tqu so much Radha"
    },
    {
      "id": "text-0782",
      "name": "Antara Gupta",
      "rating": 5,
      "text": "Amazing Service by Rajkumar"
    },
    {
      "id": "text-0783",
      "name": "Akshaya Srinivasan",
      "rating": 5,
      "text": "We had a lovely experience shopping her. Kunal particularly helped in showing all options as per our liking and was very patient with our requests. Would totally recommend shopping here for great designs of pearls."
    },
    {
      "id": "text-0784",
      "name": "Anees Fatima",
      "rating": 5,
      "text": "Kunal is very nice and polite"
    },
    {
      "id": "text-0785",
      "name": "Romy Cyriac",
      "rating": 5,
      "text": "Radha, good shopping and good items"
    },
    {
      "id": "text-0786",
      "name": "bharath kittu",
      "rating": 5,
      "text": "Satish.M - Thank you for your great help! Your patience and effort made my experience smooth and easy. I truly appreciate your support and excellent service."
    },
    {
      "id": "text-0788",
      "name": "Preeti Pahuja",
      "rating": 5,
      "text": "Mr Satish at Jubilee Hills branch was very patient with us and did show us all the variety possible. Was very pleased with variety and customer service."
    },
    {
      "id": "text-0789",
      "name": "Anu Vijay Kumar",
      "rating": 5,
      "text": "Very Good experience with Rohit."
    },
    {
      "id": "text-0792",
      "name": "Kirti",
      "rating": 5,
      "text": "Kashinath was very helpful. We had a great experience"
    },
    {
      "id": "text-0793",
      "name": "Bharti Rajoli",
      "rating": 5,
      "text": "Rajkumar is very nice and very good service please all of u visit once very nice collection s tqu soo much krishna pearls jubileehills"
    },
    {
      "id": "text-0794",
      "name": "caffeinatedscientist",
      "rating": 4,
      "text": "Good selection of pearls and Satish was very helpful and knowledgable."
    },
    {
      "id": "text-0795",
      "name": "Richa Lowe",
      "rating": 5,
      "text": "Ms. Radha helped me out find the best pearl necklace for me. She is very cooperative. Highly recommended for pearl shopping."
    },
    {
      "id": "text-0796",
      "name": "Sanjayanthan V",
      "rating": 5,
      "text": "Lovely collection,Friendly staffs"
    },
    {
      "id": "text-0797",
      "name": "Tanuja Reddy Konda",
      "rating": 5,
      "text": "Radha is the good service"
    },
    {
      "id": "text-0798",
      "name": "manoj kumar thallapally",
      "rating": 5,
      "text": "Designs were too good. Sales person Sachin was very friendly"
    },
    {
      "id": "text-0800",
      "name": "Dileep Teja",
      "rating": 5,
      "text": "Good pearls variety and the earrings ga and necklace sets come at reasonable prices at the same time with an authenticity certificate. The sales lady Radha has taken care of us well and has explained the differences patiently."
    },
    {
      "id": "text-0801",
      "name": "Dibz",
      "rating": 5,
      "text": "Great service by Mr Satish and Mr vivek and good selection of products."
    },
    {
      "id": "text-0802",
      "name": "Veena Bharath",
      "rating": 5,
      "text": "Radha- awesome experience buying pearls"
    },
    {
      "id": "text-0803",
      "name": "Dishita peketi",
      "rating": 5,
      "text": "Satish service nice"
    },
    {
      "id": "text-0804",
      "name": "Sonali Verma",
      "rating": 5,
      "text": "Helpful team, very supportive and understanding of one’s choices. Reach out Mr. Rajkumar for the best recommendations :)"
    },
    {
      "id": "text-0806",
      "name": "sailaja gorantla",
      "rating": 5,
      "text": "Excellent pearl collection and Rajkumar is a nice sales executive."
    },
    {
      "id": "text-0807",
      "name": "Tanvi Sharma",
      "rating": 5,
      "text": "Great Collection and service"
    },
    {
      "id": "text-0808",
      "name": "Deepak Nambiar",
      "rating": 5,
      "text": "Excellent collection, amazing service. Rajkumar was amazing in taking care of all our requirements."
    },
    {
      "id": "text-0809",
      "name": "Madhuri Ramanathan",
      "rating": 5,
      "text": "Good service from Radha and nice contemporary and pretty earrings"
    },
    {
      "id": "text-0810",
      "name": "Pothula SivaReddy",
      "rating": 4,
      "text": "Very nice service and place"
    },
    {
      "id": "text-0811",
      "name": "Chandana Poojari",
      "rating": 5,
      "text": "Excellent collection."
    },
    {
      "id": "text-0812",
      "name": "Aishwarya Tinaikar",
      "rating": 5,
      "text": "Amazing experience. Friendly staff. Good collection. Would definitely return if possible."
    },
    {
      "id": "text-0813",
      "name": "Dhruthi Devulapalli",
      "rating": 5,
      "text": "Great quality pearls with incredible designs"
    },
    {
      "id": "text-0814",
      "name": "Arathi G.R",
      "rating": 4,
      "text": "Veru good collection of pearls earring.Service was really good."
    },
    {
      "id": "text-0816",
      "name": "Dinesh Badgujar",
      "rating": 5,
      "text": "Rajkumar Thanks for your service & collection offered to me . will visit again"
    },
    {
      "id": "text-0817",
      "name": "Kamal Kishore",
      "rating": 5,
      "text": "Radha was very helpful and helped get what we wanted very patiently"
    },
    {
      "id": "text-0818",
      "name": "Vidya",
      "rating": 5,
      "text": "Kashinath is very good sales"
    },
    {
      "id": "text-0819",
      "name": "Guru Prasanth",
      "rating": 5,
      "text": "Collection was good and the staff was really good, Special mention to Satish and Vivek handling the pearls section got a wonderful gift for my mom"
    },
    {
      "id": "text-0820",
      "name": "Manish Kumar Jha",
      "rating": 5,
      "text": "Mr M Satish is Very Composed person to interact. Nice and cooperative behavior"
    },
    {
      "id": "text-0821",
      "name": "harsh vardhan",
      "rating": 5,
      "text": "Mr.Satish was very helpful."
    },
    {
      "id": "text-0822",
      "name": "Nishitha Kasara",
      "rating": 5,
      "text": "Great service. Good designs."
    },
    {
      "id": "text-0823",
      "name": "Vinitha Reddy",
      "rating": 5,
      "text": "Radha was very welcoming and has assisted us for the purchase of pearl sets. The collection is very nice with reasonable price and quality."
    },
    {
      "id": "text-0824",
      "name": "sachin soni",
      "rating": 5,
      "text": "Amazing experience with Syed ,seemleess shopping experience"
    },
    {
      "id": "text-0825",
      "name": "Rashmi Gupta",
      "rating": 5,
      "text": "Satish was patient , helpful, and gracious. Kusuma was Aldo helpful."
    },
    {
      "id": "text-0826",
      "name": "Roxann Luckenbill",
      "rating": 5,
      "text": "Beautiful selection & excellent service from Kusuma! So happy with my pearl earrings!"
    },
    {
      "id": "text-0827",
      "name": "Sanjana Satish",
      "rating": 5,
      "text": "Thanks for your support Neelam for the product"
    },
    {
      "id": "text-0828",
      "name": "Srihari N",
      "rating": 5,
      "text": "Nice service keep it up"
    },
    {
      "id": "text-0829",
      "name": "subramayam jyoti",
      "rating": 5,
      "text": "I was impressed with the sale skills of Mr Kashinath Looking forward for some more purchases"
    },
    {
      "id": "text-0830",
      "name": "Divya Prakash",
      "rating": 5,
      "text": "Lovely collection!! I was very happy I came to purchase here.. Manjula and kashinath and ashok were very helpful and showed me great collection.. thanks to them.."
    },
    {
      "id": "text-0831",
      "name": "Subathira Senthil",
      "rating": 5,
      "text": "Nice collections and good ambience. Radha attended us & very friendly."
    },
    {
      "id": "text-0832",
      "name": "swapnalatha bhimaneni",
      "rating": 5,
      "text": "Radha service is great👍"
    },
    {
      "id": "text-0833",
      "name": "Priya Gupta",
      "rating": 5,
      "text": "Miss pavni gave great service thank you!"
    },
    {
      "id": "text-0834",
      "name": "Aman Chauhan",
      "rating": 5,
      "text": "B Pavani - she is really nice and gave us genuine suggestions."
    },
    {
      "id": "text-0835",
      "name": "Ashutosh Dhar",
      "rating": 5,
      "text": "Radha and all staff members were pretty good. We came to buy pearl and got all what we wanted."
    },
    {
      "id": "text-0836",
      "name": "Tanya Duggal",
      "rating": 5,
      "text": "Beautiful designs and helpful staff at the store. Special thanks to Chandrashekhar for special assistance."
    },
    {
      "id": "text-0837",
      "name": "Pankaj Lahon",
      "rating": 5,
      "text": "Nice experience , and very well explained by Rajkumar. Will come back to buy more ."
    },
    {
      "id": "text-0838",
      "name": "Sumit D",
      "rating": 5,
      "text": "Excellent service & products"
    },
    {
      "id": "text-0839",
      "name": "NITIN ARORA",
      "rating": 5,
      "text": "I recently had the pleasure of shopping at Krishna Pearls, and I must say, the experience was exceptional. The collection is exquisite, offering a perfect blend of elegance and craftsmanship. A special mention to M. Satish, whose service was outstanding. He was incredibly knowledgeable, patient, and helped me find exactly what I was looking for. His professionalism and customer-centric approach made the entire shopping experience smooth and enjoyable. I highly recommend Krishna Pearls for anyone looking for quality jewelry with excellent service. Kudos to the team, and a big thank you to M. Satish for his assistance!"
    },
    {
      "id": "text-0840",
      "name": "Kharvannan RV",
      "rating": 5,
      "text": "Good collection of pearls , the staff radha was patient and explained about the pearls in detail, had a good overall experience buying pearls"
    },
    {
      "id": "text-0842",
      "name": "Shrutkirti Divekar",
      "rating": 5,
      "text": "Awesome collection and very experienced staff .Thankyou Rajkumar for patience and understanding the concept of jewellery required"
    },
    {
      "id": "text-0843",
      "name": "Niki kumari",
      "rating": 5,
      "text": "We went for pearl shopping and Radha helped us with varieties of options. Overall it was a good experience"
    },
    {
      "id": "text-0848",
      "name": "Laxmi Teja",
      "rating": 5,
      "text": "Satish nice service"
    },
    {
      "id": "text-0849",
      "name": "Mouni Shiva",
      "rating": 5,
      "text": "Very cooperative and frendly"
    },
    {
      "id": "text-0850",
      "name": "Meenakshi Ajith",
      "rating": 5,
      "text": "Satish is very good"
    },
    {
      "id": "text-0851",
      "name": "Aakash G",
      "rating": 5,
      "text": "Pavini offered personalized support for a custom pearl jewelry bracelet, demonstrating patience and expertise. Highly recommend."
    },
    {
      "id": "text-0853",
      "name": "Priyanka Singh",
      "rating": 5,
      "text": "It was good experience with Radha. I bought pearl set They have good amount of collections"
    },
    {
      "id": "text-0854",
      "name": "Reena Ningombam",
      "rating": 5,
      "text": "Collection are available in wide range with reasons price. Staff are very cooperative. Rajkumar and Kunal help to select my items. Thanks to both of them."
    },
    {
      "id": "text-0855",
      "name": "Rahul Patil",
      "rating": 5,
      "text": "Collection was so good Fully satisfied complete wedding and fancy collection is there one of staff govind patil shown me he fully satisfied I like to visit jubilee krishna jewellery"
    },
    {
      "id": "text-0856",
      "name": "Usha Prabhakar",
      "rating": 5,
      "text": "Fabulous collection, must visit this show room"
    },
    {
      "id": "text-0858",
      "name": "ashish mehta",
      "rating": 5,
      "text": "Bought pearl jewellery for wife and mother. Their collection is huge and can serve all price points. Staff is courteous and explained different types of pearl jewellery patiently. Had nice interaction with Mr Sathish and he was able to assist me in finding the right jewellery set. Thanks"
    },
    {
      "id": "text-0860",
      "name": "Shirish S",
      "rating": 5,
      "text": "Very good collection of Pearls Jwellery. B.Pavani was very helpful and patient to understand requirement and suggested right items. Wish all the best to her."
    },
    {
      "id": "text-0861",
      "name": "Nishitha Vemula",
      "rating": 5,
      "text": "The experience was really pleasant. The staff were really sweet."
    },
    {
      "id": "text-0862",
      "name": "Jagannath Biswas",
      "rating": 5,
      "text": "Beautiful experience. Mr. Satish and Mrs. Manjula helped me throughout my purchase. Very helpful staffs."
    },
    {
      "id": "text-0864",
      "name": "Gajanan Nigavekar",
      "rating": 5,
      "text": "Very good and cooperative nature of the staff here. Please do visit."
    },
    {
      "id": "text-0865",
      "name": "Gursimran Shergill",
      "rating": 5,
      "text": "Was a great experience shopping here . All the staff was super helpful ."
    },
    {
      "id": "text-0866",
      "name": "Ravi kapoor",
      "rating": 5,
      "text": "Ambica’s service was good,she’s knowledgeable & quick"
    },
    {
      "id": "text-0867",
      "name": "Venkateshwar rao Mudara",
      "rating": 5,
      "text": "\"Nice designs high end collections good response from salesman\" raj kumar and kusuma was helped us"
    },
    {
      "id": "text-0868",
      "name": "Jitender Gauri",
      "rating": 5,
      "text": "Amazing experience"
    },
    {
      "id": "text-0869",
      "name": "Sameer Agrawal",
      "rating": 5,
      "text": "Nice service provided by ambika."
    },
    {
      "id": "text-0870",
      "name": "Durga Kala",
      "rating": 5,
      "text": "Sachin and team have been excellent in showing and explaining all details. A huge variety of silver collection with excellent customer service"
    },
    {
      "id": "text-0871",
      "name": "Jagan s",
      "rating": 5,
      "text": "Ryt place if you looking for silver articles, guided by ambika n Kashinath on floor.. nice collections n coordinating staff"
    },
    {
      "id": "text-0874",
      "name": "Satyakumar Byri",
      "rating": 5,
      "text": "Ambika gave good ser"
    },
    {
      "id": "text-0875",
      "name": "Hema Jain",
      "rating": 5,
      "text": "Very beautiful n royal collections of pearls jewellery,mr satish sir very good n polite ,he gave as good discount also on purchase of pearls jewellery Thanks"
    },
    {
      "id": "text-0876",
      "name": "prithvee maharaj",
      "rating": 5,
      "text": "Nice pearl collections, excellent service provided by Mr.Damodar and Mr. Satish"
    },
    {
      "id": "text-0877",
      "name": "M.SaiMaha Lakshmi",
      "rating": 5,
      "text": "MS. AMBIKA PROVIDED GOOD SERVICE.THANKS"
    },
    {
      "id": "text-0878",
      "name": "Aishwarya Pemmaraju",
      "rating": 5,
      "text": "Great customer service and care, bought silver from them and highly satisfied with the quality of the product. Ambika helped me with my order, she was able to understand my need of the product and assisted me in buying the right product at the best price. Will definitely recommend this store!"
    },
    {
      "id": "text-0880",
      "name": "Bijay Kumar Dash",
      "rating": 5,
      "text": "Ambika . She is very polite & knowledgeable about the product ."
    },
    {
      "id": "text-0881",
      "name": "Dhananjay Pawar",
      "rating": 5,
      "text": "Excellent pearls collection and very courteous staff"
    },
    {
      "id": "text-0882",
      "name": "Preeti Lakra",
      "rating": 5,
      "text": "Good collection Satish showed behaviour is good"
    },
    {
      "id": "text-0883",
      "name": "Mitali Paul",
      "rating": 5,
      "text": "Pavani is very good woman... Good talking & very good saller"
    },
    {
      "id": "text-0884",
      "name": "LEELA KUMARI P",
      "rating": 5,
      "text": "Mr Mohan Kumar and Mr Jagannad very good service"
    },
    {
      "id": "text-0885",
      "name": "saimi sattar",
      "rating": 5,
      "text": "Beautiful collection and attentive salesperson, mohan. Mr Pasha guided to a great purchase"
    },
    {
      "id": "text-0886",
      "name": "Jahnavi Selvakumar",
      "rating": 5,
      "text": "Efficient and kind service from Mr. Satish. Good variety in the store."
    },
    {
      "id": "text-0887",
      "name": "Gude SaiPrasanthi",
      "rating": 5,
      "text": "Nice staff and really good collection. Thanks for accompanying us Raj Kumar such a patience he has and Manjula for making the billing proces smooth. Thanks Jaganadh Reddy for showing such good collection with patience."
    },
    {
      "id": "text-0888",
      "name": "Akshay Poddaturi",
      "rating": 5,
      "text": "Ambica service is good"
    },
    {
      "id": "text-0889",
      "name": "Pramod Anavangot",
      "rating": 5,
      "text": "Kunal and satish was fantastic and helped me very much to select the items"
    },
    {
      "id": "text-0890",
      "name": "Dr Saroj Utage",
      "rating": 4,
      "text": "Staff is very coperative"
    },
    {
      "id": "text-0891",
      "name": "PRAVEEN KUMAR",
      "rating": 5,
      "text": "I like Sree Krishna jewelries very unique and antic collection available here and good service employee's"
    },
    {
      "id": "text-0892",
      "name": "Srivatsan R",
      "rating": 5,
      "text": "Good experience and excellent customer service thanks to Sathish"
    },
    {
      "id": "text-0893",
      "name": "Yatindra Verma",
      "rating": 5,
      "text": "Satish is very helpful"
    },
    {
      "id": "text-0894",
      "name": "PREM PRAKASH NIRALA Nirala",
      "rating": 5,
      "text": "Kashi Nath Very nice person and good experience"
    },
    {
      "id": "text-0898",
      "name": "Manasvi Kanaparthy",
      "rating": 5,
      "text": "Pasha is very good service"
    },
    {
      "id": "text-0900",
      "name": "j Ravi Kiran",
      "rating": 5,
      "text": "Pasha is very cool salesman"
    },
    {
      "id": "text-0901",
      "name": "Pranu Kotte",
      "rating": 5,
      "text": "Very good service by pasha"
    },
    {
      "id": "text-0902",
      "name": "Shiwani Mishra",
      "rating": 5,
      "text": "My experience at Krishna pearls has always been great and this visit experience was made even smoother with professional service from Satish."
    },
    {
      "id": "text-0903",
      "name": "rahul chavan",
      "rating": 4,
      "text": "Was very good experience at shop , Satish took care of our needs well"
    },
    {
      "id": "text-0904",
      "name": "Dr Lalit Mohan Joshi",
      "rating": 5,
      "text": "Sathish, Kisha, Mohan are awesome staff keen to serve you there👍"
    },
    {
      "id": "text-0906",
      "name": "Nayonika Rudra",
      "rating": 5,
      "text": "Pavani helped me with her expertise. She is patient with the customer and shows them what they need."
    },
    {
      "id": "text-0907",
      "name": "Gagandeep Singh",
      "rating": 5,
      "text": "Pasha sir….a very good service person! Good collection"
    },
    {
      "id": "text-0908",
      "name": "saimounika kovi",
      "rating": 5,
      "text": "Good service Raj Kumar"
    },
    {
      "id": "text-0909",
      "name": "Aditya Jeripotula",
      "rating": 5,
      "text": "Thanks to Mr Raj Kumar and Ms Pavani"
    },
    {
      "id": "text-0911",
      "name": "Debahuti Banerjee",
      "rating": 5,
      "text": "Very nice collection... Staffs behaviour is very good specially satish, kashinath, bhavani and jagannath reddy..."
    },
    {
      "id": "text-0912",
      "name": "V V",
      "rating": 5,
      "text": "Amazing quality of pears at the best price. Sales person Pavani was very patience in showing different models and very cooperative"
    },
    {
      "id": "text-0913",
      "name": "Debadyuti Banerjee",
      "rating": 5,
      "text": "Very beautiful collection ... Good behaviour of the staff ... Kashinath , bhavna and Jagannath three helped us a lot"
    },
    {
      "id": "text-0914",
      "name": "Sridhanya Harihar",
      "rating": 5,
      "text": "Ms. B Pavani was our sales rep and she was absolutely wonderful, smiling and showed us so many designs patiently and we ended up making a very satisfactory purchase. Thank you."
    },
    {
      "id": "text-0916",
      "name": "cherish E",
      "rating": 5,
      "text": "Pavani Sales rep was pretty good at her job.. She is marvelous with good rapport with customers... Hopefully she will raise to heights she wish for.."
    },
    {
      "id": "text-0917",
      "name": "Bhaskar P. Chowdary",
      "rating": 5,
      "text": "Nice collection. Pavani helped us to choose right collections. Thank you."
    },
    {
      "id": "text-0918",
      "name": "Riyah Ramesh",
      "rating": 5,
      "text": "Excellent Service from Pasha"
    },
    {
      "id": "text-0919",
      "name": "Anusha S",
      "rating": 5,
      "text": "Satish is very good"
    },
    {
      "id": "text-0920",
      "name": "Prajakta Ghatikar",
      "rating": 5,
      "text": "Wonderful experience , we had a short time , and got what we wanted with the help of Kusuma and Kashinath . Thankyou very much . Will visits again in our next trip of Hyderabad"
    },
    {
      "id": "text-0921",
      "name": "Biswarup Chaki",
      "rating": 5,
      "text": "It was a great shopping experience specially salesperson kashinath who knew what he was selling."
    },
    {
      "id": "text-0922",
      "name": "Abhishek Srivastava",
      "rating": 5,
      "text": "I visited while in HYD on a friend's reference and was delighted by the services offered. Pasha from the staff attended to us and was prompt and courteous in her manners ."
    },
    {
      "id": "text-0923",
      "name": "Hema D.",
      "rating": 5,
      "text": "Lovely collections as seen in social media. Very good service by Mr. Rajkumar. Must visit place to buy certified pearls."
    },
    {
      "id": "text-0924",
      "name": "Arun Kamal R V",
      "rating": 5,
      "text": "Had a pleasant shopping experience with Mr. Pasha and staff (Kusuma and Pavani)"
    },
    {
      "id": "text-0926",
      "name": "Trisha sinha",
      "rating": 5,
      "text": "Amazing collection. Best service from pavani. Must visit in Hyderabad for pearls"
    },
    {
      "id": "text-0928",
      "name": "Rifat Parween",
      "rating": 5,
      "text": "Raj kumar Very nice collection Very supportive staff members"
    },
    {
      "id": "text-0929",
      "name": "Mohammad Hozaifa",
      "rating": 5,
      "text": "Mrm Raj Kumar is very good at customer dealing."
    },
    {
      "id": "text-0930",
      "name": "Rajesh T",
      "rating": 5,
      "text": "Mr. Pasha… great service , collections are good, very friendly environment,"
    },
    {
      "id": "text-0931",
      "name": "Susan George",
      "rating": 5,
      "text": "Good experience with Mr. Pasha. Good collection."
    },
    {
      "id": "text-0932",
      "name": "Dhwani Gopinath",
      "rating": 5,
      "text": "Had a great experience at Krishna pearls.. Pavani was exceptionally cordial"
    },
    {
      "id": "text-0933",
      "name": "Madhurima Sane",
      "rating": 5,
      "text": "Raj Kumar very helpful"
    },
    {
      "id": "text-0934",
      "name": "Kruthi Challa",
      "rating": 5,
      "text": "Pavani and Kashana were helpful in assisting me today with finding the right pieces"
    },
    {
      "id": "text-0935",
      "name": "Ritika",
      "rating": 5,
      "text": "It was wonderful shopping with Krishna jewellers. Everyone is polite and patient 😊"
    },
    {
      "id": "text-0936",
      "name": "Aditi Upadhyay",
      "rating": 5,
      "text": "Had great experience seeing and buying pearl jewellery. Kusuma, Raj Kumar and Kunal helped us very well. We bought 6 sets overall."
    },
    {
      "id": "text-0937",
      "name": "Mega Lavanya",
      "rating": 5,
      "text": "Very great service is the best sales man good staff especially pasha"
    },
    {
      "id": "text-0938",
      "name": "Varun Chaturvedi",
      "rating": 5,
      "text": "Nice service by pasha"
    },
    {
      "id": "text-0939",
      "name": "sonakshi bvs",
      "rating": 5,
      "text": "Good Collection of both gold and pearls Worth purchasing..!"
    },
    {
      "id": "text-0940",
      "name": "Praveen Dasari",
      "rating": 5,
      "text": "Good service and very good experience thaks for the assistant."
    },
    {
      "id": "text-0941",
      "name": "yella sravanthi",
      "rating": 5,
      "text": "Gold items and service are good"
    },
    {
      "id": "text-0942",
      "name": "Anshum Bangari",
      "rating": 5,
      "text": "Value for money and the service was excellent. The staff behavior was great especially Mr.Satish and Kusuma and kunal"
    },
    {
      "id": "text-0943",
      "name": "Kiranmaye K",
      "rating": 5,
      "text": "Thank you rajkumar"
    },
    {
      "id": "text-0944",
      "name": "vishal singh",
      "rating": 5,
      "text": "Nice experience"
    },
    {
      "id": "text-0945",
      "name": "Arun Kancharla",
      "rating": 5,
      "text": "A.Hanumanth was very helpful in showing us the silver articles..really happy with the service.."
    },
    {
      "id": "text-0946",
      "name": "Srishti Chandra",
      "rating": 4,
      "text": "Customer service is really good. Sathis and Pavani helped me to choose the correct jewellery I wanted"
    },
    {
      "id": "text-0947",
      "name": "Nihar Garg",
      "rating": 5,
      "text": "Pasha service is nice"
    },
    {
      "id": "text-0949",
      "name": "Shristy Singh",
      "rating": 5,
      "text": "Great place with beautiful jewelry and friendly people. Pavani and Kashinath helped us shop today. I 100% recommend the store"
    },
    {
      "id": "text-0950",
      "name": "Arjun T",
      "rating": 5,
      "text": "Pasha is very nice"
    },
    {
      "id": "text-0951",
      "name": "Manjistha Sarma",
      "rating": 5,
      "text": "Good service by Pavani and Satish ."
    },
    {
      "id": "text-0952",
      "name": "Viswanathan Gokulkrishnan",
      "rating": 5,
      "text": "M.Satish was of great help and the service was outstanding"
    },
    {
      "id": "text-0953",
      "name": "atul sharma",
      "rating": 5,
      "text": "Great collection, and service. Very very humble in explaining everything in detail. Thank you Kashinath Ji"
    },
    {
      "id": "text-0954",
      "name": "Md Yasin",
      "rating": 5,
      "text": "Good collections and very polite and excellent service please visit all of u thank u Satish"
    },
    {
      "id": "text-0955",
      "name": "Moumita Payra",
      "rating": 5,
      "text": "It was a good experience, and kavita helped me very well. Thank You."
    },
    {
      "id": "text-0956",
      "name": "Chaitali Goswami",
      "rating": 5,
      "text": "Good collection very nice store please visit once too all off u thank u pasha"
    },
    {
      "id": "text-0957",
      "name": "Jigyasa Sharma",
      "rating": 5,
      "text": "Kashinath...soft spoken...good variety and option of pearl jewellery"
    },
    {
      "id": "text-0958",
      "name": "Ravikiran K",
      "rating": 5,
      "text": "We had very good experience in Krishna pearls. Hanuman A assured us very well and make us feel comfortable in selecting good design. Thank you once again"
    },
    {
      "id": "text-0959",
      "name": "sindhuja ramkumar",
      "rating": 5,
      "text": "Best place to buy silver items.."
    },
    {
      "id": "text-0960",
      "name": "Pragya Priyadarshini",
      "rating": 5,
      "text": "Satish... He is supportive"
    },
    {
      "id": "text-0961",
      "name": "priyanka jayachandran",
      "rating": 5,
      "text": "We came all the way from Chennai to Krishna pearls and we fell head over heels in love with the place. A shopping which was planned as a quick stop took us nearly two hours.Mr. Kashinath, Mr.Jaganath and Mrs. Paavani were one of the best staff we met any where else. We really appreciate the service of Ms. Kavita and Mr. Vipin from silver section . Looking forward to shopping again. Thank you so much"
    },
    {
      "id": "text-0962",
      "name": "Prashant Baroliya",
      "rating": 5,
      "text": "Rajkumar is very nice service good collection keep it up"
    },
    {
      "id": "text-0963",
      "name": "Divya Adumala",
      "rating": 5,
      "text": "“I absolutely love this silver store! Their collection is truly unique and stands out from the usual designs you find elsewhere. Each piece feels special and has its own charm, whether you’re looking for something modern or traditional. The quality is exceptional, and the craftsmanship is impeccable. Highly recommend this store for anyone who wants something different and stunning!”"
    },
    {
      "id": "text-0964",
      "name": "Yasmeen Basith",
      "rating": 5,
      "text": "Thank you Kashinath for providing us with excellent customer service."
    },
    {
      "id": "text-0965",
      "name": "Parag Desai",
      "rating": 4,
      "text": "The sales person Satish was very welcoming and helpful. However, I wasn't very impressed with the pearl collections you have. We have high expectations from brand like yours. Overall an average experience."
    },
    {
      "id": "text-0966",
      "name": "Subba Rao",
      "rating": 5,
      "text": "Good service by Satish"
    },
    {
      "id": "text-0967",
      "name": "Sravya Adiraju",
      "rating": 5,
      "text": "Excellent pearls..good customer service from Kashinath"
    },
    {
      "id": "text-0968",
      "name": "nandini yamdagni",
      "rating": 5,
      "text": "I had an extremely hospitable experience with Pavani and Kashi. Loved their pearl collection"
    },
    {
      "id": "text-0969",
      "name": "Dr. Nrusingha Charan Pradhan",
      "rating": 5,
      "text": "Value for money and the service was excellent. The staff behavior was great especially Mr. Kasinath and Kusum"
    },
    {
      "id": "text-0970",
      "name": "Yogesh Dash",
      "rating": 5,
      "text": "Kashinath and Kusuma behaved well and helped a lot during purchase."
    },
    {
      "id": "text-0971",
      "name": "Selvaraj Subramanian",
      "rating": 5,
      "text": "Rajkumar and rohith helped well to select the pearls thank you"
    },
    {
      "id": "text-0972",
      "name": "NIBEDITA SARKAR",
      "rating": 5,
      "text": "Very good services by kashinath cool and very polite"
    },
    {
      "id": "text-0973",
      "name": "Rohini Sadasivan",
      "rating": 5,
      "text": "Pasha ji is great! Kusuma was very helpful today!"
    },
    {
      "id": "text-0974",
      "name": "aishu loknath",
      "rating": 5,
      "text": "i had a great experience with this place , the quality of the pearls are amazing, rajakumar sir and manjula maam were very welcoming"
    },
    {
      "id": "text-0975",
      "name": "abi loknath",
      "rating": 5,
      "text": "Raj Kumar is very good"
    },
    {
      "id": "text-0976",
      "name": "hbs parihar",
      "rating": 5,
      "text": "Pasha serving is very good collection also nice keep it up"
    },
    {
      "id": "text-0977",
      "name": "Radhika Mateti",
      "rating": 5,
      "text": "Happy with the service@krishna jewl. Kasinath helped us a lot. Thank you!"
    },
    {
      "id": "text-0978",
      "name": "BHARATHI GOLI",
      "rating": 5,
      "text": "Raj Kumar and kusuma we both are very good thank you"
    },
    {
      "id": "text-0980",
      "name": "iphone user",
      "rating": 5,
      "text": "Very cool and inspiring thank u pasha sir"
    },
    {
      "id": "text-0981",
      "name": "Mayank Aggarwal",
      "rating": 5,
      "text": "Pavani and Rajkumar did very good job in explaining and helping with all options"
    },
    {
      "id": "text-0982",
      "name": "Gautier CHAMPION",
      "rating": 5,
      "text": "Super expérience avec Pasha"
    },
    {
      "id": "text-0983",
      "name": "omkar baradol",
      "rating": 5,
      "text": "Pasha nice service and options were great"
    },
    {
      "id": "text-0984",
      "name": "L Yamini",
      "rating": 5,
      "text": "Pavani ...she very nice and polite good collections thank u Krishna pearls"
    },
    {
      "id": "text-0985",
      "name": "Makireddy Rajalakshmi",
      "rating": 5,
      "text": "Very nice service pavani and kusuma good collection s"
    },
    {
      "id": "text-0986",
      "name": "Akash Verma",
      "rating": 5,
      "text": "Great experience at the Jubilee Hills store in Hyderabad. Pavani has showed the range of pearl products that has helped me to choose the best. Kudos to the team."
    },
    {
      "id": "text-0987",
      "name": "HIMANSHI SHARMA",
      "rating": 5,
      "text": "Thankyou Satish sir."
    },
    {
      "id": "text-0988",
      "name": "Shantanu Raman",
      "rating": 5,
      "text": "Wonderful experience,Nice staff and they have a lot of knowledge about their jewels and products. Especially Mr. Kashinath and Ms.Manjula were very polite and explained everything for about 4 hours and also explained the history about the city of pearls, Hyderabad.."
    },
    {
      "id": "text-0990",
      "name": "R Sasidhar",
      "rating": 5,
      "text": "Pasha helped us find an amazing necklace and got it with in reasonable price.overall great experience"
    },
    {
      "id": "text-0992",
      "name": "Mansi Jain",
      "rating": 5,
      "text": "Rajkumar was great, nice service."
    },
    {
      "id": "text-0993",
      "name": "Kundankumar Kasar",
      "rating": 5,
      "text": "M Satish sir have given very good service al well explained about the pearl quality"
    },
    {
      "id": "text-0994",
      "name": "Uttam Gajjar",
      "rating": 5,
      "text": "Excellent courtesy shown by Pavani and Rajkumar. Keep it up"
    },
    {
      "id": "text-0995",
      "name": "shivshankar singh",
      "rating": 5,
      "text": "Rajkumar he given very nice service. Very polite and well behaved. Quite Impressive"
    },
    {
      "id": "text-0996",
      "name": "amit pandey",
      "rating": 5,
      "text": "Pasha great show good shop genuine pearls"
    },
    {
      "id": "text-0997",
      "name": "neeraj upadhyay",
      "rating": 5,
      "text": "Good and great product . Especially Mr pasha who was a great help. Highly recommended"
    },
    {
      "id": "text-0998",
      "name": "AYUSH SINGH",
      "rating": 5,
      "text": "Promptly attended by the staff - Pavani and Raj Kumar . Will come again for future purchases"
    },
    {
      "id": "text-0999",
      "name": "Divesh thakur",
      "rating": 5,
      "text": "Really great support by Sandeep Who works on the 2 nd floor and they have helped with the purchase Pasha who is the manager also helped with the pricing and billing Kusuma who has offered me tea and coffee Made me feel special customer and I would definitely visit the store again"
    },
    {
      "id": "text-1001",
      "name": "yashika sareen",
      "rating": 5,
      "text": "Specially assisted by pasha.very nice collection and jicely attended by them"
    },
    {
      "id": "text-1002",
      "name": "Aaron Solomon",
      "rating": 5,
      "text": "Kashinath Manjula good staff , good experience collection are good 👍"
    },
    {
      "id": "text-1003",
      "name": "Saumen Das",
      "rating": 5,
      "text": "Nice collection of pearls, good behaviour by the staffs, will visit next time ad well."
    },
    {
      "id": "text-1004",
      "name": "Somya Jain",
      "rating": 4,
      "text": "The service from Rajkumar and Kusuma was good"
    },
    {
      "id": "text-1006",
      "name": "D S",
      "rating": 5,
      "text": "Excellent service by Mr. Satish!"
    },
    {
      "id": "text-1007",
      "name": "Sudha Bhat",
      "rating": 5,
      "text": "Great experience. Pasha was a big help"
    },
    {
      "id": "text-1008",
      "name": "Alpa Sonkar",
      "rating": 5,
      "text": "Kashinath , kunal and kusuma were very good. Nice collection."
    },
    {
      "id": "text-1009",
      "name": "GAURAV SHARMA",
      "rating": 5,
      "text": "Fabulous experience. Mr V Kashinath attended and was very keen to help and present multiple selections."
    },
    {
      "id": "text-1010",
      "name": "Adbhut Sikha",
      "rating": 5,
      "text": "Pasha was very helpful in making us select the designs. Thanks!"
    },
    {
      "id": "text-1011",
      "name": "Trauj Tu",
      "rating": 5,
      "text": "Rajkumar he is very helpful and very nice recving kusuma very helped soo much thank u krishnapearls"
    },
    {
      "id": "text-1012",
      "name": "Divya",
      "rating": 5,
      "text": "Excellent and efficient service! ✨"
    },
    {
      "id": "text-1013",
      "name": "Sasanka GRS",
      "rating": 5,
      "text": "They have a good range of collections and Kashinath was a great guide."
    },
    {
      "id": "text-1016",
      "name": "Nazaneen Begum",
      "rating": 5,
      "text": "Mr.Pasha and Ms kusuma .. collection is good ..all varieties available ..good service .."
    },
    {
      "id": "text-1017",
      "name": "Aamir Ali",
      "rating": 5,
      "text": "Pasha and kusuma.. good service.. and collection is good but price is on little higher side compared to other pearl shops for similar kind of collection.."
    },
    {
      "id": "text-1018",
      "name": "ahana kaul",
      "rating": 5,
      "text": "Amazing collection and even better service by Satish and Manjula"
    },
    {
      "id": "text-1019",
      "name": "Melanie D'Costa",
      "rating": 5,
      "text": "Good service, good collection"
    },
    {
      "id": "text-1020",
      "name": "Subramanyam KNV (Subbu)",
      "rating": 5,
      "text": "Good experience. Good suggestions and service by Satish."
    },
    {
      "id": "text-1021",
      "name": "Anshika Thakur",
      "rating": 5,
      "text": "Raj Kumar sir is assistant me in pearls This store is best in town."
    },
    {
      "id": "text-1023",
      "name": "latha sree",
      "rating": 5,
      "text": "Raj Kumar and kusuma nice service good collectionns"
    },
    {
      "id": "text-1024",
      "name": "divya reddy",
      "rating": 5,
      "text": "Rajkumar nice service"
    },
    {
      "id": "text-1025",
      "name": "Monowar Hussain",
      "rating": 5,
      "text": "Raj Kumar He is a good guy with good sense of humour Kusuma Great sales girl with convincing ability"
    },
    {
      "id": "text-1026",
      "name": "Aadhithya Thiyagarajan",
      "rating": 5,
      "text": "Sales executive rajkumar was very friendly and overall good experience"
    },
    {
      "id": "text-1027",
      "name": "Aishwarya Jote",
      "rating": 5,
      "text": "Really amazing jewelry collection. Good recommendation given by Pasha, Manjula and Rohit. Helped us choose the best options for family and friends."
    },
    {
      "id": "text-1028",
      "name": "Amith Iraj Sood",
      "rating": 5,
      "text": "Satisfied result and happy with service. Pasha, Rohit and Manjula"
    },
    {
      "id": "text-1029",
      "name": "Rachita Sarangi",
      "rating": 5,
      "text": "Had a great shopping experience with Mr. Satish! Good job... Will definitely visit again!"
    },
    {
      "id": "text-1030",
      "name": "meenal dagar",
      "rating": 5,
      "text": "Superb collection and awesome customer service, thank you sathish & team 😊"
    },
    {
      "id": "text-1032",
      "name": "Murthy Nalla",
      "rating": 5,
      "text": "Satish . He is very nice service thank u"
    },
    {
      "id": "text-1033",
      "name": "Sahithi Tammineni",
      "rating": 5,
      "text": "Mr Pasha and Kunal helped us in selection of return gifts for my sister’s baby shower. They very patiently showed us the available options and worked with us in getting best price. They were very respectful in their conduct and spoke very warmly and also helped us with good packaging of the gifts. Thank you for the service, always the best experience in Shri Krishna!"
    },
    {
      "id": "text-1034",
      "name": "Rini Banerjee",
      "rating": 5,
      "text": "Had a great experience shopping at KPJ. Mr. Kashinath assisted us throughout the process."
    },
    {
      "id": "text-1035",
      "name": "Tirumala Koduri",
      "rating": 5,
      "text": "Satish was very helpful. Service was great. Good variety"
    },
    {
      "id": "text-1036",
      "name": "Sukanya Dasgupta",
      "rating": 5,
      "text": "Satish and Manjula were great and they helped us choosing the right pearl👍🏻"
    },
    {
      "id": "text-1038",
      "name": "Achala Waghmare",
      "rating": 5,
      "text": "Had a very good experience here. Pasha was very welcoming and kind. They have very good post purchase service as well. Would definitely recommend."
    },
    {
      "id": "text-1039",
      "name": "Dhvanika Tanna",
      "rating": 5,
      "text": "Nice collection and Ms. Manjula provided lovely services. Mr. Kashi was gracious too."
    },
    {
      "id": "text-1040",
      "name": "Sohini roy",
      "rating": 5,
      "text": "Enjoyed the experience and pasha was really helpful in explaining the entire process thank you"
    },
    {
      "id": "text-1041",
      "name": "Yathin Reddy",
      "rating": 5,
      "text": "Hospitality was great . Rama Lakshmi has given me good assistance (Best Value )"
    },
    {
      "id": "text-1042",
      "name": "Farah Razvi",
      "rating": 5,
      "text": ".Manjula and Kashinath was very helpful, lovely experience"
    },
    {
      "id": "text-1044",
      "name": "Varun Veer",
      "rating": 5,
      "text": "Friendly staff, very courteous. Great collection."
    },
    {
      "id": "text-1046",
      "name": "Kaushik Saha",
      "rating": 5,
      "text": "Pasha Very prompt, courteous service. Great ambience. Will come again during next visit to Hyderabad."
    },
    {
      "id": "text-1047",
      "name": "shahil kumar",
      "rating": 5,
      "text": "Satish he very helpful good collection the biggest showroom"
    },
    {
      "id": "text-1048",
      "name": "Vivek Patel",
      "rating": 5,
      "text": "We visited the Krishna jewellery shop on diwali. We liked the collection. And I would like to appreciate Mr.Pasha's support for selecting jewellery."
    },
    {
      "id": "text-1049",
      "name": "bhagirath jogdand",
      "rating": 5,
      "text": "Rajkumar and other staff were very courteous. Thnx."
    },
    {
      "id": "text-1050",
      "name": "Vadapally Nagashree",
      "rating": 5,
      "text": "Good collection,Satish helped to pick the perfect pearl jewellery."
    },
    {
      "id": "text-1051",
      "name": "sailish behal",
      "rating": 4,
      "text": "I visited the store and stock is good. Kashinath was helpful"
    },
    {
      "id": "text-1052",
      "name": "vasavi nagunuri",
      "rating": 5,
      "text": "Thank you Pasha Fantastic personalized service."
    },
    {
      "id": "text-1053",
      "name": "Renuka",
      "rating": 5,
      "text": "Have good collection and great services by Kasinath and Kusuma"
    },
    {
      "id": "text-1054",
      "name": "Praveen Bollam",
      "rating": 5,
      "text": "Very good pearl jewellery collection. Kashinath & Kusuma service is very good.. they are able to understand our requirement a nd suggest jewellery"
    },
    {
      "id": "text-1055",
      "name": "shubhanshu mehrotra",
      "rating": 5,
      "text": "Kashinath was the person, I am a regular customer here. Good service and products."
    },
    {
      "id": "text-1056",
      "name": "Swetha Vutukuri",
      "rating": 5,
      "text": "Raj Kumar,he has helped me in picking good parls am happy with the product thanku for Krishna Jewellers"
    },
    {
      "id": "text-1057",
      "name": "HADIBANDHU SAHOO",
      "rating": 5,
      "text": "Raj kumar Is nice service the best shop jewellery shop in Jubilee hills please visit once all of u"
    },
    {
      "id": "text-1058",
      "name": "Ary Gupta",
      "rating": 5,
      "text": "Rajkumar overall dealing of staff is excellent."
    },
    {
      "id": "text-1059",
      "name": "vamsi keerthi",
      "rating": 5,
      "text": "Pasha garu is showed d items very well"
    },
    {
      "id": "text-1060",
      "name": "Arun Singh",
      "rating": 5,
      "text": "Great experience with Mr Satish can request him for some discount"
    },
    {
      "id": "text-1061",
      "name": "Vgsankar Veldurai",
      "rating": 5,
      "text": "@Rajkumar….Good customer service must visit the store"
    },
    {
      "id": "text-1062",
      "name": "Hima Maramreddy",
      "rating": 5,
      "text": "Great experience with Kusuma and Khasinath!"
    },
    {
      "id": "text-1063",
      "name": "Vamadevan K",
      "rating": 5,
      "text": "Pasha , Kunal and Kusuma was helpful in selecting the jewellery. Really appreciate the help"
    },
    {
      "id": "text-1064",
      "name": "Priti Mahapatre",
      "rating": 5,
      "text": "Good Collection and ,Good Service thank u pasha ji and kusuma please visit the store alll"
    },
    {
      "id": "text-1065",
      "name": "Nandhakumar Senthil",
      "rating": 5,
      "text": "Good pearls!!! Raj kumar and kusuma shows best collections!!"
    },
    {
      "id": "text-1066",
      "name": "Tejveer Singh",
      "rating": 5,
      "text": "Satish was good salesman"
    },
    {
      "id": "text-1067",
      "name": "Smriti Dixit",
      "rating": 5,
      "text": "Pasha service is excellent nice collections rohit and kusum helping very nice"
    },
    {
      "id": "text-1068",
      "name": "Falguni Joshi",
      "rating": 5,
      "text": "Nice service and very good collectoins pasha and kunal more helping"
    },
    {
      "id": "text-1069",
      "name": "Giruba Sankar",
      "rating": 5,
      "text": "Good service and support from the employes kashinath, kushma they guided well and helped us a lot."
    },
    {
      "id": "text-1070",
      "name": "Ashwani Rawat",
      "rating": 5,
      "text": "It was a wonderful experience. Thanks Satish for help extended."
    },
    {
      "id": "text-1071",
      "name": "Himanshu Munda",
      "rating": 5,
      "text": "Kashinath Ji and Kusuma Ji have wonderfully explained each ornament collection in their store and would recommend all to visit once."
    },
    {
      "id": "text-1072",
      "name": "Khushi Sahoo",
      "rating": 5,
      "text": "Good place...good varieties to explore...pasha and kusuma were very helpful."
    },
    {
      "id": "text-1075",
      "name": "Media Team",
      "rating": 5,
      "text": "Rajkumar and kushma were amazing. Loved their collection. Must visit"
    },
    {
      "id": "text-1077",
      "name": "Karthikeyan Deenadhayalan",
      "rating": 5,
      "text": "I came to buy some pearl jewellery for my wife and daughters. Amazing collections and great customer service."
    },
    {
      "id": "text-1078",
      "name": "Aswini",
      "rating": 5,
      "text": "Rajkumar the customer service is very good"
    },
    {
      "id": "text-1079",
      "name": "Sangamitra Bhowmik",
      "rating": 5,
      "text": "Kashinath serving very nice and also kusuma nice helping best shop in jubieehills please visit the store"
    },
    {
      "id": "text-1080",
      "name": "janani janu",
      "rating": 5,
      "text": "Mr. pasha has given very good service with nice product please visit the store"
    },
    {
      "id": "text-1081",
      "name": "Kushal Gandhi",
      "rating": 5,
      "text": "Very good service by staff of Krishna pearls Kashinath ji and Kunal ji. Thank you."
    },
    {
      "id": "text-1082",
      "name": "Usha Ramani",
      "rating": 5,
      "text": "Visited Krishna Jewellers at Jubili hills today . Sateesh has shown items based on our choice with patience and shown many items and given enough time to select which is very important when buying gold. Can visit for designer variety of gold with pearls and precious stones"
    },
    {
      "id": "text-1083",
      "name": "shruthi reddy",
      "rating": 5,
      "text": "The store has good collections of pearl jewellery. Staff members Pasha and Kusuma were quite good with the service and in showing us different collections."
    },
    {
      "id": "text-1084",
      "name": "Nithin M R",
      "rating": 5,
      "text": "I have always had a pleasant experience at Krishna Pearls & Jewellers. The only place for me to buy pearls and jewels from. Thank you Rajkumar, Kunal and Kusuma for all the support. Have a great day."
    },
    {
      "id": "text-1087",
      "name": "Raed Hassan",
      "rating": 5,
      "text": "V. Kashinath was great"
    },
    {
      "id": "text-1088",
      "name": "Taalish",
      "rating": 5,
      "text": "Satish, nice quick service."
    },
    {
      "id": "text-1089",
      "name": "Shraddha Pandey",
      "rating": 5,
      "text": "Very good collection and very polite employees"
    },
    {
      "id": "text-1091",
      "name": "Narsimha Murthy",
      "rating": 5,
      "text": "Kashina and kusuma good service nice collection the best shop in jubilee hills Krishna jewellers"
    },
    {
      "id": "text-1092",
      "name": "Kaustav Das",
      "rating": 5,
      "text": "Satish helped me purchase the jewellery"
    },
    {
      "id": "text-1093",
      "name": "Abhi",
      "rating": 5,
      "text": "Rajkumar and Kusuma helped us today to close a small purchase. Showed us multiple models, well organized and coordinating team"
    },
    {
      "id": "text-1094",
      "name": "Rhea Kochhar",
      "rating": 5,
      "text": "All the staff served me very well. Thank you"
    },
    {
      "id": "text-1095",
      "name": "Sarika Dakshikar",
      "rating": 5,
      "text": "Wonderful shopping experience ! Great variety of sea pearls n river pearls too ! Mr Abdul Pasha was of great help."
    },
    {
      "id": "text-1096",
      "name": "vivek parauha",
      "rating": 5,
      "text": "Excellent demo by Mr. Pasha, authentic pearls sold here"
    },
    {
      "id": "text-1098",
      "name": "Nagamani Gadiraju",
      "rating": 5,
      "text": "I bought a nakshi necklace and a pair of antique earrings from here. Pavani showed us all these pieces and was very helpful ."
    },
    {
      "id": "text-1099",
      "name": "Venkata Megham",
      "rating": 5,
      "text": "Excellent service by Kashinath and Kusuma, Collection was great, they showed me several options and I purchased the perfect pearl set. They were extremely helpful and I recommend them to anyone who comes to this store. Thank you!"
    },
    {
      "id": "text-1100",
      "name": "Manika Gupta",
      "rating": 5,
      "text": "Mr. Raj Kumar was a great help to us today. Over all experience was nice"
    },
    {
      "id": "text-1101",
      "name": "Upasana Singh",
      "rating": 5,
      "text": "V. Kashinath & team are extremely polite & knowledgeable. Store has amazing collection ! A must visit"
    },
    {
      "id": "text-1102",
      "name": "Ruju Unadkat",
      "rating": 5,
      "text": "Pravin ji was really helpful andoffered his valuable insight also."
    },
    {
      "id": "text-1103",
      "name": "Sahil Chaudhary",
      "rating": 5,
      "text": "Kshainath and kusuma excellent service provided"
    },
    {
      "id": "text-1104",
      "name": "mansi mittal",
      "rating": 5,
      "text": "The staff was very friendly and supportive. Pasha helped me choose wonderful pieces. Kushma gave valuable suggestions and was super sweet.."
    },
    {
      "id": "text-1105",
      "name": "Suraj sirsikar",
      "rating": 5,
      "text": "Had a really good experience with Mr. Kashinath who explained things well"
    },
    {
      "id": "text-1106",
      "name": "rajyalakshmin madhavam",
      "rating": 5,
      "text": "Good experience, Mr Kashi and Kusuma are very good staff. Best place to visit for pearls n gold ornaments."
    },
    {
      "id": "text-1108",
      "name": "Vasundhara Devi",
      "rating": 5,
      "text": "Pasha Always prompt and cordial"
    },
    {
      "id": "text-1109",
      "name": "Prashanth Lakhamraju",
      "rating": 5,
      "text": "Raj Kumar is very good service"
    },
    {
      "id": "text-1111",
      "name": "Anuj Aglawe",
      "rating": 5,
      "text": "Pasha, he's a nice presenter, collections he shown were good"
    },
    {
      "id": "text-1112",
      "name": "CHETNA GUJRAL",
      "rating": 5,
      "text": "Designs are extremely impressive. Very smooth experience with the salesperson Rajkumar sir"
    },
    {
      "id": "text-1113",
      "name": "Aditi Ramchandra",
      "rating": 5,
      "text": "Had a great time! Me and my girl friends bought 5 ear rings made of pearl! Cheers! :)"
    },
    {
      "id": "text-1114",
      "name": "Ashwarya Jain",
      "rating": 5,
      "text": "Great collection and Service by Kashinath"
    },
    {
      "id": "text-1115",
      "name": "Paban Sarma",
      "rating": 5,
      "text": "Awesome shopping experience. Satish and Kusuma has server us well. Great collection of all ranges."
    },
    {
      "id": "text-1116",
      "name": "karunakar sadarla@",
      "rating": 5,
      "text": "excellent service. People working over here having lot patience.. they themselves showing verity of things in it.. superb.. I like it.. over experience.. super"
    },
    {
      "id": "text-1117",
      "name": "Jaya T",
      "rating": 5,
      "text": "Mr. Satish is a good salesman and good service has been provided by Krishna pearls"
    },
    {
      "id": "text-1118",
      "name": "Rekha Kakkar",
      "rating": 5,
      "text": "Satish was good in showing us all the varieties of pearls and helped us in our purchase"
    },
    {
      "id": "text-1119",
      "name": "Niharika Vykuntam",
      "rating": 4,
      "text": "Raj Kumar has shown us nice pearl sets....has done a good work"
    },
    {
      "id": "text-1121",
      "name": "Nithish D",
      "rating": 5,
      "text": "Praveen and rajkumar were very good host for our pearl purchase...everything all the best experience"
    },
    {
      "id": "text-1123",
      "name": "tanmay godiyal",
      "rating": 5,
      "text": "Satish and Kusuma were wonderfully assisting me while purchasing a beautiful earrings for my dear one."
    },
    {
      "id": "text-1125",
      "name": "LIPI SINGH",
      "rating": 5,
      "text": "Pasha is a very nice sales executive and helped me find a jwellery as a gift for my mom"
    },
    {
      "id": "text-1126",
      "name": "Anjali Chowdary",
      "rating": 5,
      "text": "Nice collection pasha"
    },
    {
      "id": "text-1127",
      "name": "Balaji Rao",
      "rating": 5,
      "text": "Mr Pasha is very experienced and has been very good in his approach. We rate him very good."
    },
    {
      "id": "text-1128",
      "name": "narmadha kumar",
      "rating": 5,
      "text": "Kashinath and Kusuma were very good and our experience was very good."
    },
    {
      "id": "text-1129",
      "name": "Rohan Samtani",
      "rating": 4,
      "text": "Amazing products and the salesman, Gajanand, is very polite and good."
    },
    {
      "id": "text-1130",
      "name": "Athish Rahul Rao",
      "rating": 5,
      "text": "Had a great experience at the store. Kashinath and Kusuma were of great help. Good selection of pearls!"
    },
    {
      "id": "text-1131",
      "name": "Dan Shafir",
      "rating": 5,
      "text": "Krishna does right by its customers, has a great selection, and works with you to find the perfect purchase. Gajanand was very helpful at the Jubilee Hills location!"
    },
    {
      "id": "text-1132",
      "name": "Anuska Rakshit",
      "rating": 5,
      "text": "Satish was great in guiding me through the collections and helped me to have a wonderful shopping experience."
    },
    {
      "id": "text-1133",
      "name": "Sagar Patchala",
      "rating": 5,
      "text": "Kashinath is very friendly and we are happy to see different models of pearls."
    },
    {
      "id": "text-1135",
      "name": "Ramesh Thiraviam",
      "rating": 5,
      "text": "Good service, Kusuma explained everything perfectly and keep up the good work"
    },
    {
      "id": "text-1136",
      "name": "Priyanka Srivastava",
      "rating": 5,
      "text": "Authentic jewellery store with good quality of products. Great assistance by Mr Satish and Kusuma."
    },
    {
      "id": "text-1137",
      "name": "VISHESH V",
      "rating": 5,
      "text": "Well, for a newbie selecting pearl jewellery, the sales executive Gajanand was quite patient with the explanation, convinced with a good buy at the end"
    },
    {
      "id": "text-1138",
      "name": "Aman Prakash",
      "rating": 5,
      "text": "Very pleasant experience, Gajanand was our sales executive and was very professional and his service is of high order. Very much happy with his service. Looking forward to visit again."
    },
    {
      "id": "text-1139",
      "name": "Mahender Ravula",
      "rating": 5,
      "text": "I liked excellent service by p.vinod Kumar sales n floor manager shri Srinivas garu.can be recommended for higher grade."
    },
    {
      "id": "text-1140",
      "name": "sirish garikapati",
      "rating": 5,
      "text": "Variety and quality items for gifts and functions. Rajukumar"
    },
    {
      "id": "text-1142",
      "name": "H P",
      "rating": 5,
      "text": "Sathish showed us good options."
    },
    {
      "id": "text-1143",
      "name": "Aishwarya Deb",
      "rating": 5,
      "text": "Pasha - Great experience"
    },
    {
      "id": "text-1145",
      "name": "Naveen Kumar",
      "rating": 5,
      "text": "Mr. Pasha was very helpful in selecting the right pearls. Thanks to Kunal also who assisted well"
    },
    {
      "id": "text-1147",
      "name": "viswanadha sastry",
      "rating": 5,
      "text": "Very nice. Good number of models with quality designs"
    },
    {
      "id": "text-1148",
      "name": "Pallavi mulli",
      "rating": 5,
      "text": "Excellent service by Sathish m"
    },
    {
      "id": "text-1149",
      "name": "sujatha surya",
      "rating": 5,
      "text": "Praveen has patiently showed all the products and requested cost. Satisfied with the service"
    },
    {
      "id": "text-1150",
      "name": "Lakshmi Tulasi Danaboyina",
      "rating": 5,
      "text": "Thanks for very patient service…Jogu Krishna garu"
    },
    {
      "id": "text-1151",
      "name": "Rajasekhar Konki",
      "rating": 5,
      "text": "Pasha has been extremely good in treating us as customer. Would recommend krishna pearl"
    },
    {
      "id": "text-1153",
      "name": "meghna challagulla",
      "rating": 5,
      "text": "Mr. Satish provided good service in buying chains. Thanks"
    },
    {
      "id": "text-1154",
      "name": "mounica jammu",
      "rating": 5,
      "text": "Customer service was great, especially Satish"
    },
    {
      "id": "text-1155",
      "name": "Pradyumna Sinha",
      "rating": 5,
      "text": "It was a very nice experience with V Kashinath, he was showing us different variety of pearls. Gave it to us at a best price."
    },
    {
      "id": "text-1156",
      "name": "Aanchal Rawal",
      "rating": 5,
      "text": "Thanks Ratna Raju for showing us jewellery so patiently"
    },
    {
      "id": "text-1158",
      "name": "sukanta chakraborty",
      "rating": 5,
      "text": "Nice experience here today (21.07.24) at ur place - Krishna Pearls at Jubilee Hills, Hyderabad. Bought some things, good n rich experience! Good hospitality extended and I find a good ambience here. Thanks to everyone! Jogu Krishna, Praveen. - Sukanta Chakraborty (Customer), Retd Asstt Commr of Customs/CGST & Central Excise, Kolkata."
    },
    {
      "id": "text-1159",
      "name": "Shubham sikarwar",
      "rating": 5,
      "text": "Satish you are very polite and helpful"
    },
    {
      "id": "text-1160",
      "name": "veronica antony",
      "rating": 5,
      "text": "Pasha and kusma and kunal were very polite in addressing all my queries and had the patience to show different patterns and designs explaining the varied of pearls loved the experience thank you"
    },
    {
      "id": "text-1162",
      "name": "Shalini Thakur",
      "rating": 5,
      "text": "Mr Rajkumar was a kind man"
    },
    {
      "id": "text-1163",
      "name": "ckkrimc",
      "rating": 5,
      "text": "Good collection, nice service"
    },
    {
      "id": "text-1164",
      "name": "A swarnalatha reddy",
      "rating": 5,
      "text": "Nice collection and service is good and salesmen Satish service is good"
    },
    {
      "id": "text-1165",
      "name": "Dr. Sagarika B A",
      "rating": 5,
      "text": "Good pearl jewellery store, nice collection. Coordinated staff Ratna Raju"
    },
    {
      "id": "text-1166",
      "name": "Sri Raksha",
      "rating": 5,
      "text": "Really happy with the collection of pearls.. would like to visit the store again for more jewellery. Friendly staff. Ratna Raju garu was of great help in my shopping journey"
    },
    {
      "id": "text-1168",
      "name": "Gokul Vijay",
      "rating": 5,
      "text": "Jogu Krishna, Rathnaraju provided good customer service"
    },
    {
      "id": "text-1169",
      "name": "Sreekumar G",
      "rating": 5,
      "text": "Raj Kumar, excellent service we got ..thank uu"
    },
    {
      "id": "text-1171",
      "name": "vijaya lakshmi",
      "rating": 5,
      "text": "Good great product designs"
    },
    {
      "id": "text-1172",
      "name": "Giridharbabu Vemuri",
      "rating": 5,
      "text": "Your salesman Mr. Raj Kumar is very helpful and innovative. He advices us in an excellent manner. The collections with you are numerous and eye catching. The ambience of the show room is excellent and peaceful. Feel like shopping. Thanks to your staff."
    },
    {
      "id": "text-1175",
      "name": "Vani sekhar",
      "rating": 5,
      "text": "Very good collections and nice team. Ratna raju and kunal were very helpful and showed nice collections. very nice products and services."
    },
    {
      "id": "text-1176",
      "name": "Prashant Naik",
      "rating": 5,
      "text": "Good hospitality and nice, cooperative staff. Would like to visit again, and also give reference to others! Mr Kashinath was very enthusiastic in helping to make choice."
    },
    {
      "id": "text-1177",
      "name": "Nikhil Sojan",
      "rating": 5,
      "text": "Excellent service. They were patient while we took our time searching for the perfect pieces. Especially Pasha and Praveen were very responsive to questions and offered us a really good discount as well!"
    },
    {
      "id": "text-1178",
      "name": "Sunil Choudhary",
      "rating": 5,
      "text": "Provided all the details before purchasing the pearls by Mohit"
    },
    {
      "id": "text-1179",
      "name": "Deepak M Choudhary",
      "rating": 5,
      "text": "Mohit has been awesome in getting the best pearl."
    },
    {
      "id": "text-1180",
      "name": "Rahul A R",
      "rating": 5,
      "text": "Rathnaraju---- had good purchase, got in the budget. But expected more collections on only pearl sets."
    },
    {
      "id": "text-1181",
      "name": "Punit Trikha",
      "rating": 5,
      "text": "The staff is very cooperative and makes shopping and navigation very easy. Special mention to Mr. Mohit for his hospitality and prompt response"
    },
    {
      "id": "text-1183",
      "name": "Pallavi Kiran",
      "rating": 5,
      "text": "good service kashinath"
    },
    {
      "id": "text-1184",
      "name": "Barun Sutradhar",
      "rating": 5,
      "text": "Best pearl shop in jubilee hills customer service also very nice mr . Satish and kunal"
    },
    {
      "id": "text-1185",
      "name": "Roxx Star",
      "rating": 5,
      "text": "Good collection and professional staff. Pasha was the sales executive."
    },
    {
      "id": "text-1186",
      "name": "Kapil Sharma",
      "rating": 5,
      "text": "Pasha ji was very helpful and courteous, shown items exactly as as required This my third visit to Krishna Jeweller and Gems"
    },
    {
      "id": "text-1188",
      "name": "Manish Sharma",
      "rating": 5,
      "text": "Had a great experience buying pearls with the help of Kashinath"
    },
    {
      "id": "text-1189",
      "name": "Saptapadi",
      "rating": 5,
      "text": "Best pearlshop in Jubilee hills pasha he is very good person"
    },
    {
      "id": "text-1190",
      "name": "Sudha Rani",
      "rating": 5,
      "text": "I have recently visited, Staff is very friendly and Raj Kumar sir shown more options it is easy to shop again I will visit"
    },
    {
      "id": "text-1191",
      "name": "Dronavalli sowmya",
      "rating": 5,
      "text": "Had a great experience at Krishna jewelers Mr pasha has assisted us very well"
    },
    {
      "id": "text-1192",
      "name": "Hari Madasu",
      "rating": 5,
      "text": "V.Kashinath has provided best service, he took time to show various handcrafted pearl jewelry."
    },
    {
      "id": "text-1193",
      "name": "vijay telu",
      "rating": 5,
      "text": "Great pearl collection , the staff is very helpful I really appreciate kashinath help, he is very knowledgeable and provided lot of details with lot of patience. I really recommend this store and services from the staff."
    },
    {
      "id": "text-1195",
      "name": "Nishasrinivas Talampalli",
      "rating": 5,
      "text": "I did buy pearl necklace & pearl ear studs I loved the products also, really had a great executive for assistance named by V Kashinath. He’s kindness made me buy 5 pair of ear studs Thank you V Kashinath Highly recommend the place👍🏻"
    },
    {
      "id": "text-1196",
      "name": "Tridip Chakraborty",
      "rating": 5,
      "text": "Satish is excellent. All products are good"
    },
    {
      "id": "text-1197",
      "name": "sushmitha vinay",
      "rating": 5,
      "text": "K. Rajesh is very polit and good explained"
    },
    {
      "id": "text-1198",
      "name": "sandeep agrawal",
      "rating": 5,
      "text": "Rajkumar ji, nice interaction and purchase"
    },
    {
      "id": "text-1200",
      "name": "Ekta Giri",
      "rating": 5,
      "text": "Thank you Satish sir for showing us beautiful pearl and silver jewellery on 2nd floor. Much appreciated."
    },
    {
      "id": "text-1203",
      "name": "Manjushree nanjappa",
      "rating": 5,
      "text": "Thank you Satish and G Praveen Wonderful experience"
    },
    {
      "id": "text-1204",
      "name": "Dhanya Ganga",
      "rating": 5,
      "text": "Sathish and G.praveen"
    },
    {
      "id": "text-1205",
      "name": "G Sachin Gavaral",
      "rating": 5,
      "text": "Rajkumar was very good. Kusuma madam was also very nice . Overall great experience."
    },
    {
      "id": "text-1206",
      "name": "Shyam",
      "rating": 5,
      "text": "Mohit was very kind and helpful. Had a good experience."
    },
    {
      "id": "text-1208",
      "name": "aditi jha",
      "rating": 5,
      "text": "It was an amazing experience here. Mr Pasha helped us choose really good pieces. Worth visiting."
    },
    {
      "id": "text-1209",
      "name": "Ishaani Makam",
      "rating": 5,
      "text": "It was very good! We had a tough time looking for modern certified pearl jewellery but here they had a very good collection. Mr. Ratnaraju was very helpful and friendly and helped us find the jewellery according to our needs. Mr. G Praveen was very helpful as well. They have excellent staff and service."
    },
    {
      "id": "text-1210",
      "name": "Ramya BS",
      "rating": 5,
      "text": "The collections are good. Ratna Raju and Praveen G were very patient throughout our process of selecting the pearl jewelleries."
    },
    {
      "id": "text-1211",
      "name": "Ruchi Shinde",
      "rating": 5,
      "text": "Had a good experience at this outlet. Gopal has good knowledge about pearls and outlet has good collection of neck piece and earrings"
    },
    {
      "id": "text-1212",
      "name": "Go Ak",
      "rating": 5,
      "text": "Excellent experience at Krishna Pearls. Got customized jewelry as per choice. Rekha mam helped us in customizing the design."
    },
    {
      "id": "text-1214",
      "name": "Elizabeth",
      "rating": 5,
      "text": "Satish did a fantastic job helping me find the perfect jewels for my family and myself. I highly recommend this jewelry store when visiting the city!"
    },
    {
      "id": "text-1215",
      "name": "Rajatendu Dey",
      "rating": 5,
      "text": "Very good experience of buying jewellery"
    },
    {
      "id": "text-1216",
      "name": "Sharada",
      "rating": 4,
      "text": "Good, quality products Honest Traders. Wide choices Personally if visited, can get the exact, desired shade of pearls Received standard and hood shade pearl Online ordered a pair of stud for the first time"
    },
    {
      "id": "text-1218",
      "name": "Neha Shah",
      "rating": 5,
      "text": "Kashinath is very good sales"
    },
    {
      "id": "text-1219",
      "name": "Mital Jodhani",
      "rating": 5,
      "text": "Kashinsth service is very good"
    },
    {
      "id": "text-1220",
      "name": "shradha bisht",
      "rating": 5,
      "text": "Really nice and warm experience. Hosted bye Mohit . Really warm and sweet hospitality."
    },
    {
      "id": "text-1221",
      "name": "Sumedha Chatterjee",
      "rating": 5,
      "text": "Mohit helped us choosing very nice items.loved it"
    },
    {
      "id": "text-1222",
      "name": "Mangesh Pathak",
      "rating": 5,
      "text": "Mohit Agrawal has served very good. Displayed appropriate valued products."
    },
    {
      "id": "text-1223",
      "name": "Soumya Reddy",
      "rating": 5,
      "text": "The workshop conducted by the Krishna jewelers and pearls was really awesome and Pasha helped us and guided us in the making process.Thank you so much."
    },
    {
      "id": "text-1224",
      "name": "Srinivas Veluri",
      "rating": 5,
      "text": "Kashinath, he provided excellent customer service. Thanks!"
    },
    {
      "id": "text-1226",
      "name": "Jaejung Nam",
      "rating": 5,
      "text": "두번째 방문입니다. 진주의 퀄리티도 좋고. 직원이 좋은 조건을 제시해줘서 가격또한 좋았습니다. 직원마다 다를수 있겠지만 직원들의 서비스 또한 훌륭하네요."
    },
    {
      "id": "text-1227",
      "name": "Sreenivasulareddy Bandatmakuru",
      "rating": 5,
      "text": "Rajkumar service is very good"
    },
    {
      "id": "text-1228",
      "name": "Kiranmayi Photos",
      "rating": 5,
      "text": "Very nice service by pasha ji"
    },
    {
      "id": "text-1229",
      "name": "Ali Khan",
      "rating": 5,
      "text": "Rajkumar sir has been extremely helpful and patient with us. Overall a great experience they have the best collection"
    },
    {
      "id": "text-1230",
      "name": "shruti saluja",
      "rating": 5,
      "text": "Wonderful experience with Mr Pasha who helped us in selecting grey sea water pearl. Satisfactory experience"
    },
    {
      "id": "text-1231",
      "name": "Sonal Gupta",
      "rating": 5,
      "text": "Very nice collection and reasonable price"
    },
    {
      "id": "text-1232",
      "name": "k.s.v satvik",
      "rating": 5,
      "text": "Mr.Pasha is very nice and kind.., showed us various models with patience.."
    },
    {
      "id": "text-1233",
      "name": "J.N HANSDA",
      "rating": 5,
      "text": "Raj Kumar ...he is very good person and also Rohit help"
    },
    {
      "id": "text-1234",
      "name": "BIJAY KUMAR BEHERA",
      "rating": 5,
      "text": "Raj kumar Service is very good"
    },
    {
      "id": "text-1235",
      "name": "Prajakta Jayale",
      "rating": 5,
      "text": "Mr. Kashinath was very helping and very good in nature and also kusuma was a very kind and helping .. overall best experience of buying real pearls at Krishna pearls"
    },
    {
      "id": "text-1237",
      "name": "Ondina Espinal",
      "rating": 5,
      "text": "Kashinath very good Service"
    },
    {
      "id": "text-1239",
      "name": "Priyanka Phadke",
      "rating": 4,
      "text": "Staff is very cooperative and Attentive.."
    },
    {
      "id": "text-1240",
      "name": "Sovaiba Bukhari",
      "rating": 5,
      "text": "Pasha Sir was extremely helpful so was the rest of the staff. Overall a great experience."
    },
    {
      "id": "text-1242",
      "name": "Pavanjeet Garewal",
      "rating": 5,
      "text": "Great place for shopping pearls and for gifting. Rajkumar has been a great help in assisting for the purchase."
    },
    {
      "id": "text-1243",
      "name": "Namrata Jha",
      "rating": 5,
      "text": "Had a very pleasant experience. Ratna Raju helped us a lot throughout our time there. Good place for pearls."
    },
    {
      "id": "text-1244",
      "name": "Lushma Rathore",
      "rating": 5,
      "text": "Very good customer experience"
    },
    {
      "id": "text-1245",
      "name": "Tarana Faroqi",
      "rating": 5,
      "text": "Ratna Raju is excellent with his expertise and amazing experience as always to come to Krishna jewels"
    },
    {
      "id": "text-1246",
      "name": "Animesh Barat",
      "rating": 5,
      "text": "Great Service by Raj Kumar Ji, Lovely Variety & 100% good quality."
    },
    {
      "id": "text-1249",
      "name": "Pallavi Tata",
      "rating": 5,
      "text": "The pearl jewellery purchase was so happy and easy with the cooperation of staff, Mr Pasha, Mr Mahesh and Ms Kusuma. The experience is so pleasant and feels good."
    },
    {
      "id": "text-1250",
      "name": "Jayakrishna Paleti",
      "rating": 5,
      "text": "Had good collection ..great job by rama lakshni"
    },
    {
      "id": "text-1252",
      "name": "Praveen T",
      "rating": 5,
      "text": "Kashmiri and kusuma both of u very good service"
    },
    {
      "id": "text-1253",
      "name": "Shreyas Darne",
      "rating": 5,
      "text": "Very friendly staff, good range of pearls. Thank you Kashinath ji"
    },
    {
      "id": "text-1254",
      "name": "Suwetaa Ramesh",
      "rating": 5,
      "text": "Rajkumar was very cooperative and patience enough to show us all the collections that matches our tastes. This shop has many collections on pearls."
    },
    {
      "id": "text-1255",
      "name": "Bipul Ayan",
      "rating": 5,
      "text": "Good collection and they give a 10% discount. Ask for Kashinath - he explained us a lot about pearls"
    },
    {
      "id": "text-1256",
      "name": "Devrim Dogan",
      "rating": 5,
      "text": "Highly recommend this place. Kashinath helped us a lot"
    },
    {
      "id": "text-1257",
      "name": "Bharath Kotapati",
      "rating": 5,
      "text": "Guravaiah showed us everything patiently and answered all our queries. Great store and awesome service. Absolutely recommended to anyone looking to buy jewellery."
    },
    {
      "id": "text-1258",
      "name": "Debjyoti Sharma",
      "rating": 5,
      "text": "One of the most fascinating places in entire Hyderabad for authentic pearls and outstanding Jewellery collections. Me and my wife was assisted by Mr.Pasha who is extremely professional with proper communication candor. This has been extremely good experience for us. Thanks Krishna Pearls."
    },
    {
      "id": "text-1259",
      "name": "Mukesh Kumar",
      "rating": 5,
      "text": "They have lot of collections in pearls and Mr. Kasinath hospitality was really good and he explain each and everything with patience."
    },
    {
      "id": "text-1260",
      "name": "Murthy chintala",
      "rating": 5,
      "text": "Rajkumar is very supportive and giving information clearly"
    },
    {
      "id": "text-1261",
      "name": "KRITI GOYAL",
      "rating": 4,
      "text": "Good experience overall. Sathish was of great help for the overall process"
    },
    {
      "id": "text-1262",
      "name": "Madhavi Kaza",
      "rating": 5,
      "text": "I was very impressed with Pasha’s customer service and professionalism."
    },
    {
      "id": "text-1265",
      "name": "chaithanya gopalan",
      "rating": 5,
      "text": "We had a great experience shopping at Krishna pearls, Jubilee Hills. Pasha sir assisted us well during our purchase. Thank you so much for the great shopping experience. Will definitely refer to my friends and family members."
    },
    {
      "id": "text-1267",
      "name": "Dhanashri Inamdar",
      "rating": 5,
      "text": "Pasha sir is amazing person , very comfortable and Co operative . Reasonable price 🫶🏻✨👌🏻will suggest everyone to visit 👍🏻"
    },
    {
      "id": "text-1268",
      "name": "Swarna Kuchipudi",
      "rating": 5,
      "text": "Pasha is good sales man"
    },
    {
      "id": "text-1269",
      "name": "GIRISH DESHMUKH",
      "rating": 5,
      "text": "Today visited pearls section. And was delighted to purchase one necklace with help of Mr Praveen. Thanks"
    },
    {
      "id": "text-1270",
      "name": "Abhijeet Mohanty",
      "rating": 5,
      "text": "V.Kashinath helped us for choosing our best pearl sets and he is very polite and other staffs too...we definitely visit again to the store..."
    },
    {
      "id": "text-1271",
      "name": "Padhu T A",
      "rating": 5,
      "text": "Pasha service is good"
    },
    {
      "id": "text-1272",
      "name": "chandrani das",
      "rating": 5,
      "text": "Visited Krishna pearls and gems in Jubilee hills. Kashinath and Kusuma was very helpful. Really loved the hospitality. Will visit again."
    },
    {
      "id": "text-1273",
      "name": "Prathamesh Karpe",
      "rating": 5,
      "text": "Good service by the sale person Mr.Kashinath and Ms Kusuma."
    },
    {
      "id": "text-1274",
      "name": "Sudheer Telaprolu",
      "rating": 4,
      "text": "Kashinath guidance is good.."
    },
    {
      "id": "text-1275",
      "name": "sweata gomes",
      "rating": 5,
      "text": "This place has great collection. Very polite and kind service by Mr. Pasha . Would love to visit again.."
    },
    {
      "id": "text-1276",
      "name": "Mukul Mohan Rafiz",
      "rating": 5,
      "text": "Great experience in the store, Mr. Pasha was calm and courteous in showing all the varieties which I asked for. Great shopping experience."
    },
    {
      "id": "text-1277",
      "name": "Nanik Hathiramani",
      "rating": 5,
      "text": "We has the pleasure to meet Mr Satish . He served us well and gave us good advise .Rgds Nanik Hathiramani"
    },
    {
      "id": "text-1279",
      "name": "Neha Niharika",
      "rating": 5,
      "text": "V.Kashinath was very helpful and professional..He made us buy more than we wanted"
    },
    {
      "id": "text-1280",
      "name": "RadhaKrishna Kandula",
      "rating": 5,
      "text": "good service by gopal and very good collection"
    },
    {
      "id": "text-1281",
      "name": "shamika pande",
      "rating": 5,
      "text": "They have very good collection. Mr Praveen showed us all the collection patiently"
    },
    {
      "id": "text-1282",
      "name": "anusha reddy",
      "rating": 5,
      "text": "Vinod &venkatesh garu reseving is good& good discount andi tq very much andi"
    },
    {
      "id": "text-1283",
      "name": "tln sastry",
      "rating": 5,
      "text": "Reasonable prices. Good cooperation with customer Mr.rajkumar"
    },
    {
      "id": "text-1284",
      "name": "Arushi Chawla",
      "rating": 5,
      "text": "Great collection. Wonderful experience. Extremely helpful staff - especially Pasha, mahesh, kushma. Thank you! Keep it up!"
    },
    {
      "id": "text-1285",
      "name": "R S",
      "rating": 5,
      "text": "Rajkumar - excellent customer service, good prices"
    },
    {
      "id": "text-1286",
      "name": "Sowj A",
      "rating": 5,
      "text": "Great collection and amazing service. So much variety and attention to details. Mr Suraj Jadav helped us make the right choice. Overall very satisfied and going to keep visiting for all my future purchases."
    },
    {
      "id": "text-1287",
      "name": "Ibrahim Ahmed",
      "rating": 5,
      "text": "Amazing place. Pasha was very friendly and helpful. Totally recommended this place."
    },
    {
      "id": "text-1288",
      "name": "Sriram Sahith",
      "rating": 5,
      "text": "Had a good experience shopping at Krishna Jewellers Jubilee Hills. Praveen is very patient and coordinated with us well in showing different models."
    },
    {
      "id": "text-1289",
      "name": "Dharm Kumar",
      "rating": 5,
      "text": "Good collection, Excellent, Sandhya Rani good Sales girl she is explaining good for Ornaments purchase 👍"
    },
    {
      "id": "text-1290",
      "name": "VSN Raju Rudraraju",
      "rating": 5,
      "text": "Excellent. Good job by Naveen"
    },
    {
      "id": "text-1292",
      "name": "jerard ashwin",
      "rating": 5,
      "text": "Gajanand treated us nicely"
    },
    {
      "id": "text-1293",
      "name": "Aayush Ambegaoker",
      "rating": 5,
      "text": "Excellent customer service by Gajanand !! Thank you for the experience 👍"
    },
    {
      "id": "text-1294",
      "name": "Abhishek Kumar",
      "rating": 5,
      "text": "Nice shopping experience. Thanks to Praveen for helping me choosing the designs."
    },
    {
      "id": "text-1295",
      "name": "Rohit Yadav",
      "rating": 5,
      "text": "Excellent experience and thanks to Praveen who helped me with the selection."
    },
    {
      "id": "text-1296",
      "name": "AAKANKSHA SINGH",
      "rating": 5,
      "text": "Nice experience Attended by Gajanand Thankyou"
    },
    {
      "id": "text-1297",
      "name": "shreya rao",
      "rating": 5,
      "text": "Really good pearl collection. Staff is very humble and helpful especially ratna raju."
    },
    {
      "id": "text-1299",
      "name": "devika pandian",
      "rating": 5,
      "text": "Great collection and reasonable price.. Its our second visit to this branch.. Good service by gajanandh.."
    },
    {
      "id": "text-1301",
      "name": "Chirag Arora",
      "rating": 5,
      "text": "Bought beautiful pearl jewellery Staff Ratna Raju help me select the nicest pearl. Thanks for his wonderful service Thanks for his patience. Will visit again"
    },
    {
      "id": "text-1302",
      "name": "Pooja Arora",
      "rating": 5,
      "text": "Bought earings for myself and my mother. They have beautiful collection for all age groups. Employee M Satish was very helpful polite courteous. Thank you for the wonderful experience 🙏"
    },
    {
      "id": "text-1304",
      "name": "Priyanka Purohit",
      "rating": 5,
      "text": "Good collection!! Store staff Pasha showed us beautiful collections. Also he is very cooperating and polite."
    },
    {
      "id": "text-1305",
      "name": "sanaha shaik",
      "rating": 5,
      "text": "Pavani is a nice sales women, she’s enthusiastic and very patient have shown nice designs as per my taste and choice"
    },
    {
      "id": "text-1306",
      "name": "uttiyan nandy",
      "rating": 5,
      "text": "Ratna Raju was very helpful, guided me properly. Thanks to him, it was a good experience"
    },
    {
      "id": "text-1307",
      "name": "susmitha neelam",
      "rating": 5,
      "text": "Praveen has assisted us so good and helped us with the best pricing.. the designs are amazing and will definitely come back soon"
    },
    {
      "id": "text-1308",
      "name": "Anvesha Sinha",
      "rating": 5,
      "text": "Great quality and collection. Mr. Kashinath was very helpful whike selecting pearl sets."
    },
    {
      "id": "text-1310",
      "name": "Owen Pereira",
      "rating": 5,
      "text": "Excellent shopping experience! Special attention given by Kashinth and kusuma"
    },
    {
      "id": "text-1311",
      "name": "Hardik Agarwal",
      "rating": 5,
      "text": "Visited jubilee hills branch, Praveen was every helpful in making me selecting pearls for my friend. Authentic and genuine service."
    },
    {
      "id": "text-1314",
      "name": "Rishabh Parashar",
      "rating": 5,
      "text": "Collection and quality is impressive. Good service by Pasha. Thank you."
    },
    {
      "id": "text-1315",
      "name": "Milly Jay",
      "rating": 5,
      "text": "The experience was amazing. We were here to purchase pearls they have multiple options and good quality pearls. Good experience. Praveen invested his time with patience to show us the jewellery. Do visit if you want to purchase any jewellery."
    },
    {
      "id": "text-1316",
      "name": "sireesha satty",
      "rating": 5,
      "text": "Praveen is good at showing us the best pearls.."
    },
    {
      "id": "text-1317",
      "name": "Vijetha Gundi",
      "rating": 5,
      "text": "Praveen, Sales...a very nice and helpful gentleman Good Ambience"
    },
    {
      "id": "text-1318",
      "name": "Dinesh Koumleli",
      "rating": 5,
      "text": "Abdul pasha took good care and showed right products"
    },
    {
      "id": "text-1319",
      "name": "deepak rao",
      "rating": 5,
      "text": "Ratna raju is a very friendly staff and showed lot of varieties with lot of patience.I am very happy to choose krishna pearls."
    },
    {
      "id": "text-1320",
      "name": "Nishu Gangwar",
      "rating": 4,
      "text": "Raj Kumars behaviour was nice"
    },
    {
      "id": "text-1321",
      "name": "Raji Movva",
      "rating": 5,
      "text": "Mr Raj Kumar has helped us get what we are looking for. He is very knowledgeable about pearls and all kinds and also guides you accordingly to your budget"
    },
    {
      "id": "text-1323",
      "name": "simranjeet singh",
      "rating": 5,
      "text": "Rajkumar anna has done perfect job and easy to handle my query’s best person we like"
    },
    {
      "id": "text-1324",
      "name": "Amit Supe",
      "rating": 5,
      "text": "Best designs and customisation options available. Thanks to Raj Kumar for great service and hospitality."
    },
    {
      "id": "text-1325",
      "name": "Manasa Jinnuri",
      "rating": 5,
      "text": "Had a very good experience at Krishna Jewellers .. Thanks to Mr.Raj Kumar who was very patient with us"
    },
    {
      "id": "text-1327",
      "name": "Pandruvada Ramachandra",
      "rating": 5,
      "text": "Pasha is very good service"
    },
    {
      "id": "text-1328",
      "name": "RYSON JOSEPH",
      "rating": 5,
      "text": "I met Raj Kumar Sir here... It was an excellent experience.. 👍💐❤️"
    },
    {
      "id": "text-1329",
      "name": "Uma Vijayasimhulu",
      "rating": 5,
      "text": "Pasha is very good service"
    },
    {
      "id": "text-1330",
      "name": "Anusha Surineni",
      "rating": 5,
      "text": "Good service and good collection, helped by pasha"
    },
    {
      "id": "text-1331",
      "name": "Pratik Shah",
      "rating": 5,
      "text": "Very good experience and professional staff"
    },
    {
      "id": "text-1332",
      "name": "my sweetu Tesha",
      "rating": 5,
      "text": "Thanks for helping us to choose better bangle . Raj Kumar cool person. Kusuma thanks for supporting me"
    },
    {
      "id": "text-1333",
      "name": "Farhan Ahmed",
      "rating": 5,
      "text": "Had a good experience to come over year. Thank you Praveen"
    },
    {
      "id": "text-1334",
      "name": "Chee Kiang Lim",
      "rating": 5,
      "text": "Appreciate the excellent service of Mr Praveen. Very professional and patient in guiding through the selection for my wife."
    },
    {
      "id": "text-1335",
      "name": "Rajshree Pawar",
      "rating": 5,
      "text": "Pasha ji is very good service"
    },
    {
      "id": "text-1336",
      "name": "Sayan Singh",
      "rating": 5,
      "text": "Very good experience and pravin is a good guy"
    },
    {
      "id": "text-1337",
      "name": "Bikram Paul",
      "rating": 5,
      "text": "It's good and also the service is very good"
    },
    {
      "id": "text-1338",
      "name": "Samadrita Ganguly",
      "rating": 5,
      "text": "Praveen was quite professional and the experience was good"
    },
    {
      "id": "text-1339",
      "name": "vaibhav Pandey",
      "rating": 5,
      "text": "Great service, advisory and guidance to us in selecting the best piece from Mr. Kashinath ji. Great experience as always!"
    },
    {
      "id": "text-1340",
      "name": "Himanshu Dora",
      "rating": 4,
      "text": "Good Service by Raj kumar at Krishna pearls. Bought Pearl bracelets and earrings."
    },
    {
      "id": "text-1341",
      "name": "tanuja thapliyal",
      "rating": 5,
      "text": "Good service by pasha"
    },
    {
      "id": "text-1342",
      "name": "Vijetha C",
      "rating": 5,
      "text": "Very cooperative and helpful staff especially Mr kashinath and kunal"
    },
    {
      "id": "text-1343",
      "name": "Pushpa Vijaykumar",
      "rating": 5,
      "text": "Kashinath is very good service"
    },
    {
      "id": "text-1344",
      "name": "Deepti Sharma",
      "rating": 5,
      "text": "Pasha was awesome and very patient"
    },
    {
      "id": "text-1345",
      "name": "Partho Das",
      "rating": 4,
      "text": "Good collection of pearls, Pasha helped with showing variety."
    },
    {
      "id": "text-1346",
      "name": "Christy Notigan",
      "rating": 5,
      "text": "Great experience at this shop for pearls and jewelry gifts. Mr Kashinath was very knowledgeable and helpful in the product line."
    },
    {
      "id": "text-1347",
      "name": "anton droopie",
      "rating": 5,
      "text": "Mr Kasinath was excellent"
    },
    {
      "id": "text-1350",
      "name": "Sujata Kantipudi",
      "rating": 5,
      "text": "Pasha very good service"
    },
    {
      "id": "text-1351",
      "name": "soumen g mail",
      "rating": 5,
      "text": "Very good nice satisfying exp Praveen sir"
    },
    {
      "id": "text-1352",
      "name": "Madhav Diwakar",
      "rating": 5,
      "text": "Came here to buy pearls for the first time and it was a wonderful experience. Mr. Praveen helped us understand pearls and gave us a thorough tour. Highly recommend"
    },
    {
      "id": "text-1354",
      "name": "Mridusmita Buragohain",
      "rating": 5,
      "text": "Great customer service. Reasonable price with great collection."
    },
    {
      "id": "text-1355",
      "name": "Preeti Kannan",
      "rating": 4,
      "text": "Good staff experience with Pasha"
    },
    {
      "id": "text-1356",
      "name": "Sumit Kumar",
      "rating": 5,
      "text": "I visited this store for buying pearl.I was entertained by Mr Raj Kumar Saleman. He is a gentleman and have a great buying experience with him."
    },
    {
      "id": "text-1357",
      "name": "Anusha Chaturvedi",
      "rating": 5,
      "text": "Rajkumar sir showed us all the pearl jewelry and it was really good."
    },
    {
      "id": "text-1358",
      "name": "LLohitkumar Lahane",
      "rating": 5,
      "text": "Pasha sir , Service is very excellent, thanks"
    },
    {
      "id": "text-1359",
      "name": "ramesh8051",
      "rating": 5,
      "text": "Mr Praveen showes us all Pearl based jewellery designs with patience & explained well so that we could take a right decision especially the type of pearls."
    },
    {
      "id": "text-1360",
      "name": "Vinay Patil",
      "rating": 5,
      "text": "Excellent service by Mr Kashinath. He helped us in finding the best pearl jewelry set. All staffs are very nice and it's a best place to shop pearl jewelry with latest designs and collections."
    },
    {
      "id": "text-1361",
      "name": "Bharti Vijaykar",
      "rating": 5,
      "text": "It was an great experience as the service provided by Pasha was excellence"
    },
    {
      "id": "text-1362",
      "name": "Rajesh Vijaykar",
      "rating": 5,
      "text": "Pasha shown variety of products also given details and we are satisfied with their service."
    },
    {
      "id": "text-1363",
      "name": "Sammy Anand",
      "rating": 5,
      "text": "Had a very good experience with Ratna Raju while buying pearl jewelry"
    },
    {
      "id": "text-1364",
      "name": "prathap kumar",
      "rating": 5,
      "text": "We bought Perl jewellery, it’s nice collection and brought for best price. Praveen sales manager given good demo and explained quite well."
    },
    {
      "id": "text-1365",
      "name": "sunanda charan",
      "rating": 4,
      "text": "Prices on beads are very high"
    },
    {
      "id": "text-1366",
      "name": "Tarun V",
      "rating": 5,
      "text": "Great collection of pearls. Mr Pasha was extremely helpful, patient and great salesman! Keep it up."
    },
    {
      "id": "text-1367",
      "name": "Hanika Kashyap",
      "rating": 5,
      "text": "Lovely experience. Loved being assisted by Ratna Raju. Bought some special pearls. Very satisfied with the service. ✨❤️"
    },
    {
      "id": "text-1368",
      "name": "Santhosh Umesh",
      "rating": 5,
      "text": "Had a good experience. They were able to grasp the requirements well well. Thanks to Mr.Pasha"
    },
    {
      "id": "text-1372",
      "name": "Mowna Smiley",
      "rating": 5,
      "text": "Sales executive Pavani's customer service is excellent. She is very patient and would help you in selecting the right item of your choice. Range of items is huge."
    },
    {
      "id": "text-1373",
      "name": "Priyanka Reddy",
      "rating": 5,
      "text": "Praveen was very helpful for guiding us and the collection of beads and pearls are really good loved it!"
    },
    {
      "id": "text-1374",
      "name": "Sathya R",
      "rating": 5,
      "text": "Praveen good service nice collection."
    },
    {
      "id": "text-1375",
      "name": "Milind Nadkarni",
      "rating": 5,
      "text": "Mr. Pasha & his team were very courteous & help!!! Pleasant experience… Thanks! 🙏🏻"
    },
    {
      "id": "text-1376",
      "name": "Leena Nadkarni",
      "rating": 5,
      "text": "Abdullah Pasha.. Great experience and extremely helpful"
    },
    {
      "id": "text-1377",
      "name": "Vinay Kumar Mummadi",
      "rating": 5,
      "text": "Pasha helped us with a wide range of designs n price. Very supportive staff, thanks"
    },
    {
      "id": "text-1378",
      "name": "Manisha Sahoo",
      "rating": 5,
      "text": "Pasha...nice service and collection."
    },
    {
      "id": "text-1379",
      "name": "Lavanya Perambudur",
      "rating": 5,
      "text": "Very good customer service like always never got disappointed with their collection.Mr.ratna Raju service is gud.Thnku Krishna jewels"
    },
    {
      "id": "text-1380",
      "name": "Nishi Benoj",
      "rating": 5,
      "text": "Pasha damn good service"
    },
    {
      "id": "text-1381",
      "name": "Arindam Roy",
      "rating": 5,
      "text": "Kashinath interacted very politely. He gave a brief detail about the pearls. Looking to visit again in future."
    },
    {
      "id": "text-1382",
      "name": "P G",
      "rating": 5,
      "text": "Pasha was helpful and excellent"
    },
    {
      "id": "text-1383",
      "name": "Anshul Ramteke",
      "rating": 5,
      "text": "Praveen was great help in selecting the product!"
    },
    {
      "id": "text-1384",
      "name": "shruthi shyam sunder",
      "rating": 5,
      "text": "Rajkumar showed good pearl options"
    },
    {
      "id": "text-1385",
      "name": "Vs Manibharathi",
      "rating": 5,
      "text": "Rajkumar . Well supported"
    },
    {
      "id": "text-1386",
      "name": "Pooja Gupta",
      "rating": 5,
      "text": "Nice collection and helpful staff. Pasha was very helpful."
    },
    {
      "id": "text-1387",
      "name": "Sindhuja M",
      "rating": 5,
      "text": "Service by Kashinath was very friendly in showing us the collections and good quality products."
    },
    {
      "id": "text-1388",
      "name": "Gaurav Chaudhari",
      "rating": 5,
      "text": "Good service by Praveen. Happy with the purchase."
    },
    {
      "id": "text-1389",
      "name": "Alok Puranik",
      "rating": 5,
      "text": "Praveen helped me pick great jewelry pieces. He seemed very knowledgeable about the products. Will definitely recommend him to others."
    },
    {
      "id": "text-1391",
      "name": "Mona singh",
      "rating": 5,
      "text": "Kashinath -It was altogether nice experience visiting the shop."
    },
    {
      "id": "text-1392",
      "name": "shraddha rao",
      "rating": 5,
      "text": "Had a good experience. Great service by Kashinath :)"
    },
    {
      "id": "text-1393",
      "name": "Rathish kumar",
      "rating": 4,
      "text": "Very good hospitality and explained the product features in detail patiently by explaining all the questions raised by us, Mr Praveen thanks for the service it shows your experience in dealing the customer"
    },
    {
      "id": "text-1395",
      "name": "prashant kumar",
      "rating": 5,
      "text": "Praveen has attended me and really helped me to choose the correct gift I was looking for"
    },
    {
      "id": "text-1396",
      "name": "MANISHA SATAPATHY",
      "rating": 5,
      "text": "It was nice shopping. Thank you Raj Kumar"
    },
    {
      "id": "text-1397",
      "name": "Sasikiran Singaraju",
      "rating": 5,
      "text": "Always had a great shopping experience with Krishna."
    },
    {
      "id": "text-1398",
      "name": "Dr. Arnab Maji",
      "rating": 5,
      "text": "Very much satisfied with Mr Praveen and co for thier behaviour and co-operation they showed towards us. A must visit place in Hyderabad"
    },
    {
      "id": "text-1399",
      "name": "Thiyagarajan Purushothaman",
      "rating": 5,
      "text": "Customer service is good. Pasha"
    },
    {
      "id": "text-1400",
      "name": "Divyaa Rao",
      "rating": 5,
      "text": "I am regular customer of Krishna jwellers an I really glad how nicely Mr Praveen attended us."
    },
    {
      "id": "text-1401",
      "name": "Sowjanya",
      "rating": 5,
      "text": "Good collection"
    },
    {
      "id": "text-1402",
      "name": "Rohit",
      "rating": 5,
      "text": "Amazing service, pure Pearl and loved the assistance by sales assistant Praveen Kumar."
    },
    {
      "id": "text-1404",
      "name": "sundari kala",
      "rating": 5,
      "text": "Kashinath, Mahesh and Kusuma team showed us all varieties and made us to feel great experience. Nice shopping"
    },
    {
      "id": "text-1405",
      "name": "Nidhi Mantri",
      "rating": 5,
      "text": "I have visted twice Krisha paearls in 15 dyas gap. Loved the experience and the behavior of the staff"
    },
    {
      "id": "text-1406",
      "name": "Vidushi Shukla",
      "rating": 5,
      "text": "Beautiful and quality pearls Rajkumar was pleased to assist us"
    },
    {
      "id": "text-1407",
      "name": "Sudhanya Mohanty",
      "rating": 5,
      "text": "I was captivated by the gorgeous assortment of pearls when I discovered this shop by chance long back. I always return back to get more. I had a wonderful shopping experience with the helpful and kind staff who helped me select the ideal pearls. This business is a must-visit for anyone seeking timeless beauty in their jewellery. The quality is great, the range is wide, and the service is impeccable"
    },
    {
      "id": "text-1408",
      "name": "Naveen Kumar",
      "rating": 5,
      "text": "Great service, by Pasha"
    },
    {
      "id": "text-1410",
      "name": "Parth Khokhani",
      "rating": 5,
      "text": "Super good service, easy going people, try to visit in weekend and ask for kasinath. He is very cool, clam and fun loving"
    },
    {
      "id": "text-1411",
      "name": "Vamsi Krishna",
      "rating": 5,
      "text": "Very cooperative staff....pasha"
    },
    {
      "id": "text-1412",
      "name": "Risha Supreeth",
      "rating": 5,
      "text": "Excellent collection. Sales executive Kashinath was very kind and helpful."
    },
    {
      "id": "text-1414",
      "name": "Krishi Saripalli",
      "rating": 5,
      "text": "Good service from Pasha!"
    },
    {
      "id": "text-1415",
      "name": "Mrudula Reddy",
      "rating": 5,
      "text": "Nice collection.. thankyou to Praveen for showing all the collection patiently"
    },
    {
      "id": "text-1416",
      "name": "Sweta Agrawal",
      "rating": 4,
      "text": "Very good service by p praveen , very good collection"
    },
    {
      "id": "text-1417",
      "name": "Bharathi Yennam",
      "rating": 5,
      "text": "Thank you Pasha for making my day with gold"
    },
    {
      "id": "text-1419",
      "name": "hara kishore",
      "rating": 5,
      "text": "Overall good collection,wide range of pearl sets and especillay lovely friendly staff (T. Praveen Kumar garu), I recommend people to purchase pearl necklace and earrings."
    },
    {
      "id": "text-1420",
      "name": "tangledspeech",
      "rating": 5,
      "text": "Praveen was very helpful and dedicated."
    },
    {
      "id": "text-1421",
      "name": "Ram",
      "rating": 5,
      "text": "Best place to buy pearl and we immensely satisfied with Mr. Gopal’s courtesy and understanding of our needs."
    },
    {
      "id": "text-1422",
      "name": "FARISH s",
      "rating": 5,
      "text": "Especially Mr T Praveen , excellent customer care. Thank you"
    },
    {
      "id": "text-1423",
      "name": "Deepti Khurana Chourey",
      "rating": 5,
      "text": "Mr. Pasha gave us a proper response and help us choose the best. Highly satisfied and recommend."
    },
    {
      "id": "text-1424",
      "name": "Padma Pulical",
      "rating": 5,
      "text": "It is a great experience in the krishna pearls especially the service provided by Praveen with in depth knowledge on pearls and guidance Provided by him Would recommend it for anyone who is interested in purchasing good quality pearls"
    },
    {
      "id": "text-1425",
      "name": "ttarun k89",
      "rating": 5,
      "text": "Very nice gesture .. ms pasha"
    },
    {
      "id": "text-1426",
      "name": "Kavita Sehrawat",
      "rating": 5,
      "text": "Amazing experience"
    },
    {
      "id": "text-1427",
      "name": "Akshaya Shetty",
      "rating": 5,
      "text": "Lovely collections"
    },
    {
      "id": "text-1429",
      "name": "RADHAK STUDIO",
      "rating": 5,
      "text": "NICE COLLECTIONS AND POLITE GENEROUS STAFFS. Mr rajkumar helped us nicely in picking our desired product. Overall very good experience."
    },
    {
      "id": "text-1430",
      "name": "ravi kumar singh",
      "rating": 5,
      "text": "Rajkumar service is very good"
    },
    {
      "id": "text-1431",
      "name": "Sumanta Biswas",
      "rating": 5,
      "text": "Rajkumar, the service was very good and i am suggesting to everyone to came here"
    },
    {
      "id": "text-1432",
      "name": "milind bhadbhade",
      "rating": 5,
      "text": "Pasha is very good service"
    },
    {
      "id": "text-1433",
      "name": "Reshma Bairavarasu",
      "rating": 5,
      "text": "Praveen was extremely helpful and patient with us. We really enjoyed the experience."
    },
    {
      "id": "text-1434",
      "name": "Aishwarya Sivanandam",
      "rating": 5,
      "text": "Great service by Praveen at the shop. It was closing hours but he was very patient and displayed all the designs and made relevant suggestions. Will certainly recommend the shop for the designs and selections."
    },
    {
      "id": "text-1435",
      "name": "surovita banerjee",
      "rating": 5,
      "text": "Highly recommend. Praveen was very friendly."
    },
    {
      "id": "text-1436",
      "name": "suresh kongala",
      "rating": 5,
      "text": "Vast variety of articles. Service rendered by Mr. Ratna Raju is excellent."
    },
    {
      "id": "text-1438",
      "name": "ruchi purohit",
      "rating": 5,
      "text": "Great service by Pasha at Krishna jewellers Jubilee Hills . Amazing collection I am going to come again for more shopping"
    },
    {
      "id": "text-1439",
      "name": "Sanika Deshpande",
      "rating": 5,
      "text": "Very nice service. Loved their collection. Special thanks to Kashinath for the amazing service at Krishna Pearls."
    },
    {
      "id": "text-1440",
      "name": "Jino Jeyasingh",
      "rating": 5,
      "text": "Our salesperson - Shri.Rajkumar showed us a veriety of range - from pearls to diamonds, very patiently and explained the intricacies of the exquisite jewellery"
    },
    {
      "id": "text-1441",
      "name": "nagubandi raghu",
      "rating": 5,
      "text": "Customer service is good. Collections are awesome. Mr.Kashinath was prompt and friendly."
    },
    {
      "id": "text-1442",
      "name": "Shivani Singh",
      "rating": 5,
      "text": "I went to buy pearls for my aunt. It was an overall great experience. Kusuma, Kashinath and Mahesh helped me choose the best pearls and the required help I needed. Do reach to them. Thank you so much!"
    },
    {
      "id": "text-1443",
      "name": "Sujana Bhumadi",
      "rating": 5,
      "text": "Pasha Good service"
    },
    {
      "id": "text-1445",
      "name": "navin singh",
      "rating": 5,
      "text": "Praveen ji ..excellent customer service ..."
    },
    {
      "id": "text-1446",
      "name": "Sudarshana Badhe",
      "rating": 5,
      "text": "The pearls jwellery is best and pravin sir showed nice collection with all information related to pearls. Good experience with Krishna pearls"
    },
    {
      "id": "text-1447",
      "name": "Prashant Joshi",
      "rating": 5,
      "text": "Kashinath... He is very helpful"
    },
    {
      "id": "text-1451",
      "name": "Karthikeyan Sathyaseelan",
      "rating": 5,
      "text": "Good courteous staff and a good collection as well. Worth coming here. Seems to be genuine place with genuine stuff, so ideal for travellers like me to purchase pearls from Hyderabad. They speak multiple languages as well, so very convenient. Mr. Kashinath was very kind and courteous and thereby would suggest you to consult him when here."
    },
    {
      "id": "text-1452",
      "name": "Yashma Muthanna",
      "rating": 5,
      "text": "Great experience I’m Krishna pearls with amazing staff like Kashinath , Kusuma and Sanjeev.. they showed extreme patience in showing their wide variety of silver collections… happy to be served by them."
    },
    {
      "id": "text-1453",
      "name": "Yashika Goel",
      "rating": 5,
      "text": "Good collection and Pasha helped us find the perfect pearls we were looking for."
    },
    {
      "id": "text-1454",
      "name": "Sarthak Garg",
      "rating": 5,
      "text": "Pasha good service"
    },
    {
      "id": "text-1455",
      "name": "Kranthi Koneti",
      "rating": 5,
      "text": "Staff - Kashinath has been patient enough to show all the varieties and exclusive designs.. Courteousness of the staff along with exclusive designs attract the repeated customers and I am one of them."
    },
    {
      "id": "text-1456",
      "name": "benazir maherin",
      "rating": 4,
      "text": "Authentic pearls nd a must go"
    },
    {
      "id": "text-1457",
      "name": "KISHOR BHOLE",
      "rating": 5,
      "text": "Nice service, pasha"
    },
    {
      "id": "text-1459",
      "name": "latha meruva",
      "rating": 5,
      "text": "Designers are too good here and especially Mr Praveen he is very supportive and showed all the designs as per our requirement.. Thank u"
    },
    {
      "id": "text-1460",
      "name": "Vishnu Chand",
      "rating": 5,
      "text": "Excellent collection and great service Pasha. Thank you! 😊"
    },
    {
      "id": "text-1461",
      "name": "Kanika Yadav",
      "rating": 5,
      "text": "Nice experience, one should visit the store to see variety. Thanks Rajkumar for your time"
    },
    {
      "id": "text-1463",
      "name": "Monalisa Mohapatra",
      "rating": 5,
      "text": "kashinath is a nice person and gave proper service. felt happy"
    },
    {
      "id": "text-1464",
      "name": "Misbah Maaheen Razmi",
      "rating": 5,
      "text": "Kusuma, Mahesh and Gopal were really helpful in picking sets. They understood what I needed and weren’t pushy salesman but let me take my time to buy what I needed. This is a beautiful store with amazing jewelry collection and I will be back again."
    },
    {
      "id": "text-1466",
      "name": "Ankita Vakil",
      "rating": 5,
      "text": "Raj Kumar helped us in selecting the pearls. Beautiful looking pearls.Thankyou"
    },
    {
      "id": "text-1467",
      "name": "Aparna Deshmukh",
      "rating": 5,
      "text": "Mr Praveen was very helpful & supported very well. Good collection"
    },
    {
      "id": "text-1468",
      "name": "Hary Reddy",
      "rating": 5,
      "text": "Kashinath had explained in detail about the product and it was very nice experience and wishing to visit more times.Thank you"
    },
    {
      "id": "text-1469",
      "name": "Raja Sekhar",
      "rating": 5,
      "text": "Pasha.. wonderful collection and Nice service."
    },
    {
      "id": "text-1470",
      "name": "Vivek Reddy",
      "rating": 5,
      "text": "Pasha.. good service and well maintained, nice staff"
    },
    {
      "id": "text-1472",
      "name": "Pradeep Bonda",
      "rating": 5,
      "text": "Pasha: very well received. Has great knowledge on the products"
    },
    {
      "id": "text-1474",
      "name": "sujitha jayakumar",
      "rating": 5,
      "text": "Had a great shopping experience with Krishna Pearls, Jubilee hills today.. Good collection of pearl ornaments.. Great service by Mr Gopal.."
    },
    {
      "id": "text-1476",
      "name": "Ashmita Praharaj",
      "rating": 5,
      "text": "Great collection. Rajkumar was really informative about pearls"
    },
    {
      "id": "text-1477",
      "name": "Dr Akhil Kumar",
      "rating": 5,
      "text": "Nice products with good quality and the jewellery recieved was exactly what was displayed on the website. Special thanks to Bhavani for taking care of the finer details."
    },
    {
      "id": "text-1478",
      "name": "sai harsha",
      "rating": 5,
      "text": "Good Service and Good selection! Pasha did a nice job explaining the collection."
    },
    {
      "id": "text-1480",
      "name": "Chandana Kanukurthi",
      "rating": 5,
      "text": "Good service by pavani"
    },
    {
      "id": "text-1481",
      "name": "Sareyo Abdi",
      "rating": 5,
      "text": "Raj kumar was really helpful and friendly"
    },
    {
      "id": "text-1482",
      "name": "Harshit Srivastava",
      "rating": 5,
      "text": "Authentic and great jewellery store. Perfect service and coordination by Mr Pasha. Good quality of products indeed"
    },
    {
      "id": "text-1483",
      "name": "Dr Azeem Rasheed",
      "rating": 5,
      "text": "Kashinath and pasha very good service and good team"
    },
    {
      "id": "text-1484",
      "name": "Vijay Kumar",
      "rating": 5,
      "text": "Good collection ,gopal helps us and explained everything clearly"
    },
    {
      "id": "text-1486",
      "name": "Pooja Rao",
      "rating": 5,
      "text": "Excellent service by gopal"
    },
    {
      "id": "text-1487",
      "name": "narendra chowdary",
      "rating": 5,
      "text": "Good experience Kashinath and Vipin"
    },
    {
      "id": "text-1488",
      "name": "Debasri Chakrabarti",
      "rating": 5,
      "text": "Praveen, Excellent"
    },
    {
      "id": "text-1489",
      "name": "nagakishore kanumilli",
      "rating": 5,
      "text": "Nice designs high end collections good response from salesman"
    },
    {
      "id": "text-1491",
      "name": "Suvajeet Sengupta",
      "rating": 5,
      "text": "Than you Praveen for the wonderful support provided while we visited your shop!!!"
    },
    {
      "id": "text-1492",
      "name": "Srivatsan Seshadri",
      "rating": 5,
      "text": "Good service and very nice selection of pearl jewellery. Pasha sir was very helpful and guided us on the purchase."
    },
    {
      "id": "text-1494",
      "name": "bhavana janu",
      "rating": 5,
      "text": "Pasha Highly recommend it as there is a wide range of collections and Friendly staff"
    },
    {
      "id": "text-1495",
      "name": "Vidyadhari N",
      "rating": 5,
      "text": "Very good collection. Mr Praveen was very helpful."
    },
    {
      "id": "text-1496",
      "name": "Yoganadh R",
      "rating": 5,
      "text": "Our experience is great and pasha has assisted us well with the models that they have in their collections"
    },
    {
      "id": "text-1497",
      "name": "Aswin Vimal",
      "rating": 5,
      "text": "Kashinath did a great job in helping me pick precious stones. I will definitely come again. Keep up the good work"
    },
    {
      "id": "text-1498",
      "name": "Archita Arora",
      "rating": 5,
      "text": "Mr Pasha was very nice and very patient"
    },
    {
      "id": "text-1499",
      "name": "Chaitali Roy",
      "rating": 5,
      "text": "Mr. Pravin was very helpful & showed many jewelry very happily"
    },
    {
      "id": "text-1500",
      "name": "caberi sinha",
      "rating": 4,
      "text": "Very beautiful products and very nice staff behavior and service by Ratna Raju. A little bit more stock of the stoned pendants with earrings in some medium price range would be good."
    },
    {
      "id": "text-1501",
      "name": "Rupali Das",
      "rating": 5,
      "text": "Great service by Ratna Raju,very polite, the collection is good. Satisfactory experience."
    },
    {
      "id": "text-1502",
      "name": "Monika Suresh",
      "rating": 5,
      "text": "Great shop and Design quality and service is appreciatable. Speacial mention to Abdulla Pasha sir and team. Well explained."
    },
    {
      "id": "text-1503",
      "name": "JOTHIKA S",
      "rating": 5,
      "text": "Great shop and quality jewelry. Good service by Pasha sir and team."
    },
    {
      "id": "text-1504",
      "name": "Ali Musthafa",
      "rating": 5,
      "text": "Sales executive Gopal is very generous and kind person"
    },
    {
      "id": "text-1505",
      "name": "Kiran Dabas",
      "rating": 5,
      "text": "Had a great experience shopping with Gopal, he is very patient and customer friendly"
    },
    {
      "id": "text-1506",
      "name": "hema sri",
      "rating": 5,
      "text": "Raj kumar very good serivce"
    },
    {
      "id": "text-1507",
      "name": "sri latha",
      "rating": 5,
      "text": "More models are available here.and service is very good. Sales persons are explaining evrything clearly about products"
    },
    {
      "id": "text-1509",
      "name": "Sailaja Sanivarapu",
      "rating": 5,
      "text": "Bought eartops from Krishna pearls, Sales person Kashinath is very helpful and let me while making decision regarding purchase."
    },
    {
      "id": "text-1512",
      "name": "Nihaar Udathu",
      "rating": 5,
      "text": "Pasha was very good"
    },
    {
      "id": "text-1513",
      "name": "Anindita Bordoloi",
      "rating": 5,
      "text": "Very nice sevice by Kashinath and Kusuma..good quality jewellery"
    },
    {
      "id": "text-1514",
      "name": "Sanchita Sarkar",
      "rating": 5,
      "text": "Great customer service, Mr. Kashinath was very helpful"
    },
    {
      "id": "text-1515",
      "name": "ASHOK TARU DASGUPTA",
      "rating": 5,
      "text": "It was a good experience. Mr Praveen was quite cordial. Little more discounts would have been more helpful."
    },
    {
      "id": "text-1516",
      "name": "Khushboo Mantri",
      "rating": 5,
      "text": "Praveen Very cooperative and polite."
    },
    {
      "id": "text-1517",
      "name": "Drishti Mittal",
      "rating": 5,
      "text": "Great variety of jewellery and nice staff- Rajkumar."
    },
    {
      "id": "text-1518",
      "name": "Prathu Reddy",
      "rating": 5,
      "text": "Kashinath provided us an outstanding customer service He also explained us everything in detail and also loved their collection"
    },
    {
      "id": "text-1519",
      "name": "shivangi sheoran",
      "rating": 5,
      "text": "Pravin Awesome service Thank you so much."
    },
    {
      "id": "text-1521",
      "name": "Payel Banerjee",
      "rating": 5,
      "text": "Enjoyed shopping here! Praveen was very helpful and showed us all types of gold, silver, pearl and precious materials they have stock of!"
    },
    {
      "id": "text-1523",
      "name": "Camellia Dey",
      "rating": 5,
      "text": "Praveen from Krishna Pearls showed us lot of jewellery patiently and we r v happy with the purchase"
    },
    {
      "id": "text-1524",
      "name": "Subhamoy Sinha",
      "rating": 5,
      "text": "Always love & trustfully recommend Krishna Pearls - Jubilee Hills, Rd No 36. Very humbled Praveen Sir always assist with his knowledge on pearl."
    },
    {
      "id": "text-1525",
      "name": "Pravin Naxane",
      "rating": 5,
      "text": "Kashinath very good service"
    },
    {
      "id": "text-1526",
      "name": "Isselle Links",
      "rating": 5,
      "text": "Raj kumar very nice place, Love the pearls"
    },
    {
      "id": "text-1529",
      "name": "Santhosh Jochim",
      "rating": 5,
      "text": "One of the authentic place to buy pearls in Hyderabad, Mr. Praveen at the shop will take you through each pearls and very good customer service and discount you will get it"
    },
    {
      "id": "text-1530",
      "name": "shivani mandula",
      "rating": 5,
      "text": "Pasha is really helped us"
    },
    {
      "id": "text-1531",
      "name": "Poorni G",
      "rating": 5,
      "text": "Amazing staff, very approachable #Bhagya # Raj Kumar 100% recommended 👌 Thank you..."
    },
    {
      "id": "text-1534",
      "name": "Prabhjot",
      "rating": 5,
      "text": "Great place to shop at , good service"
    },
    {
      "id": "text-1535",
      "name": "Aditi Bhatpahari",
      "rating": 5,
      "text": "Nice store . Great collection and variety in design. Cooperative staff and show all items with patience . Salesman Rajkumar made it easy and shopping a blissful experience ..!"
    },
    {
      "id": "text-1536",
      "name": "rajani T",
      "rating": 5,
      "text": "Very good experience and the designs are beautiful .Mr.Pravèen helped us according to our specifications"
    },
    {
      "id": "text-1537",
      "name": "Shrimoyee Mukherjee",
      "rating": 5,
      "text": "Krishna Pearls had amazing collection. Pasha was very helpful and he showed us collection"
    },
    {
      "id": "text-1538",
      "name": "Ketki Gadre",
      "rating": 5,
      "text": "Praveen was very patient and helped us find the right piece of jewelry within our budget. He was very friendly and sweet and made the experience very pleasant. He also gave us a great price and discount. Kusuma helped us wear the jewelry even though we tried on the same pieces again and again: overall a wonderful experience and definitely a memorable buy. We will surely be back soon."
    },
    {
      "id": "text-1539",
      "name": "Badrinath sinha",
      "rating": 5,
      "text": "Kashinath was nice in behaviour"
    },
    {
      "id": "text-1540",
      "name": "Geethika Sebastian",
      "rating": 5,
      "text": "On February of 2021 their salesperson Pasha helped me find the best piece for my wedding, that too via WhatsApp. I will be forever grateful to him."
    },
    {
      "id": "text-1541",
      "name": "M S Khuba",
      "rating": 5,
      "text": "Kashinath he is very polite and very good sales man"
    },
    {
      "id": "text-1542",
      "name": "Sindhu Matadha",
      "rating": 5,
      "text": "Pasha Kushma Excellent service & very polite"
    },
    {
      "id": "text-1543",
      "name": "Anupama P",
      "rating": 5,
      "text": "Nice collections and nice customer service. Srikanth is the person who assisted me for online Jewellery purchase. Am very much satisfied. Will recommend to contact Srikanth for jewelry assistance."
    },
    {
      "id": "text-1544",
      "name": "Amy Tanner",
      "rating": 5,
      "text": "Pasha was very nice!"
    },
    {
      "id": "text-1545",
      "name": "Oscar Aguilar Perez",
      "rating": 5,
      "text": "Raj kumar was excellent. All the experience was great. Thanks!"
    },
    {
      "id": "text-1546",
      "name": "Nandaakumar S R",
      "rating": 4,
      "text": "Good experience. Nice service from Pasha."
    },
    {
      "id": "text-1547",
      "name": "Jasmine Ara Khan",
      "rating": 5,
      "text": "Krishna pearls is our go to destination whenever we think of pearls. It's a trusted place with a very diligent staff. Especially Pashaji was very patient and hospitable."
    },
    {
      "id": "text-1548",
      "name": "vennapusa reddy",
      "rating": 5,
      "text": "Very nice experience and showed so many models and executives are so friendly. Very happy visit again"
    },
    {
      "id": "text-1549",
      "name": "Vishnu Vardhana Reddy kuppala",
      "rating": 5,
      "text": "Kashinath... he is very good polite and very awesome collection"
    },
    {
      "id": "text-1552",
      "name": "Tushar Agarwal",
      "rating": 5,
      "text": "Very good Mr. Praveen"
    },
    {
      "id": "text-1553",
      "name": "Vijaykumar badiger",
      "rating": 5,
      "text": "Excellent service given by Mr. Kashinath."
    },
    {
      "id": "text-1554",
      "name": "Ram Borra",
      "rating": 5,
      "text": "Good collection. Praveen was super helpful."
    },
    {
      "id": "text-1558",
      "name": "Rebecca Akansha",
      "rating": 5,
      "text": "Was reasonable. Good service by Praveen"
    },
    {
      "id": "text-1560",
      "name": "Urvi Bandhu",
      "rating": 5,
      "text": "Amazing variety of pearls. Best in Hyderabad. Helpful and friendly staff. Special mention to Raj Kumar ji, Kusuma and Sanjeev. Thank you for making our experience so wonderful."
    },
    {
      "id": "text-1561",
      "name": "santhoshi Silla",
      "rating": 5,
      "text": "Good service by v.kashinath ."
    },
    {
      "id": "text-1562",
      "name": "Diwakar Palemkota",
      "rating": 5,
      "text": "Rajkumar sir , service is good"
    },
    {
      "id": "text-1563",
      "name": "Pragyan Epari",
      "rating": 5,
      "text": "Very happy with the service, cooperation and detailed explanation from Praveen, Kusuma and Mahesh, Thank you"
    },
    {
      "id": "text-1565",
      "name": "Swathi Reddy",
      "rating": 5,
      "text": "Praveen has showed a large variety of collections , thank u"
    },
    {
      "id": "text-1566",
      "name": "abhishek bandyopadhyay",
      "rating": 5,
      "text": "Excellent service..very helpful and showed up multiple options…Praveen was very helpful…"
    },
    {
      "id": "text-1568",
      "name": "mahi teja Ekkaldevi",
      "rating": 5,
      "text": "Pasha, good service and was fast"
    },
    {
      "id": "text-1569",
      "name": "pranavi addanki",
      "rating": 5,
      "text": "The Collections were really good and prices were reasonable.Praveen has given us a comfortable service and has shown all the models with patience"
    },
    {
      "id": "text-1571",
      "name": "baddem mamatha",
      "rating": 5,
      "text": "Good receiving nice collection"
    },
    {
      "id": "text-1572",
      "name": "Smita Khanorkar",
      "rating": 5,
      "text": "Raj kumar very good"
    },
    {
      "id": "text-1573",
      "name": "Hari Prasad",
      "rating": 5,
      "text": "Had a good experience here at the store Good staff experience- Mr Rajkumar"
    },
    {
      "id": "text-1574",
      "name": "Bhakti Darda",
      "rating": 5,
      "text": "Had an amazing shopping experience with Mr. Praveen. He was very detailed with the designs and quality."
    },
    {
      "id": "text-1576",
      "name": "Pamela",
      "rating": 5,
      "text": "Great service by Mr. Mohit.. Had an amazing experience at Krishna Pearls.. authentic products"
    },
    {
      "id": "text-1577",
      "name": "Srivatsava Gorthy",
      "rating": 5,
      "text": "Pasha gave me amazing service…thank you"
    },
    {
      "id": "text-1578",
      "name": "siddharth chandra",
      "rating": 5,
      "text": "Interacted with Mr Mohit . Excellent service ...and wide range of product ..with beautiful designs .. Highly recommended to people who are coming from outside Hyderabad and wanna purchase authentic pearls with good economic price ranges.."
    },
    {
      "id": "text-1579",
      "name": "Vikram Dharmraj",
      "rating": 5,
      "text": "Hi Pasha Nice experience with team, they delivered information properly and more about authenticity Thank you"
    },
    {
      "id": "text-1582",
      "name": "shilpa Chappidi",
      "rating": 5,
      "text": "Experience was good . Mohit and Mr.Venkatesh and helped us in all the ways and explained clearly of rates"
    },
    {
      "id": "text-1583",
      "name": "Sumanth Reddy Saribala",
      "rating": 5,
      "text": "Mohit hospitality and the way he explained us the rates was really good"
    },
    {
      "id": "text-1585",
      "name": "Ajay Nalabhatla",
      "rating": 5,
      "text": "Thank you Team - Mohit , Praveen and Sachin for all the support . You have been so patient , answered all out questions and ensured we pick the right product. My family has been hapoy with the quality, designs and more over with the price. Thank you ! A must visit place for collection if someone looking for a quick pick."
    },
    {
      "id": "text-1586",
      "name": "Vidyasagar G",
      "rating": 5,
      "text": "Very wide range of varities! Mohit was very helpful!"
    },
    {
      "id": "text-1587",
      "name": "Uma Voruganti",
      "rating": 5,
      "text": "Good service by pasha"
    },
    {
      "id": "text-1588",
      "name": "Mohit Kumar",
      "rating": 5,
      "text": "Thanks a lot Praveen for your hospitality. Lovely experience"
    },
    {
      "id": "text-1589",
      "name": "Chandrashekhar Murthy",
      "rating": 5,
      "text": "Great experience we had today while purchasing peral necklace, Praveen and Kashinatha were very helpful to explain different varieties of pearls made our job easy to purchase the item."
    },
    {
      "id": "text-1591",
      "name": "Rajvir Singh",
      "rating": 5,
      "text": "Mr Pasha was extremely helpful."
    },
    {
      "id": "text-1593",
      "name": "pravichandra reddy",
      "rating": 5,
      "text": "Mr praveen taken care very well up to closing of the call Services are good"
    },
    {
      "id": "text-1595",
      "name": "raghava radhika",
      "rating": 5,
      "text": "Mr. Pasha has provided good service and was ensuring customer satisfaction"
    },
    {
      "id": "text-1597",
      "name": "Deepika Naidu",
      "rating": 5,
      "text": "Rajkumar his service was good"
    },
    {
      "id": "text-1598",
      "name": "Aishwarya Rachaputi",
      "rating": 5,
      "text": "Gopal assistance from silver section was great!! Very good service as usual! 🥰"
    },
    {
      "id": "text-1599",
      "name": "Versha Balaji",
      "rating": 5,
      "text": "Very good service and hospitality by Mr. Pasha. Good collection of pearls 😊"
    },
    {
      "id": "text-1601",
      "name": "kalpana reddy",
      "rating": 5,
      "text": "Mr raj kumar,was kind enough to show many varties, wherein I cud select at ease. Appreciate his patience . Thanks"
    },
    {
      "id": "text-1602",
      "name": "Adit Fernandes",
      "rating": 5,
      "text": "Mr.Rajkumar was very helpful and very friendly. He helped me select the ear ring thatbi was looking for"
    },
    {
      "id": "text-1603",
      "name": "Nishant Diwaker",
      "rating": 4,
      "text": "Sales man Raj Kumar was good"
    },
    {
      "id": "text-1605",
      "name": "Murali Cheekati",
      "rating": 5,
      "text": "Good service by kashinath"
    },
    {
      "id": "text-1606",
      "name": "Alisha Bajaj",
      "rating": 5,
      "text": "Good service, reasonable price. Review for Mr. Kashinath."
    },
    {
      "id": "text-1607",
      "name": "Manohar Kumar Goud Thorupunuri",
      "rating": 5,
      "text": "Good service by pasha"
    },
    {
      "id": "text-1608",
      "name": "neeraja",
      "rating": 5,
      "text": "Good service Kashinath garu very nice collection s"
    },
    {
      "id": "text-1609",
      "name": "DIVIA C",
      "rating": 5,
      "text": "We visited Krishna Pearls during our vacation to Hyderabad and they had very good collection of jewellery. Praveen and Kusuma helped us a lot in the selection as well as explained well about the products."
    },
    {
      "id": "text-1610",
      "name": "Salonie Malkar",
      "rating": 5,
      "text": "So happy for the service given by Mohit , If I am honest my family visits only if Mohit is around,and no doubt the quality of the pearls and the design in jwellery is amazing"
    },
    {
      "id": "text-1611",
      "name": "Srinivas Patibandla",
      "rating": 5,
      "text": "Very good service by Rajkumar sir....and very polite"
    },
    {
      "id": "text-1612",
      "name": "Anu Radha Patibandla",
      "rating": 5,
      "text": "Good service by rajkumar ....polite and very good staff more than helping by krishna pearls staff ....thank you krishna pearls thank u very much 😍🥰"
    },
    {
      "id": "text-1613",
      "name": "Prajakta Pravin Naxane",
      "rating": 5,
      "text": "Thanks to Mr. Gopal for good hospitality. They have varieties of good collection"
    },
    {
      "id": "text-1614",
      "name": "Ashna",
      "rating": 5,
      "text": "Great collection of pearls and Mohit was very helpful with the whole selection process."
    },
    {
      "id": "text-1615",
      "name": "manjeera krishna",
      "rating": 5,
      "text": "Quality is good Wide range of varieties"
    },
    {
      "id": "text-1616",
      "name": "Dr. Sudesh Wankhede",
      "rating": 5,
      "text": "Very nice collection & very good staff ABDULLAH PASHA"
    },
    {
      "id": "text-1617",
      "name": "Pankaj Shirbhate",
      "rating": 5,
      "text": "A good experience at Krishna Pearls. Mr. Praveen given us satisfactory service Thanks Krishna Pearls!"
    },
    {
      "id": "text-1618",
      "name": "Prithvi Raj",
      "rating": 5,
      "text": "Customer friendly, polite, patient, multilingual. The name speaks for itself."
    },
    {
      "id": "text-1620",
      "name": "Aman Vincent",
      "rating": 5,
      "text": "Pasha is very courteous and understands the requirement well. We loved rhe collection and will certainly visit again"
    },
    {
      "id": "text-1621",
      "name": "Rao Sachin",
      "rating": 5,
      "text": "Kashinath, Mahesh- Very good supportive staff . Had a very good experience ."
    },
    {
      "id": "text-1622",
      "name": "Rahul Jadhav",
      "rating": 5,
      "text": "Purchased pearl jewelleries at Krishna Pearl Jubilee Hills, one of the finest in Hyderabad. Had a really good experience, Mohit who assisted us was really helpful. He helped us in the shopping by suggesting different varieties."
    },
    {
      "id": "text-1623",
      "name": "Vidisha Balasubramanian",
      "rating": 5,
      "text": "We had a lovely experience at the store. Wonderful collection and staff. Praveen was very patient and showed us some of the most amazing pieces."
    },
    {
      "id": "text-1624",
      "name": "Kashish Handa",
      "rating": 5,
      "text": "Great service by Mr Mohit & quality ensured"
    },
    {
      "id": "text-1625",
      "name": "Sergio Garcia de Dios",
      "rating": 5,
      "text": "I had a very good experience buying at Krishna Pearls. Thanks a lot Raj Kumar and Kusuma for the great service :)"
    },
    {
      "id": "text-1626",
      "name": "Aleena Naaz",
      "rating": 5,
      "text": "It was amazing assisted by mohith. Would definitely shop again thank you"
    },
    {
      "id": "text-1627",
      "name": "Ankit Dhikonia",
      "rating": 5,
      "text": "Good Nd genuine place to shop for pearls. Cost is also best for buy."
    },
    {
      "id": "text-1629",
      "name": "Claret Augustine",
      "rating": 5,
      "text": "Awesome experience, staff here are cordial especially Mr.Praveen. Thanks a lot! Got all I needed as per my budget."
    },
    {
      "id": "text-1631",
      "name": "Savitri Mathapati-Jangam",
      "rating": 5,
      "text": "Good service by Pasha and Kusuma! Thanks a lot it’s a nice purchase"
    },
    {
      "id": "text-1632",
      "name": "kishan",
      "rating": 5,
      "text": "Very good store to buy pearls excellent sales person T. Praveen."
    },
    {
      "id": "text-1633",
      "name": "Swati N",
      "rating": 5,
      "text": "Amazing experiance with Mr Kashinath , He is very patient , provided all the details , very happy with my purchase at Kishna Jewellers and Pearls"
    },
    {
      "id": "text-1634",
      "name": "Vishnu Varadan",
      "rating": 5,
      "text": "Had good experience with Sales person Mr.Praveen was patient and explaining the details very clear."
    },
    {
      "id": "text-1635",
      "name": "samdisha sapra",
      "rating": 5,
      "text": "Gopal showed a good collection of earrings and explained the pearls categories very well"
    },
    {
      "id": "text-1637",
      "name": "Rana S",
      "rating": 5,
      "text": "Very courteous customer service"
    },
    {
      "id": "text-1638",
      "name": "Kabir Nadkarni",
      "rating": 4,
      "text": "Mohit was great!"
    },
    {
      "id": "text-1639",
      "name": "Abdul Moh'd",
      "rating": 5,
      "text": "Mohith was very helpful in choosing us decide a beautiful pearl necklace. Thanks!"
    },
    {
      "id": "text-1640",
      "name": "Sayeda Fatima",
      "rating": 4,
      "text": "Very good service mohit gave"
    },
    {
      "id": "text-1642",
      "name": "shoubhik chakraborty",
      "rating": 5,
      "text": "Good experience. Thanks Pravin for helping me out"
    },
    {
      "id": "text-1643",
      "name": "A Sathish",
      "rating": 5,
      "text": "Has excellent collection. Pasha was very supportive and showed us the right collection with good attitude. Highly recommended for wide range of collection in gold, pearls and silver."
    },
    {
      "id": "text-1645",
      "name": "suvarnarekha dola",
      "rating": 5,
      "text": "Mr.Praveen good service at Sri krishna jwlrs..good experience"
    },
    {
      "id": "text-1646",
      "name": "Roshan Singh",
      "rating": 5,
      "text": "Staff behavior and pearl item is good"
    },
    {
      "id": "text-1647",
      "name": "Pallavi Tirumanisette",
      "rating": 5,
      "text": "Great experience thank u gopal"
    },
    {
      "id": "text-1648",
      "name": "Prasanna Venkatachala",
      "rating": 5,
      "text": "Great Place. Lots of designs. Thanks to Pasha"
    },
    {
      "id": "text-1649",
      "name": "Vittal Vislavath",
      "rating": 5,
      "text": "Very good service kashinath garu good reciveing helps good feel in Krishna pearls thank you so very much"
    },
    {
      "id": "text-1650",
      "name": "Chandan Nath",
      "rating": 5,
      "text": "Good experience with praveen"
    },
    {
      "id": "text-1651",
      "name": "anand reddy",
      "rating": 5,
      "text": "Good customer service by Gopal"
    },
    {
      "id": "text-1652",
      "name": "Haritha Karna",
      "rating": 4,
      "text": "Sales man raj lunar was very friendly and patient in showing all the items"
    },
    {
      "id": "text-1653",
      "name": "Damacharla Narendra babu",
      "rating": 5,
      "text": "Very good service Praveen receiving is very well kusuma she is good helping"
    },
    {
      "id": "text-1655",
      "name": "Prasanti K",
      "rating": 5,
      "text": "Good experience shoppibgbat Krishna pearls jublie hills, Rajkumar is very helpful and polite"
    },
    {
      "id": "text-1656",
      "name": "jasvin kaur",
      "rating": 5,
      "text": "Well assisted by Mr. Gopal. Wonderful varieties."
    },
    {
      "id": "text-1658",
      "name": "sailoo r",
      "rating": 5,
      "text": "Good service praveen"
    },
    {
      "id": "text-1661",
      "name": "Sherin Abraham",
      "rating": 5,
      "text": "Best collection as always! Rajkumar was very patient and kind through our whole selection process and helped us get great jewellery"
    },
    {
      "id": "text-1662",
      "name": "Sashi Varanasi",
      "rating": 5,
      "text": "Mohit was very helpful"
    },
    {
      "id": "text-1663",
      "name": "Goutham C M",
      "rating": 5,
      "text": "Wonderful service"
    },
    {
      "id": "text-1664",
      "name": "Suvam Rout",
      "rating": 5,
      "text": "Amazing place and really loved it and service of Mohit was really excellent and cooperative."
    },
    {
      "id": "text-1665",
      "name": "Kunal Chandra",
      "rating": 5,
      "text": "Kashinath and Kusuma knew all about pearls and helped us to choose the pearl earing i was looking for"
    },
    {
      "id": "text-1667",
      "name": "Anirudh Reddy",
      "rating": 5,
      "text": "Mohit, Experience was pretty good they provided exact the thing which i looking for . Thank you"
    },
    {
      "id": "text-1668",
      "name": "Kokonda Priyanka",
      "rating": 5,
      "text": "Kashinath service was good"
    },
    {
      "id": "text-1669",
      "name": "Binoy Sharma",
      "rating": 5,
      "text": "Good service mohith ji and Good experience thank u Krishna pearls"
    },
    {
      "id": "text-1670",
      "name": "jayant rawat",
      "rating": 5,
      "text": "Kashinath gave great service! Keep it up"
    },
    {
      "id": "text-1671",
      "name": "Info DataM",
      "rating": 5,
      "text": "Excellent advice towards client. Kashinath is an good adviser and supporting towards customers!!!!"
    },
    {
      "id": "text-1673",
      "name": "paramita Chattapadhayay",
      "rating": 5,
      "text": "Pasha sales man are quite helpful.They guided me very well."
    },
    {
      "id": "text-1674",
      "name": "soumita halder",
      "rating": 5,
      "text": "Pasha serivce is good and polite very good collection and kusuma receiveing is very good"
    },
    {
      "id": "text-1676",
      "name": "ANAMIKA YADAV",
      "rating": 5,
      "text": "Good designs and the representer Mohit has shown amazing collection"
    },
    {
      "id": "text-1677",
      "name": "Anupama Roy",
      "rating": 5,
      "text": "Good service by Pasha and nice collection please do visit."
    },
    {
      "id": "text-1678",
      "name": "Pompi Boro",
      "rating": 5,
      "text": "Beautiful pearl collection. Mohit helped us decide what we were looking for. Thank you."
    },
    {
      "id": "text-1680",
      "name": "sree viinodh",
      "rating": 5,
      "text": "The service is good and excellent had a smooth time with MR Praveen."
    },
    {
      "id": "text-1681",
      "name": "Ansh Naidu",
      "rating": 5,
      "text": "Mr. Pasha and Ms. Kusuma were fantastic and very helpful in helping us find the correct jewelry. Keep up the good work. Thank you."
    },
    {
      "id": "text-1682",
      "name": "Saloni Maheshwari",
      "rating": 5,
      "text": "Great place, trusted, certified pearls. Kashinath Kusuma"
    },
    {
      "id": "text-1683",
      "name": "Rohan",
      "rating": 5,
      "text": "Very good service"
    },
    {
      "id": "text-1684",
      "name": "Dr. Sajithkumar P",
      "rating": 5,
      "text": "Good collection of excellent pearl ornaments excellent service The service of Mr. pasha was remarkable"
    },
    {
      "id": "text-1686",
      "name": "Kp Singh",
      "rating": 5,
      "text": "It was nice experience and Mohit was an enterprising guy"
    },
    {
      "id": "text-1687",
      "name": "Vikram M",
      "rating": 5,
      "text": "Thanks Mohit....u r gr8"
    },
    {
      "id": "text-1688",
      "name": "Guru Z",
      "rating": 5,
      "text": "Praveen really helped in knowing us the authenticity of pearls"
    },
    {
      "id": "text-1689",
      "name": "chikyala shashikala",
      "rating": 5,
      "text": "Excellent Service,hospitality is awesome.Pasha has excellent salesmanship.Kusuma n Mahesh has done excellent team work.Kudos to the team.Thank you .Regds.Shashikala"
    },
    {
      "id": "text-1690",
      "name": "Aruna Zakkam",
      "rating": 5,
      "text": "Praveen has assisted us in selection.very friendly & guided us well..good experience"
    },
    {
      "id": "text-1691",
      "name": "Mohan Etikela",
      "rating": 5,
      "text": "Praveen helped us with purchase of jewelry. He was courteous and gave best price."
    },
    {
      "id": "text-1692",
      "name": "Tanya",
      "rating": 5,
      "text": "Gopal, one of the shopkeepers, served us nicely."
    },
    {
      "id": "text-1693",
      "name": "Sristi",
      "rating": 5,
      "text": "Good service by Gopal. Good variety."
    },
    {
      "id": "text-1694",
      "name": "Abhilasha Thackur",
      "rating": 5,
      "text": "Naresh has given me great service"
    },
    {
      "id": "text-1695",
      "name": "Srikanth Gattu",
      "rating": 5,
      "text": "Excellent collection and good experience with the staff Praveen"
    },
    {
      "id": "text-1696",
      "name": "Potterhead Me",
      "rating": 5,
      "text": "Great experience in store! Pasha was amazing and accomodating for our budget restraints 😁"
    },
    {
      "id": "text-1697",
      "name": "Anishka",
      "rating": 5,
      "text": "Gopal was really helpful and help me choose the right jewellery"
    },
    {
      "id": "text-1700",
      "name": "Anu Surya",
      "rating": 5,
      "text": "We had good hospitality and service by Mr. Mohit in Krishna pearls."
    },
    {
      "id": "text-1701",
      "name": "Mansi Dubey",
      "rating": 5,
      "text": "Rajkumar was extremely helpful and at ease during my visit and shopping for pearls"
    },
    {
      "id": "text-1702",
      "name": "Deblina De",
      "rating": 5,
      "text": "Very nice, Gopal"
    },
    {
      "id": "text-1703",
      "name": "jinal shah",
      "rating": 5,
      "text": "They have beautiful designs and staff especially Mr Pasha is very friendly. Will definitely recommend others"
    },
    {
      "id": "text-1704",
      "name": "Vivek Janodhai",
      "rating": 4,
      "text": "Good Hospitality Good Behaviour Good Understanding Skills Customer Assistance by A Raj Kumar."
    },
    {
      "id": "text-1705",
      "name": "Chandrakant Kalambe",
      "rating": 5,
      "text": "Kashinath & Kusuma Like the service & varieties of the products"
    },
    {
      "id": "text-1706",
      "name": "Ahmed Mohammed Ali",
      "rating": 5,
      "text": "Great experience. Gopal helped me choose well.kusuma also good received"
    },
    {
      "id": "text-1707",
      "name": "Sashi Reddy",
      "rating": 5,
      "text": "Mohit is knowledgeable, patient and kind. Shopping here was a pleasurable experience."
    },
    {
      "id": "text-1708",
      "name": "Sagar",
      "rating": 5,
      "text": "Thank you very much for your service. Specially Rajkumar, kusuma helped us a lot in searching for pearl set."
    },
    {
      "id": "text-1709",
      "name": "Ankita Maan",
      "rating": 5,
      "text": "Good collection. Good service by Mr. Pasha."
    },
    {
      "id": "text-1710",
      "name": "Rahul Menon",
      "rating": 5,
      "text": "Special mention to Mr. Rajkumar. The most courteous staff who was very helpful in guiding and showing the amazing collection of pearls and silver ornaments. Thanks."
    },
    {
      "id": "text-1711",
      "name": "Tejaswini Akula",
      "rating": 5,
      "text": "It was good experience to buy at Krishna pearls. Praveen helped as alot to buy the jewelry and kusuma did assist as so well."
    },
    {
      "id": "text-1712",
      "name": "shajiuddin mohammed",
      "rating": 5,
      "text": "Excellent customer service by Mr.Gopal & Mr.Rohit Time convenient satisfaction"
    },
    {
      "id": "text-1713",
      "name": "soham gawde",
      "rating": 5,
      "text": "Kashinath is an excellent sales man, recommend some really nice pearls."
    },
    {
      "id": "text-1714",
      "name": "Soumak Dalapati",
      "rating": 5,
      "text": "Experienced nice to meet Sri Pasha and perfect market experience of him and team."
    },
    {
      "id": "text-1715",
      "name": "Siva Sankar Gupta",
      "rating": 5,
      "text": "Kasinath was very helpful in our purchase of the pearl. We thank you him very much"
    },
    {
      "id": "text-1716",
      "name": "kartheek Reddy Dachani",
      "rating": 5,
      "text": "Praveen assisted very well in the purchase 😊, and good collection in the store."
    },
    {
      "id": "text-1717",
      "name": "Amol Mendhi",
      "rating": 5,
      "text": "Very nice collection ! The salesman Praveen was very polite and showed variety with lots of patience"
    },
    {
      "id": "text-1718",
      "name": "Biju Baby",
      "rating": 5,
      "text": "Good service with Mr.Praveen"
    },
    {
      "id": "text-1719",
      "name": "HARIKRISHNA BODLA",
      "rating": 5,
      "text": "Pasha service is excellent"
    },
    {
      "id": "text-1720",
      "name": "Akash Thirunagari",
      "rating": 5,
      "text": "Pasha helped us in choosing the best necklace set good service"
    },
    {
      "id": "text-1721",
      "name": "Sumit Raturi",
      "rating": 5,
      "text": "Good service by Praveen Ji"
    },
    {
      "id": "text-1722",
      "name": "Dr Joyal J Kandathil",
      "rating": 5,
      "text": "Excellent customer care..beautiful designs Best shppoing..just loved it..Thank you Paasha the manager and Rohith my sale person..great experience"
    },
    {
      "id": "text-1723",
      "name": "SREERAJ C.G",
      "rating": 5,
      "text": "Good experience with praveen"
    },
    {
      "id": "text-1724",
      "name": "Hemansu Kansara",
      "rating": 5,
      "text": "Fantastic and very courteous service by Pasha"
    },
    {
      "id": "text-1725",
      "name": "ARYA S",
      "rating": 5,
      "text": "Thanks Rohit good service"
    },
    {
      "id": "text-1726",
      "name": "Subbrat Dash",
      "rating": 5,
      "text": "Bhupal is a nice guy assistant as in buying a what we needed good place to buy pearls."
    },
    {
      "id": "text-1727",
      "name": "Bheerappa Sonte",
      "rating": 5,
      "text": "Good sales man gopal garu"
    },
    {
      "id": "text-1728",
      "name": "vanu K",
      "rating": 5,
      "text": "Praveen showed us the jewellery very patiently. Good experience"
    },
    {
      "id": "text-1729",
      "name": "raghuvendra upadhyay",
      "rating": 5,
      "text": "Very nice experience while in Krishna pearls.Mr.Pravin at perls department is very nice & humble person helped for having my purchase with his cute smile. Mrs.Kushma also helped along with."
    },
    {
      "id": "text-1730",
      "name": "Harsh Gautam",
      "rating": 5,
      "text": "Kashinath and Kusuma gave us the good services. N they are very humble. Thanks 👍"
    },
    {
      "id": "text-1731",
      "name": "Shivani Dandir",
      "rating": 5,
      "text": "Thank you Kashinath for the great service ☺️"
    },
    {
      "id": "text-1732",
      "name": "kiran dhabade",
      "rating": 5,
      "text": "Mohit conversation with us is awesome"
    },
    {
      "id": "text-1733",
      "name": "Sriteja T",
      "rating": 5,
      "text": "Good service kashinath"
    },
    {
      "id": "text-1734",
      "name": "Mahender Dantham",
      "rating": 5,
      "text": "He is very patient Kashinath"
    },
    {
      "id": "text-1735",
      "name": "Shashi Kanth Ganti",
      "rating": 5,
      "text": "Mr Praveen at Krishna pearls is very patient, understands customer sentiment and has good knowledge of the products offered at the store. I visited casually and ended up purchasing quite a few for gifting,personal shopping. Great collection!"
    },
    {
      "id": "text-1737",
      "name": "Kodelli Veerabhadrarao",
      "rating": 5,
      "text": "Had a visit to buy pearl jewellery, Got serviced by Mr T Praveen. Very Polite and Excellent service. Appreciated"
    },
    {
      "id": "text-1738",
      "name": "Sahasra Tenali",
      "rating": 5,
      "text": "Staff are so polite and helpful with selection.. special mention to Kasi Nath Gaaru and Kusuma Gaaru for helping us with selection… they made us as home… thanks a lot for the great collection and service.. We are able to narrow down 2 sets within 30 min time… Once again thanks 🙏"
    },
    {
      "id": "text-1739",
      "name": "sateesh kumar",
      "rating": 5,
      "text": "Thanks Praveen for showing more varieties of Jewellery, we purchased ear rings. Great collection!"
    },
    {
      "id": "text-1740",
      "name": "Sasi Meghana Vanguru",
      "rating": 5,
      "text": "Great hospitality and amazing designs.kashnath service was really great."
    },
    {
      "id": "text-1741",
      "name": "ashish pandey",
      "rating": 5,
      "text": "Awesome staff and very polite and humble. And its good pricing for all jewellary"
    },
    {
      "id": "text-1743",
      "name": "Sridharrao Putti",
      "rating": 5,
      "text": "Kashinath service are good are great we appisate"
    },
    {
      "id": "text-1744",
      "name": "Dr. K.J. Lavanya Lakshmi",
      "rating": 5,
      "text": "Mr. Kashinath is very good staff"
    },
    {
      "id": "text-1746",
      "name": "Sukla Das",
      "rating": 5,
      "text": "Good collection, very patient service by Rajkumar"
    },
    {
      "id": "text-1747",
      "name": "Salini Purkayastha",
      "rating": 5,
      "text": "Rajkumar- very good service Good collection"
    },
    {
      "id": "text-1748",
      "name": "Vaibhav Parab",
      "rating": 5,
      "text": "The quality of pearls are excellent and are reasonable priced. Praveen help us chose the better options and provided discounts also."
    },
    {
      "id": "text-1750",
      "name": "Kanika Bhatia",
      "rating": 5,
      "text": "Designs and services are very good. Staff is very experienced"
    },
    {
      "id": "text-1751",
      "name": "Adarsh Chandrasekhar",
      "rating": 5,
      "text": "Very good collection and staff were curtious (Kashinath). Highly recommended."
    },
    {
      "id": "text-1752",
      "name": "Geetha Madhuri",
      "rating": 5,
      "text": "Wide range of collection and excellent reception! Kasinath jee in particular is always very helpful and has been our go to person during all our visits. Thank you 😊"
    },
    {
      "id": "text-1753",
      "name": "Sumitha R",
      "rating": 4,
      "text": "Excellent service given by Mr.Rajkumar."
    },
    {
      "id": "text-1754",
      "name": "ncgowda ncgowda",
      "rating": 5,
      "text": "Very good place for purchase of pearls .Mr Praveen assisted us showing all varities with lot of patience"
    },
    {
      "id": "text-1755",
      "name": "bill sowmya",
      "rating": 5,
      "text": "Sravan helped in showing the latest collection according to the requirements. Very helpful in making decisions in a short duration of 45 minutes."
    },
    {
      "id": "text-1756",
      "name": "uppalapati jhansi rani",
      "rating": 5,
      "text": "Very good service given by Raj Kumarji"
    },
    {
      "id": "text-1758",
      "name": "Mohit Gupta",
      "rating": 5,
      "text": "Awesome Shopping Experinence with Krishna Pearls-Jubilee Hills. Mr Kashinath patience for showing the range of products inline to customer needs and information about the Perals is outstanding. Thanks to Krishna Jewelllers team for nice Experience. 👍👍👍🤩🤩"
    },
    {
      "id": "text-1759",
      "name": "Lipsika Bhashyam",
      "rating": 5,
      "text": "Great place to find different types of pearls.. Thank you kashinath garu for the great customer service."
    },
    {
      "id": "text-1760",
      "name": "Payal Jaiswal",
      "rating": 5,
      "text": "Pasha : very good experience"
    },
    {
      "id": "text-1761",
      "name": "tarun gupta",
      "rating": 5,
      "text": "The sales person was very helpful in selecting the right neckpiece. Especially, Kashinath. Also, very good variety in pearls."
    },
    {
      "id": "text-1762",
      "name": "Shweta Gupta",
      "rating": 5,
      "text": "Kashinath really helped us pick some beautiful pieces with a trivia about Pearl's and silver"
    },
    {
      "id": "text-1763",
      "name": "hari priya",
      "rating": 5,
      "text": "The place was great and very hospitable… pasha was super helpful"
    },
    {
      "id": "text-1764",
      "name": "Avuta Kavitha",
      "rating": 5,
      "text": "Good and patience service Appreciate his professionalism of pasha"
    },
    {
      "id": "text-1765",
      "name": "Sujitha Priyadarsini Kosaraju",
      "rating": 5,
      "text": "Kashinath good experience"
    },
    {
      "id": "text-1766",
      "name": "jeeja c.k.",
      "rating": 5,
      "text": "plenty to choose from. latest designs. Kusuma was very helpful and pleasant. Pasha showed a variety of silver and gold earrings and was very helpful."
    },
    {
      "id": "text-1767",
      "name": "anish kumar",
      "rating": 5,
      "text": "Nice place to buy pearls .. I guess trust has always attracted me to Krishna pearls . Praveen was very helpful."
    },
    {
      "id": "text-1768",
      "name": "kedar jadhav",
      "rating": 5,
      "text": "Go quality pearl products .. ver much satisfied with service, specially Mr Pravin was very helpful"
    },
    {
      "id": "text-1769",
      "name": "sai sumiran (bubby)",
      "rating": 5,
      "text": "Good collection. Staff are friendly and helpful. Pasha assisted very well."
    },
    {
      "id": "text-1770",
      "name": "Praveen Reddy. J",
      "rating": 5,
      "text": "Purchased the pearl chocker.The collection was good from under the guidance of Mr.Raj kumar..Can go ahead and withthe shopping experience was good"
    },
    {
      "id": "text-1771",
      "name": "Girija S Gorbal",
      "rating": 5,
      "text": "Nice collections and reasonable price"
    },
    {
      "id": "text-1772",
      "name": "Ranjana G",
      "rating": 5,
      "text": "Very nice collections"
    },
    {
      "id": "text-1775",
      "name": "DHARANIPRIYA ARIKRISHNAN",
      "rating": 5,
      "text": "Reliable place.. Mr. Mohit was very friendly and helpful."
    },
    {
      "id": "text-1776",
      "name": "Preeti Singh",
      "rating": 5,
      "text": "Raj kumar,Excellent Experience"
    },
    {
      "id": "text-1777",
      "name": "J Sree",
      "rating": 5,
      "text": "Mr. Mohit was very friendly and provided very good service"
    },
    {
      "id": "text-1781",
      "name": "Ayesha Owen",
      "rating": 5,
      "text": "Great experience, very helpful staff! Especially Raj! Thank you!"
    },
    {
      "id": "text-1782",
      "name": "Veronica Downs",
      "rating": 5,
      "text": "Raj Kumar had great service! Helped up with all of our requests"
    },
    {
      "id": "text-1783",
      "name": "Vishakha Singh",
      "rating": 5,
      "text": "Very good quality pearls and easily customizable. Pasha and his team assisted us and they very polite and courteous. Must recommend shop for pearls."
    },
    {
      "id": "text-1785",
      "name": "Siddesh C R",
      "rating": 5,
      "text": "Good place to buy.."
    },
    {
      "id": "text-1786",
      "name": "Rakishma M",
      "rating": 5,
      "text": "Great service by Praveen"
    },
    {
      "id": "text-1787",
      "name": "Shielly Pahwa Bahl",
      "rating": 5,
      "text": "Gopal and Kusuma were extremely polite, and .courteous."
    },
    {
      "id": "text-1788",
      "name": "Viji Sekar",
      "rating": 5,
      "text": "Experience was very good. Good collections"
    },
    {
      "id": "text-1791",
      "name": "Ila Sharma",
      "rating": 5,
      "text": "Had an amazing experience at Krishna Pearls shopping for exquisite pieces for self and family. Especially taken care of patiently and joyously by Mohit Agarwal!"
    },
    {
      "id": "text-1792",
      "name": "Snigdha Singh",
      "rating": 5,
      "text": "Great experience with Mohit Agarwal here!'"
    },
    {
      "id": "text-1793",
      "name": "shahaji shinde",
      "rating": 5,
      "text": "Had a very good Interaction with Pasha, Good shop"
    },
    {
      "id": "text-1794",
      "name": "madhu KS",
      "rating": 5,
      "text": "Excellent service by Pasha"
    },
    {
      "id": "text-1796",
      "name": "Bishakha Dasgupta",
      "rating": 5,
      "text": "Praveen helped guide pearl jewellery sets for us expertly. Thank you"
    },
    {
      "id": "text-1797",
      "name": "Devansh kumar",
      "rating": 5,
      "text": "Great experience with Mohit."
    },
    {
      "id": "text-1798",
      "name": "Gnana prasuna",
      "rating": 5,
      "text": "Very detailed explanation by Mr.Mohith Happy to shop at krishna pearls :-)"
    },
    {
      "id": "text-1801",
      "name": "Alljunkhere 111",
      "rating": 5,
      "text": "Collection on the earrings have to increase. Good customer service"
    },
    {
      "id": "text-1802",
      "name": "nivedita srivastava",
      "rating": 5,
      "text": "The products are nice and designs are good. More than anything else uthe staff is very good and so is the service . Praveen was very polite and courteous"
    },
    {
      "id": "text-1803",
      "name": "Anushka Palkamsetty",
      "rating": 5,
      "text": "Elaborate collection with tasteful display. Kashinath was our sales guy and he was very sweet and showed us around very patiently and kept the whole process smooth and quick. Keep it up."
    },
    {
      "id": "text-1804",
      "name": "shweta lodaya",
      "rating": 5,
      "text": "Praveen .. thank you for the wonderful shopping experience..."
    },
    {
      "id": "text-1805",
      "name": "Sneha Sharma",
      "rating": 5,
      "text": "I'm very happy that I found out this store. This store has great varieties and good quality of jewellery, staff is really helpful who don't put any pressure. Paasha sir helped me with my requirement and I'm happy with my purchase"
    },
    {
      "id": "text-1806",
      "name": "Mohit Kalra",
      "rating": 5,
      "text": "Collection is very good, and Mr Pasha was very knowleabout the petals and ruby. Overal first time but very good"
    },
    {
      "id": "text-1807",
      "name": "ANANTHA KISHORE PANIGRAHI",
      "rating": 5,
      "text": "Kashinath is good sales man"
    },
    {
      "id": "text-1808",
      "name": "Rohith Naga",
      "rating": 5,
      "text": "Very supportive staff @ praveen"
    },
    {
      "id": "text-1809",
      "name": "Chaitanya Kiran",
      "rating": 5,
      "text": "Nice collection and good service praveen"
    },
    {
      "id": "text-1810",
      "name": "Smita Khandelwal",
      "rating": 5,
      "text": "Exclusive design for gifting in budget. Well guided by Mr. Praveen (jublee hills)"
    },
    {
      "id": "text-1811",
      "name": "Ajinkya Babar",
      "rating": 5,
      "text": "Nice collections shown by kashinath sales manager.very polite and good behaviour. Collection is of all ranges and pearl quality is too good😊"
    },
    {
      "id": "text-1812",
      "name": "Mihir Rajput",
      "rating": 5,
      "text": "Had visited the store and had a wonderful experience. Staff is very courteous and helpful. Kashinath had assisted us and he made our shopping experience easy. Must visit when in hyderabad."
    },
    {
      "id": "text-1813",
      "name": "nivedita saini",
      "rating": 5,
      "text": "Salesperson- Kashinath Awesome services"
    },
    {
      "id": "text-1814",
      "name": "sukumar sahu",
      "rating": 5,
      "text": "Gopal & Rohit, Nice behaviour."
    },
    {
      "id": "text-1816",
      "name": "Kumar Yadav",
      "rating": 5,
      "text": "Mr Rajkumar is very helpful. Has very good customer handling skills."
    },
    {
      "id": "text-1819",
      "name": "Nishant Vardhmani",
      "rating": 5,
      "text": "Good environment n good quality product"
    },
    {
      "id": "text-1821",
      "name": "Durai G",
      "rating": 4,
      "text": "Good place. Mohit showed"
    },
    {
      "id": "text-1822",
      "name": "Sumit Mahadik",
      "rating": 5,
      "text": "It was a nice experience, they have so many varieties in reasonable rates. Thank you Mr Pravin for helping me out"
    },
    {
      "id": "text-1823",
      "name": "Turgay Tekin",
      "rating": 5,
      "text": "Very good experience here thanks to mr raj kumar"
    },
    {
      "id": "text-1824",
      "name": "Dr. Vinod v",
      "rating": 5,
      "text": "Rajkumar- excellent collection and moderate price. Well behaved and good explanation on pearls. Worth purchase"
    },
    {
      "id": "text-1825",
      "name": "Durga Patra",
      "rating": 5,
      "text": "Nice experience of shopping with salesman Rajkumar. He guided us to choose the right pearl set. Good collection and nice ambiance. Thanks 👍"
    },
    {
      "id": "text-1826",
      "name": "Nilam Patel",
      "rating": 5,
      "text": "It was a great experience with Mr Raj kumar"
    },
    {
      "id": "text-1827",
      "name": "disha yadav",
      "rating": 5,
      "text": "Have variety of collections... it was great shopping here"
    },
    {
      "id": "text-1828",
      "name": "Renuka Gajendra",
      "rating": 5,
      "text": "Exited to see lot of designs pure pearls.. must visit"
    },
    {
      "id": "text-1829",
      "name": "Kavita Chavan",
      "rating": 5,
      "text": "Excellent shop … raj Kumar specifically understood our taste and showed us pieces according"
    },
    {
      "id": "text-1832",
      "name": "Sonali Das",
      "rating": 5,
      "text": "Liked the service by KashiNath"
    },
    {
      "id": "text-1833",
      "name": "Kanishka Sreelakshmi",
      "rating": 5,
      "text": "Amazing collection and very friendly staff especially Kashinath"
    },
    {
      "id": "text-1834",
      "name": "KANISHKA",
      "rating": 5,
      "text": "The collection is amazing and the staff is also very nice. Kashinath is very helpful"
    },
    {
      "id": "text-1835",
      "name": "Sathya Ramasamy",
      "rating": 5,
      "text": "Excellent shop to buy pearls"
    },
    {
      "id": "text-1836",
      "name": "Yeshwanth Vakati Ramesh",
      "rating": 5,
      "text": "The collections were very good and the quality is also on point. The staff were very courteous and special mention to Praveen who assisted us patiently"
    },
    {
      "id": "text-1838",
      "name": "Sohini Sheth",
      "rating": 5,
      "text": "It was great experience and Praveen was very helpful and will recommend to everyone!. Thanks Praveen and Krishna Jewellers"
    },
    {
      "id": "text-1839",
      "name": "Denuka K",
      "rating": 5,
      "text": "Raj Kumar was very helpful and accommodating. Would recommend"
    },
    {
      "id": "text-1840",
      "name": "Dnyaneshwar Kekan",
      "rating": 5,
      "text": "One of the best shop for pearls in hyderabad, staff member pasha sir are very polite."
    },
    {
      "id": "text-1841",
      "name": "uma mahesh",
      "rating": 5,
      "text": "@Pasha the staff was quite friendly and pleasant; plenty of design around to try and colorful stones and pearls which was perfectly fits in every occasion ;and very budget friendly loved ittt"
    },
    {
      "id": "text-1842",
      "name": "Balabrahmanandam Garapati",
      "rating": 5,
      "text": "Very good salesmanship by praveen"
    },
    {
      "id": "text-1843",
      "name": "Rohit Verma",
      "rating": 5,
      "text": "Had great experience with Mr. KashiNath"
    },
    {
      "id": "text-1844",
      "name": "Abhinav Tomar",
      "rating": 5,
      "text": "The collection was amazing, and Mr. Kashinath from Jubilee Hills store help a lot during my trip"
    },
    {
      "id": "text-1845",
      "name": "harikanth reddy",
      "rating": 5,
      "text": "Good range of pearl sets with gold and silver. Praveen Kumar thanks for serving us with all doubts and finding in fancy designer pearl set"
    },
    {
      "id": "text-1846",
      "name": "Rupali Mehta",
      "rating": 5,
      "text": "Had a wonderful shopping experience at Krishna pearls. Thanks to Mr. Kashinath for showing the exclusive collection."
    },
    {
      "id": "text-1847",
      "name": "Jenitha Cardoza",
      "rating": 5,
      "text": "It was a good experience. Salesman kashinath helped me in selecting my choice understanding what I need ."
    },
    {
      "id": "text-1848",
      "name": "Pooja Bhardwaj",
      "rating": 5,
      "text": "Its a best place in hyderabad to get pearls, Price very affordable and also staff is very helpful and friendly. Mohit Agarwal was very helpful and patience in showing the pieces. Thanks for the service Mohit Sir!"
    },
    {
      "id": "text-1850",
      "name": "Pooja Bafna",
      "rating": 5,
      "text": "Wonderful collection. Mr Kashinath displayed the pearls ,has perfect knowledge about the products ."
    },
    {
      "id": "text-1851",
      "name": "Manas Das",
      "rating": 5,
      "text": "It's first time visit this shop. I met with Rajkumar here. I bought pearl necklace. It looks good and they have lots of varieties. His behaviour is good. You can try this shop for shopping."
    },
    {
      "id": "text-1853",
      "name": "Manoj Nair",
      "rating": 5,
      "text": "It was a wonderful experience to shop here. Mr. Pravin showed all the designs with patience and understood my requirements. Would appreciate if more pearl finger rings are available"
    },
    {
      "id": "text-1854",
      "name": "Vikas jamwal",
      "rating": 5,
      "text": "We had good experience with Mr.Mohit"
    },
    {
      "id": "text-1855",
      "name": "Elizabeth Cherian",
      "rating": 5,
      "text": "We had a good experience shopping here. Kudos to Gopal for helping us through the process of finding the best!"
    },
    {
      "id": "text-1856",
      "name": "Nithin N",
      "rating": 4,
      "text": "Praveen explained the product well."
    },
    {
      "id": "text-1857",
      "name": "Sravanthi Gaddam",
      "rating": 5,
      "text": "It’s good store for pearl sets. Very nice customer service too. Praveen helped us for selection. He was very helpful."
    },
    {
      "id": "text-1858",
      "name": "Sharmila Karande",
      "rating": 5,
      "text": "Beautiful designs and great customer service by Mr pasha."
    },
    {
      "id": "text-1859",
      "name": "Praneetha Reddy",
      "rating": 5,
      "text": "Collection is very good and Yadav service was good and polite"
    },
    {
      "id": "text-1860",
      "name": "Abi Felix",
      "rating": 5,
      "text": "Visited the shop for the first time and the response was good.. Mr. Mohit, Sales person, guided and the service was very good.."
    },
    {
      "id": "text-1861",
      "name": "Nisha Das",
      "rating": 5,
      "text": "Variety of collections with all price ranges. Liked the collections _pasha was very good in showing the collections"
    },
    {
      "id": "text-1862",
      "name": "Dk",
      "rating": 5,
      "text": "Great collection and Mohit was very knowledgeable and showed us all the new collections"
    },
    {
      "id": "text-1863",
      "name": "Dee Ganesh",
      "rating": 5,
      "text": "Nice and many varities of pearl pasha"
    },
    {
      "id": "text-1864",
      "name": "Sahil Anand",
      "rating": 5,
      "text": "Best service given by Mohit Aggarwal. Many thanks 😊"
    },
    {
      "id": "text-1865",
      "name": "sarupsikha ghosh",
      "rating": 4,
      "text": "Had a lot of collections, Praveen guided us and helped us choosing the right one. Can recommend others as well"
    },
    {
      "id": "text-1866",
      "name": "Debadutta Pramanik",
      "rating": 5,
      "text": "MR.PASHA is excellent service"
    },
    {
      "id": "text-1867",
      "name": "GEETA MUPPALLA",
      "rating": 4,
      "text": "Given an order for Gold ring. Customer service is good. Nitesh has gave us good understanding about the designs or prices. Looking forward to see the product, if I like would continue buying here."
    },
    {
      "id": "text-1868",
      "name": "Anushree Chaudhary",
      "rating": 5,
      "text": "Great experience, thanks to Mohit"
    },
    {
      "id": "text-1869",
      "name": "Pratibha Dubey",
      "rating": 5,
      "text": "Great collection for pearls ! Great customer service.Thanks Mohit."
    },
    {
      "id": "text-1871",
      "name": "Konasani Siribhushan",
      "rating": 5,
      "text": "Mohith given good assistance and he is so appreciative…. Good"
    },
    {
      "id": "text-1872",
      "name": "ramya sayani",
      "rating": 5,
      "text": "Praveen garu it's very nice service from him and good collection of pearls thanku so much"
    },
    {
      "id": "text-1874",
      "name": "rasool B",
      "rating": 5,
      "text": "Good service. 5hank you Praveen."
    },
    {
      "id": "text-1875",
      "name": "Trisha Bhatt",
      "rating": 5,
      "text": "Pasha...Thank you so much ..."
    },
    {
      "id": "text-1876",
      "name": "Niveditha R",
      "rating": 5,
      "text": "Very nice collections and good service"
    },
    {
      "id": "text-1877",
      "name": "Narmadha Adimoolam",
      "rating": 5,
      "text": "This is my first visit to Krishna Pearls and one of the best experiences. The collections were mind blowing and the service was great. Pavani did an excellent job in patiently showing us designs and help choose what we wanted the way we wanted and Pradeep in the Pearl section helped choose pearls of our choice. Even in the Pearl section we were mesmerised by the collections. A must visit place if you are a jewellery lover."
    },
    {
      "id": "text-1879",
      "name": "mayank1116 sharma",
      "rating": 5,
      "text": "Really nice service. Pasha is very professional, answers all questions politely and overall made our experience good."
    },
    {
      "id": "text-1881",
      "name": "Divya Maddireddi",
      "rating": 5,
      "text": "Good place to go for any kind of pearls and service is really good. @Praveen was very nice in showing the items"
    },
    {
      "id": "text-1882",
      "name": "Suparna Kar",
      "rating": 5,
      "text": "Mr pasha thank you for your great service and showing us patiently"
    },
    {
      "id": "text-1883",
      "name": "Sanjay Bhar",
      "rating": 5,
      "text": "Excellent showroom, with excellent service & manners. Excellent service of Pasha"
    },
    {
      "id": "text-1884",
      "name": "Mrudul Kulkarni",
      "rating": 5,
      "text": "Trusted ! And very beautiful collections of pearl and jewellery. The words are not enough to describe it. You should visit here once. Also the staff is very helpful and caring. They coordinated very well."
    },
    {
      "id": "text-1885",
      "name": "Vrushali Patil",
      "rating": 5,
      "text": "Good collection of jewellery ... Must visit at least one time, you love it"
    },
    {
      "id": "text-1886",
      "name": "chaitali patil",
      "rating": 5,
      "text": "Great collection, great combination of traditional and new age era Special Thanks to *Mohit* for helping us select a better design for my regular use Thank you"
    },
    {
      "id": "text-1887",
      "name": "Ram Prasad",
      "rating": 5,
      "text": "Very good explanation in product thank you.. Praveen"
    },
    {
      "id": "text-1888",
      "name": "Shalini Chauhan",
      "rating": 5,
      "text": "Mr. Mohit was very cooperative and really explained everything nicely. Very good collection."
    },
    {
      "id": "text-1889",
      "name": "ANANTH REDDY",
      "rating": 5,
      "text": "Service is. Good appreciate"
    },
    {
      "id": "text-1890",
      "name": "Uday Kumar",
      "rating": 5,
      "text": "Very good collection of jewelry and Very good service of preveen , what exactly we want he showed that jewelry design , Great service experience"
    },
    {
      "id": "text-1891",
      "name": "Navneeth Kumar",
      "rating": 5,
      "text": "I went to krishna pearls in jublee hills which made me get the right pearl jewellery . Praveen kumar was so cooperative with us and patiently presented all the different variety of products and designs accorsing to our intrest .thanks for help us choosing the right ornament."
    },
    {
      "id": "text-1892",
      "name": "Monika Gupta",
      "rating": 5,
      "text": "Very nice collection and price is also ok. Mr. Gopal was very humble and showed us the best pieces. At discounted price too."
    },
    {
      "id": "text-1893",
      "name": "Naveen Raju",
      "rating": 5,
      "text": "Good received from gopal... Staff members"
    },
    {
      "id": "text-1894",
      "name": "CC Y",
      "rating": 5,
      "text": "Here to buy a gift , Mr Mohit has really helped us figure out the right one and has taken care of the entire process making it easier for us to choose . Thanks , Appreciate It."
    },
    {
      "id": "text-1895",
      "name": "Veni Manchala",
      "rating": 5,
      "text": "Good collection and friendly approach."
    },
    {
      "id": "text-1896",
      "name": "Senthil Raj Baradhi",
      "rating": 5,
      "text": "Gopal and Sonia were good and helped in deciding"
    },
    {
      "id": "text-1897",
      "name": "Ravinder P",
      "rating": 5,
      "text": "Very nice experience, thanks to Mr Gopal."
    },
    {
      "id": "text-1898",
      "name": "Priya Saini",
      "rating": 5,
      "text": "Thankyou Gopal for great services and helping us in finding my gift. Keep doing the good work.. best wishes for your future.."
    },
    {
      "id": "text-1899",
      "name": "Ganesh Pimple",
      "rating": 5,
      "text": "Nice ambience and experience. Gopal was really helpful to select the products."
    },
    {
      "id": "text-1900",
      "name": "Palash Kasture",
      "rating": 5,
      "text": "Very Good Collection… Mr. Kashinath showed is the amazing collection they have… Very polite staff and good collection. Must Visit"
    },
    {
      "id": "text-1901",
      "name": "dhananjay sharma",
      "rating": 5,
      "text": "Great collection. Mohit was very helpful in explaining about the products, and helping us in deciding our purchase. Wonderful experience"
    },
    {
      "id": "text-1902",
      "name": "Krishn Amit Bhargava",
      "rating": 4,
      "text": "Great collection, Kashinath was very helpful !"
    },
    {
      "id": "text-1903",
      "name": "tarushi aggarwal",
      "rating": 5,
      "text": "Mr. Kashinath was very helpful. Good store."
    },
    {
      "id": "text-1906",
      "name": "gowthami adusumilli",
      "rating": 5,
      "text": "Kashinath garu service was very good and showed the best product"
    },
    {
      "id": "text-1907",
      "name": "Ruchi Paliwal",
      "rating": 5,
      "text": "My love place.... Happy hosting from kashinath"
    },
    {
      "id": "text-1908",
      "name": "Micky 04",
      "rating": 5,
      "text": "Im satisfied with the service. Great collection. Thank you Praveen for helping me out."
    },
    {
      "id": "text-1909",
      "name": "Payal Jain",
      "rating": 5,
      "text": "Love the collection, and the hospitality was great. Kashinath served us well. Both the pearls and diamonds collection was great."
    },
    {
      "id": "text-1911",
      "name": "Chandra Sekar",
      "rating": 5,
      "text": "Good Designs and very friendly staff. Mr.Praveen showed us the entire designs patiently and helped us in deciding the best of the design with in our range."
    },
    {
      "id": "text-1912",
      "name": "Pradeep Malladi",
      "rating": 5,
      "text": "Mr. Raj Kumar had showed the chocker sets. The place is very ambient. Ms. Soniya showed us pearl bangles and overall customer satisfaction is great. Got pearl choker set from here"
    },
    {
      "id": "text-1913",
      "name": "Chitra Rajpurohit",
      "rating": 5,
      "text": "Kashinath was good and patient regarding his sales. And suggested many options"
    },
    {
      "id": "text-1914",
      "name": "Vipul Mistry",
      "rating": 5,
      "text": "Mohit showed all options patiently and politely"
    },
    {
      "id": "text-1915",
      "name": "Dilip Irabatti",
      "rating": 4,
      "text": "Best store for pearls. They greet you first with the welcome and make sure you are comfortable with a glass of water. Nice hospitality. Pravin was the sales guy who was showed us all the options what we wanted and shared lot details about types pearls and how they are priced in market. This store has lot of options for fresh water as well as sea water pearls in many different sizes."
    },
    {
      "id": "text-1916",
      "name": "Sameer Kumar",
      "rating": 5,
      "text": "Mohit gave great advice and has been patient while showing us all set of antiques."
    },
    {
      "id": "text-1917",
      "name": "Komal Goplani",
      "rating": 5,
      "text": "Kashinath is very supportive and nice...He is very soft spoken and patience."
    },
    {
      "id": "text-1919",
      "name": "Amulya Saxena",
      "rating": 5,
      "text": "Gopal was extremely helpful and was full of knowledge, he was a great help"
    },
    {
      "id": "text-1920",
      "name": "Sarat Pinapati",
      "rating": 5,
      "text": "We visited Krishna Jewellers for first time. Our experience is very great. They have several models of Jewellery. My wife bought Pearl and precious stone necklace. Mr. Praveen was very helpful in patiently showing us the models."
    },
    {
      "id": "text-1921",
      "name": "ayushi",
      "rating": 5,
      "text": "Great experience,Nice collection.Thanks Rajkumar for helping us out."
    },
    {
      "id": "text-1922",
      "name": "Sanket Sonkusle",
      "rating": 5,
      "text": "Good experience with Praveen for buying real pearl jewellery for my Aai."
    },
    {
      "id": "text-1923",
      "name": "ECO PANELS",
      "rating": 5,
      "text": "Good job 👍T praven"
    },
    {
      "id": "text-1924",
      "name": "Agnee Ghosh",
      "rating": 5,
      "text": "Mohit Agarwal at the Krishna Pearls did a fantastic job of making us feel at home and showed us the best jewellery! Highly recommend Krishna Pearls if you’re looking for authentic pearls and fashionable jewellery!"
    },
    {
      "id": "text-1925",
      "name": "Anchal Jain",
      "rating": 5,
      "text": "Gopal is an excellent salesman and the entire team has been extremely helpful in the pearls department. We went to buy 1 piece of jewellery and ended up with more than one. They were all absolutely amazing"
    },
    {
      "id": "text-1926",
      "name": "Anand",
      "rating": 5,
      "text": "Gopal and Mahesh guided very well with our purchase. They were very patient and co-operative and guided us with enthusiasm and dedication!"
    },
    {
      "id": "text-1927",
      "name": "Sharath K B",
      "rating": 5,
      "text": "Nice experience got what i want thanks to abdulla pasha and team."
    },
    {
      "id": "text-1928",
      "name": "Pranav Bharadwaj",
      "rating": 5,
      "text": "My favourite jewellery shop , Praveen garu has been a great help suggesting me and my family choose the best piece of ornament"
    },
    {
      "id": "text-1929",
      "name": "Shuvratav Mitra",
      "rating": 5,
      "text": "V Kashinath was extremely helpful and he helped in selecting the right product. Thanks"
    },
    {
      "id": "text-1930",
      "name": "Monica Ramamoorthy",
      "rating": 5,
      "text": "We were serviced by person named Pasha .He showed us wide range of Pearl collections..extra ordinary designs"
    },
    {
      "id": "text-1932",
      "name": "Inderjeet Singh",
      "rating": 5,
      "text": "Kashinath was awesome"
    },
    {
      "id": "text-1933",
      "name": "nitesh prajapati",
      "rating": 5,
      "text": "Kashinath and soniya are the best,always help us chose the best options in pearls"
    },
    {
      "id": "text-1934",
      "name": "udit paliwal",
      "rating": 5,
      "text": "Amazing place with a huge variety of jewellery, Mohit was super helpful in selecting the right set"
    },
    {
      "id": "text-1935",
      "name": "ashwini k g",
      "rating": 5,
      "text": "Good service Pasha and polite"
    },
    {
      "id": "text-1937",
      "name": "Prudhvi Raj Chalamala",
      "rating": 5,
      "text": "Very nice service by Raj Kumar."
    },
    {
      "id": "text-1938",
      "name": "Abhinav Mishra",
      "rating": 5,
      "text": "Very pleasant experience. Mr. Abdullah Pasha was very considerate and patient."
    },
    {
      "id": "text-1939",
      "name": "Varun Pola",
      "rating": 5,
      "text": "Had a very good experience in the showroom. Staff here are very user friendly and value customers a lot. We had interacted with Naga Sai during our purchase and he was very good."
    },
    {
      "id": "text-1940",
      "name": "priyasha chaubey",
      "rating": 5,
      "text": "Came second time. Loved it. Praveen was very helpful"
    },
    {
      "id": "text-1941",
      "name": "Uma Devi",
      "rating": 5,
      "text": "Raj kumar was a good sales man"
    },
    {
      "id": "text-1942",
      "name": "Raghavan SK",
      "rating": 5,
      "text": "Amazing collection a must visit if you are looking for pearls and silver collection. Kashinath was helpful"
    },
    {
      "id": "text-1943",
      "name": "Gayathri Katta",
      "rating": 5,
      "text": "Very pleasant experience and service by Mr.Praveen. very nice destination to finalize pearls"
    },
    {
      "id": "text-1945",
      "name": "Adarsh Das",
      "rating": 5,
      "text": "Good service by Pasha. Very patient and helpful"
    },
    {
      "id": "text-1946",
      "name": "Anitha Chalasani",
      "rating": 5,
      "text": "Kashinath and Kusuma helped a lot patiently throughout the day and made us feel comfortable with the purchase ."
    },
    {
      "id": "text-1947",
      "name": "Ashwani Shrivastav",
      "rating": 5,
      "text": "Mr. Pravin had done good service during my visit for selection of items. His service was extraordinary. Ms.Bhagyashree also assisted well during telephonic conversation. I appreciate her cooperation."
    },
    {
      "id": "text-1948",
      "name": "Ramesh Guguloth",
      "rating": 5,
      "text": "Gopal is nice person"
    },
    {
      "id": "text-1949",
      "name": "Dharur Shubam conventions",
      "rating": 5,
      "text": "Satisfied with service and patience Praveen"
    },
    {
      "id": "text-1950",
      "name": "janmeja nayak",
      "rating": 5,
      "text": "I had an absolutely amazing time at Krishna Pearls. Pasha was excellent in attending to us and helping us find what we wanted to buy. Very warm person! Loved all the collection and would highly recommend this place!"
    },
    {
      "id": "text-1951",
      "name": "Biswabijayee Chandra Sekhara Mohanty",
      "rating": 5,
      "text": "The experience was really nice The people are really polite especially Mr. Mohit overall a really nice experience"
    },
    {
      "id": "text-1952",
      "name": "Akash Yadav",
      "rating": 5,
      "text": "The experience was really nice The people are really polite especially Mr. Mohit overall a really nice experience"
    },
    {
      "id": "text-1953",
      "name": "Suman Bandopadhyay",
      "rating": 5,
      "text": "Very nice ambience and collection. Gopal was very patient and very thorough to show us many designs. Very nice experience. My wife and me had a good time and purchase."
    },
    {
      "id": "text-1954",
      "name": "Bharadwaj Sai govind",
      "rating": 5,
      "text": "Pasha has shown us the best that we are seeking for..we got our exact pearls Thanx to pasha and soniya"
    },
    {
      "id": "text-1955",
      "name": "Priti Talwar",
      "rating": 5,
      "text": "Our experience at the store is always been good. The quality is exceptional. Mohit from the sales team was very helpful."
    },
    {
      "id": "text-1956",
      "name": "AYUSHREE BARUAH",
      "rating": 5,
      "text": "Very nice collection and nicely shown by Mr Pasha! Thank you!"
    },
    {
      "id": "text-1957",
      "name": "Hari",
      "rating": 5,
      "text": "Good service, pasha provided good information and helpful."
    },
    {
      "id": "text-1958",
      "name": "vishwas n udupa",
      "rating": 5,
      "text": "Mohit Agarwal showed well and was happy with experience"
    },
    {
      "id": "text-1959",
      "name": "Peri Anusha",
      "rating": 5,
      "text": "The hospitality, service and collection was very good by Mr Pasha and his team."
    },
    {
      "id": "text-1960",
      "name": "Kayithi K suma",
      "rating": 5,
      "text": "Pavani service is good models are nice"
    },
    {
      "id": "text-1961",
      "name": "neeraj bajaj",
      "rating": 5,
      "text": "Being from delhi whenever I came to Hyderabad this is my first place to visit thanx pasha for best hospitality recommended to everyone"
    },
    {
      "id": "text-1963",
      "name": "Anshul Sharma",
      "rating": 5,
      "text": "Gopala was fantastic and thorough in explaining everything. Great selection!"
    },
    {
      "id": "text-1964",
      "name": "Sneha Inampudi",
      "rating": 5,
      "text": "Nice place to shop pearls"
    },
    {
      "id": "text-1966",
      "name": "narmadha veni",
      "rating": 5,
      "text": "Thank you mohith for understanding my requirements and showing right choices"
    },
    {
      "id": "text-1967",
      "name": "Mamillapalli Ramesh",
      "rating": 5,
      "text": "Wonderful experience with Krishna pearls. Must visit.. Thank you Pasha"
    },
    {
      "id": "text-1968",
      "name": "Venkat Bommakanti",
      "rating": 5,
      "text": "Excellent collection of Pearls Jewellery. The staff is very polite. Mohit was very friendly and polite. Customer satisfaction is prime concern for them. Very satisfied after visiting this place."
    },
    {
      "id": "text-1969",
      "name": "rishika sawhney",
      "rating": 5,
      "text": "Mr. Mohit Aggarwal gave us very insightful information and details about the product and guided us throughout. Being a not native person of HYD a much needed assistance was given to us by him. Thank you. We got the best ☺️"
    },
    {
      "id": "text-1970",
      "name": "puneet lalwani",
      "rating": 5,
      "text": "We purchased pearls and we are totally amaze with the service. Mohit Aggarwal help us in choosing the best pearl in our budget. His assistance/service help us a lot. One of the best team member Krishna pearls have. Thank you."
    },
    {
      "id": "text-1971",
      "name": "askani sushma",
      "rating": 5,
      "text": "Very great experience great collection and good behaviour by the staff (Pasha)😊"
    },
    {
      "id": "text-1973",
      "name": "GOLDI SHARMA",
      "rating": 5,
      "text": "Excellent experience"
    },
    {
      "id": "text-1974",
      "name": "Sohini Mukherjee",
      "rating": 5,
      "text": "Very good collection with reasonable price. Available all genuine products."
    },
    {
      "id": "text-1975",
      "name": "SREEKANTHA REDDY YEDDULA",
      "rating": 5,
      "text": "Excellent receiving and cooperation By Mr GOPAL K"
    },
    {
      "id": "text-1976",
      "name": "vinodkumar chennuri",
      "rating": 5,
      "text": "Good collection"
    },
    {
      "id": "text-1977",
      "name": "Tyler Bean",
      "rating": 5,
      "text": "Great experience!"
    },
    {
      "id": "text-1978",
      "name": "vijay vb",
      "rating": 5,
      "text": "Good customer experience and Gopal met our expectations. Happy to shop in future again."
    },
    {
      "id": "text-1979",
      "name": "gitanjali bakalial baruah",
      "rating": 5,
      "text": "Excellent collection of fresh water pearl jewellery with excellent sales staff especially Gopal. Highly recommended."
    },
    {
      "id": "text-1981",
      "name": "Emmanuel Abhinav",
      "rating": 5,
      "text": "Good service by Gopal."
    },
    {
      "id": "text-1982",
      "name": "payal dabhade",
      "rating": 5,
      "text": "It was a great experience shopping with Krishna pearls.staff is really supportive..."
    },
    {
      "id": "text-1983",
      "name": "saikumar reddy",
      "rating": 5,
      "text": "Gopal helped us select nice designs. good customer service."
    },
    {
      "id": "text-1984",
      "name": "Haritha V",
      "rating": 5,
      "text": "We bought original pearls from Krishna pearls. Mr.Gopal(sales person) who attended us, showed us huge collections and we are highly satisfied with their collections."
    },
    {
      "id": "text-1985",
      "name": "Rahul Jaiswal",
      "rating": 5,
      "text": "Good ambience, quality and design. Humble staff and good service."
    },
    {
      "id": "text-1986",
      "name": "vishwanjay zaveri",
      "rating": 5,
      "text": "Over all demonstration and communication was good specially from kashinath"
    },
    {
      "id": "text-1987",
      "name": "Chinmay Barhale",
      "rating": 5,
      "text": "Thank you Gopal Garu for amazing service!"
    },
    {
      "id": "text-1989",
      "name": "Kiran Kumar",
      "rating": 4,
      "text": "Very much satisfied with the product, and good service by Mr Gopal, well explained.."
    },
    {
      "id": "text-1990",
      "name": "Palle Swathi",
      "rating": 5,
      "text": "Mr kashinath well explained and humble"
    },
    {
      "id": "text-1991",
      "name": "parth pancholi",
      "rating": 5,
      "text": "Best service by Pasha. Showed various latest design and explained everything in detailed."
    },
    {
      "id": "text-1992",
      "name": "swetha pari",
      "rating": 5,
      "text": "Gopal has been very very patient in showing all the designs. Staff is very good and designs are very nice and good finishing and are of top quality."
    },
    {
      "id": "text-1993",
      "name": "Chinnu Chowdary",
      "rating": 5,
      "text": "I took beads collection Chain and black diamond chain. Beautiful collection and designs available over Jubilee Hills store. Kashinath helped me for choosing right one as per my taste. Thanks !"
    },
    {
      "id": "text-1994",
      "name": "Mankirat Singh Brar",
      "rating": 5,
      "text": "Excellent collection & courteous service by Mr Kashinath, We received a warm welcome, Thank you very much"
    },
    {
      "id": "text-1995",
      "name": "rashmita dash",
      "rating": 5,
      "text": "Mohit very good service.. polite behaviour"
    },
    {
      "id": "text-1997",
      "name": "Kamal Sathyanarayana",
      "rating": 5,
      "text": "Very nice and elegant designs… and high quality pearls"
    },
    {
      "id": "text-1998",
      "name": "Veena Panchumarthi",
      "rating": 5,
      "text": "Nice collection of pearls and great customer experience with Kashinath"
    },
    {
      "id": "text-2001",
      "name": "Inza Naqvi",
      "rating": 5,
      "text": "Pasha was great!"
    },
    {
      "id": "text-2002",
      "name": "Srikanth a.s",
      "rating": 5,
      "text": "Good place to shop in pearls.. Nice collections. Authentic Staffs are kind. I recommend this place"
    },
    {
      "id": "text-2003",
      "name": "ravi shekhar",
      "rating": 5,
      "text": "Amazing collection and staff (Kashinath)"
    },
    {
      "id": "text-2004",
      "name": "Chandana Krishnappa",
      "rating": 5,
      "text": "Praveen did an excellent job in explaining the details.thanks to him.."
    },
    {
      "id": "text-2005",
      "name": "Sanjam Preet Singh",
      "rating": 5,
      "text": "Raj Kumar helped a lot a good staff and good stock"
    },
    {
      "id": "text-2006",
      "name": "Indrani Ganesh",
      "rating": 4,
      "text": "Praveen was very helpful he helped me to choose the perfect choker pearl necklace, bangles and earrings! Everything was very smoothly done. Good place!"
    },
    {
      "id": "text-2007",
      "name": "Koona Ankith",
      "rating": 5,
      "text": "Good designs and super staff helped with good designs"
    },
    {
      "id": "text-2008",
      "name": "Zedino Seyie",
      "rating": 5,
      "text": "Very good service by Pasha"
    },
    {
      "id": "text-2009",
      "name": "Vitsi Seyie",
      "rating": 5,
      "text": "We were served very well by Mr. Pasha throughout the entire process."
    },
    {
      "id": "text-2010",
      "name": "kiran kumar",
      "rating": 5,
      "text": "Great collection and customer service. I bought a lovely ear ring set on the occasion of Mother’s Day."
    },
    {
      "id": "text-2011",
      "name": "BIDISHA BHAR",
      "rating": 5,
      "text": "Very nice designs available and good service by Rajkumar"
    },
    {
      "id": "text-2012",
      "name": "Abhishek Padhy",
      "rating": 5,
      "text": "Rajkumar did show us very nice designs . Nice service"
    },
    {
      "id": "text-2013",
      "name": "Sumit Goel",
      "rating": 5,
      "text": "Excellent Service and quality Staff behaviour is very good specially Mohit Aggarwal who attend us"
    },
    {
      "id": "text-2015",
      "name": "Ramnath Bhat",
      "rating": 5,
      "text": "Nice experience Well attended by Mr. Praveen."
    },
    {
      "id": "text-2016",
      "name": "Shital Lokhande",
      "rating": 5,
      "text": "I have done shopping from Krishna jewellery . I getting a very good response from Rajkumar sir who are executive there..very nice and politely handing the consumer.thanks Rajkumar sir."
    },
    {
      "id": "text-2017",
      "name": "balasubramanyam atmakuru",
      "rating": 5,
      "text": "We buy Good prizes."
    },
    {
      "id": "text-2018",
      "name": "Sujit Bhowmick",
      "rating": 5,
      "text": "Very good sales man raj kumar"
    },
    {
      "id": "text-2019",
      "name": "Enjoy Today",
      "rating": 5,
      "text": "Nice collection and very helpful staff, specially Mohit was very knowledgeable and helpful in advising and showing the options which was really useful."
    },
    {
      "id": "text-2020",
      "name": "Abdul Riyazuddin",
      "rating": 5,
      "text": "Mohit had a help and provided good services"
    },
    {
      "id": "text-2021",
      "name": "Abdul Quayum",
      "rating": 5,
      "text": "Good sales man mohit"
    },
    {
      "id": "text-2022",
      "name": "Prabhat Kumar",
      "rating": 5,
      "text": "Great service by Praveen"
    },
    {
      "id": "text-2023",
      "name": "Santosh Kumar Gulivindala",
      "rating": 5,
      "text": "Sales executive Kashinath helped us giving good Discount , trusted store for pearls"
    },
    {
      "id": "text-2024",
      "name": "Mukul Lohar",
      "rating": 5,
      "text": "Kashinath sales person good service"
    },
    {
      "id": "text-2025",
      "name": "Seema Choudhary",
      "rating": 5,
      "text": "Pavani service is good models are designes are so good she helps very well"
    },
    {
      "id": "text-2026",
      "name": "Amit Dubey",
      "rating": 5,
      "text": "We had a smooth experience at the showroom with Mr. Kashinath."
    },
    {
      "id": "text-2027",
      "name": "Mrs. Nirmala Venu",
      "rating": 5,
      "text": "Very good sales man mohit"
    },
    {
      "id": "text-2028",
      "name": "SREE HARI R NAIR",
      "rating": 5,
      "text": "Good sales man raj Kumar"
    },
    {
      "id": "text-2030",
      "name": "Aurum collections",
      "rating": 5,
      "text": "Collection was good Pasha"
    },
    {
      "id": "text-2031",
      "name": "king Jamie",
      "rating": 5,
      "text": "Pasha sir where really helpful in explaining the authenticity of pearls, great experience"
    },
    {
      "id": "text-2032",
      "name": "Umabarathy Ram",
      "rating": 5,
      "text": "Good explanation and ambience"
    },
    {
      "id": "text-2033",
      "name": "janki shah",
      "rating": 5,
      "text": "Lovely store …Mr rajkumar was very polite and made it a good experience for us"
    },
    {
      "id": "text-2034",
      "name": "archana gautam",
      "rating": 5,
      "text": "Kashinath good service"
    },
    {
      "id": "text-2035",
      "name": "shahrukh inamdar",
      "rating": 5,
      "text": "Praveen is good. Shop is good. All good"
    },
    {
      "id": "text-2036",
      "name": "H R Sarangi",
      "rating": 5,
      "text": "Mohit is very good in behavior and showing the products and explaining"
    },
    {
      "id": "text-2037",
      "name": "Devansh Mishra",
      "rating": 5,
      "text": "Pleasant experience. Mohit made sure our visit was comfortable and pleasant."
    },
    {
      "id": "text-2038",
      "name": "usha Avuthu",
      "rating": 5,
      "text": "Excellent quality of pearls and wide variety of jewellery PASHA"
    },
    {
      "id": "text-2039",
      "name": "G Thippaiah",
      "rating": 5,
      "text": "PASHA Nice collection"
    },
    {
      "id": "text-2040",
      "name": "Ann Mary Joy",
      "rating": 5,
      "text": "Great customer service by Mohit at Krishna pearls..Highly recommend"
    },
    {
      "id": "text-2041",
      "name": "Lynn Mathew",
      "rating": 5,
      "text": "Very good collection! Mr Mohit assisted us really well. Very happy with the experience:)"
    },
    {
      "id": "text-2042",
      "name": "Dhavala Sekhar",
      "rating": 5,
      "text": "Rajkumar is very gentle and shown verities within our budget."
    },
    {
      "id": "text-2044",
      "name": "Somraj Chandra",
      "rating": 5,
      "text": "Nice collection,Mr Mohit attended us very nicely n show all the items n helped in selecting.very much recommended shop...."
    },
    {
      "id": "text-2045",
      "name": "Vaneet Munjal",
      "rating": 5,
      "text": "MR. Pasha a wonderful staff and the customer satisfaction is guaranteed here, Good quality products"
    },
    {
      "id": "text-2046",
      "name": "kunal Rane",
      "rating": 4,
      "text": "Praveen helped us by the perfect jewellery for the occasion"
    },
    {
      "id": "text-2047",
      "name": "Poreddy Malathi",
      "rating": 5,
      "text": "Nice collections @executive Praveen has helped us very well to chose the products."
    },
    {
      "id": "text-2048",
      "name": "Gopal Krishna Kommisetti",
      "rating": 5,
      "text": "Mohit gave us good experience in silver Jewelery and pearl jewelry. And we did buy the jewelry we liked!!"
    },
    {
      "id": "text-2049",
      "name": "DJ",
      "rating": 5,
      "text": "Good to do shopping over here and Mr. Praveen was really an energetic and nice person who really helped us to understand our requirements and to do shopping within our likings and budgets. Must visit place if looking for authentic pearls to shop."
    },
    {
      "id": "text-2050",
      "name": "kirti chaturvedi",
      "rating": 5,
      "text": "Loved my experience, staff is super supportive, helpful, courteous and polite"
    },
    {
      "id": "text-2051",
      "name": "Sudheer Golla",
      "rating": 5,
      "text": "Very good collection and great customer service by Praveen, definitely you should check this store specially for pearls"
    },
    {
      "id": "text-2052",
      "name": "Carl Davis",
      "rating": 5,
      "text": "Had a superb experience at Krishna jewellers was handled very very well by their staff Mr pravin. Will definitely come again."
    },
    {
      "id": "text-2056",
      "name": "Sahithya Kantipudi",
      "rating": 5,
      "text": "I had good experience in the store, thanks Pasha for showing such good designs"
    },
    {
      "id": "text-2057",
      "name": "DivyaLakshmi",
      "rating": 5,
      "text": "Beautiful collections and great customer service. Mohit ji showed us all the varieties based on our ask patiently 😊"
    },
    {
      "id": "text-2058",
      "name": "Manish Madagowni",
      "rating": 5,
      "text": "Mohit was very helpful and patient in helping us to get what we wanted. Thank you Mohit"
    },
    {
      "id": "text-2060",
      "name": "gowsya alisha",
      "rating": 5,
      "text": "Had a beautiful, peaceful first pearl shopping."
    },
    {
      "id": "text-2061",
      "name": "Vijesh Nair",
      "rating": 5,
      "text": "Purchased Pearl set from “Krishna pearls”. sales person Mohit assisted us in the purchase, there is a lot of collection in pearls and silver items. Happy with my purchase."
    },
    {
      "id": "text-2062",
      "name": "Sree Narayanan",
      "rating": 5,
      "text": "Purchased a pearl set,Mohit the salesman was friendly and showed us all the collections and it was satisfactory."
    },
    {
      "id": "text-2063",
      "name": "Anurag Agrawal",
      "rating": 5,
      "text": "Shopping at Krishna Jewellers, Jubilee Hills (2nd floor) was a delight. We were served very well by Mohit Agarwal…who was very courteous as well as knowledgeable. Their pearls collection is quite large and pricing is reasonable. Supervisor Pasha was also great help. Highly recommended"
    },
    {
      "id": "text-2064",
      "name": "Abhinav Garg",
      "rating": 5,
      "text": "Excellent products!! Unmatched hospitality and customer attention by Mohit!!"
    },
    {
      "id": "text-2065",
      "name": "Deep Ghai",
      "rating": 5,
      "text": "Great assistance & suggestions provided by Mohit"
    },
    {
      "id": "text-2066",
      "name": "Nijil Surendran",
      "rating": 5,
      "text": "Thank you . Pasha helped to select our products. Nice collection. Price is also reasonable. Nice service and hospitality. Great ambiance. Thank you"
    },
    {
      "id": "text-2067",
      "name": "Neha Dubey",
      "rating": 5,
      "text": "Had a great shopping experience..Mohit was really helpful and considerate about our choices and he made sure to give us the products at best price . Thank you"
    },
    {
      "id": "text-2069",
      "name": "Robert Ravindra Sundardas",
      "rating": 5,
      "text": "Excellent experience. Praveen patiently spent close to 3 hours assisting us."
    },
    {
      "id": "text-2071",
      "name": "priyanka Reddy",
      "rating": 5,
      "text": "We had a very great day at your shop on buying gold jewellery special thanks to Mr. Sandeep he had a great patience and explaining skills if you go to him never get ending up with out buying a very good models according to our choice he is great in all what not .... Thank u Krishna pearls and jwellers and my special thanks to Sandeep 🙏"
    },
    {
      "id": "text-2072",
      "name": "Manoj Jha",
      "rating": 5,
      "text": "Praveen helped us select the right product. He has immense knowledge of pearls. Must visit when in Hyderabad."
    },
    {
      "id": "text-2074",
      "name": "Deep Mukherjee",
      "rating": 5,
      "text": "Very authentic and good pearls and Anand was really helpful and cooperative."
    },
    {
      "id": "text-2075",
      "name": "Sup Aks",
      "rating": 5,
      "text": "Gopal helped in getting customised necklace and bracelet for my daughter ,,nice experience and collection of pearl"
    },
    {
      "id": "text-2076",
      "name": "Niveditha Bhaskar",
      "rating": 5,
      "text": "Very good service by Gopal. Wonder collection"
    },
    {
      "id": "text-2077",
      "name": "adv. Sneha watane",
      "rating": 5,
      "text": "Greet experience."
    },
    {
      "id": "text-2078",
      "name": "Rishi Nair",
      "rating": 5,
      "text": "They have a really good collections. Thank you Kashinath for the wonderful service."
    },
    {
      "id": "text-2079",
      "name": "D Madhav",
      "rating": 5,
      "text": "Nice ambience and good staff"
    },
    {
      "id": "text-2080",
      "name": "Madhavi Nallapati",
      "rating": 5,
      "text": "Our overall experience with krishna pearls was excellent!, they could understand what we were looking for quickly, their Pearl and jewelry collection was great. Also, superb customer service from Mr. Praveen and team."
    },
    {
      "id": "text-2081",
      "name": "Prudhvi Raghupatruni",
      "rating": 5,
      "text": "Kashinath has shown good hospitality and he helped us to find the right pearl sets. Thanks for the service"
    },
    {
      "id": "text-2082",
      "name": "SURYA NARAYAN SAHU",
      "rating": 5,
      "text": "Excellent service by Rajkumar"
    },
    {
      "id": "text-2083",
      "name": "Kanav Khera",
      "rating": 5,
      "text": "Had a great experiemce at Krishna Pearls Jubilee Hills. The designs are very nice, great quality. Service by salesperson Kashinath was very good. Very polite and professional. Thank you. Will visit again."
    },
    {
      "id": "text-2084",
      "name": "durga manjari",
      "rating": 5,
      "text": "Wide range of collection and well mannered staff. Especially Mr.Kasinath assisted us throughout process ,show cased variety of jewellery and allowed us time to make perfect one for us."
    },
    {
      "id": "text-2086",
      "name": "Anjani vantipalli",
      "rating": 4,
      "text": "Nice collection. Godd friendly staff. Mr Rajkumar showed all the items with patience"
    },
    {
      "id": "text-2087",
      "name": "Ujwala Kishore",
      "rating": 5,
      "text": "Happy with the collection, great service by Praveen! Thank you :)"
    },
    {
      "id": "text-2088",
      "name": "Arpan Rajput",
      "rating": 5,
      "text": "Nice service by pasha and nice pearls collection"
    },
    {
      "id": "text-2089",
      "name": "Dineshlal T S",
      "rating": 5,
      "text": "Wonderful collections. Praveen was patient in showing different collections. He explained us about different pearls and it’s quality. Had a wonderful experience."
    },
    {
      "id": "text-2091",
      "name": "Ankita Parida",
      "rating": 5,
      "text": "Service from Pasha was good. Nice variety and quality."
    },
    {
      "id": "text-2092",
      "name": "Chakradhar Reddy Donuri",
      "rating": 5,
      "text": "Top notch service by Krishna Jewelers. Associate Raj Kumar was very helpful and took enough time to show different available pearls. I would definitely recommend this store for anyone who is looking for wedding shopping."
    },
    {
      "id": "text-2093",
      "name": "Dr Chaitanya",
      "rating": 5,
      "text": "Good collection and good customer services from Mr Gopal."
    },
    {
      "id": "text-2095",
      "name": "Ashutosh Yadav",
      "rating": 5,
      "text": "Praveen ji was excellent."
    },
    {
      "id": "text-2096",
      "name": "Kasiviswanadham Neti",
      "rating": 5,
      "text": "Nice collections Praveen has showed us very well"
    },
    {
      "id": "text-2097",
      "name": "Hari Mankal",
      "rating": 5,
      "text": "Kahinath has done great job explaining different perls, shown with lots of patience"
    },
    {
      "id": "text-2098",
      "name": "Govind Raju",
      "rating": 5,
      "text": "Very good collection, Informative and friendly staff Basha and Sonia, Very well informed"
    },
    {
      "id": "text-2100",
      "name": "Ram Reddy",
      "rating": 5,
      "text": "Superb service. Amicable, astonishingly elegant environment. Employees like Anand, Mounika and Ankith are awesome. Must visit to get the experience."
    },
    {
      "id": "text-2101",
      "name": "Ramesh Kolli",
      "rating": 5,
      "text": "On 21st Feb. 2023, visited Krishna pearls. Mr. Praveen have provided good service."
    },
    {
      "id": "text-2102",
      "name": "Dhirendra Kumar",
      "rating": 5,
      "text": "Anand... was most forthcoming & served with a smile..."
    },
    {
      "id": "text-2104",
      "name": "Tirumala Joshi",
      "rating": 5,
      "text": "Kashinath great guy great sales person great job"
    },
    {
      "id": "text-2105",
      "name": "Neeraj Kumar",
      "rating": 5,
      "text": "God customer experience. Nice assist by Gopal"
    },
    {
      "id": "text-2106",
      "name": "Ravi Kant Tibrewal",
      "rating": 5,
      "text": "Excellent Service, Special thanks to Mr. Pasha & Team"
    },
    {
      "id": "text-2107",
      "name": "Sahitya Godavarthi",
      "rating": 5,
      "text": "Anand showed us with all the varieties in Krishna pearls. Very good collection"
    },
    {
      "id": "text-2108",
      "name": "Narayana YVS",
      "rating": 5,
      "text": "Lot of collection.Praveen Helped me select good items"
    },
    {
      "id": "text-2109",
      "name": "simmy Chaudhary",
      "rating": 4,
      "text": "Mr Anand was very helpful in selecting the set that i was looking for a friend’s wedding. Thank you. Good work"
    },
    {
      "id": "text-2110",
      "name": "Balasundharam",
      "rating": 5,
      "text": "Had great experience with kashinath"
    },
    {
      "id": "text-2111",
      "name": "Manas Mohanty",
      "rating": 4,
      "text": "Anand has been a great salesman."
    },
    {
      "id": "text-2112",
      "name": "snr Chow",
      "rating": 5,
      "text": "Very hospitable staff. Especially Mr Kashinath and Ms Soniya. Their collection has a wide variety of pcs and is of good quality. Thanks and keep it up!"
    },
    {
      "id": "text-2113",
      "name": "Sushmit Biswas",
      "rating": 5,
      "text": "Amazing experience at Krishna jewelers today. Pasha helped me find several items , very patiently along with Soniya. Good stuff and good bargain."
    },
    {
      "id": "text-2114",
      "name": "Bhargavi Bharti",
      "rating": 5,
      "text": "Best place for pearls..kashinath serve us very well so that i purchase the product within 10 minutes"
    },
    {
      "id": "text-2115",
      "name": "Chittaranjan Gurubhagavatula",
      "rating": 5,
      "text": "Pasha and Soniya were very helpful in doing video call and helping overseas customers seamlessly select the right models."
    },
    {
      "id": "text-2117",
      "name": "P tejaswi",
      "rating": 5,
      "text": "Very good place with plenty of variety to select for pearl jewellery"
    },
    {
      "id": "text-2118",
      "name": "Ambreen",
      "rating": 5,
      "text": "Anand was very helpful in selecting the pearls string and studs. And patiently handled everything very well. Thanks"
    },
    {
      "id": "text-2119",
      "name": "blessy mahesh",
      "rating": 5,
      "text": "Service is very good"
    },
    {
      "id": "text-2120",
      "name": "DC MOTORSPORTS",
      "rating": 5,
      "text": "Kashinath was very helpful in choosing the right jewellery. Thank you"
    },
    {
      "id": "text-2122",
      "name": "SATYA KRISHNA",
      "rating": 5,
      "text": "Pasha sirgood persantage Happy"
    },
    {
      "id": "text-2124",
      "name": "Ranganadharao Thiruvuru",
      "rating": 5,
      "text": "Pasha best ambiance"
    },
    {
      "id": "text-2125",
      "name": "vikash kumar",
      "rating": 5,
      "text": "Perfect place... Thanks Mr. Aanand"
    },
    {
      "id": "text-2126",
      "name": "Santosh Gaikwad",
      "rating": 5,
      "text": "Anand is a gentleman ,courteous and understands the customer needs and provides solution accordingly... Keep it up"
    },
    {
      "id": "text-2127",
      "name": "Kailas Kaladharan",
      "rating": 5,
      "text": "Friendly staff. Affordable"
    },
    {
      "id": "text-2129",
      "name": "Avinash Das",
      "rating": 5,
      "text": "On a personal trip and looking to take home some authentic memento from Hyderabad at great rates with quality assurance and great service- look no further than Krishna Pearls! A special thank you to Mr. Anand Madhav!"
    },
    {
      "id": "text-2130",
      "name": "Dhruv Tiwari",
      "rating": 5,
      "text": "Nice collection of items, and good guidance given by Mr. Anand Madhav."
    },
    {
      "id": "text-2131",
      "name": "Abhishek Sarkar",
      "rating": 5,
      "text": "Nice selection and experience. Special thanks to Anand for guiding us through an array of jewellery."
    },
    {
      "id": "text-2134",
      "name": "Dr.CHAKRAPANI YERAMSETTI",
      "rating": 5,
      "text": "We have visited the krishna jewellers for the purchase of silver and pearl ornaments. Mr Pasha has helped us in the selection. He is very patient and suggested the pros and cons of each item we are interested in. Finally with his help we got to the best of the selection. Over all we had a very nice and pleasant experience"
    },
    {
      "id": "text-2135",
      "name": "Shashi prasad",
      "rating": 5,
      "text": "Anand very good sales person👍"
    },
    {
      "id": "text-2136",
      "name": "Mona Aire",
      "rating": 5,
      "text": "I have visited this place looking at their instagram live , truly loved the pearl collection here and kashinath garu was very helpful in assisting with the variety."
    },
    {
      "id": "text-2137",
      "name": "Subrahmanyam V",
      "rating": 5,
      "text": "Good collection. Sales person kashinath was good."
    },
    {
      "id": "text-2138",
      "name": "srivanthi Hanchate",
      "rating": 4,
      "text": "Anand. Good service"
    },
    {
      "id": "text-2139",
      "name": "biju mani",
      "rating": 5,
      "text": "Nice store with lots of selection. Wonderful ambience. The sales representative Paasha and Sonia were very helpful and friendly. Will definitely recommend"
    },
    {
      "id": "text-2140",
      "name": "KARAN SINGH",
      "rating": 5,
      "text": "Krishna Pearls is a very good place, and to be honest, I never expected the price of pearls could give tough competition to gold 🤣🤣. Special thanks to Gopal for being a good host and bearing with my confusion. He was extremely patient and helpful. Thank you for making my day."
    },
    {
      "id": "text-2141",
      "name": "Aditi Seshadri",
      "rating": 5,
      "text": "Mr. Pasha was very helpful and knowledgeable about pearls."
    },
    {
      "id": "text-2142",
      "name": "Karunakar V",
      "rating": 5,
      "text": "Anand very good service Thanks ananad"
    },
    {
      "id": "text-2143",
      "name": "Honey Jain",
      "rating": 5,
      "text": "Great place to buy genuine pearl necklace. Assisted by Mr. Kashinath who is very patient and humble. Recommend a visit!"
    },
    {
      "id": "text-2144",
      "name": "kasthala subbarao",
      "rating": 5,
      "text": "Service is excellent. Mr . Pasha hospitality is very good. He showed me all the verities and explained me about each and every item."
    },
    {
      "id": "text-2147",
      "name": "Tanmay Savant",
      "rating": 5,
      "text": "Awesome !!! Mr. Rajkumar is humble and show us lot of variety"
    },
    {
      "id": "text-2148",
      "name": "satish howdekar",
      "rating": 5,
      "text": "Good service and hospitality by Praveen garu.thanks Krishna pearl"
    },
    {
      "id": "text-2149",
      "name": "Sam Sameera",
      "rating": 5,
      "text": "great pearls and great quality. Great service from mr pasha"
    },
    {
      "id": "text-2151",
      "name": "SH HYDRAULICS",
      "rating": 5,
      "text": "PRAVEEN, VERY POLITE, EXCELLENT SERVICE"
    },
    {
      "id": "text-2152",
      "name": "Divya Avutala",
      "rating": 4,
      "text": "Great pearl collection and customer service :)"
    },
    {
      "id": "text-2153",
      "name": "Tarun Chaturvedi",
      "rating": 5,
      "text": "A.Anand. Nice selling and customer connect skills. Keep up good work."
    },
    {
      "id": "text-2154",
      "name": "Bhagyashree Patil",
      "rating": 5,
      "text": "Silver and pearl jwellery is very nice and Good Service by Rajkumar"
    },
    {
      "id": "text-2156",
      "name": "Udit Panjwani",
      "rating": 5,
      "text": "We had a lovely time with Praveen ji. He’s the best here."
    },
    {
      "id": "text-2157",
      "name": "chimmani poornachander",
      "rating": 5,
      "text": "Good experience especially there is one guy named Krishna. He is really helpful and has lot patience to show all the available jewellery"
    },
    {
      "id": "text-2158",
      "name": "Gopa Kumar",
      "rating": 5,
      "text": "Great experience. Praveen helped me pick the right gift"
    },
    {
      "id": "text-2159",
      "name": "Rivu Basu",
      "rating": 5,
      "text": "Had a great service from Mr Pasha"
    },
    {
      "id": "text-2160",
      "name": "Sam K",
      "rating": 5,
      "text": "Excellent collection and service by Mr. Pasha"
    },
    {
      "id": "text-2161",
      "name": "Nishant Ravi",
      "rating": 5,
      "text": "Was helped by T. Praveen. Excellent experience and product."
    },
    {
      "id": "text-2162",
      "name": "uzair mujeeb",
      "rating": 5,
      "text": "Anand attended us very well."
    },
    {
      "id": "text-2163",
      "name": "lavanya gantam",
      "rating": 5,
      "text": "After a little bit of waiting anand helped me out. He was great in helping find the pearls in my budget. Would recommend to ask for him"
    },
    {
      "id": "text-2164",
      "name": "JAYASREE REDDY",
      "rating": 5,
      "text": "A very good collection in pearls jewellery and silver items. Our sales person Mr.Praveen was very helpful."
    },
    {
      "id": "text-2165",
      "name": "Prasad R",
      "rating": 5,
      "text": "Kashinath provided good service and very helpful nature."
    },
    {
      "id": "text-2166",
      "name": "Sowmyasri Cherukuri",
      "rating": 5,
      "text": "Mr.pasha has given very good service with nice product please visit the store"
    },
    {
      "id": "text-2167",
      "name": "Vital Trans",
      "rating": 5,
      "text": "Products are of good quality and worth the value. Very good service provided by Mr.Pasha and explained the details of product very well, happy with the service."
    },
    {
      "id": "text-2170",
      "name": "archit mathur",
      "rating": 5,
      "text": "Very good collection and great service my Mr. Anand."
    },
    {
      "id": "text-2171",
      "name": "Veena Singh",
      "rating": 5,
      "text": "Good service by Anand"
    },
    {
      "id": "text-2172",
      "name": "Achiransu Acharyya",
      "rating": 5,
      "text": "Mr. Pasha has been very nice and helped us with the product selection."
    },
    {
      "id": "text-2175",
      "name": "Ramya Abbireddy",
      "rating": 5,
      "text": "Anand Best service"
    },
    {
      "id": "text-2176",
      "name": "kinnari parikh",
      "rating": 5,
      "text": "Anand was salesperson.. explain very well..nice experience"
    },
    {
      "id": "text-2177",
      "name": "macha nikhilchowdary",
      "rating": 5,
      "text": "Mr.kashinath showed multiples varieties and guided through out purchase"
    },
    {
      "id": "text-2178",
      "name": "Managing Director Maya Inns Pvt Ltd",
      "rating": 5,
      "text": "Anand took good care and extremely helpful in selection"
    },
    {
      "id": "text-2181",
      "name": "Vijaya Vandana",
      "rating": 5,
      "text": "Good collections. Shown different designs by Praveeen and he has good knowledge about design n patterns"
    },
    {
      "id": "text-2182",
      "name": "Konlyada Sudheer Rao",
      "rating": 5,
      "text": "Praveen good service"
    },
    {
      "id": "text-2183",
      "name": "archana ramanakumar",
      "rating": 5,
      "text": "Good collection and service by PASHA"
    },
    {
      "id": "text-2184",
      "name": "stanley christopher",
      "rating": 5,
      "text": "Mr Kashinath is an excellent sales person, deserve for a aplass"
    },
    {
      "id": "text-2185",
      "name": "anusha singh",
      "rating": 4,
      "text": "Bought some pearl earrings. Had a good experience....got some discounts too. Happy with my purchase. Thank you."
    },
    {
      "id": "text-2186",
      "name": "Kavya Shekar",
      "rating": 5,
      "text": "Wonderful service by gopal. Very polite and patient."
    },
    {
      "id": "text-2187",
      "name": "Shweta Kekal",
      "rating": 5,
      "text": "Pravin was an amazing salesman we enjoyed shopping"
    },
    {
      "id": "text-2188",
      "name": "Mahesh B",
      "rating": 5,
      "text": "The products and service is wonderful.Praveen is highly customer friendly. Thank you"
    },
    {
      "id": "text-2190",
      "name": "Bhanu Pratap Singh",
      "rating": 5,
      "text": "I had a great experience today, it was the time I have been to this place. The guy named Anand helped me go through the purchase of pearl studs. He was polite and had a good behaviour throughout the purchase."
    },
    {
      "id": "text-2191",
      "name": "Harini Reddy",
      "rating": 5,
      "text": "Good experience at store, patient staff esp Mr. Anand"
    },
    {
      "id": "text-2192",
      "name": "Dhanush Kumar",
      "rating": 5,
      "text": "Wonderful collections, Anand explained us in detail...Worth a visit...Thank you team !!"
    },
    {
      "id": "text-2193",
      "name": "Geetika Tyagi Ahuja",
      "rating": 5,
      "text": "Amazing Experience with Pasha !!!! He helped me to choose the best earrings. They have the variety of designs! Thank you"
    },
    {
      "id": "text-2194",
      "name": "arvind vasudeva",
      "rating": 5,
      "text": "Good and courteous service by Ananad."
    },
    {
      "id": "text-2195",
      "name": "Ratan Chelani",
      "rating": 5,
      "text": "Mr. Pasha Very Happy with his experience and to customer satisfaction. Thank you"
    },
    {
      "id": "text-2196",
      "name": "RAMACHANDRA RAO ADDALA",
      "rating": 5,
      "text": "Gopal Excellent experience"
    },
    {
      "id": "text-2198",
      "name": "Deepak Ramdas",
      "rating": 5,
      "text": "Absolutely lovely place to get amazing pearls. Loved the steward Praveen who showed perfect customer service, knew his way around understanding customer needs and gave a good product and deal! Thanks Krisha pearls and Praveen"
    },
    {
      "id": "text-2200",
      "name": "Vikram Venkatesh",
      "rating": 5,
      "text": "Good experience. Thanks to Praveen."
    },
    {
      "id": "text-2201",
      "name": "CHINMAYA HARSHA",
      "rating": 5,
      "text": "Pasha good service.."
    },
    {
      "id": "text-2202",
      "name": "Abhishek Abhi",
      "rating": 5,
      "text": "Pasha very nice."
    },
    {
      "id": "text-2203",
      "name": "Devi A",
      "rating": 5,
      "text": "Nice n sleek items"
    },
    {
      "id": "text-2204",
      "name": "suryateja rallapalli",
      "rating": 5,
      "text": "Sony ji was very patient in showing us all the best possible options trying to understand our needs and helped us in deciding the gifts we want."
    },
    {
      "id": "text-2205",
      "name": "Mallica Mandal",
      "rating": 4,
      "text": "Good service by Ms Sony and team"
    },
    {
      "id": "text-2206",
      "name": "Bikash Samal",
      "rating": 5,
      "text": "It was a great experience. Kashinath explained the product in details and made a good deal in buying"
    },
    {
      "id": "text-2208",
      "name": "Uyanga Erdenebileg",
      "rating": 5,
      "text": "Kashinath helped us to make the decisions"
    },
    {
      "id": "text-2209",
      "name": "sankeerthana munny",
      "rating": 5,
      "text": "Excellent. Mr.praveen was very humble and fantastic in his job"
    },
    {
      "id": "text-2210",
      "name": "Teneti Gowtham",
      "rating": 5,
      "text": "Excellent design and good coustomer service by Akshaya garu"
    },
    {
      "id": "text-2211",
      "name": "Malav Jhala",
      "rating": 5,
      "text": "Very professional staff. Mr Pasha really helped us in deciding the sets that we wanted. Very patient and friendly staff"
    },
    {
      "id": "text-2213",
      "name": "ujjal pathak",
      "rating": 5,
      "text": "Delightful service and excellent purchase recommendations by Gopal!"
    },
    {
      "id": "text-2214",
      "name": "Shreya Arora",
      "rating": 5,
      "text": "Excellent service by Mr Kashinath"
    },
    {
      "id": "text-2215",
      "name": "kaluri sandeep",
      "rating": 5,
      "text": "Anand: good service"
    },
    {
      "id": "text-2216",
      "name": "Dushyant Panchal",
      "rating": 5,
      "text": "Kashinath - keep it up. Nice work"
    },
    {
      "id": "text-2217",
      "name": "Swarna Mekala",
      "rating": 5,
      "text": "Praveen, very good staff with patience…explained every detail of the product with so much patience."
    },
    {
      "id": "text-2218",
      "name": "raghu ram",
      "rating": 5,
      "text": "Good collection. Gopal has patiently assisted in showing the collection as well as getting us the product at best price."
    },
    {
      "id": "text-2219",
      "name": "Praveen M",
      "rating": 5,
      "text": "Nice collection and excellent service from Pasha"
    },
    {
      "id": "text-2221",
      "name": "rahul challa",
      "rating": 5,
      "text": "Anand has a very good knowledge on the quality and variety of Pearls and provided good suggestion for our purchase. Thanks a lot"
    },
    {
      "id": "text-2222",
      "name": "madhurima madhu",
      "rating": 5,
      "text": "Kashinath - helped us with at most service quality and shopping experience and varieties are really good :)"
    },
    {
      "id": "text-2223",
      "name": "rohit jain",
      "rating": 5,
      "text": "Kashinath was very attentive and helpful in selecting the right product. He explained all queries in detail. Happy to shop"
    },
    {
      "id": "text-2224",
      "name": "Naveed Navaz",
      "rating": 5,
      "text": "Excellent presentation and explanation given by Mr Pasha"
    },
    {
      "id": "text-2225",
      "name": "RIYA Dey",
      "rating": 5,
      "text": "Very happy and satisfied with the collection..and the staff kashinath ."
    },
    {
      "id": "text-2226",
      "name": "gaurav dutta",
      "rating": 5,
      "text": "Nice service received from Mr Pasha..."
    },
    {
      "id": "text-2227",
      "name": "Arijit Saikia",
      "rating": 5,
      "text": "Thanks Kashinath for a wonderfull assistance."
    },
    {
      "id": "text-2228",
      "name": "Bhaskar Sengupta",
      "rating": 5,
      "text": "Excellent Pearls.. Thanx Mr Pasha for gr8 service"
    },
    {
      "id": "text-2229",
      "name": "Shyama P",
      "rating": 5,
      "text": "Good collection and great service. Thanks to Raj Kumar for assisting in the purchase."
    },
    {
      "id": "text-2230",
      "name": "Wilson Santhakumar",
      "rating": 5,
      "text": "Good products, reasonable price, staff (Shri. Raj Kumar) response & attention are excellent."
    },
    {
      "id": "text-2231",
      "name": "pratyusha reddy",
      "rating": 5,
      "text": "Excellent service provided… specially by the staff.. special thanks to mr. Kashinath.. both the jewellery and hospitality were at top notch.. would visit again …"
    },
    {
      "id": "text-2232",
      "name": "Priyanka Das",
      "rating": 4,
      "text": "Great experience shopping here. I was assisted by Mr. Rajkumar and I had a pleasant experience."
    },
    {
      "id": "text-2234",
      "name": "shabbar Babrawala",
      "rating": 5,
      "text": "Very well attended and presented by gopal"
    },
    {
      "id": "text-2235",
      "name": "Suraj Kumar Subudhi",
      "rating": 5,
      "text": "Kashinath helped us for showing very good collection of pearls. Originality has the value and importance. Great shop and well maintained."
    },
    {
      "id": "text-2236",
      "name": "Rudra Tejas Reddy Chaikam",
      "rating": 5,
      "text": "Gopal helped well"
    },
    {
      "id": "text-2237",
      "name": "kiranmayi 369",
      "rating": 5,
      "text": "Very good Praveen has showed me very patiently"
    },
    {
      "id": "text-2238",
      "name": "Vaishnavi Kanumuri",
      "rating": 5,
      "text": "The service was good"
    },
    {
      "id": "text-2239",
      "name": "D Mohanty",
      "rating": 5,
      "text": "Pasha is very well known on Pearls and having good service experience"
    },
    {
      "id": "text-2240",
      "name": "Jannu’s and Mommy’s Dance Channel",
      "rating": 5,
      "text": "Thank u Shankar for the wonderful service…"
    },
    {
      "id": "text-2241",
      "name": "pradeep jude",
      "rating": 5,
      "text": "PASHA... GOOD CUSTOMER CARE"
    },
    {
      "id": "text-2242",
      "name": "ANKIT KUMAR",
      "rating": 5,
      "text": "Pasha was very helpful and showed very good products"
    },
    {
      "id": "text-2243",
      "name": "Ashwini Nagendra",
      "rating": 5,
      "text": "Good collection ... must visit"
    },
    {
      "id": "text-2244",
      "name": "MITHRA GATLA",
      "rating": 5,
      "text": "Great service with lots of patience. Loved the experience with Krishna Pearls. Gopal has shown us different designs with great patience. I appreciate the staff."
    },
    {
      "id": "text-2245",
      "name": "Sriram Gopalakrishna",
      "rating": 5,
      "text": "Pasha from the pearls section was extremely enterprising and helpful. He was supremely respectful, dynamic, enthusiastic and catered precisely to what we needed. We are definitely going back for more.."
    },
    {
      "id": "text-2246",
      "name": "madhumita mukherjee",
      "rating": 5,
      "text": "Mr. Praveen is very helpful and courteous in krishna pearls.."
    },
    {
      "id": "text-2247",
      "name": "Shashank Shukla",
      "rating": 5,
      "text": "Had a great experience. Bought pearls set and very happy with the purchase. Thanks to Kashinath for helping us."
    },
    {
      "id": "text-2248",
      "name": "Prat B",
      "rating": 5,
      "text": "Great service by Rajkumar and his colleagues. Good collection and craftsmanship."
    },
    {
      "id": "text-2249",
      "name": "Sireesha Chamarthi",
      "rating": 5,
      "text": "Kashinath was proactive in showing the designs..excellent collection"
    },
    {
      "id": "text-2250",
      "name": "Shivani Waghmare",
      "rating": 5,
      "text": "Customer since 25 years. Great quality pearls, beautiful designs and great customer service by Mr. Anand."
    },
    {
      "id": "text-2251",
      "name": "SPANDANA KUMBHAM",
      "rating": 5,
      "text": "Nice experience excellent service: praveen"
    },
    {
      "id": "text-2252",
      "name": "tarun gera",
      "rating": 5,
      "text": "Hi was realy impressed with Mr pasha. He was realy good in his services."
    },
    {
      "id": "text-2253",
      "name": "megha vijayakumar",
      "rating": 5,
      "text": "Nice collection of pearl jewellery. Gopal assisted really well and was very patient in showing us the designs. It was a quick selection of chain and earrings."
    },
    {
      "id": "text-2254",
      "name": "rahul kumar",
      "rating": 5,
      "text": "Pravin Support me very nicely. Nice collection , Will Visit again. Thankyou."
    },
    {
      "id": "text-2255",
      "name": "Veeru Kumar",
      "rating": 5,
      "text": "Nice collections and good service by Akshaya madam."
    },
    {
      "id": "text-2256",
      "name": "Shiva kumar Yadav",
      "rating": 5,
      "text": "Good designs and excellent service Akshaya..."
    },
    {
      "id": "text-2257",
      "name": "Gagan Bag",
      "rating": 5,
      "text": "Excellent design's and good service Akshaya"
    },
    {
      "id": "text-2258",
      "name": "Moneesh Pradhan",
      "rating": 5,
      "text": "Wonderful experience and enhanced with the help of Gopal, who was gladly able to help and show is around."
    },
    {
      "id": "text-2259",
      "name": "divya reddy",
      "rating": 5,
      "text": "They had nice collection and salesperson pasha was friendly and gave good price for the pearl set."
    },
    {
      "id": "text-2260",
      "name": "BHUVAN CHANDRA",
      "rating": 5,
      "text": "Nice designs and good coustomer service Akshaya..."
    },
    {
      "id": "text-2261",
      "name": "Krishna Ram",
      "rating": 5,
      "text": "Good design and good service by Akshaya"
    },
    {
      "id": "text-2262",
      "name": "Rahul Kutthi",
      "rating": 5,
      "text": "Greetings meeting Mr. Pasha sir"
    },
    {
      "id": "text-2263",
      "name": "Prasad R S",
      "rating": 5,
      "text": "Pasha was well versed with his job, polite and was able to give what we wanted. Asset to your organization."
    },
    {
      "id": "text-2264",
      "name": "Vandana Shah",
      "rating": 5,
      "text": "Kashinath was very helpful and polite and showed variety of options , good experience"
    },
    {
      "id": "text-2265",
      "name": "Emaniyel T",
      "rating": 5,
      "text": "Nice collection and àll staff is very comfortable expecally Akshaya very sopport and very good person"
    },
    {
      "id": "text-2266",
      "name": "BSK Kaushik",
      "rating": 5,
      "text": "Models were unique and price range was quiet affordable. sales person Kashinath who was knowledgable and guided us well as it was pur first time purchasing pearls."
    },
    {
      "id": "text-2267",
      "name": "Raj Mb",
      "rating": 5,
      "text": "Excellent designs and good service by Akshaya madam"
    },
    {
      "id": "text-2268",
      "name": "Neela Ghosh",
      "rating": 5,
      "text": "Kashinath was excellent at helping us select what we needed and skillfully guided us through our shopping experience."
    },
    {
      "id": "text-2270",
      "name": "Girja Shanker",
      "rating": 5,
      "text": "Have a good dealing experience with sales person Mr. Pasha"
    },
    {
      "id": "text-2271",
      "name": "Md Ravi",
      "rating": 5,
      "text": "Good designs and good coustomer service Akshaya madam"
    },
    {
      "id": "text-2272",
      "name": "Mohd Fazil",
      "rating": 5,
      "text": "I am thanQ ful to Pasha for showing me good product I am satisfied with his service."
    },
    {
      "id": "text-2273",
      "name": "Samal Manasi",
      "rating": 5,
      "text": "Pasha is a good sales person"
    },
    {
      "id": "text-2274",
      "name": "Harish Borah",
      "rating": 5,
      "text": "Mr Pasha was great help ! Had never bought pearls before. He helped me understand it and choose the best pair ! Thank you."
    },
    {
      "id": "text-2275",
      "name": "ULHAS CHAUBAL",
      "rating": 5,
      "text": "A very creative and wide range to select from, Mr Praveen sales assistant helped and guided us to choose right ornament"
    },
    {
      "id": "text-2278",
      "name": "Manish Verma",
      "rating": 5,
      "text": "Excellent service Very good variety of items All the best Thanks for the courtesy extended to us"
    },
    {
      "id": "text-2280",
      "name": "Rajes Sk",
      "rating": 5,
      "text": "Excellent designs and good service by Akshaya"
    },
    {
      "id": "text-2281",
      "name": "Injarul Sekh",
      "rating": 5,
      "text": "Excellent designs and good coustomer service by Akshaya madam"
    },
    {
      "id": "text-2282",
      "name": "Ahammed Sabir",
      "rating": 5,
      "text": "Good design's and excellent service by Akshaya madam"
    },
    {
      "id": "text-2283",
      "name": "swetha reddy",
      "rating": 5,
      "text": "Excellent service by Mr. Pasha at Krishna Pearls, Jubilee Hills. Went there for getting a pearl choker done and it was done in no time and was very happy with the result. Thank you"
    },
    {
      "id": "text-2284",
      "name": "shanmukh kothala",
      "rating": 5,
      "text": "Krishna Pearls is the one best store having a wide range of different varieties jewelery in both Jems and Pearl's❤️ Executive Praveen has good skills to explain each and every point to the customer fully satisfied"
    },
    {
      "id": "text-2285",
      "name": "Kashyap K",
      "rating": 5,
      "text": "Praveen from the pearls department has served us very well.. I'm a returning customer and thoroughly enjoy Praveen's hospitality."
    },
    {
      "id": "text-2286",
      "name": "Raja Patre",
      "rating": 5,
      "text": "Good coustomer service by Akshaya"
    },
    {
      "id": "text-2287",
      "name": "chandrakala",
      "rating": 5,
      "text": "Sravan has showed the very good and latest collection,great experience with Krishna jewellers."
    },
    {
      "id": "text-2288",
      "name": "E Harish",
      "rating": 5,
      "text": "Great collection. Excellent service and absolutely great prizing. Executive - Pasha was a great help in explaining the product range. He was patient all the while."
    },
    {
      "id": "text-2289",
      "name": "C Sundaram",
      "rating": 5,
      "text": "Pleasant staff, very nice collection of jewellery with best designs and varieties."
    },
    {
      "id": "text-2290",
      "name": "veeramalla krishna",
      "rating": 5,
      "text": "Good custmour service Akshaya."
    },
    {
      "id": "text-2291",
      "name": "Pawan Singh",
      "rating": 5,
      "text": "Very good service by Akshaya."
    },
    {
      "id": "text-2292",
      "name": "Prasanth Gude",
      "rating": 5,
      "text": "Good customer service by Akshaya madam"
    },
    {
      "id": "text-2293",
      "name": "gayathri salva",
      "rating": 5,
      "text": "When we initially contacted Krishna Jewellers, they were so responsive and they patiently showed each and every model that we asked for. Vijay is the one who took care of our questions, and he patiently explained in a very detailed manner. With their international shipping service, they made our lives so much easier."
    },
    {
      "id": "text-2295",
      "name": "Swathi Nimmala",
      "rating": 4,
      "text": "Nice collection and budget friendly showroom . Sales person Saikumar is very humble and patient"
    },
    {
      "id": "text-2296",
      "name": "Samhetha Balusu",
      "rating": 5,
      "text": "I have ordered an ornament from Krishna jewelers it came out so good I will surely recommend this place ..!! I have contacted Vijay Agarwal through online he responded quickly and I have received the order in short span of time.. well satisfied with the product"
    },
    {
      "id": "text-2297",
      "name": "Swapna Priya",
      "rating": 5,
      "text": "I purchased jewellery from Krishna Jewellers. I am pleased with their warm welcome, customer service & ofcourse wide variety of collection. I would give 5 star to Vijay who has taken care every thing from the start to till the delivery. I contacted initially through WhatsApp call, he shared pictures, I visited the store during my India visit. Vijay have got it customized few things & delivered to my home address too."
    },
    {
      "id": "text-2298",
      "name": "jayaraju konidela",
      "rating": 5,
      "text": "Good service Akshaya"
    },
    {
      "id": "text-2299",
      "name": "pavan koppula",
      "rating": 5,
      "text": "Excellent service by Akshaya madam"
    },
    {
      "id": "text-2300",
      "name": "Aruna B",
      "rating": 5,
      "text": "Sai Kumar excellent service"
    },
    {
      "id": "text-2301",
      "name": "saibaradwaj varanasi",
      "rating": 5,
      "text": "Sravan Best service"
    },
    {
      "id": "text-2302",
      "name": "Bhanumathi Buddhavarapu",
      "rating": 5,
      "text": "Wonderful services"
    },
    {
      "id": "text-2303",
      "name": "Preetham Reddy G",
      "rating": 5,
      "text": "Good models….! Thank you Rajesh & Nayeem..!"
    },
    {
      "id": "text-2305",
      "name": "Dr Veena Dhanekula",
      "rating": 5,
      "text": "We enjoyed shooping at Krishna pearls and jewellery. They have exclusive collections and designer antique sets.I highly recommend to visit this place before buying any gold/diamond. Vinay sir is extremely great with customers."
    },
    {
      "id": "text-2306",
      "name": "K. Amen Nilson",
      "rating": 5,
      "text": "Kashinath ji service is great"
    },
    {
      "id": "text-2307",
      "name": "shruthi reddy",
      "rating": 5,
      "text": "Great collection in different types of designs. Customised by Kashinath he did good job in helping/ modifying the design"
    },
    {
      "id": "text-2308",
      "name": "Siddhartha Zid",
      "rating": 5,
      "text": "Best place to shop exquisite pearl collections. Service provided by Kashinath was wonderful."
    },
    {
      "id": "text-2309",
      "name": "Kaavya Sree",
      "rating": 5,
      "text": "It’s my second time shopping here. Very good experience. We were associated with Pasha. He was very polite and kind. Showed us all the collection with lot of patience and a smile on the face. I am always satisfied with Krishna jewellers"
    },
    {
      "id": "text-2310",
      "name": "Padma ADDADA",
      "rating": 5,
      "text": "Online Ramya and sales at Ramadevi patiently showed us so many designs . It’s like talking with friends . Excellent service . Thank u"
    },
    {
      "id": "text-2311",
      "name": "Maritha Giri",
      "rating": 5,
      "text": "Good collection sales executive rajesh"
    },
    {
      "id": "text-2312",
      "name": "hamsa priya",
      "rating": 5,
      "text": "Kudos to Pawan & Ramya, who assisted in my purchase. Both are Very knowledgeable and understand needs well. Keep rocking !!"
    },
    {
      "id": "text-2314",
      "name": "Deepa Junna",
      "rating": 5,
      "text": "Excellent collection haven't seen that much collection anywhere. Sales person Mallikarjun gave outstanding service. I highly recommend the store, Infact the first store to visit for jewelry purchase"
    },
    {
      "id": "text-2315",
      "name": "Sandeep Mehrok",
      "rating": 5,
      "text": "Really good experience, good experience with kashinath ji for multiple varieties of hyderabadi pearls"
    },
    {
      "id": "text-2316",
      "name": "Ramyasree Mekala",
      "rating": 5,
      "text": "We visited first time to krishna jewellers pearls n gems Jubilee hills hyd very good ambience n good service given by staff especially our sales executive Sandeep shown good designs as per our need must visit store for bridal collection n others also.....tan q Sandeep"
    },
    {
      "id": "text-2319",
      "name": "Padma Charan",
      "rating": 5,
      "text": "Updated models... Nd I really like shopping experience, they r friendly n cooperative"
    },
    {
      "id": "text-2320",
      "name": "sagar vidya",
      "rating": 5,
      "text": "Nice collection's Good models have Very good staffing Nice experience"
    },
    {
      "id": "text-2322",
      "name": "Soujanya Thotapalli",
      "rating": 5,
      "text": "I had an awesome customer experience with Krishna jewelers with their video calling feature helping people purchase from all over the word.All of the employees that I have worked with are amazing & courteous.They answered all of the questions and made my purchase easy.I had a time constraint my husband was traveling to India and wanted to buy some diamond earrings ,made a video call ahead of the time and selected the ones that I wanted and they were ready by the time my husband reached .It was a seem less experience . Thanks you all who ever helped me with my purchase."
    },
    {
      "id": "text-2324",
      "name": "shilpa teja",
      "rating": 5,
      "text": "Awesome collection with detailing designs … Best Customer Service"
    },
    {
      "id": "text-2325",
      "name": "Tummala Ravi Kumar",
      "rating": 5,
      "text": "All are OK but ur AHU/ is not working well in Hot Summer. Parking 👍. Customer reception Perfect , staff awesome 👌. May you require an extension for your stores.😀 , crowdy always. All are awesome"
    },
    {
      "id": "text-2327",
      "name": "dhaval shah",
      "rating": 5,
      "text": "Must visit place for beautiful South Indian collection and competitive prices with quality Thank you !!Ramya for much needed and helpful jewellery was received as expected and on time."
    },
    {
      "id": "text-2328",
      "name": "Kalyani Origanti",
      "rating": 5,
      "text": "Awesome collection and staff.. Thanks Krishna Pearls Praveen garu."
    },
    {
      "id": "text-2329",
      "name": "Pinki Tripathi",
      "rating": 5,
      "text": "Aheesh singh , all thigs are good except cash discout pls think about it"
    },
    {
      "id": "text-2330",
      "name": "Anamika Gautam",
      "rating": 5,
      "text": "Absolutely gorgeous collection. Really appreciate how quickly the staff ( Shrikant) responded to each n every query 👍🏻. Would recommend all to go ahead n buy beautiful stuff 😇"
    },
    {
      "id": "text-2332",
      "name": "Richa Yadav",
      "rating": 5,
      "text": "Salesman - Mr.Kashinath is very helpful and goes extra mile to ensure that customer leaves with a smile. Thank you very much, bcos of him we have become a regular customer of Krishna Pearls."
    },
    {
      "id": "text-2333",
      "name": "saranya paladugu",
      "rating": 5,
      "text": "Sri Krishna perls is always there for all my needs. Staff is very patient"
    },
    {
      "id": "text-2335",
      "name": "bayaneni sambasivarao",
      "rating": 5,
      "text": "Got diamond chain, and locket. Thank you for your service Bharat."
    },
    {
      "id": "text-2337",
      "name": "Asha Bommana",
      "rating": 5,
      "text": "Very good service and good quality Mr Praveen was very helpful"
    },
    {
      "id": "text-2339",
      "name": "Ashwini reddy",
      "rating": 5,
      "text": "Must visit if you are looking for latest designs, they have good collection and customer service is top notch. Thanks to Mahesh and Ramya for making our shopping experience great."
    },
    {
      "id": "text-2340",
      "name": "Maya Amanova",
      "rating": 5,
      "text": "Shrikanth Ji has a professional experience to work with customers. I am thankful to him for his great assistance 🙏"
    },
    {
      "id": "text-2341",
      "name": "Aisha Hojanova",
      "rating": 5,
      "text": "Staff named Srikanth was very helpful choosing a best pearl for my Mom"
    },
    {
      "id": "text-2342",
      "name": "srinu chekuri",
      "rating": 5,
      "text": "Preveen is very very good sales man"
    },
    {
      "id": "text-2343",
      "name": "Pooja Mehta",
      "rating": 5,
      "text": "Staff was very freindly and patient:)"
    },
    {
      "id": "text-2345",
      "name": "Ratheesh Kannan Baskaran",
      "rating": 5,
      "text": "A very pleasant online shopping experience. Thanks to Srikanth Reddy for his patience and amazing customer service skills. Great place and people to consider if you’re looking for pearl sets & jewellery."
    },
    {
      "id": "text-2348",
      "name": "Sonia Walia",
      "rating": 5,
      "text": "A very friendly and welcoming environment for small as well as large shopping needs, wedding jewellery, gifts, pearls and the staff is very cooperative and helps you understand your choices ."
    },
    {
      "id": "text-2349",
      "name": "Anurag Tiwari",
      "rating": 5,
      "text": "Kashinath Ji showed us the jewellery very nicely. Thanks to him!"
    },
    {
      "id": "text-2350",
      "name": "Junaid Ahmed",
      "rating": 5,
      "text": "Had a great experience here and kashinath has been great assisting us."
    },
    {
      "id": "text-2351",
      "name": "jyoti patil",
      "rating": 4,
      "text": "Srikanth was polite and helped me buy the right choice of pearls.. The store has a variety of pearl collections"
    },
    {
      "id": "text-2352",
      "name": "Bhavana Guntur",
      "rating": 5,
      "text": "An excellent service and show by the team at Krishna Jewellers. Bhavani and Mr Srinivas welcomed us, treated us very friendly, and the prices are reasonable and negotiations are honest. Very satisfied with the purchases today."
    },
    {
      "id": "text-2354",
      "name": "Deepti Madala",
      "rating": 5,
      "text": "It was a great experience shopping at Krishna Pearls -Jubliee Hills, staff was friendly and prompt even in online shopping, they were very responsible and delivered products timely to our home. Thanks to Mr. Nagraaju who took care of all my shopping needs on time and worked effortlessly to give me the best experience. Thanks to everyone at Krishna Pearls."
    },
    {
      "id": "text-2355",
      "name": "Poojitha Sigiri",
      "rating": 5,
      "text": "Very great experience shopping here .. great customer service, very patient and humble behaviour by Mr.Shivaji. we are very happy and satisfied with the product we bought. Looking forward to shop more."
    },
    {
      "id": "text-2357",
      "name": "Nikhil Namani",
      "rating": 5,
      "text": "It was very nice to shop in Krishna Jewlleries. And also Praveen really was too good in easing the process for us."
    },
    {
      "id": "text-2360",
      "name": "Prasad T",
      "rating": 5,
      "text": "It was really good experience with *Krishna Pearls* , Wonderful designs. Mr. *Sandeep* specially - good product knowledge and good support to select the items. Highly recommended *Krishna Pearls* in Jubilee Hills."
    },
    {
      "id": "text-2361",
      "name": "Tejaswi Y",
      "rating": 5,
      "text": "Quality is assured at Krishna jewellers!! Great customer service availability for customers far away from India and within India. Thank you Ramya for helping me choose what I need even being remote and far away in this covid situations.Wide range of collections and great quality where I have seen being in video calls which doesn’t make any difference visiting physically!!!"
    },
    {
      "id": "text-2363",
      "name": "Dr Jayathri",
      "rating": 5,
      "text": "Very good collection.! Mr T Praveen was good at display and reasonably good price was given. Thank you."
    },
    {
      "id": "text-2364",
      "name": "taranjeet singh",
      "rating": 5,
      "text": "Praveen helped us out giving us all the details about pearls and how they are categorised/priced. He was very helpful throughout the buying process. The store has a good collection and the staff is courteous."
    },
    {
      "id": "text-2365",
      "name": "Rohith Anumasu",
      "rating": 5,
      "text": "Staff brigs added positive vibe to your store🤘🏻 Especially krishnakumari garu and srinivas garu Very much satisfied!!!!"
    },
    {
      "id": "text-2367",
      "name": "Madhavi C",
      "rating": 5,
      "text": "This was first time I purchased jewelry from krishna jewelry pearls and gems. Staff was very friendly. Mahesh helped me with showing lot designs and Ajay helped me with billing and shipping details. Special thanks to Ajay he keep updating with me status. Overall process was very smooth. I would highly recommend for abroad people and I was amazed with packing. I would like to buy more products from Krishna."
    },
    {
      "id": "text-2368",
      "name": "saivijay annarapu",
      "rating": 5,
      "text": "Great customer service by team and Venkatesh in helping us"
    },
    {
      "id": "text-2369",
      "name": "DEBI PRASAD Sen",
      "rating": 5,
      "text": "Nice and safe experience even on remotely purchasing it from Kolkata through video calls facilitated by the shop. The professionalism, transparency and support by Mr Pasha and Ms Bhagyasree are worthy of mentioning. Great customer experiences."
    },
    {
      "id": "text-2376",
      "name": "mahima azad",
      "rating": 5,
      "text": "I am happy with the service. Ramya & Mahesh helped me a lot via WhatsApp. very very good service ♥️"
    },
    {
      "id": "text-2377",
      "name": "k k",
      "rating": 5,
      "text": "It was really good experience with Krishna pearls. Wonderful designs, Mr. Srikanth Reddy specially good support to selected the items. Highly recommend Krishnapearls in jubilee hills."
    },
    {
      "id": "text-2378",
      "name": "Mamillapalli Anusha",
      "rating": 5,
      "text": "This place has amazing collection in town.. This should be preference if you looking for exclusive pieces or economical pieces.. Loknath garu helped us choose best among thousands of collections they have in store.. He took very good care of our needs and budget and took an extra step to get us many more collection from the workshop and spend lots of time patiently while we choose our pieces.. Swapna garu and Sowjanya garu assisted us with utmost patience while we tried thousands of pieces and made our shopping so easy.. 😊"
    },
    {
      "id": "text-2380",
      "name": "Sachin Mittal",
      "rating": 5,
      "text": "Excellent Service !!"
    },
    {
      "id": "text-2381",
      "name": "Ashwini Kondepudi",
      "rating": 5,
      "text": "Hands down the best jewelry store when is comes to the quality and service. We had an amazing experience when we purchased online and in physical store. Ajay garu guided us through WhatsApp and was very patient and responsive. Yadav garu helped us and made our shopping experience smooth at store. We really love krishna jewelers and will purchase more and more in future. 😊👍👍👍"
    },
    {
      "id": "text-2382",
      "name": "rekha palakurthi",
      "rating": 5,
      "text": "Excellent collection of jewellery and awesome workmanship. Have been searching many premium stores for good jewellery but we took best decision by choosing Krishna Jewellers. Online staff Dinakar made the process very easy by responding immediately every time we call him even during his week off and offline staff Rekha patiently showed all the designs and answered all our questions very patiently. Very satisfied with both the product and the service. From now my ONLY destination to purchase jewellery is Krishna jewellery Pearl's and gems."
    },
    {
      "id": "text-2385",
      "name": "venkata kadali",
      "rating": 5,
      "text": "I would highly recommend selecting Krishna Jewellers if you’re shopping online from abroad. Riyaz and Dinaker were friendly and easy to work with. They were always available to show various items on a video call and available to answer questions. The whole experience ( Purchase, shipping & delivery) was pleasant and seamless. I would definitely shop with them again."
    },
    {
      "id": "text-2388",
      "name": "Jaya Nallam",
      "rating": 5,
      "text": "Great designs and wonderful virtual service to purchase jewelry. Customer service is so patient and helpful. Mahesh and Dinakar helped us in the purchase without any hassle. We will definitely visit again and refer to friends and family."
    },
    {
      "id": "text-2389",
      "name": "Swathi Gali",
      "rating": 5,
      "text": "I have been looking for a perfect bottu maala for almost 1 yr, been to almost all the popular Jwellery shops in Hyderabad. Just went to Krishna Jwellery casually to check out the designs. I was received like a VIP right from the beginning, our sales assistant was Ambica, who showed us so many designs, gave us options, she kept us updated with latest models through watsapp. Our second visit, we were so impressed by the intricate details of the designs, we ended up buying. The customer service from when you enter the door until you leave is beyond words. Ambica specially was so sweet and she took care of us like a family. We have decided to keep Krishna Jwellers as our permanent go to shop from now on."
    },
    {
      "id": "text-2390",
      "name": "Uma Raju",
      "rating": 5,
      "text": "The service was very good. And the staff was very friendly. There was a wide variety of designs too. We purchased some custom made jewelry and we loved how it turned out. Thank you so much Ramya and Rama for helping me out."
    },
    {
      "id": "text-2391",
      "name": "Apoorva Nallamala",
      "rating": 5,
      "text": "Unique designs at best prices.Thanks to Ramadevi and Ramya for showing beautiful designs."
    },
    {
      "id": "text-2392",
      "name": "Anvesh Reddy",
      "rating": 5,
      "text": "Nice to shop here excellent service thanks n all the best"
    },
    {
      "id": "text-2394",
      "name": "sari bomma",
      "rating": 5,
      "text": "I liked the collection , people are very nice definitely recommended for bridal and all types of occassions"
    },
    {
      "id": "text-2395",
      "name": "Prasad Narravula",
      "rating": 5,
      "text": "We visited krishna jewellers multiple times. Lokanath Dattu assisted us showed the designs very patiently. He understood the customer requirement and showed the jewellery and explained us the design models and everything. I would recommend to go to krishna jewellery to buy gold and diamonds and ask lokanath Dattu for assistance."
    },
    {
      "id": "text-2396",
      "name": "rohita jakkana",
      "rating": 5,
      "text": "This was the first time I have purchased a set from krishna Jewellers as well as online. Staff is really helpful. (Especially sales person Rekha, she helped me very patiently to showing me the Jewellery. Dinakar helped me with billing and courier which was very quick). Overall process was very smooth. Designs are awesome."
    },
    {
      "id": "text-2398",
      "name": "Sowmya Reddy",
      "rating": 5,
      "text": "Very good collection. Rekha garu and Dhinkar garu provide excellent service. Must visit for all types of jewellery."
    },
    {
      "id": "text-2399",
      "name": "Sharmila P",
      "rating": 5,
      "text": "Our shopping experience with Krishna Jewellers was great. They have great collection and their youtube videos helped us to get an idea on latest designs/trend. Their store has huge collection of ornaments. The service provided by Ramya (from online department) and Rekha (from sales team) is amazing. They answered all our questions and showed us everything we need with great patience. The best part is they have home delivery option which is very helpful during this pandemic. I would highly recommend this shop for buying ornaments."
    },
    {
      "id": "text-2402",
      "name": "Venkata Karanam",
      "rating": 5,
      "text": "Ajay and Nagaraju of Krishna Jeweller patiently showed us all the jewellery models according to our requirements. Ajay and Nagaraju displayed good knowledge of all their products and presented to us in a very timely manner. Nagaraju went out of his way to display all the models and ensured that the product was delivered to us in time."
    },
    {
      "id": "text-2403",
      "name": "Sonakshi Butt",
      "rating": 5,
      "text": "Vijay was excellent. He very patiently showed me several pieces. Keenly listened for my preferences and suggested jewellery selection. Excellent work Vijay. Thnx Sonia"
    },
    {
      "id": "text-2404",
      "name": "Samhita Reddy",
      "rating": 5,
      "text": "I've had a great experience shopping at this store! I had to do all my wedding shopping virtually. Ambika and Ajay were great at helping me through out the whole process."
    },
    {
      "id": "text-2405",
      "name": "Deepak Katta",
      "rating": 5,
      "text": "We got our wedding jewellery from Krishna their staff Ramya and Mahesh helped us to pick their best collections."
    },
    {
      "id": "text-2406",
      "name": "sindhura reddy",
      "rating": 5,
      "text": "The store has very good collection. I initially reached to them via WhatsApp with questions . I was helped by Bhagyashree from online department. She provided me everything I needed , answered all my questions patiently and quick via WhatsApp. She understood what products I was looking for and provided the designs and photos accordingly. The quality of the product, workmanship and service was very good. This made my online shopping easy and was able to select what I needed. I would definitely recommend this store to all my family and friends."
    },
    {
      "id": "text-2407",
      "name": "Navya Peddinti",
      "rating": 5,
      "text": "I bought a diamond Haaram Online over whatsapp video call.Dinakar has helped me to get the best price and the ornament got delivered on time.It took 8-10 days to reach US.Had to pay customs here.The entire experience was smooth.I personally liked Krishna Jewellers models a lot."
    },
    {
      "id": "text-2409",
      "name": "Anitha Bachina",
      "rating": 5,
      "text": "Bhagya made my purchase very easy although living in a different continent. She followed up on every call and posted the necessary information immediately Thank you"
    },
    {
      "id": "text-2410",
      "name": "Kavya Prathyusha Chekka",
      "rating": 5,
      "text": "The staff is very friendly. I had started setting up things with help of Dinakar who arranged a video call with S Mahesh. They have patiently answered all my questions and sent me good designs in the budget I had. I loved their collection in store too! Thanks for your service and help!"
    },
    {
      "id": "text-2411",
      "name": "Anitha Bondada",
      "rating": 4,
      "text": "I recommend Krishna jewelry for buying gold and diamond. Rekha helped me with selecting my items. she was very helpful . Also, Dinakar helped to deliver my jewelry on time. Overall it’s a nice experience 🙏Thanks to all🙏🙏🙏"
    },
    {
      "id": "text-2413",
      "name": "deepika paturu",
      "rating": 5,
      "text": "Very nice collections with good quality & prices. Thank you Riaz and Dinakar for great customer support and I would love to come back again."
    },
    {
      "id": "text-2414",
      "name": "Donthireddy Kavitha",
      "rating": 5,
      "text": "Great experience.Dinesh great job and good hospitality. you for the quick service"
    },
    {
      "id": "text-2415",
      "name": "vani vanguri",
      "rating": 5,
      "text": "It was a really good experience at krishna jewellers...They've very good collections with unique designs...i was assisted by Ramya from online department and Ambika from Sales department...They were so professional and have patience throughout my purchase 🙏 Thankyou ☺️"
    },
    {
      "id": "text-2416",
      "name": "Mamatha Goli",
      "rating": 5,
      "text": "Sheshnath Good service. Will visit again Nice collection"
    },
    {
      "id": "text-2418",
      "name": "harikabindu medisetty",
      "rating": 5,
      "text": "Wide variety and attractive designs ,finishing at reasonable price.looking forward to shop more.Mr.mahesh was enthusiatic and helped us by showing different models."
    },
    {
      "id": "text-2419",
      "name": "prianca g",
      "rating": 5,
      "text": "The store has good ornament collection. They were helpful to me and were able to show the jewellery on video calls. Dinakar helped me out initially and got all my questions answered virtually. All the staff members were helpful as well when I visited the store and provided me suggestions. My overall shopping experience was less stressful and went really well."
    },
    {
      "id": "text-2420",
      "name": "Anupama devi",
      "rating": 4,
      "text": "Excellent Customer Service Especially DINKER and Rekha are very helpful , I recommend Krishna Jewellers for Beautiful Jewelry designs"
    },
    {
      "id": "text-2421",
      "name": "Prasanthi",
      "rating": 5,
      "text": "Krishna Jewlers Jubilee hill branch Hyd , provided a very good customer serivice. The employees Dinkar and Mahesh are very good , in assisting and showed all the items when ever we asked . Thank you very much Dinkar And Mahesh I am completely satisfied with them"
    },
    {
      "id": "text-2422",
      "name": "A Pavani",
      "rating": 5,
      "text": "We are received perfect product .this is the first time we are ordered in online I am very happy with my product. Excellent service from krishna Jewellery Thank you . Friendly staff Ramya from online and Rama from sales Staff response is very nice and they made my online shopping so easy Excellent collections and designs . I would like to buy more products from krishna Jewellery"
    },
    {
      "id": "text-2424",
      "name": "nivali kongara",
      "rating": 5,
      "text": "It was a great experience shopping at Krishna Jewellers. I contacted them through WhatsApp after watching their live and their staff Ajay and Srikanth were very patient and showed the jewelry as per our taste. Prices are very competitive and they also got wide variety of jewelry of all budget range. One must visit the store and I am sure you will get the jewelry of your taste."
    },
    {
      "id": "text-2425",
      "name": "Sangeetha Panguru",
      "rating": 5,
      "text": "Had very good customer experience and I would love to come back again. Thank you Riaz Garu for your service."
    },
    {
      "id": "text-2426",
      "name": "Suneetha Debbad",
      "rating": 5,
      "text": "Mr Ajith was very helpful as I live in US my friend picked up my purchase and my cousin made payment it was all possible with Mr ajith sir coordinating all parties for a smooth transaction I would recommend krishna jewellers for customers living in 🇺🇸 can get it delivered with friends when they visit hyderabad. I'm excited can't wait to see my earrings. Thank you ajith garu for all ur help."
    },
    {
      "id": "text-2427",
      "name": "Rekha Kodali",
      "rating": 5,
      "text": "Thanks to Rama and Dinakar for providing us a great shopping experience! You guys did a outstanding job .Special Thanks to Nayeem Garu.Excellent collection."
    },
    {
      "id": "text-2429",
      "name": "santhi sudha yadlapalli",
      "rating": 5,
      "text": "They have large collection , friendly staff and reasonable pricing .Ramya and mahesh made it online shopping really easy . Highly recommend this place ."
    },
    {
      "id": "text-2430",
      "name": "Syamalatha M",
      "rating": 5,
      "text": "I must say we got good trust and gained good knowledge to buy right Diamond jewellery at Krishna Jewellers. Thank you very much Dinakar garu you helped and Educated to pick right one without any fear and further doubts. Trustworthy place to visit to buy Diamond Jewellery."
    },
    {
      "id": "text-2431",
      "name": "Manjusha Musugu",
      "rating": 5,
      "text": "Riaz and Dinakar were very helpful. Especially Riaz provided excellent service."
    },
    {
      "id": "text-2433",
      "name": "Spoorthy Bodhanam",
      "rating": 5,
      "text": "I first connected with Dinekar online and he shared few fabulous designs as I requested..Then I am tagged with Mahesh S who is another knowledgeable sales person. They both makes a great team who catches customers interest and shows the products with out customer requesting for. I feel so happy working with both these guys. There are no words to explain about them especially the way they recieve customers and keeps up the relation with customers. Management is so friendly and helps you I with any questions. Simply best place to visit with vast collection and most loveable people around the store."
    },
    {
      "id": "text-2435",
      "name": "Sowmya Kotha",
      "rating": 5,
      "text": "Very good designs and the service is very good . Rekha garu and Dhinkar garu take special care in customers interest. I definitely suggest everyone to go and check out their store."
    },
    {
      "id": "text-2436",
      "name": "Kavitha V",
      "rating": 5,
      "text": "Mahesh and dinakar helped us alot from beginning to end, they gave us good suggestions."
    },
    {
      "id": "text-2437",
      "name": "Maha Lakshmi Gadde",
      "rating": 5,
      "text": "Ambika &dinakar u both are very polite and friendly nature I will refer my friends awesome design's and pricing also tq both...👍"
    },
    {
      "id": "text-2438",
      "name": "teju Vallabhaneni",
      "rating": 5,
      "text": "The jewellery designers were extra ordinary. I got all my wedding jewellery at krishna jewellers & the staff was extremely helpful. Riaz and Dinakar reached out to me on watsapp after online inquiry and from they helped me with every detail to get all jewellery under my budget."
    },
    {
      "id": "text-2439",
      "name": "Aditya Ekbote",
      "rating": 5,
      "text": "Good collection, and great service by Krishna."
    },
    {
      "id": "text-2441",
      "name": "Indira Iyer",
      "rating": 5,
      "text": "I worked with Dinakar remotely over a period of 1 week to finalize my selections for a few jewelry items that I needed to purchase for an upcoming wedding in the family. Dinakar was extremely patient, taking the time to video, take pictures, and even have the jewelry pieces modeled and worked with my aunts who picked up the items. The store gave us a generous discount as well. Overall a great experience and looking forward to making more purchases in person."
    },
    {
      "id": "text-2443",
      "name": "RG Balusu",
      "rating": 5,
      "text": "Mahesh & Dinakar garu , Thank you a lot for making my online shopping experience so smooth , truly appreciate your patience and support. I am really impressed by the way you handled video calls, and provided quick responses for any queries. I would recommend Krishna jewellers to all my friends and family in USA. Thanks for all your support during this process , looking forward to shop more from your store 😊🙏💐"
    },
    {
      "id": "text-2444",
      "name": "we4 pharma",
      "rating": 5,
      "text": "Classic collections of Pearl ornaments."
    },
    {
      "id": "text-2445",
      "name": "Megha Sharma",
      "rating": 5,
      "text": "I visited krishna jwellers in Jubilee hills branch recently to buy pearl set and had very good experience. They have good variety of pearl sets and in wide price range. Staff is friendly and assist you very well in making a decision by trying to understand your choice and helping you to find your perfect fit piece of jwellery. I was attended by Shrikant here and had very good and pleasant shopping experience. I will definitely visit again not only for pearl but to buy gold and diamond set also. Will recommend this place to everyone. If u r visiting Hyderabad first time this is the place u can trust😊"
    },
    {
      "id": "text-2446",
      "name": "A S",
      "rating": 5,
      "text": "I visited their store along with my friend to buy a Gift and we ended up buying a beautiful pearl necklace too along with the Gold chain. If you visit the store, look for the Salesperson Mr. Mahesh.. He is very sweet, quite helpful and with great patience shown us all the designs. I actually bought the pearl necklace cos I loved the hospitality, totally impressed and honestly as a gesture of appreciation I took that necklace. The store certainly has beautiful pieces and I totally totally recommend shopping there and don’t forget to ask for the Salesperson Mahesh."
    },
    {
      "id": "text-2447",
      "name": "Rishi Bhatt",
      "rating": 5,
      "text": "Best place to go if you need to buy Pearls. Mr. Amirali explained us thoroughly about the Pearl set we bought. Keep on the great work"
    },
    {
      "id": "text-2448",
      "name": "THENEBANDA SUNIL",
      "rating": 5,
      "text": "I have purchased pearl necklace from Krishna pearls jubilee hills store. I Highly Recommend for their trusted service overseas."
    },
    {
      "id": "text-2449",
      "name": "Jigisha Modi",
      "rating": 5,
      "text": "Krishna Pearls on second floor has a mamoth collection of fresh water pearls to sea pearls one looking is looking for. Srikanth helped me to choose the colour of pearls accordingly to my requirements from various options they have. One should definitely visit the store before buying pearls from anywhere else."
    },
    {
      "id": "text-2450",
      "name": "Uma Ratna Kumari Mulagala",
      "rating": 5,
      "text": "I bought rice pearl strings from Krishna pearls online store which are awesome ,and service provided by bhagya sree customer relationship executive is excellent ."
    },
    {
      "id": "text-2451",
      "name": "Vamsi Andena",
      "rating": 4,
      "text": "We have visited Krishna Pearls in Jubilee Hills road no.36,they were greeted with Welcome drink.very helpful n obedient staff n showed us a number of collections with smile especially Mr.Shoukat helped us about pricing n details about each item..V r very much impressed with collection n service..Will advice some others make their visit here.."
    },
    {
      "id": "text-2452",
      "name": "mitali paul",
      "rating": 4,
      "text": "I BOUGHT PEARL 4STRING NECKLESS FROM KRISHNA PEARLS ONLINE ,IN THIS RESPECT SELLSPERSON PASSA HELP ME. AGAIN I BOUGHT PEARL BANGLE PAIR ,ANOTHER PEARL NECKLESS ,AND ONE SILVER SINGHASAN ONLINE. , CUSTOMER RELATIONSHIP EXECUTIVE BHAGYA SREE HELP ME TO PURCHASE THESE THINGS. THE PRDUCTS ARE AWESOME SERIOUSLY AND CUSTOMER RELATIONSHIP EXECUTIVS ARE EXCELLENT INDEED .I AM QUITE IMPRESSED."
    },
    {
      "id": "text-2453",
      "name": "Vasu Reddy",
      "rating": 5,
      "text": "The store has amazing collections for pearls related jewelery, we found as per our liking in the range. Srikanth was very helpful and patiently explained and showed us the designs till we finalized, the entire staff was courteous and helpful must visit place for pearls related jewelery...."
    },
    {
      "id": "text-2454",
      "name": "Bharathi Duvvuru",
      "rating": 5,
      "text": "In my recent visit to India, I have had a chance to visit Krishna Pearls and Jewelers. They really have amazing gold and diamond collection. My initial thought was to explore their collection, probably buy one item. But I actually ended up buying couple of them. I received many complements from my family and friends for the jewelry purchased from Krishna Pearls and Jewels. I should particularly speak about one of their team member Loknath garu, who very patiently took time to show me the items of my taste. He is such a nice gentleman who pulled in his manager to finalize in giving the best price for me. I am very happy to recommend this store, which will be in my favorites list."
    },
    {
      "id": "text-2455",
      "name": "Abdul Kareem",
      "rating": 5,
      "text": "Purchased silver and 3 pearls necklaces... Very nice experience..."
    },
    {
      "id": "text-2456",
      "name": "Mad at Cricket",
      "rating": 5,
      "text": "The service was really good. The designs of the pearls were really good and they offered reasonable discounts on the product. The sales representative, Mr Shoukat, was very polite, provided all the information about pearls, and handled all the queries with Grace."
    },
    {
      "id": "text-2457",
      "name": "Anadi Chaturvedi",
      "rating": 5,
      "text": "Store has a very good pearls collection. Great for shopping silver and gold jewelry of all price range. Service is excellent. Mr. Srikanth has good knowledge about jewelry and showed us a lot of variety of items. Must visit for pearl shopping in Hyderabad."
    },
    {
      "id": "text-2458",
      "name": "Sazid Ali Mohammed",
      "rating": 5,
      "text": "This place is best for wedding jewelry and also for diffrent models and a very trusted shop krishna pearls l.best staff who recives customer with a good manner and if you choose this shop for shopping its a better option"
    },
    {
      "id": "text-2459",
      "name": "Somaprakash R",
      "rating": 5,
      "text": "Polite and humble staff pearls section (Mr.Pasha) in second floor. Also they are having good collections."
    },
    {
      "id": "text-2460",
      "name": "Jeremiah Bennett Gunasekar",
      "rating": 5,
      "text": "Great Variety of Pearls and Good Quality of Service by Shoukat!! Amazing interiors as well!! Must visit!!"
    },
    {
      "id": "text-2461",
      "name": "Poonam Namodatt",
      "rating": 5,
      "text": "Great experience! Beautiful collection of pearls jewellery!! 😊"
    },
    {
      "id": "text-2462",
      "name": "Ravi Narayan",
      "rating": 5,
      "text": "Naveen did a fantastic job of giving us a Pearls 101 class. He was patient, transparent and extremely helpful in my decision making. The overall shopping experience was pleasant and very satisfying thanks to Naveen and his team"
    },
    {
      "id": "text-2463",
      "name": "Himanshu Thakur",
      "rating": 5,
      "text": "Awesome experience. 1st time went to buy a gift and the staff named Amirali suggested an awesome pearl neckless. It was really awesome."
    },
    {
      "id": "text-2464",
      "name": "Rahulmetraskar Rahul",
      "rating": 5,
      "text": "Nice experience in buy pearl bangles and earrings for daily use. Staff is friendly and patience in showing their vast collections"
    },
    {
      "id": "text-2466",
      "name": "indu govindswamy",
      "rating": 5,
      "text": "Good collection and the staffs are very helpful.The person who assisted me was Srikanth was very patient and friendly and helped me to make good choice."
    },
    {
      "id": "text-2468",
      "name": "SB Goldencreation",
      "rating": 5,
      "text": "Very nice shop,staffs are very gentle,SPECIALLY mr shaukat,I think one will visit for the next time.huge collection"
    },
    {
      "id": "text-2469",
      "name": "Sumit Kataria",
      "rating": 5,
      "text": "Very good service. Great staff."
    },
    {
      "id": "text-2470",
      "name": "MOHAN SAHNI",
      "rating": 5,
      "text": "Visited Krishna jeweller at jubilee hills Very nice collection Must visit store Mr shoukat helped us to choose pearls Thank you"
    },
    {
      "id": "text-2471",
      "name": "Anup Kumar",
      "rating": 5,
      "text": "Good collection and service. Mr. Srikanth was very patient and polite."
    },
    {
      "id": "text-2473",
      "name": "Malika Dharani",
      "rating": 5,
      "text": "It was awesome service Product and representative named Amirali were excellent"
    },
    {
      "id": "text-2476",
      "name": "N SATHIYA SEELAN",
      "rating": 5,
      "text": "Good collections, Nice courtesy by SHOUKAT"
    },
    {
      "id": "text-2477",
      "name": "Balwinder Pal Sethi",
      "rating": 5,
      "text": "Amazing Service by Srikanth. Guided well about pearls."
    },
    {
      "id": "text-2478",
      "name": "kishore kumar",
      "rating": 4,
      "text": "Very good service. You can purchased in online pearl Jewellery items. Very transparent transaction. All our doubts are clarified!."
    },
    {
      "id": "text-2479",
      "name": "Shireesha Koninti",
      "rating": 5,
      "text": "Great place to buy pearls in Hyderabad at Krishna pearls Jubilee Hills"
    },
    {
      "id": "text-2480",
      "name": "venkstesh narapaka",
      "rating": 5,
      "text": "Great experience! Lovely friendly staff and I am very impressed and recommend people to purchase pearl necklaces and pearl earrings. Thank you once again to Krishna Pearls Team!"
    },
    {
      "id": "text-2481",
      "name": "Ayshika Mitra",
      "rating": 5,
      "text": "The pearls are of top-notch quality. The staff are very friendly and courteous. Shoukath attended us with his prompt services. We had a very pleasant experience and would love to be back again."
    },
    {
      "id": "text-2483",
      "name": "Archana Tripathi",
      "rating": 5,
      "text": "Amazing collections of designs they have."
    },
    {
      "id": "text-2484",
      "name": "Yousuf Mohammad",
      "rating": 5,
      "text": "Awesome experience with Krishna Pearls. Very customer friendly staff and nice designs."
    },
    {
      "id": "text-2485",
      "name": "manoj raj",
      "rating": 5,
      "text": "Best Pearl Jewelry Shop you will get good and updated variety model comparing to other reputed jewelry showrooms in Hyderabad. Excellent customer service. Parking area is good. I had Good experience with this jewelry shop at Jubilee Hills, recommend others for quality pearls."
    },
    {
      "id": "text-2486",
      "name": "Ganesh Ganesh",
      "rating": 5,
      "text": "Great collection Jewellery Pearl shop in Jubilee Hills !! And alot of options along with less cost due to good schemes."
    },
    {
      "id": "text-2488",
      "name": "Amirali Dharani",
      "rating": 5,
      "text": "Very nice and unique collection. Staff is also very cooperative and friendly"
    },
    {
      "id": "text-2489",
      "name": "harisai1188",
      "rating": 4,
      "text": "The staff are very friendly and courteous. Shoukath attended me with his prompt services. They have a wide range of collection and best in service."
    },
    {
      "id": "text-2490",
      "name": "naveen kumar",
      "rating": 5,
      "text": "Purchased a two row pearl string chain As a gift to my wife on our wedding anniversary. She loved it a lot!!"
    },
    {
      "id": "text-2491",
      "name": "hinduja reddy",
      "rating": 5,
      "text": "The store have a good collection. Received very good hospitality as well the reasonable prices for the items! Thank you very much Krishna Jewellers !"
    },
    {
      "id": "text-2492",
      "name": "Devendran R",
      "rating": 5,
      "text": "Wonderful place exclusively for Pearl Jewelry in Jubilee hills. Patient customer service offered by Mr. Srikanth. Definitely visiting again the next time I come to Hyderabad."
    },
    {
      "id": "text-2493",
      "name": "Nyshitha Rathna Mala",
      "rating": 5,
      "text": "Lovely designs and great prices. The person attended me is Mr. Srikanth. I think you'll see me often now. Thanks a lot!"
    },
    {
      "id": "text-2495",
      "name": "Barasha Devi",
      "rating": 5,
      "text": "wonderful experience at the shop .Customer care was great Md Shaukat has been very nice to us .He has proven to b a good sales person .Hope to visit again."
    },
    {
      "id": "text-2496",
      "name": "Praveen Kumar",
      "rating": 5,
      "text": "A very good collection of pearl earrings & sets"
    },
    {
      "id": "text-2497",
      "name": "Rohit Sharma",
      "rating": 5,
      "text": "Great customer experience, the staff is very soft spoken.large amount of variety of pearls & at a good price."
    },
    {
      "id": "text-2505",
      "name": "Dr.Lalitha Reddy",
      "rating": 5,
      "text": "Very beautiful luxury jewellery store for all your needs They have various designer collections and good hospitality , service to customers. Must visit place in hyderabad"
    },
    {
      "id": "text-2506",
      "name": "vegesna trinadha raju",
      "rating": 5,
      "text": "Asheesh Singh have us a wonderful deal and service Highly recommend 👍"
    },
    {
      "id": "text-2507",
      "name": "Narra ananya Reddy",
      "rating": 5,
      "text": "The store have good collection n excellent service 😊👍🏻"
    },
    {
      "id": "text-2508",
      "name": "Shashank Ramadurgam",
      "rating": 5,
      "text": "Awesome shop best price best models"
    },
    {
      "id": "text-2510",
      "name": "Dev",
      "rating": 5,
      "text": "Bhagya sree from this store was very helpfull in sending different models and exactly what I was looking for..great service from her.thank you..had a great shopping experience.."
    },
    {
      "id": "text-2520",
      "name": "taniya kalrra",
      "rating": 5,
      "text": "The staff and service is excellent. Special thanks to srikanth ji for his help. Felt welcomed. Thank you!!!!"
    },
    {
      "id": "text-2528",
      "name": "Harika reddy",
      "rating": 5,
      "text": "Completely fell in love with their collections and hospitality.. from now on I prefer and refer everyone to this jewellery shop.. especially thank you chary gaaru for dealing with us.. looking forward to shop here again and again"
    },
    {
      "id": "text-2529",
      "name": "prasanna gm",
      "rating": 5,
      "text": "Very good and rates are fine."
    },
    {
      "id": "text-2535",
      "name": "vaishnavi borgalli",
      "rating": 5,
      "text": "Amazing service from shop. And quality products ☺"
    },
    {
      "id": "text-2537",
      "name": "Archana Reddy Charuku",
      "rating": 4,
      "text": "Good collection"
    },
    {
      "id": "text-2540",
      "name": "Ranjani Mangalampalli",
      "rating": 5,
      "text": "Great collection"
    },
    {
      "id": "text-2543",
      "name": "Raji Ananthula",
      "rating": 5,
      "text": "Good service by Mahesh and latest variety of beautiful collections shown in detail, highly recommended."
    },
    {
      "id": "text-2545",
      "name": "Taruni Latha Chaganti",
      "rating": 5,
      "text": "I am very happy with the customer service leading to customer delight...Ankit is the guy who ensure when ever we go we are at comfort and shows all the jwellery with so much patience.. they understand teg preference and choice of the customer and show the designs my experience is good so far.. have been going from past 2 yrs.."
    },
    {
      "id": "text-2548",
      "name": "varnika mandapaka",
      "rating": 5,
      "text": "Krishna jewellers has got best of the diamond collections. Neatly and patiently presented by Rajkumar rao. Must visit place for wedding collection."
    },
    {
      "id": "text-2549",
      "name": "Ishika Jiwani",
      "rating": 5,
      "text": "Good staff Amir Ali is best one"
    },
    {
      "id": "text-2550",
      "name": "Bharath R",
      "rating": 5,
      "text": "Good shopping experience and quality staff Mr.srikanth looking to come once again at my Hyderabad visits"
    },
    {
      "id": "text-2551",
      "name": "Mayank Joshi",
      "rating": 5,
      "text": "Representatives are very generous and customer centric. Good collection in store. Recommended to visit."
    },
    {
      "id": "text-2553",
      "name": "Sravani S",
      "rating": 4,
      "text": "Nice experience. Srikanth explained clearly regarding the item which we bought."
    },
    {
      "id": "text-2554",
      "name": "Shilpa Shah",
      "rating": 5,
      "text": "Beautiful store nice collection ....helpful staff.......worth a visit when u come to Hyderabad Krishna palace at jubliee hills"
    },
    {
      "id": "text-2555",
      "name": "Rachna Mhatre",
      "rating": 5,
      "text": "Great quality!! Srikant assisted me well."
    },
    {
      "id": "text-2556",
      "name": "Ramakant Singh",
      "rating": 5,
      "text": "Nice show room and nice collection with good hospitality thx. specially Shoukat 👍"
    },
    {
      "id": "text-2557",
      "name": "Tirtha Chatterjee",
      "rating": 5,
      "text": "Very good behaviour of the sales man..."
    },
    {
      "id": "text-2558",
      "name": "Elananu",
      "rating": 5,
      "text": "Nice atmosphere and good collections.. Shoukat assisted assisting with the requirements.. very helpful"
    },
    {
      "id": "text-2559",
      "name": "Cicily Savia",
      "rating": 5,
      "text": "Very friendly staff and such a good customer service. Srikanth who helped us through our purchase was just amazing!They are always ready to show any type of product or item you are searching for and will make sure you are leaving their store very happy !"
    },
    {
      "id": "text-2560",
      "name": "arya j",
      "rating": 5,
      "text": "Great customer service and patience. (Srikanth)"
    },
    {
      "id": "text-2561",
      "name": "Deepa Thomas",
      "rating": 5,
      "text": "Very good service and great collection..Srikanth who helped us throughout the purchase was very patient and helpful"
    },
    {
      "id": "text-2562",
      "name": "Vivek Balchandani",
      "rating": 5,
      "text": "I Purchased original pearl jewelry online from krishnapearls. Latest pearl jewelry designs and excellent collection With Krishnapearls.com"
    },
    {
      "id": "text-2564",
      "name": "Shreesh Yadav",
      "rating": 5,
      "text": "At Forum krishna pearls u have good varities of products which attracted me very much"
    },
    {
      "id": "text-2565",
      "name": "shiva reddy",
      "rating": 5,
      "text": "Very nice collections attracting jewellery in jems and pearls. Very good staff having muchoapatients .finally I am happy to collect what I need I got..."
    },
    {
      "id": "text-2566",
      "name": "Jhansi Kadiala",
      "rating": 4,
      "text": "Very good collection in pearls jewellery and staff service is also very good at HICC"
    },
    {
      "id": "text-2567",
      "name": "alcon healthcare",
      "rating": 4,
      "text": "Krishna jewellers pearls gems in orbit mall .blue sapphire ring with diamonds collection is good."
    },
    {
      "id": "text-2568",
      "name": "Prudhvi Yadav",
      "rating": 5,
      "text": "All the collections are attractive at reasonable price at forum mall krishna pearls"
    },
    {
      "id": "text-2569",
      "name": "Charan Yerravelli",
      "rating": 5,
      "text": "Today I went to Inorbit mall for shopping for new year so step in krishna pearls and jewellery store who sell pearls and gold I like small pendent that in yellow gold with emerald stone by quick decision I purchased"
    },
    {
      "id": "text-2570",
      "name": "syed mouzam",
      "rating": 5,
      "text": "Last week I was in westin hotel where I saw a pearl shop I wanted to buy some gold jewellery for my wife the shop staff recommended me there big showroom i went to Krishna jewellers pearls & gem showroom at jubli hills Hyderabad as I enter the shop I got very good welcome and I saw finest jewellery designees at there shop. it one of the great shop for all kinds of jewellery requirements and the staff is very much knowladgable"
    },
    {
      "id": "text-2571",
      "name": "Ravi Kumar",
      "rating": 5,
      "text": "U have good Black daimond collection in krishna pearls at forum mall and wanted to see more collection which gets me attracted for gifting purpose"
    },
    {
      "id": "text-2572",
      "name": "Ysai Charan",
      "rating": 5,
      "text": "Hi I visited to krishna pearls and gems we got a lots of collection there the staffs also good response from the staffs again I will come back to krishna pearls and purchase more . Thkz to staff"
    }
  ]
};
